export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: string;
  /** A field whose value matches the provided regular expression /^([\w-]+\.)*[\w\-]+\.\w{2,10}$/. */
  DomainName: any;
  /** A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/. */
  EmailAddress: any;
  /** A field whose value should conform to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/ with a Top level domain. Valid RFC822 addresses with local domains are invalid with this scalar */
  EmailAddressWithTLD: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** String with a maximum length of 100000 */
  LengthValidatedString_100000: string;
  /** String with a maximum length of 255 */
  LengthValidatedString_255: string;
  /** String with a maximum length of 1000 characters and minimum length of 2 characters */
  LengthValidatedString_2_to_1000: any;
  /** String with a maximum length of 512 */
  LengthValidatedString_512: string;
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`. */
  LocalTime: any;
  /** A string that cannot be passed as an empty value */
  NonEmptyString: string;
  /** Floats that will have a value of 0 or more. */
  NonNegativeFloat: number;
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: number;
  /** Integers that will have a value greater than 0. */
  PositiveInt: number;
  /** String with a maximum size of 100KB */
  SizeValidatedString_100KB: any;
  /** String with a maximum size of 199KB */
  SizeValidatedString_199KB: any;
  /** String with a maximum size of 200KB */
  SizeValidatedString_200KB: string;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: any;
  /** marks an argument that should not be used */
  VoidArgument: any;
};

export enum ActionsEffectivenessCommName {
  Slack = 'Slack',
  Banners = 'Banners',
  SMS = 'SMS',
  Teams = 'Teams',
  Emails = 'Emails'
}

export enum ActivityHistoryOrderColumn {
  activityName = 'activityName',
  itemType = 'itemType',
  startedAt = 'startedAt',
  completedAt = 'completedAt'
}

export type AdditionalFieldsConfigRecord = {
  __typename?: 'AdditionalFieldsConfigRecord';
  additionalFields?: Maybe<Array<AllowedUserFieldsEnum>>;
  privacyPolicyEnabled?: Maybe<Scalars['Boolean']>;
  privacyPolicyUrl?: Maybe<Scalars['String']>;
};

export type AdditionalFieldsConfigRecordInput = {
  additionalFields?: Maybe<Array<AllowedUserFieldsEnum>>;
  privacyPolicyEnabled?: Maybe<Scalars['Boolean']>;
  privacyPolicyUrl?: Maybe<Scalars['String']>;
};

export enum AllowedUserFieldsEnum {
  first_name = 'first_name',
  last_name = 'last_name',
  display_name = 'display_name',
  email = 'email',
  phone_number = 'phone_number',
  account_name = 'account_name',
  position = 'position',
  area = 'area',
  location = 'location',
  department = 'department',
  custom_1 = 'custom_1',
  custom_2 = 'custom_2',
  custom_3 = 'custom_3'
}

export type AnalyticsCertificationDetailFilter = {
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['PositiveInt']>;
  orderColumn?: Maybe<CertificationDetailOverviewOrderColumn>;
  certificationId?: Maybe<Scalars['PositiveInt']>;
  campaignIds?: Maybe<Array<Scalars['PositiveInt']>>;
};

export type AnalyticsCertificationsFilter = {
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  orderColumn?: Maybe<CertificationsOverviewOrderColumn>;
};

/** Analytics model specifically for certifications */
export type AnalyticsCertificationsModel = {
  __typename?: 'AnalyticsCertificationsModel';
  /** returns list of enrolments fulfilling given filters */
  certificationEnrolments?: Maybe<CertificationEnrolmentsOverview>;
  /** returns list of enrolments fulfilling given filters */
  overview?: Maybe<CertificationOverview>;
  /** Archives multiple certification enrolments. Returns count of processed items. */
  batchArchiveEnrolments?: Maybe<Scalars['NonNegativeInt']>;
};


/** Analytics model specifically for certifications */
export type AnalyticsCertificationsModelCertificationEnrolmentsArgs = {
  overviewTableFilter?: Maybe<AnalyticsCertificationDetailFilter>;
};


/** Analytics model specifically for certifications */
export type AnalyticsCertificationsModelOverviewArgs = {
  overviewTableFilter?: Maybe<AnalyticsCertificationsFilter>;
};


/** Analytics model specifically for certifications */
export type AnalyticsCertificationsModelBatchArchiveEnrolmentsArgs = {
  certificationId: Scalars['PositiveInt'];
  enrolmentIds: Array<Scalars['PositiveInt']>;
};

/** analytics model specifically for events */
export type AnalyticsEventsModel = {
  __typename?: 'AnalyticsEventsModel';
  /** data for main analytics events overview table */
  userEventsOverview?: Maybe<Array<UserEventModel>>;
  /** total event items for pagination */
  userEventsOverviewCount?: Maybe<Scalars['NonNegativeInt']>;
  /** returns count of attended events in given date range */
  attendedCount?: Maybe<Scalars['NonNegativeInt']>;
};


/** analytics model specifically for events */
export type AnalyticsEventsModelUserEventsOverviewArgs = {
  overviewFilter?: Maybe<AnalyticsUserEventsFilter>;
};


/** analytics model specifically for events */
export type AnalyticsEventsModelUserEventsOverviewCountArgs = {
  overviewFilter?: Maybe<AnalyticsUserEventsFilter>;
};

export type AnalyticsFilter = {
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  includeAdmins: Scalars['Boolean'];
  includeArchived: Scalars['Boolean'];
  includeDrafts: Scalars['Boolean'];
  workspaceIds?: Maybe<Array<Scalars['PositiveInt']>>;
  pathwayIds?: Maybe<Array<Scalars['PositiveInt']>>;
  topicId?: Maybe<Scalars['PositiveInt']>;
  userId?: Maybe<Scalars['PositiveInt']>;
  topicElementId?: Maybe<Scalars['PositiveInt']>;
};

export type AnalyticsHitCountByHourModel = {
  __typename?: 'AnalyticsHitCountByHourModel';
  count: Scalars['PositiveInt'];
  hour: Scalars['NonNegativeInt'];
};

export type AnalyticsHitCountByTimeUnit = {
  __typename?: 'AnalyticsHitCountByTimeUnit';
  count: Scalars['PositiveInt'];
  /** day when the chosen time unit starts */
  day: Scalars['DateTime'];
};

export type AnalyticsMediaImpressionsOverviewFilter = {
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  orderColumn?: Maybe<MediaImpressionsOverviewOrderColumn>;
  onlyEngagements?: Maybe<Scalars['Boolean']>;
};

export type AnalyticsMediaImpressionsOverviewModel = {
  __typename?: 'AnalyticsMediaImpressionsOverviewModel';
  items: Array<VideoImpressionModelAsAdmin>;
  count?: Maybe<Scalars['Float']>;
};

/** analytics model specifically for media - video and audio */
export type AnalyticsMediaModel = {
  __typename?: 'AnalyticsMediaModel';
  /** returns list of our own hosted media */
  mediaOverview?: Maybe<AnalyticsMediaOverviewModel>;
  topicElement?: Maybe<TopicElementModel>;
  impressionsOverview?: Maybe<AnalyticsMediaImpressionsOverviewModel>;
  /** Average of the total of the video watched divided by the total length of the video, across all sessions */
  averageEngagement: Scalars['NonNegativeFloat'];
  /** Number of times the video was started */
  playsCount: Scalars['NonNegativeInt'];
  /** Number of times the video was loaded on a visited page, when a user reached it */
  impressionsCount: Scalars['NonNegativeInt'];
  /** A percentage of plays to loads (impressions) */
  playRate: Scalars['NonNegativeFloat'];
  /** Count of workbooks that are already overdue in given date range */
  playTimeMinutes: Scalars['NonNegativeInt'];
  /** returns a day and count of users who viewed some topics in that day */
  impressionsByTimeUnit: Array<AnalyticsHitCountByTimeUnit>;
};


/** analytics model specifically for media - video and audio */
export type AnalyticsMediaModelMediaOverviewArgs = {
  overviewTableFilter?: Maybe<AnalyticsMediaOverviewFilter>;
};


/** analytics model specifically for media - video and audio */
export type AnalyticsMediaModelTopicElementArgs = {
  id: Scalars['PositiveInt'];
};


/** analytics model specifically for media - video and audio */
export type AnalyticsMediaModelImpressionsOverviewArgs = {
  topicElementId: Scalars['PositiveInt'];
  overviewTableFilter: AnalyticsMediaImpressionsOverviewFilter;
};


/** analytics model specifically for media - video and audio */
export type AnalyticsMediaModelPlaysCountArgs = {
  onlyUnique?: Maybe<Scalars['Boolean']>;
};


/** analytics model specifically for media - video and audio */
export type AnalyticsMediaModelImpressionsCountArgs = {
  onlyUnique?: Maybe<Scalars['Boolean']>;
};


/** analytics model specifically for media - video and audio */
export type AnalyticsMediaModelPlayRateArgs = {
  onlyUnique?: Maybe<Scalars['Boolean']>;
};


/** analytics model specifically for media - video and audio */
export type AnalyticsMediaModelImpressionsByTimeUnitArgs = {
  unit: TimeUnitEnum;
  onlyEngagements: Scalars['Boolean'];
};

export type AnalyticsMediaOverviewFilter = {
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  orderColumn?: Maybe<MediaOverviewOrderColumn>;
};

export type AnalyticsMediaOverviewModel = {
  __typename?: 'AnalyticsMediaOverviewModel';
  items: Array<AnalyticsMediaReportModel>;
  count?: Maybe<Scalars['Float']>;
};

export type AnalyticsMediaReportModel = {
  __typename?: 'AnalyticsMediaReportModel';
  id?: Maybe<Scalars['PositiveInt']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  resourceDeletedAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  resourceName?: Maybe<Scalars['String']>;
  avgEngagement?: Maybe<Scalars['NonNegativeFloat']>;
  playsCount?: Maybe<Scalars['NonNegativeInt']>;
  uniquePlaysCount?: Maybe<Scalars['NonNegativeInt']>;
  impressionsCount?: Maybe<Scalars['NonNegativeInt']>;
  uniqueImpressionsCount?: Maybe<Scalars['NonNegativeInt']>;
  playRate?: Maybe<Scalars['NonNegativeFloat']>;
  totalPlayTimeMinutes?: Maybe<Scalars['NonNegativeFloat']>;
  lastActivity?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

/** Top level analytics model */
export type AnalyticsModel = {
  __typename?: 'AnalyticsModel';
  people: AnalyticsPeopleModel;
  resources: AnalyticsResourcesModel;
  workbooks: AnalyticsWorkbooksModel;
  pathways: AnalyticsPathwaysModel;
  search: AnalyticsSearchModel;
  events: AnalyticsEventsModel;
  surveys: AnalyticsSurveysModel;
  certifications: AnalyticsCertificationsModel;
  scorm: AnalyticsScormModel;
  media: AnalyticsMediaModel;
};

export type AnalyticsPathwayEnrolmentsFilter = {
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['PositiveInt']>;
  orderColumn?: Maybe<PathwaysOverviewOrderColumn>;
  progress?: Maybe<PathwayProgressStatus>;
  campaignIds?: Maybe<Array<Scalars['PositiveInt']>>;
};

/** Analytics model specifically for pathways */
export type AnalyticsPathwaysModel = {
  __typename?: 'AnalyticsPathwaysModel';
  pathwayEnrolment?: Maybe<PathwayEnrolmentModelAsAdmin>;
  /** returns list of enrolments fulfilling given filters */
  enrolmentsOverview: Array<PathwayEnrolmentModelAsAdmin>;
  relatedCampaigns?: Maybe<Array<CampaignModel>>;
  enrolmentsCount: Scalars['NonNegativeInt'];
  /** Count of successfully completed pathway enrolments in given date range */
  completedCount: Scalars['NonNegativeInt'];
  /** Count of pathway enrolments in failed state in given date range */
  failedCount: Scalars['NonNegativeInt'];
  /** Count of pathway enrolments in progress in given date range */
  inProgressCount: Scalars['NonNegativeInt'];
  /** Count of pathway enrolments that did not start yet in given date range */
  notStartedCount: Scalars['NonNegativeInt'];
  /** Count of pathway enrolments that are already overdue in given date range */
  overdueCount: Scalars['NonNegativeInt'];
};


/** Analytics model specifically for pathways */
export type AnalyticsPathwaysModelPathwayEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};


/** Analytics model specifically for pathways */
export type AnalyticsPathwaysModelEnrolmentsOverviewArgs = {
  overviewTableFilter?: Maybe<AnalyticsPathwayEnrolmentsFilter>;
};


/** Analytics model specifically for pathways */
export type AnalyticsPathwaysModelEnrolmentsCountArgs = {
  overviewTableFilter?: Maybe<AnalyticsPathwayEnrolmentsFilter>;
};

export type AnalyticsPeopleFilter = {
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['PositiveInt']>;
  orderColumn?: Maybe<UsersOverviewOrderColumn>;
  userActivity?: Maybe<UsersActivityFilterEnum>;
};

/** analytics model specifically for people */
export type AnalyticsPeopleModel = {
  __typename?: 'AnalyticsPeopleModel';
  uniqueActiveUsersCount: Scalars['NonNegativeInt'];
  usersOverviewCount?: Maybe<Scalars['NonNegativeInt']>;
  /** used for the main table on people tab */
  usersOverview: Array<AnalyticsViewCountByUserModel>;
  /** returns a day and count of users who viewed some topics in that day */
  activeUsersByTimeUnit: Array<AnalyticsHitCountByTimeUnit>;
  /** returns count of user sessions in given date range */
  totalUserSessionCount?: Maybe<Scalars['NonNegativeInt']>;
};


/** analytics model specifically for people */
export type AnalyticsPeopleModelUsersOverviewCountArgs = {
  overviewTableFilter?: Maybe<AnalyticsPeopleFilter>;
};


/** analytics model specifically for people */
export type AnalyticsPeopleModelUsersOverviewArgs = {
  overviewTableFilter?: Maybe<AnalyticsPeopleFilter>;
};


/** analytics model specifically for people */
export type AnalyticsPeopleModelActiveUsersByTimeUnitArgs = {
  unit: TimeUnitEnum;
};

export type AnalyticsRatingSpreadModel = {
  __typename?: 'AnalyticsRatingSpreadModel';
  rating?: Maybe<Scalars['NonNegativeInt']>;
  count?: Maybe<Scalars['NonNegativeInt']>;
};

export type AnalyticsResourceActivityFilter = {
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['PositiveInt']>;
  orderColumn?: Maybe<ResourceActivityOverviewOrderColumn>;
  resourceId?: Maybe<Scalars['PositiveInt']>;
};

export type AnalyticsResourceActivityModel = {
  __typename?: 'AnalyticsResourceActivityModel';
  lastViewedAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['PositiveInt']>;
  viewsCount?: Maybe<Scalars['NonNegativeInt']>;
  is_archived?: Maybe<Scalars['Boolean']>;
};

export type AnalyticsResourceVersionsModel = {
  __typename?: 'AnalyticsResourceVersionsModel';
  id?: Maybe<Scalars['PositiveInt']>;
  title?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  lastViewedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  publishedByUserName?: Maybe<Scalars['String']>;
  avgRating?: Maybe<Scalars['NonNegativeInt']>;
  viewsCount?: Maybe<Scalars['NonNegativeInt']>;
  publishingMessage?: Maybe<Scalars['String']>;
  numberRated?: Maybe<Scalars['NonNegativeInt']>;
  totalRating?: Maybe<Scalars['NonNegativeInt']>;
};

export type AnalyticsResourceVersionsOverviewFilter = {
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  orderColumn?: Maybe<ResourceVersionsOverviewOrderColumn>;
  resourceId?: Maybe<Scalars['PositiveInt']>;
};

export type AnalyticsResourceVersionsOverviewModel = {
  __typename?: 'AnalyticsResourceVersionsOverviewModel';
  items: Array<AnalyticsResourceVersionsModel>;
  count: Scalars['Float'];
};

export type AnalyticsResourcesFilter = {
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['PositiveInt']>;
  orderColumn?: Maybe<ResourcesOverviewOrderColumn>;
};

/** analytics model specifically for resources */
export type AnalyticsResourcesModel = {
  __typename?: 'AnalyticsResourcesModel';
  /** count of ratings for every score (1-5) given by all users who completed an enrolment in the selected time interval */
  ratingSpread: Array<AnalyticsRatingSpreadModel>;
  /** average rating given by all users who completed an enrolment in the selected time interval */
  averageRating?: Maybe<Scalars['NonNegativeFloat']>;
  /** data for activity overview table */
  userActivityOverview: Array<AnalyticsUserActivityModel>;
  /** count of rows in activity overview table */
  userActivityOverviewCount: Scalars['NonNegativeInt'];
  /** data for main analytics resources table */
  resourcesOverview: Array<AnalyticsViewsCountByTopicModel>;
  /** count of resources according to current filters setup */
  resourcesCount: Scalars['NonNegativeInt'];
  totalViewsCount: Scalars['NonNegativeInt'];
  usersViewedResourceCount: Scalars['NonNegativeInt'];
  uniqueViewedTopicsCount: Scalars['NonNegativeInt'];
  /** used for charting the graphs on Resources tab */
  topicViewsByTimeUnit: Array<AnalyticsHitCountByTimeUnit>;
  /** used for charting the graphs on Resources tab */
  topicViewsByHour?: Maybe<Array<AnalyticsHitCountByHourModel>>;
  /** data for activity overview table, showing user activity (view count) in resources */
  resourceActivityOverview: Array<AnalyticsResourceActivityModel>;
  /** count of rows in activity overview table */
  resourceActivityOverviewCount: Scalars['NonNegativeInt'];
  /** returns list of topic versions */
  versionsOverview?: Maybe<AnalyticsResourceVersionsOverviewModel>;
};


/** analytics model specifically for resources */
export type AnalyticsResourcesModelUserActivityOverviewArgs = {
  overviewFilter: AnalyticsUserActivityFilter;
};


/** analytics model specifically for resources */
export type AnalyticsResourcesModelUserActivityOverviewCountArgs = {
  overviewFilter: AnalyticsUserActivityFilter;
};


/** analytics model specifically for resources */
export type AnalyticsResourcesModelResourcesOverviewArgs = {
  overviewTableFilter?: Maybe<AnalyticsResourcesFilter>;
};


/** analytics model specifically for resources */
export type AnalyticsResourcesModelResourcesCountArgs = {
  overviewTableFilter?: Maybe<AnalyticsResourcesFilter>;
};


/** analytics model specifically for resources */
export type AnalyticsResourcesModelTotalViewsCountArgs = {
  deviceType?: Maybe<DeviceTypeEnum>;
};


/** analytics model specifically for resources */
export type AnalyticsResourcesModelUsersViewedResourceCountArgs = {
  deviceType?: Maybe<DeviceTypeEnum>;
};


/** analytics model specifically for resources */
export type AnalyticsResourcesModelTopicViewsByTimeUnitArgs = {
  unit: TimeUnitEnum;
};


/** analytics model specifically for resources */
export type AnalyticsResourcesModelResourceActivityOverviewArgs = {
  overviewFilter: AnalyticsResourceActivityFilter;
};


/** analytics model specifically for resources */
export type AnalyticsResourcesModelResourceActivityOverviewCountArgs = {
  overviewFilter: AnalyticsResourceActivityFilter;
};


/** analytics model specifically for resources */
export type AnalyticsResourcesModelVersionsOverviewArgs = {
  overviewTableFilter?: Maybe<AnalyticsResourceVersionsOverviewFilter>;
};

/** analytics model specifically for SCORM resources */
export type AnalyticsScormModel = {
  __typename?: 'AnalyticsSCORMModel';
  /** aggregated data for SCORM quiz */
  resourcesAggregatedQuizResults?: Maybe<Scalars['JSON']>;
};


/** analytics model specifically for SCORM resources */
export type AnalyticsScormModelResourcesAggregatedQuizResultsArgs = {
  overviewFilter?: Maybe<AnalyticsScormResourcesFilter>;
};

export type AnalyticsScormResourcesFilter = {
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  topicId?: Maybe<Scalars['PositiveInt']>;
};

export type AnalyticsSearchFilter = {
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['PositiveInt']>;
  orderColumn?: Maybe<SearchOverviewOrderColumn>;
  resultSelect?: Maybe<SearchOverviewResultSelectEnum>;
};

/** analytics model specifically for search page */
export type AnalyticsSearchModel = {
  __typename?: 'AnalyticsSearchModel';
  /** data for main analytics search table */
  searchOverview: Array<AnalyticsSearchOverviewModel>;
  /** total search items for pagination */
  searchOverviewCount: Scalars['NonNegativeInt'];
  /** used for charting the graphs on Search tab */
  searchByTimeUnit: Array<AnalyticsHitCountByTimeUnit>;
  /** used for charting the graphs on Search tab - with no result filter */
  searchNoResultsByTimeUnit: Array<AnalyticsHitCountByTimeUnit>;
  /** stats - Total searches */
  searchesCount?: Maybe<Scalars['NonNegativeInt']>;
  /** stats - People searching */
  uniqueUsersWhoUsedSearchCount?: Maybe<Scalars['NonNegativeInt']>;
};


/** analytics model specifically for search page */
export type AnalyticsSearchModelSearchOverviewArgs = {
  overviewTableFilter?: Maybe<AnalyticsSearchFilter>;
};


/** analytics model specifically for search page */
export type AnalyticsSearchModelSearchOverviewCountArgs = {
  overviewTableFilter?: Maybe<AnalyticsSearchFilter>;
};


/** analytics model specifically for search page */
export type AnalyticsSearchModelSearchByTimeUnitArgs = {
  unit: TimeUnitEnum;
};


/** analytics model specifically for search page */
export type AnalyticsSearchModelSearchNoResultsByTimeUnitArgs = {
  unit: TimeUnitEnum;
  resultSelect: SearchOverviewResultSelectEnum;
};


/** analytics model specifically for search page */
export type AnalyticsSearchModelSearchesCountArgs = {
  filters?: Maybe<Array<FilterDescriptor>>;
};

export type AnalyticsSearchOverviewModel = {
  __typename?: 'AnalyticsSearchOverviewModel';
  search_term?: Maybe<Scalars['String']>;
  avg_results?: Maybe<Scalars['NonNegativeFloat']>;
  count?: Maybe<Scalars['NonNegativeInt']>;
  last_searched?: Maybe<Scalars['DateTime']>;
};

export type AnalyticsSingleCertificationModelAsAdmin = {
  __typename?: 'AnalyticsSingleCertificationModelAsAdmin';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  template_id?: Maybe<Scalars['PositiveInt']>;
  created_by?: Maybe<Scalars['PositiveInt']>;
  locked_at?: Maybe<Scalars['DateTime']>;
  months_of_validity?: Maybe<Scalars['PositiveInt']>;
  items: Array<CertificationItemModelAsAdmin>;
  users: Array<UserModelPublicBase>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  /** Archives multiple certification enrolments. Returns count of processed items. */
  batchArchiveEnrolments?: Maybe<Scalars['NonNegativeInt']>;
  certificateTemplate?: Maybe<CertificateTemplateModel>;
  author?: Maybe<UserModel>;
  itemsCount: Scalars['NonNegativeInt'];
  /** finds a single item by the idColumn of the relation */
  item?: Maybe<CertificationItemModelAsAdmin>;
  organisation: OrganisationModelAsAdminMutations;
  remove?: Maybe<CertificationModelAsAdmin>;
  patch?: Maybe<CertificationModelAsAdmin>;
  shareWithGroups?: Maybe<Scalars['Boolean']>;
  isSharingCompleted: Scalars['Boolean'];
  shareWithUsers?: Maybe<Scalars['Boolean']>;
  addUser?: Maybe<CertificationModelAsAdmin>;
  removeUser?: Maybe<CertificationModelAsAdmin>;
  addItems?: Maybe<CertificationModelAsAdmin>;
  moveItemDown?: Maybe<CertificationModelAsAdmin>;
  moveItemUp?: Maybe<CertificationModelAsAdmin>;
  removeItem?: Maybe<CertificationModelAsAdmin>;
  relatedCampaigns?: Maybe<Array<CampaignModel>>;
  usersCount: Scalars['NonNegativeInt'];
  /** finds a single user by the idColumn of the relation */
  user?: Maybe<UserModelPublicBase>;
  enrolments: Array<CertificationEnrolmentModelAsAdmin>;
  enrolmentsCount: Scalars['NonNegativeInt'];
  /** finds a single enrolment by the idColumn of the relation */
  enrolment?: Maybe<CertificationEnrolmentModelAsAdmin>;
  completedEnrolments: Array<CertificationEnrolmentModel>;
  completedEnrolmentsCount: Scalars['NonNegativeInt'];
  /** finds a single completedEnrolment by the idColumn of the relation */
  completedEnrolment?: Maybe<CertificationEnrolmentModel>;
  inProgressEnrolments: Array<CertificationEnrolmentModel>;
  inProgressEnrolmentsCount: Scalars['NonNegativeInt'];
  /** finds a single inProgressEnrolment by the idColumn of the relation */
  inProgressEnrolment?: Maybe<CertificationEnrolmentModel>;
  shares: Array<CertificationShareModel>;
  sharesCount: Scalars['NonNegativeInt'];
  /** finds a single share by the idColumn of the relation */
  share?: Maybe<CertificationShareModel>;
  completed_count?: Maybe<Scalars['NonNegativeInt']>;
  in_progress_count?: Maybe<Scalars['NonNegativeInt']>;
  shared_count?: Maybe<Scalars['NonNegativeInt']>;
};


export type AnalyticsSingleCertificationModelAsAdminItemsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type AnalyticsSingleCertificationModelAsAdminUsersArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type AnalyticsSingleCertificationModelAsAdminBatchArchiveEnrolmentsArgs = {
  enrolmentIds: Array<Scalars['PositiveInt']>;
};


export type AnalyticsSingleCertificationModelAsAdminItemsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type AnalyticsSingleCertificationModelAsAdminItemArgs = {
  id: Scalars['PositiveInt'];
};


export type AnalyticsSingleCertificationModelAsAdminPatchArgs = {
  data: CertificationModelAsAdminInput;
};


export type AnalyticsSingleCertificationModelAsAdminShareWithGroupsArgs = {
  groupIds: Array<Scalars['PositiveInt']>;
  targetDate?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  sendEmail: Scalars['Boolean'];
  resetEnrolments: Scalars['Boolean'];
  emailIdentityId?: Maybe<Scalars['PositiveInt']>;
};


export type AnalyticsSingleCertificationModelAsAdminShareWithUsersArgs = {
  userIds: Array<Scalars['PositiveInt']>;
  targetDate?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  sendEmail: Scalars['Boolean'];
  resetEnrolments: Scalars['Boolean'];
  emailIdentityId?: Maybe<Scalars['PositiveInt']>;
};


export type AnalyticsSingleCertificationModelAsAdminAddUserArgs = {
  userId: Scalars['PositiveInt'];
};


export type AnalyticsSingleCertificationModelAsAdminRemoveUserArgs = {
  userId: Scalars['PositiveInt'];
};


export type AnalyticsSingleCertificationModelAsAdminAddItemsArgs = {
  itemIds: Array<Scalars['PositiveInt']>;
  itemType: CertificationItemTypes;
};


export type AnalyticsSingleCertificationModelAsAdminMoveItemDownArgs = {
  itemId: Scalars['PositiveInt'];
};


export type AnalyticsSingleCertificationModelAsAdminMoveItemUpArgs = {
  itemId: Scalars['PositiveInt'];
};


export type AnalyticsSingleCertificationModelAsAdminRemoveItemArgs = {
  itemId: Scalars['PositiveInt'];
};


export type AnalyticsSingleCertificationModelAsAdminUsersCountArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
};


export type AnalyticsSingleCertificationModelAsAdminUserArgs = {
  id: Scalars['PositiveInt'];
};


export type AnalyticsSingleCertificationModelAsAdminEnrolmentsArgs = {
  filters?: Maybe<Array<CertificationEnrolmentModelAsAdminFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type AnalyticsSingleCertificationModelAsAdminEnrolmentsCountArgs = {
  filters?: Maybe<Array<CertificationEnrolmentModelAsAdminFilterInput>>;
};


export type AnalyticsSingleCertificationModelAsAdminEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};


export type AnalyticsSingleCertificationModelAsAdminCompletedEnrolmentsArgs = {
  filters?: Maybe<Array<CertificationEnrolmentModelAsAdminFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type AnalyticsSingleCertificationModelAsAdminCompletedEnrolmentsCountArgs = {
  filters?: Maybe<Array<CertificationEnrolmentModelAsAdminFilterInput>>;
};


export type AnalyticsSingleCertificationModelAsAdminCompletedEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};


export type AnalyticsSingleCertificationModelAsAdminInProgressEnrolmentsArgs = {
  filters?: Maybe<Array<CertificationEnrolmentModelAsAdminFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type AnalyticsSingleCertificationModelAsAdminInProgressEnrolmentsCountArgs = {
  filters?: Maybe<Array<CertificationEnrolmentModelAsAdminFilterInput>>;
};


export type AnalyticsSingleCertificationModelAsAdminInProgressEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};


export type AnalyticsSingleCertificationModelAsAdminSharesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type AnalyticsSingleCertificationModelAsAdminSharesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type AnalyticsSingleCertificationModelAsAdminShareArgs = {
  id: Scalars['PositiveInt'];
};

export type AnalyticsSurveyUsersFilter = {
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['PositiveInt']>;
  orderColumn?: Maybe<SurveyUsersOverviewOrderColumn>;
};

/** analytics model specifically for surveys */
export type AnalyticsSurveysModel = {
  __typename?: 'AnalyticsSurveysModel';
  /** data for main analytics survey users overview table */
  surveyUsersOverview: Array<SurveyUserModel>;
  /** total survey users items for pagination */
  surveyUsersOverviewCount: Scalars['NonNegativeInt'];
  /** returns count of completed surveys in given date range */
  completedCount: Scalars['NonNegativeInt'];
};


/** analytics model specifically for surveys */
export type AnalyticsSurveysModelSurveyUsersOverviewArgs = {
  overviewFilter?: Maybe<AnalyticsSurveyUsersFilter>;
};


/** analytics model specifically for surveys */
export type AnalyticsSurveysModelSurveyUsersOverviewCountArgs = {
  overviewFilter?: Maybe<AnalyticsSurveyUsersFilter>;
};

export type AnalyticsUserActivityFilter = {
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  orderColumn?: Maybe<UserActivityOverviewOrderColumn>;
  userId: Scalars['PositiveInt'];
};

export type AnalyticsUserActivityModel = {
  __typename?: 'AnalyticsUserActivityModel';
  lastViewedAt?: Maybe<Scalars['DateTime']>;
  resourceName?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['PositiveInt']>;
  viewsCount?: Maybe<Scalars['NonNegativeInt']>;
  is_archived?: Maybe<Scalars['Boolean']>;
};

export type AnalyticsUserEventsFilter = {
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['PositiveInt']>;
  orderColumn?: Maybe<UserEventsOverviewOrderColumn>;
};

export type AnalyticsViewCountByUserModel = {
  __typename?: 'AnalyticsViewCountByUserModel';
  user: UserModel;
  resourceViewsCount?: Maybe<Scalars['NonNegativeInt']>;
  pathwayEnrolmentsCount?: Maybe<Scalars['NonNegativeInt']>;
  attendedEventsCount?: Maybe<Scalars['NonNegativeInt']>;
  workbooksCount?: Maybe<Scalars['NonNegativeInt']>;
  surveysCount?: Maybe<Scalars['NonNegativeInt']>;
  certificationEnrolmentsCount?: Maybe<Scalars['NonNegativeInt']>;
};

export type AnalyticsViewsCountByTopicModel = {
  __typename?: 'AnalyticsViewsCountByTopicModel';
  topic: TopicModelAsEditor;
  viewsCount?: Maybe<Scalars['NonNegativeInt']>;
  passRate?: Maybe<Scalars['NonNegativeInt']>;
};

export type AnalyticsWorkbooksFilter = {
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  orderColumn?: Maybe<WorkbooksOverviewOrderColumn>;
  assigned?: Maybe<WorkbookAssignedFilterEnum>;
  completed?: Maybe<WorkbookCompletedFilterEnum>;
  resourceId?: Maybe<Scalars['PositiveInt']>;
  workbookId?: Maybe<Scalars['PositiveInt']>;
  updatedAfter?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['PositiveInt']>;
};

/** analytics model specifically for workbooks (topic enrolments) */
export type AnalyticsWorkbooksModel = {
  __typename?: 'AnalyticsWorkbooksModel';
  /** returns list of topic enrolments fulfilling given filters */
  workbooksOverview: Array<AnalyticsWorkbooksOverviewModel>;
  /** returns count of workbooks related to given filters */
  workbooksCount: Scalars['NonNegativeInt'];
  /** Count of completed workbooks in given date range */
  completedCount: Scalars['NonNegativeInt'];
  /** Count of workbooks in progress in given date range */
  inProgressCount: Scalars['NonNegativeInt'];
  /** Count of workbooks that did not start yet in given date range */
  notStartedCount: Scalars['NonNegativeInt'];
  topicEnrolment?: Maybe<TopicEnrolmentModelAsEditor>;
  /** Count of workbooks that are already overdue in given date range */
  overdueCount: Scalars['NonNegativeInt'];
  passedWorkbooksInPercents?: Maybe<Scalars['NonNegativeFloat']>;
};


/** analytics model specifically for workbooks (topic enrolments) */
export type AnalyticsWorkbooksModelWorkbooksOverviewArgs = {
  overviewTableFilter?: Maybe<AnalyticsWorkbooksFilter>;
};


/** analytics model specifically for workbooks (topic enrolments) */
export type AnalyticsWorkbooksModelWorkbooksCountArgs = {
  overviewTableFilter?: Maybe<AnalyticsWorkbooksFilter>;
};


/** analytics model specifically for workbooks (topic enrolments) */
export type AnalyticsWorkbooksModelTopicEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};

export type AnalyticsWorkbooksOverviewModel = {
  __typename?: 'AnalyticsWorkbooksOverviewModel';
  enrolment: TopicEnrolmentModelAsEditor;
  resourceName?: Maybe<Scalars['String']>;
};

export type AppEventModel = {
  __typename?: 'AppEventModel';
  id: Scalars['PositiveInt'];
  timestamp: Scalars['DateTime'];
  origin: Scalars['String'];
  /** user who made the operation */
  user_id?: Maybe<Scalars['PositiveInt']>;
  /** user session from which the call was made */
  session_id?: Maybe<Scalars['PositiveInt']>;
  /** id of a database entity/model instance */
  entity_id?: Maybe<Scalars['PositiveInt']>;
  model: Scalars['String'];
  model_table: Scalars['String'];
  /** which GQL field/Model method generated this app event */
  field: Scalars['String'];
  /** arguments used for the call */
  args?: Maybe<Scalars['JSON']>;
};

export type ArchiveWorkspaceResult = {
  __typename?: 'ArchiveWorkspaceResult';
  pathwayVersionsAffected?: Maybe<Scalars['NonNegativeInt']>;
  campaignsDeactivated?: Maybe<Scalars['NonNegativeInt']>;
};

export type AssignTopicsInput = {
  topicIds: Array<Scalars['PositiveInt']>;
  userIds: Array<Scalars['PositiveInt']>;
  groupIds: Array<Scalars['PositiveInt']>;
  forceNewEnrolment: Scalars['Boolean'];
  targetCompletionDate?: Maybe<Scalars['DateTime']>;
  customEmailBody?: Maybe<Scalars['String']>;
  emailIdentityId?: Maybe<Scalars['PositiveInt']>;
  sendEmail?: Maybe<Scalars['Boolean']>;
  disableNotification?: Maybe<Scalars['Boolean']>;
};

export type AvailableForLoginResponse = {
  __typename?: 'AvailableForLoginResponse';
  status?: Maybe<UserStateResponseEnum>;
  email?: Maybe<Scalars['String']>;
};

export type BannerEvent = {
  __typename?: 'BannerEvent';
  shown?: Maybe<Scalars['DateTime']>;
  clicked?: Maybe<Scalars['DateTime']>;
};

export enum BillingStatusType {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED'
}

export type BusinessHoursByDays = {
  __typename?: 'BusinessHoursByDays';
  sunday?: Maybe<Array<Scalars['String']>>;
  monday?: Maybe<Array<Scalars['String']>>;
  tuesday?: Maybe<Array<Scalars['String']>>;
  wednesday?: Maybe<Array<Scalars['String']>>;
  thursday?: Maybe<Array<Scalars['String']>>;
  friday?: Maybe<Array<Scalars['String']>>;
  saturday?: Maybe<Array<Scalars['String']>>;
};

export type BusinessHoursByDaysInput = {
  sunday?: Maybe<Array<Scalars['String']>>;
  monday?: Maybe<Array<Scalars['String']>>;
  tuesday?: Maybe<Array<Scalars['String']>>;
  wednesday?: Maybe<Array<Scalars['String']>>;
  thursday?: Maybe<Array<Scalars['String']>>;
  friday?: Maybe<Array<Scalars['String']>>;
  saturday?: Maybe<Array<Scalars['String']>>;
};

export type CpdData = {
  __typename?: 'CPDData';
  enabled?: Maybe<Scalars['Boolean']>;
  switched_on?: Maybe<Scalars['Boolean']>;
};

export type CpdManualEntryModel = {
  __typename?: 'CPDManualEntryModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  edited_by: Scalars['PositiveInt'];
  name: Scalars['String'];
  description: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  number_of_minutes: Scalars['PositiveInt'];
  date_started?: Maybe<Scalars['Date']>;
  date_completed?: Maybe<Scalars['Date']>;
  document_cdn_url?: Maybe<Scalars['String']>;
  numberOfSeconds: Scalars['NonNegativeInt'];
  patch?: Maybe<CpdManualEntryModel>;
  delete?: Maybe<Scalars['NonNegativeInt']>;
  fileName?: Maybe<Scalars['String']>;
};


export type CpdManualEntryModelPatchArgs = {
  input: CpdManualEntryModelInput;
};

export enum CpdManualEntryModelFilterEnum {
  dateStartedBetween = 'dateStartedBetween'
}

export type CpdManualEntryModelFilterInput = {
  name: CpdManualEntryModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type CpdManualEntryModelInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  number_of_minutes?: Maybe<Scalars['PositiveInt']>;
  date_started?: Maybe<Scalars['Date']>;
  date_completed?: Maybe<Scalars['Date']>;
  document_cdn_url?: Maybe<Scalars['String']>;
};

export type CpdUserEntryModel = {
  __typename?: 'CPDUserEntryModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
};

export type CampaignActionBaseModel = {
  __typename?: 'CampaignActionBaseModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  respect_business_hours: Scalars['Boolean'];
  /** Time of day when the campaign action is supposed to go out. It is used as a mere fallback when automatic_time_of_day flag is enabled. */
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  /** when enabled looop will determine the best time of day to send the action to each user based user's history of interaction with the platform. In that case send_at_time is only used as a fallback for new users */
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  text?: Maybe<Scalars['String']>;
};

export type CampaignActionCertificationModel = {
  __typename?: 'CampaignActionCertificationModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_certification_share_action_id: Scalars['PositiveInt'];
  certification_id: Scalars['PositiveInt'];
  campaignCertificationShareAction: CampaignCertificationShareActionModel;
  certification: CertificationModelAsAdmin;
};

export type CampaignActionPathwayModel = {
  __typename?: 'CampaignActionPathwayModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_pathway_share_action_id: Scalars['PositiveInt'];
  pathway_id: Scalars['PositiveInt'];
  campaignPathwayShareAction: CampaignPathwayShareActionModel;
  pathway: PathwayModelAsAdmin;
  pathwayEnrolment: PathwayEnrolmentModel;
};

export type CampaignActionSurveyModel = {
  __typename?: 'CampaignActionSurveyModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_survey_share_action_id: Scalars['PositiveInt'];
  survey_id: Scalars['PositiveInt'];
  campaignSurveyShareAction: CampaignSurveyShareActionModel;
  survey: SurveyModel;
};

export type CampaignActionTopicModel = {
  __typename?: 'CampaignActionTopicModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_topic_share_action_id: Scalars['PositiveInt'];
  topic_id: Scalars['PositiveInt'];
  campaignTopicShareAction: CampaignTopicShareActionModel;
  topic: TopicModelAsEditor;
};

export type CampaignAnalyticEventModel = {
  __typename?: 'CampaignAnalyticEventModel';
  campaign_id?: Maybe<Scalars['PositiveInt']>;
  user_id?: Maybe<Scalars['PositiveInt']>;
  campaign_email_id?: Maybe<Scalars['PositiveInt']>;
  campaign_banner_id?: Maybe<Scalars['PositiveInt']>;
  campaign_action_topic_id?: Maybe<Scalars['PositiveInt']>;
  campaign_action_pathway_id?: Maybe<Scalars['PositiveInt']>;
  campaign_action_survey_id?: Maybe<Scalars['PositiveInt']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  type?: Maybe<CampaignAnalyticEventTypeEnum>;
  notification_processed_id?: Maybe<Scalars['PositiveInt']>;
  notification_id?: Maybe<Scalars['PositiveInt']>;
};

export enum CampaignAnalyticEventModelFilterEnum {
  omitActivationEvents = 'omitActivationEvents'
}

export type CampaignAnalyticEventModelFilterInput = {
  name: CampaignAnalyticEventModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export enum CampaignAnalyticEventTypeEnum {
  CAMPAIGN_ACTIVATED = 'CAMPAIGN_ACTIVATED',
  CAMPAIGN_DEACTIVATED = 'CAMPAIGN_DEACTIVATED',
  CAMPAIGN_DEACTIVATED_AUTO = 'CAMPAIGN_DEACTIVATED_AUTO',
  BANNER_SHOWN = 'BANNER_SHOWN',
  BANNER_CLICKED = 'BANNER_CLICKED',
  EMAIL_LINK_CLICKED = 'EMAIL_LINK_CLICKED',
  TOPIC_SHARE_LINK_CLICKED = 'TOPIC_SHARE_LINK_CLICKED',
  PATHWAY_SHARE_LINK_CLICKED = 'PATHWAY_SHARE_LINK_CLICKED',
  SURVEY_SHARE_LINK_CLICKED = 'SURVEY_SHARE_LINK_CLICKED'
}

/** represents an outcome of a campaign audience check */
export type CampaignAudienceCheckResult = {
  __typename?: 'CampaignAudienceCheckResult';
  joinCount?: Maybe<Scalars['NonNegativeInt']>;
  joinUsers: Array<UserModelPublicBase>;
  leaveCount?: Maybe<Scalars['NonNegativeInt']>;
  leaveUsers: Array<UserModelPublicBase>;
  campaignId?: Maybe<Scalars['PositiveInt']>;
};

export enum CampaignAudienceTableOrderColumn {
  display_name = 'display_name',
  last_join_timestamp = 'last_join_timestamp'
}

export type CampaignBannerInput = {
  header?: Maybe<Scalars['LengthValidatedString_255']>;
  text?: Maybe<Scalars['String']>;
  button_caption?: Maybe<Scalars['String']>;
  button_link?: Maybe<Scalars['String']>;
  fixed_show_time_start?: Maybe<Scalars['DateTime']>;
  fixed_show_time_end?: Maybe<Scalars['DateTime']>;
  show_at_day?: Maybe<Scalars['NonNegativeInt']>;
  show_at_time?: Maybe<Scalars['LocalTime']>;
  hide_at_day?: Maybe<Scalars['NonNegativeInt']>;
  hide_at_time?: Maybe<Scalars['LocalTime']>;
  timezone?: Maybe<Scalars['String']>;
};

export type CampaignBannerModel = {
  __typename?: 'CampaignBannerModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  header: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  button_caption: Scalars['String'];
  button_link: Scalars['String'];
  fixed_show_time_start?: Maybe<Scalars['DateTime']>;
  fixed_show_time_end?: Maybe<Scalars['DateTime']>;
  show_at_day?: Maybe<Scalars['NonNegativeInt']>;
  show_at_time?: Maybe<Scalars['LocalTime']>;
  hide_at_day?: Maybe<Scalars['NonNegativeInt']>;
  hide_at_time?: Maybe<Scalars['LocalTime']>;
  /** a timezone string identifier compatible with https://momentjs.com/timezone/docs/ */
  timezone?: Maybe<Scalars['String']>;
  archived_at?: Maybe<Scalars['DateTime']>;
  showFrom?: Maybe<Scalars['String']>;
  hideFrom?: Maybe<Scalars['String']>;
  /** looop react app should call it when the banner is viewed or clicked */
  captureAnalyticEvent?: Maybe<CampaignAnalyticEventModel>;
  campaign: CampaignModel;
  image?: Maybe<DocumentModel>;
  views?: Maybe<CampaignAnalyticEventModel>;
  clicks?: Maybe<CampaignAnalyticEventModel>;
  scheduledActions: Array<ScheduledCampaignActionModel>;
  scheduledActionsCount: Scalars['NonNegativeInt'];
  /** finds a single scheduledAction by the idColumn of the relation */
  scheduledAction?: Maybe<ScheduledCampaignActionModel>;
};


export type CampaignBannerModelCaptureAnalyticEventArgs = {
  eventType: CampaignAnalyticEventTypeEnum;
  timestamp: Scalars['DateTime'];
};


export type CampaignBannerModelScheduledActionsArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignBannerModelScheduledActionsCountArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
};


export type CampaignBannerModelScheduledActionArgs = {
  id: Scalars['PositiveInt'];
};

export type CampaignBannerModelAsEditor = {
  __typename?: 'CampaignBannerModelAsEditor';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  header: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  button_caption: Scalars['String'];
  button_link: Scalars['String'];
  fixed_show_time_start?: Maybe<Scalars['DateTime']>;
  fixed_show_time_end?: Maybe<Scalars['DateTime']>;
  show_at_day?: Maybe<Scalars['NonNegativeInt']>;
  show_at_time?: Maybe<Scalars['LocalTime']>;
  hide_at_day?: Maybe<Scalars['NonNegativeInt']>;
  hide_at_time?: Maybe<Scalars['LocalTime']>;
  /** a timezone string identifier compatible with https://momentjs.com/timezone/docs/ */
  timezone?: Maybe<Scalars['String']>;
  archived_at?: Maybe<Scalars['DateTime']>;
  showFrom?: Maybe<Scalars['String']>;
  hideFrom?: Maybe<Scalars['String']>;
  /** looop react app should call it when the banner is viewed or clicked */
  captureAnalyticEvent?: Maybe<CampaignAnalyticEventModel>;
  campaign: CampaignModel;
  image?: Maybe<DocumentModel>;
  views?: Maybe<CampaignAnalyticEventModel>;
  clicks?: Maybe<CampaignAnalyticEventModel>;
  scheduledActions: Array<ScheduledCampaignActionModel>;
  scheduledActionsCount: Scalars['NonNegativeInt'];
  /** finds a single scheduledAction by the idColumn of the relation */
  scheduledAction?: Maybe<ScheduledCampaignActionModel>;
  patch?: Maybe<CampaignBannerModel>;
  delete?: Maybe<Scalars['NonNegativeInt']>;
  copy: Scalars['Boolean'];
  uniqueViewCount?: Maybe<Scalars['NonNegativeInt']>;
  uniqueClickCount?: Maybe<Scalars['NonNegativeInt']>;
  effectiveness?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignBannerModelAsEditorCaptureAnalyticEventArgs = {
  eventType: CampaignAnalyticEventTypeEnum;
  timestamp: Scalars['DateTime'];
};


export type CampaignBannerModelAsEditorScheduledActionsArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignBannerModelAsEditorScheduledActionsCountArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
};


export type CampaignBannerModelAsEditorScheduledActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignBannerModelAsEditorPatchArgs = {
  input: CampaignBannerInput;
};

export type CampaignCertificationShareActionInput = {
  text?: Maybe<Scalars['SizeValidatedString_100KB']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  respect_business_hours?: Maybe<Scalars['Boolean']>;
  email_identity_id?: Maybe<Scalars['PositiveInt']>;
  timezone?: Maybe<Scalars['String']>;
  reset_existing_enrolments: Scalars['Boolean'];
  send_share_email: Scalars['Boolean'];
  target_completion_date?: Maybe<Scalars['DateTime']>;
  relative_target_completion_time?: Maybe<Scalars['String']>;
  relative_target_completion_day?: Maybe<Scalars['NonNegativeInt']>;
  actionCertifications: Array<Scalars['PositiveInt']>;
};

export type CampaignCertificationShareActionModel = {
  __typename?: 'CampaignCertificationShareActionModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  respect_business_hours: Scalars['Boolean'];
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  /** when enabled looop will determine the best time of day to send the action to each user based user's history of interaction with the platform. In that case send_at_time is only used as a fallback for new users */
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  text?: Maybe<Scalars['String']>;
  relative_target_completion_day?: Maybe<Scalars['NonNegativeInt']>;
  relative_target_completion_time?: Maybe<Scalars['String']>;
  target_completion_date?: Maybe<Scalars['DateTime']>;
  effectiveness?: Maybe<Scalars['NonNegativeInt']>;
  timezone?: Maybe<Scalars['String']>;
  reset_existing_enrolments?: Maybe<Scalars['Boolean']>;
  send_share_email?: Maybe<Scalars['Boolean']>;
  email_identity_id?: Maybe<Scalars['PositiveInt']>;
  campaign: CampaignModel;
  scheduledActions: Array<ScheduledCampaignActionModel>;
  scheduledActionsCount: Scalars['NonNegativeInt'];
  /** finds a single scheduledAction by the idColumn of the relation */
  scheduledAction?: Maybe<ScheduledCampaignActionModel>;
  actionCertifications: Array<CampaignActionCertificationModel>;
  actionCertificationsCount: Scalars['NonNegativeInt'];
  /** finds a single actionCertification by the idColumn of the relation */
  actionCertification?: Maybe<CampaignActionCertificationModel>;
  trackedLinks: Array<TrackedLinkAsStudent>;
  trackedLinksCount: Scalars['NonNegativeInt'];
  /** finds a single trackedLink by the idColumn of the relation */
  trackedLink?: Maybe<TrackedLinkAsStudent>;
  emailIdentity?: Maybe<EmailIdentityModel>;
};


export type CampaignCertificationShareActionModelScheduledActionsArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignCertificationShareActionModelScheduledActionsCountArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
};


export type CampaignCertificationShareActionModelScheduledActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignCertificationShareActionModelActionCertificationsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignCertificationShareActionModelActionCertificationsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignCertificationShareActionModelActionCertificationArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignCertificationShareActionModelTrackedLinksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignCertificationShareActionModelTrackedLinksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignCertificationShareActionModelTrackedLinkArgs = {
  id: Scalars['PositiveInt'];
};

export type CampaignCertificationShareActionModelAsEditor = {
  __typename?: 'CampaignCertificationShareActionModelAsEditor';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  respect_business_hours: Scalars['Boolean'];
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  /** when enabled looop will determine the best time of day to send the action to each user based user's history of interaction with the platform. In that case send_at_time is only used as a fallback for new users */
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  text?: Maybe<Scalars['String']>;
  relative_target_completion_day?: Maybe<Scalars['NonNegativeInt']>;
  relative_target_completion_time?: Maybe<Scalars['String']>;
  target_completion_date?: Maybe<Scalars['DateTime']>;
  effectiveness?: Maybe<Scalars['NonNegativeInt']>;
  timezone?: Maybe<Scalars['String']>;
  reset_existing_enrolments?: Maybe<Scalars['Boolean']>;
  send_share_email?: Maybe<Scalars['Boolean']>;
  email_identity_id?: Maybe<Scalars['PositiveInt']>;
  campaign: CampaignModel;
  scheduledActions: Array<ScheduledCampaignActionModel>;
  scheduledActionsCount: Scalars['NonNegativeInt'];
  /** finds a single scheduledAction by the idColumn of the relation */
  scheduledAction?: Maybe<ScheduledCampaignActionModel>;
  actionCertifications: Array<CampaignActionCertificationModel>;
  actionCertificationsCount: Scalars['NonNegativeInt'];
  /** finds a single actionCertification by the idColumn of the relation */
  actionCertification?: Maybe<CampaignActionCertificationModel>;
  trackedLinks: Array<TrackedLinkAsStudent>;
  trackedLinksCount: Scalars['NonNegativeInt'];
  /** finds a single trackedLink by the idColumn of the relation */
  trackedLink?: Maybe<TrackedLinkAsStudent>;
  emailIdentity?: Maybe<EmailIdentityModel>;
  patch: CampaignPathwayShareActionModel;
  delete: Scalars['NonNegativeInt'];
  copy: Scalars['Boolean'];
  sharedCount: Scalars['NonNegativeInt'];
  completedCount: Scalars['NonNegativeInt'];
};


export type CampaignCertificationShareActionModelAsEditorScheduledActionsArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignCertificationShareActionModelAsEditorScheduledActionsCountArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
};


export type CampaignCertificationShareActionModelAsEditorScheduledActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignCertificationShareActionModelAsEditorActionCertificationsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignCertificationShareActionModelAsEditorActionCertificationsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignCertificationShareActionModelAsEditorActionCertificationArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignCertificationShareActionModelAsEditorTrackedLinksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignCertificationShareActionModelAsEditorTrackedLinksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignCertificationShareActionModelAsEditorTrackedLinkArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignCertificationShareActionModelAsEditorPatchArgs = {
  input: CampaignCertificationShareActionInput;
};

export type CampaignEmailActionInput = {
  text?: Maybe<Scalars['SizeValidatedString_100KB']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  respect_business_hours?: Maybe<Scalars['Boolean']>;
  email_identity_id?: Maybe<Scalars['PositiveInt']>;
  subject: Scalars['String'];
  button_caption?: Maybe<Scalars['String']>;
  button_link?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['JSON']>;
  is_for_manager?: Maybe<Scalars['Boolean']>;
};

export type CampaignEmailActionModel = {
  __typename?: 'CampaignEmailActionModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  respect_business_hours: Scalars['Boolean'];
  /** Time of day when the campaign action is supposed to go out. It is used as a mere fallback when automatic_time_of_day flag is enabled. */
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  /** when enabled looop will determine the best time of day to send the action to each user based user's history of interaction with the platform. In that case send_at_time is only used as a fallback for new users */
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  text?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  is_for_manager: Scalars['Boolean'];
  archived_at?: Maybe<Scalars['DateTime']>;
  image?: Maybe<ImageWithVariants>;
  name?: Maybe<Scalars['String']>;
  button_caption?: Maybe<Scalars['String']>;
  button_link?: Maybe<Scalars['String']>;
  email_identity_id?: Maybe<Scalars['PositiveInt']>;
};

export type CampaignEmailActionModelAsEditor = {
  __typename?: 'CampaignEmailActionModelAsEditor';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  respect_business_hours: Scalars['Boolean'];
  /** Time of day when the campaign action is supposed to go out. It is used as a mere fallback when automatic_time_of_day flag is enabled. */
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  /** when enabled looop will determine the best time of day to send the action to each user based user's history of interaction with the platform. In that case send_at_time is only used as a fallback for new users */
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  text?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  is_for_manager: Scalars['Boolean'];
  archived_at?: Maybe<Scalars['DateTime']>;
  image?: Maybe<ImageWithVariants>;
  name?: Maybe<Scalars['String']>;
  button_caption?: Maybe<Scalars['String']>;
  button_link?: Maybe<Scalars['String']>;
  email_identity_id?: Maybe<Scalars['PositiveInt']>;
  patch?: Maybe<CampaignEmailActionModel>;
  delete?: Maybe<Scalars['NonNegativeInt']>;
  copy: Scalars['Boolean'];
  sentCount?: Maybe<Scalars['NonNegativeInt']>;
  uniqueClickCount?: Maybe<Scalars['NonNegativeInt']>;
  viewCount?: Maybe<Scalars['NonNegativeInt']>;
  effectiveness?: Maybe<Scalars['NonNegativeInt']>;
  campaign: CampaignModel;
  campaignAnalyticEvents: Array<CampaignAnalyticEventModel>;
  campaignAnalyticEventsCount: Scalars['NonNegativeInt'];
  /** finds a single campaignAnalyticEvent by the idColumn of the relation */
  campaignAnalyticEvent?: Maybe<CampaignAnalyticEventModel>;
  scheduledActions: Array<ScheduledCampaignActionModel>;
  scheduledActionsCount: Scalars['NonNegativeInt'];
  /** finds a single scheduledAction by the idColumn of the relation */
  scheduledAction?: Maybe<ScheduledCampaignActionModel>;
  clicks: Array<CampaignAnalyticEventModel>;
  clicksCount: Scalars['NonNegativeInt'];
  /** finds a single click by the idColumn of the relation */
  click?: Maybe<CampaignAnalyticEventModel>;
  trackedLinks: Array<TrackedLinkAsStudent>;
  trackedLinksCount: Scalars['NonNegativeInt'];
  /** finds a single trackedLink by the idColumn of the relation */
  trackedLink?: Maybe<TrackedLinkAsStudent>;
  emailIdentity?: Maybe<EmailIdentityModel>;
};


export type CampaignEmailActionModelAsEditorPatchArgs = {
  input: CampaignEmailActionInput;
};


export type CampaignEmailActionModelAsEditorCampaignAnalyticEventsArgs = {
  filters?: Maybe<Array<CampaignAnalyticEventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignEmailActionModelAsEditorCampaignAnalyticEventsCountArgs = {
  filters?: Maybe<Array<CampaignAnalyticEventModelFilterInput>>;
};


export type CampaignEmailActionModelAsEditorCampaignAnalyticEventArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignEmailActionModelAsEditorScheduledActionsArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignEmailActionModelAsEditorScheduledActionsCountArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
};


export type CampaignEmailActionModelAsEditorScheduledActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignEmailActionModelAsEditorClicksArgs = {
  filters?: Maybe<Array<CampaignAnalyticEventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignEmailActionModelAsEditorClicksCountArgs = {
  filters?: Maybe<Array<CampaignAnalyticEventModelFilterInput>>;
};


export type CampaignEmailActionModelAsEditorClickArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignEmailActionModelAsEditorTrackedLinksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignEmailActionModelAsEditorTrackedLinksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignEmailActionModelAsEditorTrackedLinkArgs = {
  id: Scalars['PositiveInt'];
};

export type CampaignEnrolmentFilterSetup = {
  __typename?: 'CampaignEnrolmentFilterSetup';
  enrolmentFilterType: TargetEnrolmentStatusEnum;
  includeArchived?: Maybe<Scalars['Boolean']>;
  creationMethod?: Maybe<EnrolmentCreationMethodEnum>;
};

export type CampaignEnrolmentFilterSetupInput = {
  enrolmentFilterType: TargetEnrolmentStatusEnum;
  includeArchived?: Maybe<Scalars['Boolean']>;
  creationMethod?: Maybe<EnrolmentCreationMethodEnum>;
};

export type CampaignEventFilterSetup = {
  __typename?: 'CampaignEventFilterSetup';
  eventFilterType: EventFilterTypeEnum;
  recurringEventIds: Array<Scalars['PositiveInt']>;
  eventIds: Array<Scalars['PositiveInt']>;
};

export type CampaignEventFilterSetupInput = {
  eventFilterType: EventFilterTypeEnum;
  recurringEventIds: Array<Scalars['PositiveInt']>;
  eventIds: Array<Scalars['PositiveInt']>;
};

export type CampaignFilter = {
  __typename?: 'CampaignFilter';
  comparator?: Maybe<UserFilterComparator>;
  temporalComparator?: Maybe<TimeComparatorForEnrolment>;
  ref_ids?: Maybe<Array<Scalars['PositiveInt']>>;
  created_at: Scalars['DateTime'];
  created_by?: Maybe<Scalars['PositiveInt']>;
  enrolmentFilterSetup?: Maybe<CampaignEnrolmentFilterSetup>;
  eventFilterSetup?: Maybe<CampaignEventFilterSetup>;
  type: CampaignFilterTypeEnum;
};

export type CampaignFilterInput = {
  comparator?: Maybe<UserFilterComparatorInput>;
  temporalComparator?: Maybe<TimeComparatorForEnrolmentInput>;
  ref_ids?: Maybe<Array<Scalars['PositiveInt']>>;
  created_at: Scalars['DateTime'];
  created_by: Scalars['PositiveInt'];
  enrolmentFilterSetup?: Maybe<CampaignEnrolmentFilterSetupInput>;
  eventFilterSetup?: Maybe<CampaignEventFilterSetupInput>;
  type: CampaignFilterTypeEnum;
};

export enum CampaignFilterTypeEnum {
  value_comparison = 'value_comparison',
  duration_comparison = 'duration_comparison',
  group = 'group',
  workspace = 'workspace',
  topic_enrolment = 'topic_enrolment',
  pathway_enrolment = 'pathway_enrolment',
  certification_enrolment = 'certification_enrolment',
  event_invitation = 'event_invitation'
}

export type CampaignLinkClicksReportTypes = {
  __typename?: 'CampaignLinkClicksReportTypes';
  usersCount: Scalars['NonNegativeInt'];
  users: Array<CampaignUserLinkClicksReportRow>;
};

export type CampaignMessageActionInput = {
  text?: Maybe<Scalars['SizeValidatedString_100KB']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  respect_business_hours?: Maybe<Scalars['Boolean']>;
  type: CampaignMessageTypeEnum;
  timezone?: Maybe<Scalars['String']>;
};

export type CampaignMessageActionModel = {
  __typename?: 'CampaignMessageActionModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  respect_business_hours: Scalars['Boolean'];
  /** Time of day when the campaign action is supposed to go out. It is used as a mere fallback when automatic_time_of_day flag is enabled. */
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  /** when enabled looop will determine the best time of day to send the action to each user based user's history of interaction with the platform. In that case send_at_time is only used as a fallback for new users */
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  text?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Scalars['String']>;
};

export type CampaignMessageActionModelAsEditor = {
  __typename?: 'CampaignMessageActionModelAsEditor';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  respect_business_hours: Scalars['Boolean'];
  /** Time of day when the campaign action is supposed to go out. It is used as a mere fallback when automatic_time_of_day flag is enabled. */
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  /** when enabled looop will determine the best time of day to send the action to each user based user's history of interaction with the platform. In that case send_at_time is only used as a fallback for new users */
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  text?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Scalars['String']>;
  patch?: Maybe<CampaignMessageActionModel>;
  delete?: Maybe<Scalars['NonNegativeInt']>;
  copy: Scalars['Boolean'];
  sentCount?: Maybe<Scalars['NonNegativeInt']>;
  failedCount?: Maybe<Scalars['NonNegativeInt']>;
  campaign: CampaignModel;
  scheduledActions: Array<ScheduledCampaignActionModel>;
  scheduledActionsCount: Scalars['NonNegativeInt'];
  /** finds a single scheduledAction by the idColumn of the relation */
  scheduledAction?: Maybe<ScheduledCampaignActionModel>;
  trackedLinks: Array<TrackedLinkAsStudent>;
  trackedLinksCount: Scalars['NonNegativeInt'];
  /** finds a single trackedLink by the idColumn of the relation */
  trackedLink?: Maybe<TrackedLinkAsStudent>;
};


export type CampaignMessageActionModelAsEditorPatchArgs = {
  input: CampaignMessageActionInput;
};


export type CampaignMessageActionModelAsEditorScheduledActionsArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignMessageActionModelAsEditorScheduledActionsCountArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
};


export type CampaignMessageActionModelAsEditorScheduledActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignMessageActionModelAsEditorTrackedLinksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignMessageActionModelAsEditorTrackedLinksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignMessageActionModelAsEditorTrackedLinkArgs = {
  id: Scalars['PositiveInt'];
};

export enum CampaignMessageTypeEnum {
  SMS = 'SMS',
  SLACK = 'SLACK',
  FOURTH = 'FOURTH',
  MSTEAMS = 'MSTEAMS'
}

export type CampaignModel = {
  __typename?: 'CampaignModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  is_active: Scalars['Boolean'];
  organisation_id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  name: Scalars['String'];
  archived_at?: Maybe<Scalars['DateTime']>;
  track_links: Scalars['Boolean'];
  schedule_type: CampaignScheduleEnum;
  status: CampaignStateEnum;
  /** Count of unique people in immediate campaign. Immediate campaign does not use campaign_user_events. Count of people is calculated from scheduled_campaign_actions instead. */
  immediateUsersCount?: Maybe<Scalars['NonNegativeInt']>;
  /** List of unique people in immediate campaign. Immediate campaign does not use campaign_user_events. List of people is calculated from scheduled_campaign_actions instead. */
  immediateUsers: Array<ImmediateCampaignUser>;
  /** current audience based on the campaign_user_events table data. This table is not updated real-time for all filters. duration_comparison filter is running with a cron, so users are joined only once X minutes in the worst case scenario */
  audienceEvents: Array<UserWithCampaignUserEvent>;
  /** current audience count based on the campaign_user_events table data. This table is not updated real-time for all filters. duration_comparison filter is running with a cron, so users are joined only once X minutes */
  audienceEventsCount?: Maybe<Scalars['NonNegativeInt']>;
  /** Campaign that returns false cannot be activated */
  canBeActivated?: Maybe<Scalars['Boolean']>;
  /** campaign that returns false cannot be activated because it has actions with wrong schedule type */
  hasCorrectActionScheduleTypes?: Maybe<Scalars['Boolean']>;
  /** scheduled fixed actions that are scheduled in the past */
  actionsInThePastCount?: Maybe<Scalars['NonNegativeInt']>;
  /** DEPRECATED: Use "status" field instead. */
  wasCampaignDeactivated: Scalars['Boolean'];
  actionsCount?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelImmediateUsersArgs = {
  search?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['PositiveInt']>;
};


export type CampaignModelAudienceEventsArgs = {
  search?: Maybe<Scalars['String']>;
  statuses: Array<CampaignUserEventTypeEnum>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['PositiveInt']>;
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  orderColumn?: Maybe<CampaignAudienceTableOrderColumn>;
};


export type CampaignModelAudienceEventsCountArgs = {
  statuses: Array<CampaignUserEventTypeEnum>;
};

export type CampaignModelAsAdminMutations = {
  __typename?: 'CampaignModelAsAdminMutations';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  is_active: Scalars['Boolean'];
  organisation_id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  name: Scalars['String'];
  archived_at?: Maybe<Scalars['DateTime']>;
  track_links: Scalars['Boolean'];
  schedule_type: CampaignScheduleEnum;
  status: CampaignStateEnum;
  /** Count of unique people in immediate campaign. Immediate campaign does not use campaign_user_events. Count of people is calculated from scheduled_campaign_actions instead. */
  immediateUsersCount?: Maybe<Scalars['NonNegativeInt']>;
  /** List of unique people in immediate campaign. Immediate campaign does not use campaign_user_events. List of people is calculated from scheduled_campaign_actions instead. */
  immediateUsers: Array<ImmediateCampaignUser>;
  /** current audience based on the campaign_user_events table data. This table is not updated real-time for all filters. duration_comparison filter is running with a cron, so users are joined only once X minutes in the worst case scenario */
  audienceEvents: Array<UserWithCampaignUserEvent>;
  /** current audience count based on the campaign_user_events table data. This table is not updated real-time for all filters. duration_comparison filter is running with a cron, so users are joined only once X minutes */
  audienceEventsCount?: Maybe<Scalars['NonNegativeInt']>;
  /** Campaign that returns false cannot be activated */
  canBeActivated?: Maybe<Scalars['Boolean']>;
  /** campaign that returns false cannot be activated because it has actions with wrong schedule type */
  hasCorrectActionScheduleTypes?: Maybe<Scalars['Boolean']>;
  /** scheduled fixed actions that are scheduled in the past */
  actionsInThePastCount?: Maybe<Scalars['NonNegativeInt']>;
  /** DEPRECATED: Use "status" field instead. */
  wasCampaignDeactivated: Scalars['Boolean'];
  actionsCount?: Maybe<Scalars['NonNegativeInt']>;
  audience_check_runs_since?: Maybe<Scalars['DateTime']>;
  last_completed_audience_check?: Maybe<Scalars['DateTime']>;
  /** dry run of an audience check which resolves with a preview of users who join and leave the campaign */
  dryAudienceCheck?: Maybe<CampaignAudienceCheckResult>;
  filters: Array<CampaignFilter>;
  /** omits banner actions as these are not actions we perform on the backend */
  scheduledActionsCountUntilNow?: Maybe<Scalars['NonNegativeInt']>;
  trackedLinksReport?: Maybe<CampaignLinkClicksReportTypes>;
  usersCompletedCount?: Maybe<Scalars['NonNegativeInt']>;
  report?: Maybe<CampaignReport>;
  /** a non empty array signals that there are initial actions which might not be scheduled in time for all audience members if campaign is activated now */
  fixedActionsComingUpInActivationWindow: Array<CampaignActionBaseModel>;
  /** an estimation in milliseconds needed for a fixed campaign to schedule all the actions on activation */
  activationWindowDuration?: Maybe<Scalars['NonNegativeInt']>;
  smartScheduledActionFor?: Maybe<CampaignActionBaseModel>;
  /** When creating new campaign action with email, recommend email identity used in latest created action with email */
  defaultEmailIdentity?: Maybe<EmailIdentityModel>;
  organisation: OrganisationModel;
  emailIncludeArchivedActions: Array<CampaignEmailActionModel>;
  emailIncludeArchivedActionsCount: Scalars['NonNegativeInt'];
  /** finds a single emailIncludeArchivedAction by the idColumn of the relation */
  emailIncludeArchivedAction?: Maybe<CampaignEmailActionModel>;
  analyticEvents: Array<CampaignAnalyticEventModel>;
  analyticEventsCount: Scalars['NonNegativeInt'];
  /** finds a single analyticEvent by the idColumn of the relation */
  analyticEvent?: Maybe<CampaignAnalyticEventModel>;
  scheduledActions: Array<ScheduledCampaignActionModel>;
  scheduledActionsCount: Scalars['NonNegativeInt'];
  /** finds a single scheduledAction by the idColumn of the relation */
  scheduledAction?: Maybe<ScheduledCampaignActionModel>;
  author?: Maybe<UserModel>;
  userEvents: Array<CampaignUserEventModel>;
  userEventsCount: Scalars['NonNegativeInt'];
  /** finds a single userEvent by the idColumn of the relation */
  userEvent?: Maybe<CampaignUserEventModel>;
  messageActions: Array<CampaignMessageActionModelAsEditor>;
  messageActionsCount: Scalars['NonNegativeInt'];
  /** finds a single messageAction by the idColumn of the relation */
  messageAction?: Maybe<CampaignMessageActionModelAsEditor>;
  emailActions: Array<CampaignEmailActionModelAsEditor>;
  emailActionsCount: Scalars['NonNegativeInt'];
  /** finds a single emailAction by the idColumn of the relation */
  emailAction?: Maybe<CampaignEmailActionModelAsEditor>;
  banners: Array<CampaignBannerModelAsEditor>;
  bannersCount: Scalars['NonNegativeInt'];
  /** finds a single banner by the idColumn of the relation */
  banner?: Maybe<CampaignBannerModelAsEditor>;
  topicShareActions: Array<CampaignTopicShareActionModelAsEditor>;
  topicShareActionsCount: Scalars['NonNegativeInt'];
  /** finds a single topicShareAction by the idColumn of the relation */
  topicShareAction?: Maybe<CampaignTopicShareActionModelAsEditor>;
  pathwayShareActions: Array<CampaignPathwayShareActionModelAsEditor>;
  pathwayShareActionsCount: Scalars['NonNegativeInt'];
  /** finds a single pathwayShareAction by the idColumn of the relation */
  pathwayShareAction?: Maybe<CampaignPathwayShareActionModelAsEditor>;
  certificationShareActions: Array<CampaignCertificationShareActionModelAsEditor>;
  certificationShareActionsCount: Scalars['NonNegativeInt'];
  /** finds a single certificationShareAction by the idColumn of the relation */
  certificationShareAction?: Maybe<CampaignCertificationShareActionModelAsEditor>;
  surveyShareActions: Array<CampaignSurveyShareActionModelAsEditor>;
  surveyShareActionsCount: Scalars['NonNegativeInt'];
  /** finds a single surveyShareAction by the idColumn of the relation */
  surveyShareAction?: Maybe<CampaignSurveyShareActionModelAsEditor>;
  duplicate?: Maybe<CampaignModelAsAdminMutations>;
  patch?: Maybe<CampaignModel>;
  setFilters?: Maybe<Array<CampaignFilter>>;
  setActive?: Maybe<CampaignModelAsAdminQueries>;
  archive?: Maybe<Scalars['NonNegativeInt']>;
  setTrackLinks?: Maybe<CampaignModelAsAdminQueries>;
  createBanner?: Maybe<CampaignBannerModel>;
  createEmail?: Maybe<CampaignEmailActionModel>;
  createTopicShareAction?: Maybe<CampaignTopicShareActionModel>;
  createPathwayShareAction?: Maybe<CampaignPathwayShareActionModel>;
  createCertificationShareAction?: Maybe<CampaignCertificationShareActionModel>;
  createSurveyShareAction?: Maybe<CampaignSurveyShareActionModel>;
  createMessage?: Maybe<CampaignMessageActionModel>;
};


export type CampaignModelAsAdminMutationsImmediateUsersArgs = {
  search?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['PositiveInt']>;
};


export type CampaignModelAsAdminMutationsAudienceEventsArgs = {
  search?: Maybe<Scalars['String']>;
  statuses: Array<CampaignUserEventTypeEnum>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['PositiveInt']>;
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  orderColumn?: Maybe<CampaignAudienceTableOrderColumn>;
};


export type CampaignModelAsAdminMutationsAudienceEventsCountArgs = {
  statuses: Array<CampaignUserEventTypeEnum>;
};


export type CampaignModelAsAdminMutationsDryAudienceCheckArgs = {
  filters?: Maybe<Array<CampaignFilterInput>>;
};


export type CampaignModelAsAdminMutationsTrackedLinksReportArgs = {
  filter: CampaignTrackedLinkReportsFilterInput;
};


export type CampaignModelAsAdminMutationsReportArgs = {
  filter: CampaignReportsFilterInput;
};


export type CampaignModelAsAdminMutationsSmartScheduledActionForArgs = {
  day?: Maybe<Scalars['NonNegativeInt']>;
  sendTime?: Maybe<Scalars['DateTime']>;
};


export type CampaignModelAsAdminMutationsEmailIncludeArchivedActionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminMutationsEmailIncludeArchivedActionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminMutationsEmailIncludeArchivedActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminMutationsAnalyticEventsArgs = {
  filters?: Maybe<Array<CampaignAnalyticEventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminMutationsAnalyticEventsCountArgs = {
  filters?: Maybe<Array<CampaignAnalyticEventModelFilterInput>>;
};


export type CampaignModelAsAdminMutationsAnalyticEventArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminMutationsScheduledActionsArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminMutationsScheduledActionsCountArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
};


export type CampaignModelAsAdminMutationsScheduledActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminMutationsUserEventsArgs = {
  filters?: Maybe<Array<CampaignUserEventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminMutationsUserEventsCountArgs = {
  filters?: Maybe<Array<CampaignUserEventModelFilterInput>>;
};


export type CampaignModelAsAdminMutationsUserEventArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminMutationsMessageActionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminMutationsMessageActionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminMutationsMessageActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminMutationsEmailActionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminMutationsEmailActionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminMutationsEmailActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminMutationsBannersArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminMutationsBannersCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminMutationsBannerArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminMutationsTopicShareActionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminMutationsTopicShareActionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminMutationsTopicShareActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminMutationsPathwayShareActionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminMutationsPathwayShareActionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminMutationsPathwayShareActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminMutationsCertificationShareActionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminMutationsCertificationShareActionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminMutationsCertificationShareActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminMutationsSurveyShareActionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminMutationsSurveyShareActionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminMutationsSurveyShareActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminMutationsPatchArgs = {
  input: CampaignPatchInput;
};


export type CampaignModelAsAdminMutationsSetFiltersArgs = {
  filters: Array<CampaignFilterInput>;
};


export type CampaignModelAsAdminMutationsSetActiveArgs = {
  active: Scalars['Boolean'];
};


export type CampaignModelAsAdminMutationsSetTrackLinksArgs = {
  trackLinks: Scalars['Boolean'];
};


export type CampaignModelAsAdminMutationsCreateBannerArgs = {
  input: CampaignBannerInput;
};


export type CampaignModelAsAdminMutationsCreateEmailArgs = {
  input: CampaignEmailActionInput;
};


export type CampaignModelAsAdminMutationsCreateTopicShareActionArgs = {
  input: CampaignTopicShareActionInput;
};


export type CampaignModelAsAdminMutationsCreatePathwayShareActionArgs = {
  input: CampaignPathwayShareActionInput;
};


export type CampaignModelAsAdminMutationsCreateCertificationShareActionArgs = {
  input: CampaignCertificationShareActionInput;
};


export type CampaignModelAsAdminMutationsCreateSurveyShareActionArgs = {
  input: CampaignSurveyShareActionInput;
};


export type CampaignModelAsAdminMutationsCreateMessageArgs = {
  input: CampaignMessageActionInput;
};

export type CampaignModelAsAdminQueries = {
  __typename?: 'CampaignModelAsAdminQueries';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  is_active: Scalars['Boolean'];
  organisation_id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  name: Scalars['String'];
  archived_at?: Maybe<Scalars['DateTime']>;
  track_links: Scalars['Boolean'];
  schedule_type: CampaignScheduleEnum;
  status: CampaignStateEnum;
  /** Count of unique people in immediate campaign. Immediate campaign does not use campaign_user_events. Count of people is calculated from scheduled_campaign_actions instead. */
  immediateUsersCount?: Maybe<Scalars['NonNegativeInt']>;
  /** List of unique people in immediate campaign. Immediate campaign does not use campaign_user_events. List of people is calculated from scheduled_campaign_actions instead. */
  immediateUsers: Array<ImmediateCampaignUser>;
  /** current audience based on the campaign_user_events table data. This table is not updated real-time for all filters. duration_comparison filter is running with a cron, so users are joined only once X minutes in the worst case scenario */
  audienceEvents: Array<UserWithCampaignUserEvent>;
  /** current audience count based on the campaign_user_events table data. This table is not updated real-time for all filters. duration_comparison filter is running with a cron, so users are joined only once X minutes */
  audienceEventsCount?: Maybe<Scalars['NonNegativeInt']>;
  /** Campaign that returns false cannot be activated */
  canBeActivated?: Maybe<Scalars['Boolean']>;
  /** campaign that returns false cannot be activated because it has actions with wrong schedule type */
  hasCorrectActionScheduleTypes?: Maybe<Scalars['Boolean']>;
  /** scheduled fixed actions that are scheduled in the past */
  actionsInThePastCount?: Maybe<Scalars['NonNegativeInt']>;
  /** DEPRECATED: Use "status" field instead. */
  wasCampaignDeactivated: Scalars['Boolean'];
  actionsCount?: Maybe<Scalars['NonNegativeInt']>;
  audience_check_runs_since?: Maybe<Scalars['DateTime']>;
  last_completed_audience_check?: Maybe<Scalars['DateTime']>;
  /** dry run of an audience check which resolves with a preview of users who join and leave the campaign */
  dryAudienceCheck?: Maybe<CampaignAudienceCheckResult>;
  filters: Array<CampaignFilter>;
  /** omits banner actions as these are not actions we perform on the backend */
  scheduledActionsCountUntilNow?: Maybe<Scalars['NonNegativeInt']>;
  trackedLinksReport?: Maybe<CampaignLinkClicksReportTypes>;
  usersCompletedCount?: Maybe<Scalars['NonNegativeInt']>;
  report?: Maybe<CampaignReport>;
  /** a non empty array signals that there are initial actions which might not be scheduled in time for all audience members if campaign is activated now */
  fixedActionsComingUpInActivationWindow: Array<CampaignActionBaseModel>;
  /** an estimation in milliseconds needed for a fixed campaign to schedule all the actions on activation */
  activationWindowDuration?: Maybe<Scalars['NonNegativeInt']>;
  smartScheduledActionFor?: Maybe<CampaignActionBaseModel>;
  /** When creating new campaign action with email, recommend email identity used in latest created action with email */
  defaultEmailIdentity?: Maybe<EmailIdentityModel>;
  organisation: OrganisationModel;
  emailIncludeArchivedActions: Array<CampaignEmailActionModel>;
  emailIncludeArchivedActionsCount: Scalars['NonNegativeInt'];
  /** finds a single emailIncludeArchivedAction by the idColumn of the relation */
  emailIncludeArchivedAction?: Maybe<CampaignEmailActionModel>;
  analyticEvents: Array<CampaignAnalyticEventModel>;
  analyticEventsCount: Scalars['NonNegativeInt'];
  /** finds a single analyticEvent by the idColumn of the relation */
  analyticEvent?: Maybe<CampaignAnalyticEventModel>;
  scheduledActions: Array<ScheduledCampaignActionModel>;
  scheduledActionsCount: Scalars['NonNegativeInt'];
  /** finds a single scheduledAction by the idColumn of the relation */
  scheduledAction?: Maybe<ScheduledCampaignActionModel>;
  author?: Maybe<UserModel>;
  userEvents: Array<CampaignUserEventModel>;
  userEventsCount: Scalars['NonNegativeInt'];
  /** finds a single userEvent by the idColumn of the relation */
  userEvent?: Maybe<CampaignUserEventModel>;
  messageActions: Array<CampaignMessageActionModelAsEditor>;
  messageActionsCount: Scalars['NonNegativeInt'];
  /** finds a single messageAction by the idColumn of the relation */
  messageAction?: Maybe<CampaignMessageActionModelAsEditor>;
  emailActions: Array<CampaignEmailActionModelAsEditor>;
  emailActionsCount: Scalars['NonNegativeInt'];
  /** finds a single emailAction by the idColumn of the relation */
  emailAction?: Maybe<CampaignEmailActionModelAsEditor>;
  banners: Array<CampaignBannerModelAsEditor>;
  bannersCount: Scalars['NonNegativeInt'];
  /** finds a single banner by the idColumn of the relation */
  banner?: Maybe<CampaignBannerModelAsEditor>;
  topicShareActions: Array<CampaignTopicShareActionModelAsEditor>;
  topicShareActionsCount: Scalars['NonNegativeInt'];
  /** finds a single topicShareAction by the idColumn of the relation */
  topicShareAction?: Maybe<CampaignTopicShareActionModelAsEditor>;
  pathwayShareActions: Array<CampaignPathwayShareActionModelAsEditor>;
  pathwayShareActionsCount: Scalars['NonNegativeInt'];
  /** finds a single pathwayShareAction by the idColumn of the relation */
  pathwayShareAction?: Maybe<CampaignPathwayShareActionModelAsEditor>;
  certificationShareActions: Array<CampaignCertificationShareActionModelAsEditor>;
  certificationShareActionsCount: Scalars['NonNegativeInt'];
  /** finds a single certificationShareAction by the idColumn of the relation */
  certificationShareAction?: Maybe<CampaignCertificationShareActionModelAsEditor>;
  surveyShareActions: Array<CampaignSurveyShareActionModelAsEditor>;
  surveyShareActionsCount: Scalars['NonNegativeInt'];
  /** finds a single surveyShareAction by the idColumn of the relation */
  surveyShareAction?: Maybe<CampaignSurveyShareActionModelAsEditor>;
};


export type CampaignModelAsAdminQueriesImmediateUsersArgs = {
  search?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['PositiveInt']>;
};


export type CampaignModelAsAdminQueriesAudienceEventsArgs = {
  search?: Maybe<Scalars['String']>;
  statuses: Array<CampaignUserEventTypeEnum>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['PositiveInt']>;
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  orderColumn?: Maybe<CampaignAudienceTableOrderColumn>;
};


export type CampaignModelAsAdminQueriesAudienceEventsCountArgs = {
  statuses: Array<CampaignUserEventTypeEnum>;
};


export type CampaignModelAsAdminQueriesDryAudienceCheckArgs = {
  filters?: Maybe<Array<CampaignFilterInput>>;
};


export type CampaignModelAsAdminQueriesTrackedLinksReportArgs = {
  filter: CampaignTrackedLinkReportsFilterInput;
};


export type CampaignModelAsAdminQueriesReportArgs = {
  filter: CampaignReportsFilterInput;
};


export type CampaignModelAsAdminQueriesSmartScheduledActionForArgs = {
  day?: Maybe<Scalars['NonNegativeInt']>;
  sendTime?: Maybe<Scalars['DateTime']>;
};


export type CampaignModelAsAdminQueriesEmailIncludeArchivedActionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminQueriesEmailIncludeArchivedActionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminQueriesEmailIncludeArchivedActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminQueriesAnalyticEventsArgs = {
  filters?: Maybe<Array<CampaignAnalyticEventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminQueriesAnalyticEventsCountArgs = {
  filters?: Maybe<Array<CampaignAnalyticEventModelFilterInput>>;
};


export type CampaignModelAsAdminQueriesAnalyticEventArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminQueriesScheduledActionsArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminQueriesScheduledActionsCountArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
};


export type CampaignModelAsAdminQueriesScheduledActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminQueriesUserEventsArgs = {
  filters?: Maybe<Array<CampaignUserEventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminQueriesUserEventsCountArgs = {
  filters?: Maybe<Array<CampaignUserEventModelFilterInput>>;
};


export type CampaignModelAsAdminQueriesUserEventArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminQueriesMessageActionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminQueriesMessageActionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminQueriesMessageActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminQueriesEmailActionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminQueriesEmailActionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminQueriesEmailActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminQueriesBannersArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminQueriesBannersCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminQueriesBannerArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminQueriesTopicShareActionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminQueriesTopicShareActionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminQueriesTopicShareActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminQueriesPathwayShareActionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminQueriesPathwayShareActionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminQueriesPathwayShareActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminQueriesCertificationShareActionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminQueriesCertificationShareActionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminQueriesCertificationShareActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignModelAsAdminQueriesSurveyShareActionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignModelAsAdminQueriesSurveyShareActionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignModelAsAdminQueriesSurveyShareActionArgs = {
  id: Scalars['PositiveInt'];
};

export enum CampaignModelFilterEnum {
  name = 'name',
  active = 'active',
  notArchived = 'notArchived',
  notDeactivated = 'notDeactivated'
}

export type CampaignModelFilterInput = {
  name: CampaignModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type CampaignPatchInput = {
  name?: Maybe<Scalars['LengthValidatedString_255']>;
  schedule_type?: Maybe<CampaignScheduleEnum>;
  track_links?: Maybe<Scalars['Boolean']>;
};

export type CampaignPathwayShareActionInput = {
  text?: Maybe<Scalars['SizeValidatedString_100KB']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  respect_business_hours?: Maybe<Scalars['Boolean']>;
  email_identity_id?: Maybe<Scalars['PositiveInt']>;
  timezone?: Maybe<Scalars['String']>;
  reset_existing_enrolments: Scalars['Boolean'];
  send_share_email: Scalars['Boolean'];
  target_completion_date?: Maybe<Scalars['DateTime']>;
  relative_target_completion_time?: Maybe<Scalars['String']>;
  relative_target_completion_day?: Maybe<Scalars['NonNegativeInt']>;
  actionPathways: Array<Scalars['PositiveInt']>;
};

export type CampaignPathwayShareActionModel = {
  __typename?: 'CampaignPathwayShareActionModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  respect_business_hours: Scalars['Boolean'];
  /** Time of day when the campaign action is supposed to go out. It is used as a mere fallback when automatic_time_of_day flag is enabled. */
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  /** when enabled looop will determine the best time of day to send the action to each user based user's history of interaction with the platform. In that case send_at_time is only used as a fallback for new users */
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  text?: Maybe<Scalars['String']>;
  relative_target_completion_day?: Maybe<Scalars['NonNegativeInt']>;
  relative_target_completion_time?: Maybe<Scalars['String']>;
  target_completion_date?: Maybe<Scalars['DateTime']>;
  effectiveness?: Maybe<Scalars['NonNegativeInt']>;
  timezone?: Maybe<Scalars['String']>;
  email_identity_id?: Maybe<Scalars['PositiveInt']>;
  reset_existing_enrolments?: Maybe<Scalars['Boolean']>;
  send_share_email?: Maybe<Scalars['Boolean']>;
  campaign: CampaignModel;
  scheduledActions: Array<ScheduledCampaignActionModel>;
  scheduledActionsCount: Scalars['NonNegativeInt'];
  /** finds a single scheduledAction by the idColumn of the relation */
  scheduledAction?: Maybe<ScheduledCampaignActionModel>;
  actionPathways: Array<CampaignActionPathwayModel>;
  actionPathwaysCount: Scalars['NonNegativeInt'];
  /** finds a single actionPathway by the idColumn of the relation */
  actionPathway?: Maybe<CampaignActionPathwayModel>;
  trackedLinks: Array<TrackedLinkAsStudent>;
  trackedLinksCount: Scalars['NonNegativeInt'];
  /** finds a single trackedLink by the idColumn of the relation */
  trackedLink?: Maybe<TrackedLinkAsStudent>;
  emailIdentity?: Maybe<EmailIdentityModel>;
};


export type CampaignPathwayShareActionModelScheduledActionsArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignPathwayShareActionModelScheduledActionsCountArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
};


export type CampaignPathwayShareActionModelScheduledActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignPathwayShareActionModelActionPathwaysArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignPathwayShareActionModelActionPathwaysCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignPathwayShareActionModelActionPathwayArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignPathwayShareActionModelTrackedLinksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignPathwayShareActionModelTrackedLinksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignPathwayShareActionModelTrackedLinkArgs = {
  id: Scalars['PositiveInt'];
};

export type CampaignPathwayShareActionModelAsEditor = {
  __typename?: 'CampaignPathwayShareActionModelAsEditor';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  respect_business_hours: Scalars['Boolean'];
  /** Time of day when the campaign action is supposed to go out. It is used as a mere fallback when automatic_time_of_day flag is enabled. */
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  /** when enabled looop will determine the best time of day to send the action to each user based user's history of interaction with the platform. In that case send_at_time is only used as a fallback for new users */
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  text?: Maybe<Scalars['String']>;
  relative_target_completion_day?: Maybe<Scalars['NonNegativeInt']>;
  relative_target_completion_time?: Maybe<Scalars['String']>;
  target_completion_date?: Maybe<Scalars['DateTime']>;
  effectiveness?: Maybe<Scalars['NonNegativeInt']>;
  timezone?: Maybe<Scalars['String']>;
  email_identity_id?: Maybe<Scalars['PositiveInt']>;
  reset_existing_enrolments?: Maybe<Scalars['Boolean']>;
  send_share_email?: Maybe<Scalars['Boolean']>;
  campaign: CampaignModel;
  scheduledActions: Array<ScheduledCampaignActionModel>;
  scheduledActionsCount: Scalars['NonNegativeInt'];
  /** finds a single scheduledAction by the idColumn of the relation */
  scheduledAction?: Maybe<ScheduledCampaignActionModel>;
  actionPathways: Array<CampaignActionPathwayModel>;
  actionPathwaysCount: Scalars['NonNegativeInt'];
  /** finds a single actionPathway by the idColumn of the relation */
  actionPathway?: Maybe<CampaignActionPathwayModel>;
  trackedLinks: Array<TrackedLinkAsStudent>;
  trackedLinksCount: Scalars['NonNegativeInt'];
  /** finds a single trackedLink by the idColumn of the relation */
  trackedLink?: Maybe<TrackedLinkAsStudent>;
  emailIdentity?: Maybe<EmailIdentityModel>;
  patch: CampaignPathwayShareActionModel;
  delete: Scalars['NonNegativeInt'];
  copy: Scalars['Boolean'];
  sharedCount: Scalars['NonNegativeInt'];
  completedCount: Scalars['NonNegativeInt'];
  enrolments: Array<PathwayEnrolmentModel>;
  enrolmentsCount: Scalars['NonNegativeInt'];
  /** finds a single enrolment by the idColumn of the relation */
  enrolment?: Maybe<PathwayEnrolmentModel>;
};


export type CampaignPathwayShareActionModelAsEditorScheduledActionsArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignPathwayShareActionModelAsEditorScheduledActionsCountArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
};


export type CampaignPathwayShareActionModelAsEditorScheduledActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignPathwayShareActionModelAsEditorActionPathwaysArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignPathwayShareActionModelAsEditorActionPathwaysCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignPathwayShareActionModelAsEditorActionPathwayArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignPathwayShareActionModelAsEditorTrackedLinksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignPathwayShareActionModelAsEditorTrackedLinksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignPathwayShareActionModelAsEditorTrackedLinkArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignPathwayShareActionModelAsEditorPatchArgs = {
  input: CampaignPathwayShareActionInput;
};


export type CampaignPathwayShareActionModelAsEditorEnrolmentsArgs = {
  filters?: Maybe<Array<PathwayEnrolmentModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignPathwayShareActionModelAsEditorEnrolmentsCountArgs = {
  filters?: Maybe<Array<PathwayEnrolmentModelFilterInput>>;
};


export type CampaignPathwayShareActionModelAsEditorEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};

export type CampaignReport = {
  __typename?: 'CampaignReport';
  usersCount: Scalars['NonNegativeInt'];
  users: Array<CampaignUserReportRow>;
};

export type CampaignReportsFilterInput = {
  group_ids?: Maybe<Array<Scalars['PositiveInt']>>;
  page: Scalars['NonNegativeInt'];
  limit: Scalars['PositiveInt'];
  displayName?: Maybe<Scalars['String']>;
};

export enum CampaignScheduleEnum {
  FIXED = 'FIXED',
  RELATIVE = 'RELATIVE',
  IMMEDIATE = 'IMMEDIATE'
}

export enum CampaignSearchableUserAttribute {
  email = 'email',
  account_name = 'account_name',
  display_name = 'display_name',
  first_name = 'first_name',
  last_name = 'last_name',
  position = 'position',
  timezone = 'timezone',
  employee_id = 'employee_id',
  area = 'area',
  location = 'location',
  department = 'department',
  custom_1 = 'custom_1',
  custom_2 = 'custom_2',
  custom_3 = 'custom_3',
  phone_number = 'phone_number',
  manager_email = 'manager_email',
  locale = 'locale'
}

export type CampaignSharedCertificationEnrolmentModel = {
  __typename?: 'CampaignSharedCertificationEnrolmentModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_action_certification_id: Scalars['PositiveInt'];
  scheduled_campaign_action_id: Scalars['PositiveInt'];
  is_new_enrolment: Scalars['PositiveInt'];
  certification_enrolment_id: Scalars['Boolean'];
  certificationEnrolment?: Maybe<CertificationEnrolmentModel>;
  campaignActionCertification?: Maybe<CampaignActionCertificationModel>;
};

export enum CampaignStateEnum {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  DEACTIVATED = 'DEACTIVATED'
}

export type CampaignSurveyShareActionInput = {
  text?: Maybe<Scalars['SizeValidatedString_100KB']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  respect_business_hours?: Maybe<Scalars['Boolean']>;
  email_identity_id?: Maybe<Scalars['PositiveInt']>;
  actionSurveys: Array<Scalars['PositiveInt']>;
  timezone?: Maybe<Scalars['String']>;
  relative_target_completion_time?: Maybe<Scalars['String']>;
  relative_target_completion_day?: Maybe<Scalars['NonNegativeInt']>;
  send_share_email: Scalars['Boolean'];
};

export type CampaignSurveyShareActionModel = {
  __typename?: 'CampaignSurveyShareActionModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  respect_business_hours: Scalars['Boolean'];
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  /** when enabled looop will determine the best time of day to send the action to each user based user's history of interaction with the platform. In that case send_at_time is only used as a fallback for new users */
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  text?: Maybe<Scalars['String']>;
  relative_target_completion_day?: Maybe<Scalars['NonNegativeInt']>;
  relative_target_completion_time?: Maybe<Scalars['String']>;
  target_completion_date?: Maybe<Scalars['DateTime']>;
  effectiveness?: Maybe<Scalars['NonNegativeInt']>;
  timezone?: Maybe<Scalars['String']>;
  email_identity_id?: Maybe<Scalars['PositiveInt']>;
  send_share_email?: Maybe<Scalars['Boolean']>;
  campaign: CampaignModel;
  scheduledActions: Array<ScheduledCampaignActionModel>;
  scheduledActionsCount: Scalars['NonNegativeInt'];
  /** finds a single scheduledAction by the idColumn of the relation */
  scheduledAction?: Maybe<ScheduledCampaignActionModel>;
  actionSurveys: Array<CampaignActionSurveyModel>;
  actionSurveysCount: Scalars['NonNegativeInt'];
  /** finds a single actionSurvey by the idColumn of the relation */
  actionSurvey?: Maybe<CampaignActionSurveyModel>;
  trackedLinks: Array<TrackedLinkAsStudent>;
  trackedLinksCount: Scalars['NonNegativeInt'];
  /** finds a single trackedLink by the idColumn of the relation */
  trackedLink?: Maybe<TrackedLinkAsStudent>;
  emailIdentity?: Maybe<EmailIdentityModel>;
};


export type CampaignSurveyShareActionModelScheduledActionsArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignSurveyShareActionModelScheduledActionsCountArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
};


export type CampaignSurveyShareActionModelScheduledActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignSurveyShareActionModelActionSurveysArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignSurveyShareActionModelActionSurveysCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignSurveyShareActionModelActionSurveyArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignSurveyShareActionModelTrackedLinksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignSurveyShareActionModelTrackedLinksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignSurveyShareActionModelTrackedLinkArgs = {
  id: Scalars['PositiveInt'];
};

export type CampaignSurveyShareActionModelAsEditor = {
  __typename?: 'CampaignSurveyShareActionModelAsEditor';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  respect_business_hours: Scalars['Boolean'];
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  /** when enabled looop will determine the best time of day to send the action to each user based user's history of interaction with the platform. In that case send_at_time is only used as a fallback for new users */
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  text?: Maybe<Scalars['String']>;
  relative_target_completion_day?: Maybe<Scalars['NonNegativeInt']>;
  relative_target_completion_time?: Maybe<Scalars['String']>;
  target_completion_date?: Maybe<Scalars['DateTime']>;
  effectiveness?: Maybe<Scalars['NonNegativeInt']>;
  timezone?: Maybe<Scalars['String']>;
  email_identity_id?: Maybe<Scalars['PositiveInt']>;
  send_share_email?: Maybe<Scalars['Boolean']>;
  campaign: CampaignModel;
  scheduledActions: Array<ScheduledCampaignActionModel>;
  scheduledActionsCount: Scalars['NonNegativeInt'];
  /** finds a single scheduledAction by the idColumn of the relation */
  scheduledAction?: Maybe<ScheduledCampaignActionModel>;
  actionSurveys: Array<CampaignActionSurveyModel>;
  actionSurveysCount: Scalars['NonNegativeInt'];
  /** finds a single actionSurvey by the idColumn of the relation */
  actionSurvey?: Maybe<CampaignActionSurveyModel>;
  trackedLinks: Array<TrackedLinkAsStudent>;
  trackedLinksCount: Scalars['NonNegativeInt'];
  /** finds a single trackedLink by the idColumn of the relation */
  trackedLink?: Maybe<TrackedLinkAsStudent>;
  emailIdentity?: Maybe<EmailIdentityModel>;
  patch: CampaignSurveyShareActionModel;
  delete: Scalars['NonNegativeInt'];
  copy: Scalars['Boolean'];
  sharedCount: Scalars['NonNegativeInt'];
  completedCount: Scalars['NonNegativeInt'];
  surveys: Array<SurveyModelAsAdmin>;
  surveysCount: Scalars['NonNegativeInt'];
  /** finds a single survey by the idColumn of the relation */
  survey?: Maybe<SurveyModelAsAdmin>;
};


export type CampaignSurveyShareActionModelAsEditorScheduledActionsArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignSurveyShareActionModelAsEditorScheduledActionsCountArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
};


export type CampaignSurveyShareActionModelAsEditorScheduledActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignSurveyShareActionModelAsEditorActionSurveysArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignSurveyShareActionModelAsEditorActionSurveysCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignSurveyShareActionModelAsEditorActionSurveyArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignSurveyShareActionModelAsEditorTrackedLinksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignSurveyShareActionModelAsEditorTrackedLinksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignSurveyShareActionModelAsEditorTrackedLinkArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignSurveyShareActionModelAsEditorPatchArgs = {
  input: CampaignSurveyShareActionInput;
};


export type CampaignSurveyShareActionModelAsEditorSurveysArgs = {
  filters?: Maybe<Array<SurveyModelAsAdminFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignSurveyShareActionModelAsEditorSurveysCountArgs = {
  filters?: Maybe<Array<SurveyModelAsAdminFilterInput>>;
};


export type CampaignSurveyShareActionModelAsEditorSurveyArgs = {
  id: Scalars['PositiveInt'];
};

export type CampaignTopicShareActionInput = {
  text?: Maybe<Scalars['SizeValidatedString_100KB']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  respect_business_hours?: Maybe<Scalars['Boolean']>;
  email_identity_id?: Maybe<Scalars['PositiveInt']>;
  timezone?: Maybe<Scalars['String']>;
  reset_existing_enrolments: Scalars['Boolean'];
  send_share_email: Scalars['Boolean'];
  target_completion_date?: Maybe<Scalars['DateTime']>;
  relative_target_completion_time?: Maybe<Scalars['String']>;
  relative_target_completion_day?: Maybe<Scalars['NonNegativeInt']>;
  actionTopics: Array<Scalars['PositiveInt']>;
};

export type CampaignTopicShareActionModel = {
  __typename?: 'CampaignTopicShareActionModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  respect_business_hours: Scalars['Boolean'];
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  /** when enabled looop will determine the best time of day to send the action to each user based user's history of interaction with the platform. In that case send_at_time is only used as a fallback for new users */
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  text?: Maybe<Scalars['String']>;
  relative_target_completion_day?: Maybe<Scalars['NonNegativeInt']>;
  relative_target_completion_time?: Maybe<Scalars['String']>;
  target_completion_date?: Maybe<Scalars['DateTime']>;
  effectiveness?: Maybe<Scalars['NonNegativeInt']>;
  timezone?: Maybe<Scalars['String']>;
  reset_existing_enrolments?: Maybe<Scalars['Boolean']>;
  send_share_email?: Maybe<Scalars['Boolean']>;
  email_identity_id?: Maybe<Scalars['PositiveInt']>;
  campaign: CampaignModel;
  scheduledActions: Array<ScheduledCampaignActionModel>;
  scheduledActionsCount: Scalars['NonNegativeInt'];
  /** finds a single scheduledAction by the idColumn of the relation */
  scheduledAction?: Maybe<ScheduledCampaignActionModel>;
  actionTopics: Array<CampaignActionTopicModel>;
  actionTopicsCount: Scalars['NonNegativeInt'];
  /** finds a single actionTopic by the idColumn of the relation */
  actionTopic?: Maybe<CampaignActionTopicModel>;
  trackedLinks: Array<TrackedLinkAsStudent>;
  trackedLinksCount: Scalars['NonNegativeInt'];
  /** finds a single trackedLink by the idColumn of the relation */
  trackedLink?: Maybe<TrackedLinkAsStudent>;
  emailIdentity?: Maybe<EmailIdentityModel>;
};


export type CampaignTopicShareActionModelScheduledActionsArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignTopicShareActionModelScheduledActionsCountArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
};


export type CampaignTopicShareActionModelScheduledActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignTopicShareActionModelActionTopicsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignTopicShareActionModelActionTopicsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignTopicShareActionModelActionTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignTopicShareActionModelTrackedLinksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignTopicShareActionModelTrackedLinksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignTopicShareActionModelTrackedLinkArgs = {
  id: Scalars['PositiveInt'];
};

export type CampaignTopicShareActionModelAsEditor = {
  __typename?: 'CampaignTopicShareActionModelAsEditor';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  respect_business_hours: Scalars['Boolean'];
  send_at_time?: Maybe<Scalars['String']>;
  send_at_day?: Maybe<Scalars['NonNegativeInt']>;
  /** when enabled looop will determine the best time of day to send the action to each user based user's history of interaction with the platform. In that case send_at_time is only used as a fallback for new users */
  automatic_time_of_day?: Maybe<Scalars['Boolean']>;
  fixed_send_time?: Maybe<Scalars['DateTime']>;
  text?: Maybe<Scalars['String']>;
  relative_target_completion_day?: Maybe<Scalars['NonNegativeInt']>;
  relative_target_completion_time?: Maybe<Scalars['String']>;
  target_completion_date?: Maybe<Scalars['DateTime']>;
  effectiveness?: Maybe<Scalars['NonNegativeInt']>;
  timezone?: Maybe<Scalars['String']>;
  reset_existing_enrolments?: Maybe<Scalars['Boolean']>;
  send_share_email?: Maybe<Scalars['Boolean']>;
  email_identity_id?: Maybe<Scalars['PositiveInt']>;
  campaign: CampaignModel;
  scheduledActions: Array<ScheduledCampaignActionModel>;
  scheduledActionsCount: Scalars['NonNegativeInt'];
  /** finds a single scheduledAction by the idColumn of the relation */
  scheduledAction?: Maybe<ScheduledCampaignActionModel>;
  actionTopics: Array<CampaignActionTopicModel>;
  actionTopicsCount: Scalars['NonNegativeInt'];
  /** finds a single actionTopic by the idColumn of the relation */
  actionTopic?: Maybe<CampaignActionTopicModel>;
  trackedLinks: Array<TrackedLinkAsStudent>;
  trackedLinksCount: Scalars['NonNegativeInt'];
  /** finds a single trackedLink by the idColumn of the relation */
  trackedLink?: Maybe<TrackedLinkAsStudent>;
  emailIdentity?: Maybe<EmailIdentityModel>;
  patch?: Maybe<CampaignTopicShareActionModel>;
  delete?: Maybe<Scalars['NonNegativeInt']>;
  copy: Scalars['Boolean'];
  sharedCount?: Maybe<Scalars['NonNegativeInt']>;
  completedCount?: Maybe<Scalars['NonNegativeInt']>;
  enrolments: Array<TopicEnrolmentModel>;
  enrolmentsCount: Scalars['NonNegativeInt'];
  /** finds a single enrolment by the idColumn of the relation */
  enrolment?: Maybe<TopicEnrolmentModel>;
};


export type CampaignTopicShareActionModelAsEditorScheduledActionsArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignTopicShareActionModelAsEditorScheduledActionsCountArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
};


export type CampaignTopicShareActionModelAsEditorScheduledActionArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignTopicShareActionModelAsEditorActionTopicsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignTopicShareActionModelAsEditorActionTopicsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignTopicShareActionModelAsEditorActionTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignTopicShareActionModelAsEditorTrackedLinksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignTopicShareActionModelAsEditorTrackedLinksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CampaignTopicShareActionModelAsEditorTrackedLinkArgs = {
  id: Scalars['PositiveInt'];
};


export type CampaignTopicShareActionModelAsEditorPatchArgs = {
  input: CampaignTopicShareActionInput;
};


export type CampaignTopicShareActionModelAsEditorEnrolmentsArgs = {
  filters?: Maybe<Array<TopicEnrolmentModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CampaignTopicShareActionModelAsEditorEnrolmentsCountArgs = {
  filters?: Maybe<Array<TopicEnrolmentModelFilterInput>>;
};


export type CampaignTopicShareActionModelAsEditorEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};

export type CampaignTrackedLinkReportsFilterInput = {
  campaignEmailActionIds?: Maybe<Array<Scalars['PositiveInt']>>;
  campaignMessageActionIds?: Maybe<Array<Scalars['PositiveInt']>>;
  campaignPathwayShareActionIds?: Maybe<Array<Scalars['PositiveInt']>>;
  campaignTopicShareActionIds?: Maybe<Array<Scalars['PositiveInt']>>;
  campaignSurveyShareActionIds?: Maybe<Array<Scalars['PositiveInt']>>;
  campaignCertificationShareActionIds?: Maybe<Array<Scalars['PositiveInt']>>;
  page: Scalars['NonNegativeInt'];
  limit: Scalars['PositiveInt'];
  displayName?: Maybe<Scalars['String']>;
};

export type CampaignUserEventModel = {
  __typename?: 'CampaignUserEventModel';
  campaign_id: Scalars['PositiveInt'];
  event_type: CampaignUserEventTypeEnum;
  user_id: Scalars['PositiveInt'];
  app_event_id?: Maybe<Scalars['PositiveInt']>;
  timestamp: Scalars['DateTime'];
  campaign: CampaignModel;
  user: UserModel;
  appEvent: AppEventModel;
};

export enum CampaignUserEventModelFilterEnum {
  completed = 'completed'
}

export type CampaignUserEventModelFilterInput = {
  name: CampaignUserEventModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export enum CampaignUserEventTypeEnum {
  join = 'join',
  leave = 'leave',
  completed = 'completed'
}

export type CampaignUserLinkClicksReportRow = {
  __typename?: 'CampaignUserLinkClicksReportRow';
  user?: Maybe<UserModelPublicBase>;
  linkClicks?: Maybe<Array<UserLinkClick>>;
};

export type CampaignUserReportRow = {
  __typename?: 'CampaignUserReportRow';
  firstJoinDate?: Maybe<Scalars['DateTime']>;
  lastCampaignEvent?: Maybe<CampaignUserEventTypeEnum>;
  user?: Maybe<UserModelAsAdminQueries>;
  scheduledActions?: Maybe<Array<ScheduledActionReport>>;
};

export type CertificateTemplateInput = {
  name: Scalars['String'];
  orientation: OrientationEnum;
  default?: Maybe<Scalars['Boolean']>;
};

export type CertificateTemplateModel = {
  __typename?: 'CertificateTemplateModel';
  id: Scalars['PositiveInt'];
  name: Scalars['String'];
  svg?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  organisation_id: Scalars['PositiveInt'];
  svg_objects?: Maybe<Scalars['JSON']>;
  orientation: OrientationEnum;
};

export type CertificateTemplateModelAsAdmin = {
  __typename?: 'CertificateTemplateModelAsAdmin';
  id: Scalars['PositiveInt'];
  name: Scalars['String'];
  svg?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  organisation_id: Scalars['PositiveInt'];
  svg_objects?: Maybe<Scalars['JSON']>;
  orientation: OrientationEnum;
  deleted_at?: Maybe<Scalars['DateTime']>;
  setObjects?: Maybe<CertificateTemplateModelAsAdmin>;
  remove?: Maybe<CertificateTemplateModelAsAdmin>;
};


export type CertificateTemplateModelAsAdminSetObjectsArgs = {
  svg: Scalars['String'];
  objects: Array<SvgObject>;
};

export enum CertificationDetailOverviewOrderColumn {
  displayName = 'displayName',
  certificationName = 'certificationName',
  startedAt = 'startedAt',
  completedAt = 'completedAt',
  expiresAt = 'expiresAt',
  progress = 'progress'
}

export type CertificationEnrolmentModel = {
  __typename?: 'CertificationEnrolmentModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  user_id?: Maybe<Scalars['PositiveInt']>;
  certification_id?: Maybe<Scalars['PositiveInt']>;
  progress?: Maybe<Scalars['Float']>;
  target_date?: Maybe<Scalars['DateTime']>;
  started_at?: Maybe<Scalars['DateTime']>;
  completed_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  expires_at?: Maybe<Scalars['DateTime']>;
  shared_at?: Maybe<Scalars['DateTime']>;
  shared_by?: Maybe<Scalars['PositiveInt']>;
  status?: Maybe<CertificationEnrolmentStatusEnum>;
  certification: CertificationModel;
  user: UserModel;
  campaignSharedCertificationEnrolments: CampaignSharedCertificationEnrolmentModel;
};

export type CertificationEnrolmentModelAsAdmin = {
  __typename?: 'CertificationEnrolmentModelAsAdmin';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  user_id?: Maybe<Scalars['PositiveInt']>;
  certification_id?: Maybe<Scalars['PositiveInt']>;
  progress?: Maybe<Scalars['Float']>;
  target_date?: Maybe<Scalars['DateTime']>;
  started_at?: Maybe<Scalars['DateTime']>;
  completed_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  expires_at?: Maybe<Scalars['DateTime']>;
  shared_at?: Maybe<Scalars['DateTime']>;
  shared_by?: Maybe<Scalars['PositiveInt']>;
  status?: Maybe<CertificationEnrolmentStatusEnum>;
  certification: CertificationModelAsAdmin;
  user: UserModel;
  campaignSharedCertificationEnrolments: CampaignSharedCertificationEnrolmentModel;
};

export enum CertificationEnrolmentModelAsAdminFilterEnum {
  notArchived = 'notArchived',
  completed = 'completed',
  inProgress = 'inProgress',
  overdue = 'overdue',
  noOverdue = 'noOverdue',
  expired = 'expired'
}

export type CertificationEnrolmentModelAsAdminFilterInput = {
  name: CertificationEnrolmentModelAsAdminFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type CertificationEnrolmentModelAsStudent = {
  __typename?: 'CertificationEnrolmentModelAsStudent';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  user_id?: Maybe<Scalars['PositiveInt']>;
  certification_id?: Maybe<Scalars['PositiveInt']>;
  progress?: Maybe<Scalars['Float']>;
  target_date?: Maybe<Scalars['DateTime']>;
  started_at?: Maybe<Scalars['DateTime']>;
  completed_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  expires_at?: Maybe<Scalars['DateTime']>;
  shared_at?: Maybe<Scalars['DateTime']>;
  shared_by?: Maybe<Scalars['PositiveInt']>;
  status?: Maybe<CertificationEnrolmentStatusEnum>;
  certification: CertificationModelAsStudent;
  user: UserModel;
  campaignSharedCertificationEnrolments: CampaignSharedCertificationEnrolmentModel;
};

export enum CertificationEnrolmentStatusEnum {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  OVERDUE = 'OVERDUE',
  EXPIRED = 'EXPIRED'
}

export type CertificationEnrolmentsOverview = {
  __typename?: 'CertificationEnrolmentsOverview';
  items: Array<CertificationEnrolmentModelAsAdmin>;
  count?: Maybe<Scalars['Float']>;
};

export type CertificationItemModel = {
  __typename?: 'CertificationItemModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  certification_id: Scalars['PositiveInt'];
  order: Scalars['NonNegativeInt'];
  item_id: Scalars['PositiveInt'];
  item_type: CertificationItemTypes;
  created_by: Scalars['PositiveInt'];
  pathway?: Maybe<PathwayModelAsStudent>;
  topic?: Maybe<TopicModelAsMember>;
  event?: Maybe<EventModelAsStudent>;
};

export type CertificationItemModelAsAdmin = {
  __typename?: 'CertificationItemModelAsAdmin';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  certification_id: Scalars['PositiveInt'];
  order: Scalars['NonNegativeInt'];
  item_id: Scalars['PositiveInt'];
  item_type: CertificationItemTypes;
  created_by: Scalars['PositiveInt'];
  pathway?: Maybe<PathwayModelAsAdmin>;
  topic?: Maybe<TopicModelAsEditor>;
  event?: Maybe<EventModelAsAdmin>;
};

export enum CertificationItemTypes {
  topic = 'topic',
  event = 'event',
  pathway = 'pathway'
}

export type CertificationModel = {
  __typename?: 'CertificationModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  template_id?: Maybe<Scalars['PositiveInt']>;
  created_by?: Maybe<Scalars['PositiveInt']>;
  locked_at?: Maybe<Scalars['DateTime']>;
  months_of_validity?: Maybe<Scalars['PositiveInt']>;
  items?: Maybe<Array<CertificationItemModel>>;
  users?: Maybe<Array<UserModelPublicBase>>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type CertificationModelAsAdmin = {
  __typename?: 'CertificationModelAsAdmin';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  template_id?: Maybe<Scalars['PositiveInt']>;
  created_by?: Maybe<Scalars['PositiveInt']>;
  locked_at?: Maybe<Scalars['DateTime']>;
  months_of_validity?: Maybe<Scalars['PositiveInt']>;
  items: Array<CertificationItemModelAsAdmin>;
  users: Array<UserModelPublicBase>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  /** Archives multiple certification enrolments. Returns count of processed items. */
  batchArchiveEnrolments?: Maybe<Scalars['NonNegativeInt']>;
  certificateTemplate?: Maybe<CertificateTemplateModel>;
  author?: Maybe<UserModel>;
  itemsCount: Scalars['NonNegativeInt'];
  /** finds a single item by the idColumn of the relation */
  item?: Maybe<CertificationItemModelAsAdmin>;
  organisation: OrganisationModelAsAdminMutations;
  remove?: Maybe<CertificationModelAsAdmin>;
  patch?: Maybe<CertificationModelAsAdmin>;
  shareWithGroups?: Maybe<Scalars['Boolean']>;
  isSharingCompleted: Scalars['Boolean'];
  shareWithUsers?: Maybe<Scalars['Boolean']>;
  addUser?: Maybe<CertificationModelAsAdmin>;
  removeUser?: Maybe<CertificationModelAsAdmin>;
  addItems?: Maybe<CertificationModelAsAdmin>;
  moveItemDown?: Maybe<CertificationModelAsAdmin>;
  moveItemUp?: Maybe<CertificationModelAsAdmin>;
  removeItem?: Maybe<CertificationModelAsAdmin>;
  relatedCampaigns?: Maybe<Array<CampaignModel>>;
  usersCount: Scalars['NonNegativeInt'];
  /** finds a single user by the idColumn of the relation */
  user?: Maybe<UserModelPublicBase>;
  enrolments: Array<CertificationEnrolmentModelAsAdmin>;
  enrolmentsCount: Scalars['NonNegativeInt'];
  /** finds a single enrolment by the idColumn of the relation */
  enrolment?: Maybe<CertificationEnrolmentModelAsAdmin>;
  completedEnrolments: Array<CertificationEnrolmentModel>;
  completedEnrolmentsCount: Scalars['NonNegativeInt'];
  /** finds a single completedEnrolment by the idColumn of the relation */
  completedEnrolment?: Maybe<CertificationEnrolmentModel>;
  inProgressEnrolments: Array<CertificationEnrolmentModel>;
  inProgressEnrolmentsCount: Scalars['NonNegativeInt'];
  /** finds a single inProgressEnrolment by the idColumn of the relation */
  inProgressEnrolment?: Maybe<CertificationEnrolmentModel>;
  shares: Array<CertificationShareModel>;
  sharesCount: Scalars['NonNegativeInt'];
  /** finds a single share by the idColumn of the relation */
  share?: Maybe<CertificationShareModel>;
};


export type CertificationModelAsAdminItemsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CertificationModelAsAdminUsersArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CertificationModelAsAdminBatchArchiveEnrolmentsArgs = {
  enrolmentIds: Array<Scalars['PositiveInt']>;
};


export type CertificationModelAsAdminItemsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CertificationModelAsAdminItemArgs = {
  id: Scalars['PositiveInt'];
};


export type CertificationModelAsAdminPatchArgs = {
  data: CertificationModelAsAdminInput;
};


export type CertificationModelAsAdminShareWithGroupsArgs = {
  groupIds: Array<Scalars['PositiveInt']>;
  targetDate?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  sendEmail: Scalars['Boolean'];
  resetEnrolments: Scalars['Boolean'];
  emailIdentityId?: Maybe<Scalars['PositiveInt']>;
};


export type CertificationModelAsAdminShareWithUsersArgs = {
  userIds: Array<Scalars['PositiveInt']>;
  targetDate?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  sendEmail: Scalars['Boolean'];
  resetEnrolments: Scalars['Boolean'];
  emailIdentityId?: Maybe<Scalars['PositiveInt']>;
};


export type CertificationModelAsAdminAddUserArgs = {
  userId: Scalars['PositiveInt'];
};


export type CertificationModelAsAdminRemoveUserArgs = {
  userId: Scalars['PositiveInt'];
};


export type CertificationModelAsAdminAddItemsArgs = {
  itemIds: Array<Scalars['PositiveInt']>;
  itemType: CertificationItemTypes;
};


export type CertificationModelAsAdminMoveItemDownArgs = {
  itemId: Scalars['PositiveInt'];
};


export type CertificationModelAsAdminMoveItemUpArgs = {
  itemId: Scalars['PositiveInt'];
};


export type CertificationModelAsAdminRemoveItemArgs = {
  itemId: Scalars['PositiveInt'];
};


export type CertificationModelAsAdminUsersCountArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
};


export type CertificationModelAsAdminUserArgs = {
  id: Scalars['PositiveInt'];
};


export type CertificationModelAsAdminEnrolmentsArgs = {
  filters?: Maybe<Array<CertificationEnrolmentModelAsAdminFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CertificationModelAsAdminEnrolmentsCountArgs = {
  filters?: Maybe<Array<CertificationEnrolmentModelAsAdminFilterInput>>;
};


export type CertificationModelAsAdminEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};


export type CertificationModelAsAdminCompletedEnrolmentsArgs = {
  filters?: Maybe<Array<CertificationEnrolmentModelAsAdminFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CertificationModelAsAdminCompletedEnrolmentsCountArgs = {
  filters?: Maybe<Array<CertificationEnrolmentModelAsAdminFilterInput>>;
};


export type CertificationModelAsAdminCompletedEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};


export type CertificationModelAsAdminInProgressEnrolmentsArgs = {
  filters?: Maybe<Array<CertificationEnrolmentModelAsAdminFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CertificationModelAsAdminInProgressEnrolmentsCountArgs = {
  filters?: Maybe<Array<CertificationEnrolmentModelAsAdminFilterInput>>;
};


export type CertificationModelAsAdminInProgressEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};


export type CertificationModelAsAdminSharesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CertificationModelAsAdminSharesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CertificationModelAsAdminShareArgs = {
  id: Scalars['PositiveInt'];
};

export enum CertificationModelAsAdminFilterEnum {
  searchByIds = 'searchByIds',
  locked = 'locked',
  search = 'search',
  includeDeleted = 'includeDeleted'
}

export type CertificationModelAsAdminFilterInput = {
  name: CertificationModelAsAdminFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type CertificationModelAsAdminInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  template_id?: Maybe<Scalars['PositiveInt']>;
  created_by?: Maybe<Scalars['PositiveInt']>;
  locked_at?: Maybe<Scalars['DateTime']>;
  months_of_validity?: Maybe<Scalars['PositiveInt']>;
};

export type CertificationModelAsStudent = {
  __typename?: 'CertificationModelAsStudent';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  template_id?: Maybe<Scalars['PositiveInt']>;
  created_by?: Maybe<Scalars['PositiveInt']>;
  locked_at?: Maybe<Scalars['DateTime']>;
  months_of_validity?: Maybe<Scalars['PositiveInt']>;
  items: Array<CertificationItemModel>;
  users?: Maybe<Array<UserModelPublicBase>>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  /** Archives multiple certification enrolments. Returns count of processed items. */
  batchArchiveEnrolments?: Maybe<Scalars['NonNegativeInt']>;
  certificateTemplate?: Maybe<CertificateTemplateModel>;
  author?: Maybe<UserModelPublicBase>;
  itemsCount: Scalars['NonNegativeInt'];
  /** finds a single item by the idColumn of the relation */
  item?: Maybe<CertificationItemModel>;
  organisation: OrganisationModelGqlBase;
};


export type CertificationModelAsStudentItemsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type CertificationModelAsStudentBatchArchiveEnrolmentsArgs = {
  enrolmentIds: Array<Scalars['PositiveInt']>;
};


export type CertificationModelAsStudentItemsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type CertificationModelAsStudentItemArgs = {
  id: Scalars['PositiveInt'];
};

export type CertificationOverview = {
  __typename?: 'CertificationOverview';
  items: Array<AnalyticsSingleCertificationModelAsAdmin>;
  count?: Maybe<Scalars['Float']>;
};

export type CertificationShareModel = {
  __typename?: 'CertificationShareModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  certification_id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  content: Scalars['String'];
  succeeded_at?: Maybe<Scalars['DateTime']>;
  fail_message?: Maybe<Scalars['String']>;
};

export enum CertificationsOverviewOrderColumn {
  name = 'name',
  completed_count = 'completed_count',
  in_progress_count = 'in_progress_count',
  shared_count = 'shared_count'
}

export type CommentModel = {
  __typename?: 'CommentModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  author: Scalars['PositiveInt'];
  item_type: Scalars['String'];
  content: Scalars['String'];
  item_id: Scalars['PositiveInt'];
  reply_to?: Maybe<Scalars['PositiveInt']>;
  edit: CommentModel;
  delete?: Maybe<Scalars['NonNegativeInt']>;
  user: UserModel;
};


export type CommentModelEditArgs = {
  content: Scalars['String'];
};

export type CreateTopicInput = {
  themeId?: Maybe<Scalars['PositiveInt']>;
  title: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  type: TopicVersionType;
};

export type CsvExport = {
  __typename?: 'CsvExport';
  csvPayload: Scalars['String'];
};

export type CustomSmtp = {
  __typename?: 'CustomSMTP';
  enabled: Scalars['Boolean'];
  configuration: CustomSmtpConfiguration;
  emailIdentity?: Maybe<EmailIdentityAsAdminModel>;
  /** returns a list of email identities that will get unverified when the custom SMTP is disabled */
  emailIdentitiesVerifiedAfterValidation: Array<EmailIdentityAsAdminModel>;
  setEnabled?: Maybe<CustomSmtp>;
};


export type CustomSmtpSetEnabledArgs = {
  value: Scalars['Boolean'];
};

export type CustomSmtpConfiguration = {
  __typename?: 'CustomSMTPConfiguration';
  host?: Maybe<Scalars['String']>;
  port?: Maybe<Scalars['NonNegativeInt']>;
  user?: Maybe<Scalars['String']>;
  pass?: Maybe<Scalars['String']>;
  validated_at?: Maybe<Scalars['DateTime']>;
};

export type CustomSmtpConfigurationInput = {
  host?: Maybe<Scalars['String']>;
  port?: Maybe<Scalars['NonNegativeInt']>;
  user?: Maybe<Scalars['String']>;
  pass?: Maybe<Scalars['String']>;
};

export type CustomSmtpError = {
  __typename?: 'CustomSMTPError';
  error?: Maybe<Scalars['String']>;
};

export type CustomSmtpInput = {
  configuration: CustomSmtpConfigurationInput;
  mailFrom?: Maybe<Scalars['JSON']>;
};

export type CustomSmtpResults = CustomSmtp | CustomSmtpError;

export type CustomTranslationModel = {
  __typename?: 'CustomTranslationModel';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  organisation_id: Scalars['PositiveInt'];
  term: Scalars['String'];
  translation: Scalars['LengthValidatedString_255'];
  app_section: CustomTranslationsSectionEnum;
  locale: SupportedLocalesEnum;
  patch?: Maybe<CustomTranslationModel>;
  delete?: Maybe<Scalars['NonNegativeInt']>;
};


export type CustomTranslationModelPatchArgs = {
  translation: Scalars['String'];
};

export enum CustomTranslationsSectionEnum {
  FRONTEND_UI = 'FRONTEND_UI',
  EMAILS = 'EMAILS',
  API_ERRORS = 'API_ERRORS'
}

export type DashboardAccessModel = {
  __typename?: 'DashboardAccessModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  user?: Maybe<UserModel>;
  role: DashboardAccessRoleEnum;
  remove?: Maybe<DashboardAccessModel>;
  changeRole?: Maybe<DashboardAccessModel>;
};


export type DashboardAccessModelChangeRoleArgs = {
  role: DashboardAccessRoleEnum;
};

export enum DashboardAccessRoleEnum {
  VIEWER = 'VIEWER',
  EDITOR = 'EDITOR'
}

export type DashboardActionTypeReport = {
  __typename?: 'DashboardActionTypeReport';
  commName: ActionsEffectivenessCommName;
  processedActionsCount?: Maybe<Scalars['NonNegativeInt']>;
  userEventsCount?: Maybe<Scalars['NonNegativeInt']>;
  isCommEnabled?: Maybe<Scalars['Boolean']>;
  effectiveness?: Maybe<Scalars['NonNegativeInt']>;
};

/** represents an outcome of a dashboard audience check */
export type DashboardAudienceCheckResult = {
  __typename?: 'DashboardAudienceCheckResult';
  joinCount?: Maybe<Scalars['NonNegativeInt']>;
  joinUsers: Array<UserModelPublicBase>;
  leaveCount?: Maybe<Scalars['NonNegativeInt']>;
  leaveUsers: Array<UserModelPublicBase>;
  dashboardId?: Maybe<Scalars['PositiveInt']>;
};

export enum DashboardAudienceTableOrderColumn {
  display_name = 'display_name',
  timestamp = 'timestamp'
}

export type DashboardCustomMetricModel = {
  __typename?: 'DashboardCustomMetricModel';
  id: Scalars['PositiveInt'];
  dashboard_id: Scalars['PositiveInt'];
  timestamp: Scalars['DateTime'];
  value: Scalars['Float'];
};

export type DashboardFilter = {
  __typename?: 'DashboardFilter';
  comparator?: Maybe<UserFilterComparator>;
  temporalComparator?: Maybe<TimeComparatorForEnrolment>;
  ref_ids?: Maybe<Array<Scalars['PositiveInt']>>;
  created_at: Scalars['DateTime'];
  created_by?: Maybe<Scalars['PositiveInt']>;
  enrolmentFilterSetup?: Maybe<CampaignEnrolmentFilterSetup>;
  eventFilterSetup?: Maybe<CampaignEventFilterSetup>;
  type?: Maybe<DashboardFilterTypeEnum>;
};

export type DashboardFilterInput = {
  comparator?: Maybe<UserFilterComparatorInput>;
  temporalComparator?: Maybe<TimeComparatorForEnrolmentInput>;
  ref_ids?: Maybe<Array<Scalars['PositiveInt']>>;
  created_at: Scalars['DateTime'];
  created_by: Scalars['PositiveInt'];
  enrolmentFilterSetup?: Maybe<CampaignEnrolmentFilterSetupInput>;
  eventFilterSetup?: Maybe<CampaignEventFilterSetupInput>;
  type?: Maybe<DashboardFilterTypeEnum>;
};

export enum DashboardFilterTypeEnum {
  value_comparison = 'value_comparison',
  group = 'group'
}

export type DashboardItemModel = {
  __typename?: 'DashboardItemModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  dashboard_id: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  item_id: Scalars['PositiveInt'];
  item_type: DashboardItemTypes;
  created_by: Scalars['PositiveInt'];
};

export enum DashboardItemTypes {
  topic = 'topic',
  workspace = 'workspace',
  event = 'event',
  survey = 'survey',
  campaign = 'campaign',
  pathway = 'pathway'
}

export type DashboardModel = {
  __typename?: 'DashboardModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  title: Scalars['String'];
  color: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  organisation_id: Scalars['PositiveInt'];
  filters: Array<DashboardFilter>;
  customMetricEntries?: Maybe<Array<DashboardCustomMetricModel>>;
  metric_name?: Maybe<Scalars['String']>;
  metric_target_value?: Maybe<Scalars['Float']>;
  custom_metric: Scalars['Boolean'];
  collaborators?: Maybe<Array<DashboardAccessModel>>;
  items?: Maybe<Array<DashboardItemModel>>;
  workspaces: Array<WorkspaceModel>;
  pathways: Array<PathwayModel>;
  topics: Array<TopicModel>;
  campaigns: Array<CampaignModel>;
  events: Array<EventModel>;
  surveys: Array<SurveyModel>;
  userInsights: Array<UserInsightResult>;
  commentedTopics: Array<Scalars['NonNegativeInt']>;
  ratedCurrentEnrolments: Array<TopicEnrolmentModel>;
};


export type DashboardModelUserInsightsArgs = {
  filters: DashboardSummaryFiltersInput;
};


export type DashboardModelCommentedTopicsArgs = {
  filters: DashboardSummaryFiltersInput;
};


export type DashboardModelRatedCurrentEnrolmentsArgs = {
  filters: DashboardSummaryFiltersInput;
};

export type DashboardModelAsAdminMutations = {
  __typename?: 'DashboardModelAsAdminMutations';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  title: Scalars['String'];
  color: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  organisation_id: Scalars['PositiveInt'];
  filters: Array<DashboardFilter>;
  customMetricEntries?: Maybe<Array<DashboardCustomMetricModel>>;
  metric_name?: Maybe<Scalars['String']>;
  metric_target_value?: Maybe<Scalars['Float']>;
  custom_metric: Scalars['Boolean'];
  collaborators?: Maybe<Array<DashboardAccessModel>>;
  items?: Maybe<Array<DashboardItemModel>>;
  workspaces: Array<WorkspaceModel>;
  pathways: Array<PathwayModel>;
  topics: Array<TopicModel>;
  campaigns: Array<CampaignModel>;
  events: Array<EventModel>;
  surveys: Array<SurveyModel>;
  userInsights: Array<UserInsightResult>;
  commentedTopics: Array<Scalars['NonNegativeInt']>;
  ratedCurrentEnrolments: Array<TopicEnrolmentModel>;
  /** How many percent of users were active in given date range. 50 means 50% of all people in dashboard audience were active in given time range */
  commsPenetration?: Maybe<Scalars['NonNegativeInt']>;
  /** current audience based on the dashboard_user_events table data. This table is not updated real-time, but eventually consistent */
  audienceEvents: Array<DashboardUserEventModel>;
  isEditor?: Maybe<Scalars['Boolean']>;
  /** current audience count based on the dashboard_user_events table data. This table is not updated real-time for all filters. duration_comparison filter is running with a cron, so users are joined only once X minutes */
  audienceEventsCount?: Maybe<Scalars['NonNegativeInt']>;
  /** dry run of an audience check which resolves with a preview of users who join and leave the dashboard */
  dryAudienceCheck?: Maybe<DashboardAudienceCheckResult>;
  suggestCollaborators?: Maybe<Array<UserModel>>;
  customMetricEntriesFiltered: Array<DashboardCustomMetricModel>;
  /** How many percent of users were active in given date range. 50 means 50% of all people in dashboard audience opened topic that fits dashboard topic/workspace/pathway items in given date range */
  resourcesPenetration?: Maybe<Scalars['NonNegativeFloat']>;
  /** Effectiveness of various campaign channels */
  actionsEffectiveness: Array<DashboardActionTypeReport>;
  setFilters?: Maybe<Array<DashboardFilter>>;
  remove?: Maybe<DashboardModelAsAdminMutations>;
  patch?: Maybe<DashboardModelAsAdminMutations>;
  addItems?: Maybe<Array<DashboardItemModel>>;
  addCustomMetricEntry?: Maybe<DashboardCustomMetricModel>;
  removeCustomMetricEntry?: Maybe<Scalars['NonNegativeInt']>;
  removeItem?: Maybe<DashboardItemModel>;
  addCollaborators?: Maybe<Array<DashboardAccessModel>>;
  collaborator?: Maybe<DashboardAccessModel>;
};


export type DashboardModelAsAdminMutationsUserInsightsArgs = {
  filters: DashboardSummaryFiltersInput;
};


export type DashboardModelAsAdminMutationsCommentedTopicsArgs = {
  filters: DashboardSummaryFiltersInput;
};


export type DashboardModelAsAdminMutationsRatedCurrentEnrolmentsArgs = {
  filters: DashboardSummaryFiltersInput;
};


export type DashboardModelAsAdminMutationsCommsPenetrationArgs = {
  filters: DashboardSummaryFiltersInput;
};


export type DashboardModelAsAdminMutationsAudienceEventsArgs = {
  search?: Maybe<Scalars['String']>;
  types: Array<DashboardUserEventTypeEnum>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['PositiveInt']>;
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  orderColumn?: Maybe<DashboardAudienceTableOrderColumn>;
};


export type DashboardModelAsAdminMutationsAudienceEventsCountArgs = {
  types: Array<DashboardUserEventTypeEnum>;
};


export type DashboardModelAsAdminMutationsDryAudienceCheckArgs = {
  filters: Array<DashboardFilterInput>;
};


export type DashboardModelAsAdminMutationsSuggestCollaboratorsArgs = {
  search?: Maybe<Scalars['String']>;
};


export type DashboardModelAsAdminMutationsCustomMetricEntriesFilteredArgs = {
  filters: DashboardSummaryFiltersInput;
};


export type DashboardModelAsAdminMutationsResourcesPenetrationArgs = {
  filters: DashboardSummaryFiltersInput;
};


export type DashboardModelAsAdminMutationsActionsEffectivenessArgs = {
  filters: DashboardSummaryFiltersInput;
};


export type DashboardModelAsAdminMutationsSetFiltersArgs = {
  filters: Array<DashboardFilterInput>;
};


export type DashboardModelAsAdminMutationsPatchArgs = {
  data: DashboardModelInput;
};


export type DashboardModelAsAdminMutationsAddItemsArgs = {
  itemIds: Array<Scalars['PositiveInt']>;
  itemType: DashboardItemTypes;
  spreadItems?: Maybe<Scalars['Boolean']>;
};


export type DashboardModelAsAdminMutationsAddCustomMetricEntryArgs = {
  timestamp: Scalars['DateTime'];
  value: Scalars['Float'];
};


export type DashboardModelAsAdminMutationsRemoveCustomMetricEntryArgs = {
  id: Scalars['PositiveInt'];
};


export type DashboardModelAsAdminMutationsRemoveItemArgs = {
  itemId: Scalars['PositiveInt'];
  itemType: DashboardItemTypes;
};


export type DashboardModelAsAdminMutationsAddCollaboratorsArgs = {
  userIds: Array<Scalars['PositiveInt']>;
};


export type DashboardModelAsAdminMutationsCollaboratorArgs = {
  collaboratorId: Scalars['PositiveInt'];
};

export type DashboardModelInput = {
  title?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  metric_name?: Maybe<Scalars['String']>;
  metric_target_value?: Maybe<Scalars['Float']>;
  custom_metric?: Maybe<Scalars['Boolean']>;
};

export type DashboardSummaryFiltersInput = {
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};

export type DashboardUserEventModel = {
  __typename?: 'DashboardUserEventModel';
  dashboard_id: Scalars['PositiveInt'];
  type: DashboardUserEventTypeEnum;
  user_id: Scalars['PositiveInt'];
  timestamp: Scalars['DateTime'];
  dashboard: DashboardModel;
  user: UserModel;
};

export enum DashboardUserEventTypeEnum {
  join = 'join',
  leave = 'leave'
}



export enum DeviceTypeEnum {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
  TABLET = 'TABLET'
}

export type DocumentModel = {
  __typename?: 'DocumentModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  cdnUrl?: Maybe<Scalars['String']>;
  id: Scalars['PositiveInt'];
  mimeType?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  element: TopicElementModel;
  imageVariants: Array<ImageVariantModel>;
  imageVariantsCount: Scalars['NonNegativeInt'];
  /** finds a single imageVariant by the idColumn of the relation */
  imageVariant?: Maybe<ImageVariantModel>;
};


export type DocumentModelImageVariantsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type DocumentModelImageVariantsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type DocumentModelImageVariantArgs = {
  id: Scalars['PositiveInt'];
};

export enum DocumentTranscodingStatusEnum {
  Submitted = 'Submitted',
  Progressing = 'Progressing',
  Error = 'Error',
  Complete = 'Complete'
}




export type EmailBlacklistModelAsAdmin = {
  __typename?: 'EmailBlacklistModelAsAdmin';
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  email?: Maybe<Scalars['String']>;
  notification_queue_processed_id: Scalars['PositiveInt'];
  processedNotification: NotificationQueueProcessedModel;
  user?: Maybe<UserModel>;
};

export type EmailBlocklistExport = {
  __typename?: 'EmailBlocklistExport';
  user: UserModel;
  smtp_response_type?: Maybe<Scalars['String']>;
  smtp_response_bounce?: Maybe<Scalars['String']>;
  smtp_response_complaint?: Maybe<Scalars['String']>;
};

export type EmailEvent = {
  __typename?: 'EmailEvent';
  sent?: Maybe<Scalars['DateTime']>;
  opened?: Maybe<Scalars['DateTime']>;
  clicked?: Maybe<Scalars['DateTime']>;
};

export type EmailIdentityAsAdminModel = {
  __typename?: 'EmailIdentityAsAdminModel';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  email: Scalars['String'];
  verified_at?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['NonNegativeInt']>;
  previous_email_identity_id?: Maybe<Scalars['PositiveInt']>;
  revert?: Maybe<EmailIdentityAsAdminModel>;
  sendVerificationEmail?: Maybe<Scalars['Boolean']>;
  archive?: Maybe<Scalars['NonNegativeInt']>;
  relatedCampaigns: Array<CampaignModelAsAdminQueries>;
};

export type EmailIdentityModel = {
  __typename?: 'EmailIdentityModel';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  email: Scalars['String'];
  verified_at?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['NonNegativeInt']>;
  previous_email_identity_id?: Maybe<Scalars['PositiveInt']>;
};

export type EmbedDomains = {
  __typename?: 'EmbedDomains';
  enabled?: Maybe<Scalars['Boolean']>;
  domains?: Maybe<Array<Scalars['String']>>;
};

export type EmbedDomainsInput = {
  enabled?: Maybe<Scalars['Boolean']>;
  domains?: Maybe<Array<Scalars['String']>>;
};

export enum EnrolmentCreationMethodEnum {
  selfAssign = 'selfAssign',
  share = 'share',
  shareOrSelfAssign = 'shareOrSelfAssign'
}

export type EnrolmentEvent = {
  __typename?: 'EnrolmentEvent';
  sent?: Maybe<Scalars['DateTime']>;
  started?: Maybe<Scalars['DateTime']>;
  completed?: Maybe<Scalars['DateTime']>;
};

export type EnrolmentOriginSection = PathwayModelAsStudent | WorkspaceModelAsMember | CertificationModelAsStudent;

export enum EventFilterTypeEnum {
  any_status = 'any_status',
  accepted = 'accepted',
  declined = 'declined',
  attended = 'attended',
  not_attended = 'not_attended',
  not_responded = 'not_responded'
}

export type EventGroupModel = {
  __typename?: 'EventGroupModel';
  group_id: Scalars['PositiveInt'];
  event_id: Scalars['PositiveInt'];
  recurring_event_invitee_group_id?: Maybe<Scalars['PositiveInt']>;
  created_at?: Maybe<Scalars['DateTime']>;
};

export type EventInvitee = {
  __typename?: 'EventInvitee';
  attending?: Maybe<Scalars['Boolean']>;
  present?: Maybe<Scalars['Boolean']>;
  last_edit_by?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  certification_id?: Maybe<Scalars['PositiveInt']>;
  certification_name?: Maybe<Scalars['String']>;
  event_id?: Maybe<Scalars['PositiveInt']>;
  user_id?: Maybe<Scalars['PositiveInt']>;
  email?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  profile_img_url?: Maybe<Scalars['String']>;
  uploaded_img_url?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  organisation_role?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['PositiveInt']>;
  group_name?: Maybe<Scalars['String']>;
};

/** acceptable fieldNames are fields on EventInvitee, when omitted it defaults to searching invited users by their display_name and email */
export type EventInviteeFilterInput = {
  fieldName?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type EventModel = {
  __typename?: 'EventModel';
  deleted_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  author_id: Scalars['PositiveInt'];
  recurring_event_id?: Maybe<Scalars['PositiveInt']>;
  start_time?: Maybe<Scalars['DateTime']>;
  end_time?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  update_email_sent_at?: Maybe<Scalars['DateTime']>;
  published_date?: Maybe<Scalars['DateTime']>;
  participants_limit?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['String']>;
  title: Scalars['LengthValidatedString_512'];
  location?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['SizeValidatedString_200KB']>;
  allow_comments: Scalars['Boolean'];
  is_open: Scalars['Boolean'];
  facilitator_id?: Maybe<Scalars['PositiveInt']>;
  google_meet_uuid?: Maybe<Scalars['String']>;
  google_meet_id?: Maybe<Scalars['String']>;
  ms_teams_url?: Maybe<Scalars['String']>;
  ms_teams_enabled: Scalars['Boolean'];
  /** only individuals invited directly */
  attendedInvitees: Array<UserEventModel>;
  /** only individuals invited directly */
  invitees: Array<UserEventModel>;
  invitee?: Maybe<UserEventModel>;
  currentUserInvitee?: Maybe<UserEventModel>;
  /** only counts individuals invited directly */
  inviteesCount: Scalars['NonNegativeInt'];
  attendeesCount: Scalars['NonNegativeInt'];
  presentCount: Scalars['NonNegativeInt'];
  formattedTimeRange: Scalars['String'];
  isFollowingComments: Scalars['Boolean'];
  comments: Array<CommentModel>;
  addComment: CommentModel;
};


export type EventModelInviteeArgs = {
  userId: Scalars['PositiveInt'];
};


export type EventModelAddCommentArgs = {
  content: Scalars['String'];
  replyTo?: Maybe<Scalars['PositiveInt']>;
};

export type EventModelAsAdmin = ISearchable & {
  __typename?: 'EventModelAsAdmin';
  deleted_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  author_id: Scalars['PositiveInt'];
  recurring_event_id?: Maybe<Scalars['PositiveInt']>;
  start_time?: Maybe<Scalars['DateTime']>;
  end_time?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  update_email_sent_at?: Maybe<Scalars['DateTime']>;
  published_date?: Maybe<Scalars['DateTime']>;
  participants_limit?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['String']>;
  title: Scalars['LengthValidatedString_512'];
  location?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['SizeValidatedString_200KB']>;
  allow_comments: Scalars['Boolean'];
  is_open: Scalars['Boolean'];
  facilitator_id?: Maybe<Scalars['PositiveInt']>;
  google_meet_uuid?: Maybe<Scalars['String']>;
  google_meet_id?: Maybe<Scalars['String']>;
  ms_teams_url?: Maybe<Scalars['String']>;
  ms_teams_enabled: Scalars['Boolean'];
  /** only individuals invited directly */
  attendedInvitees: Array<UserEventModel>;
  invitees: Array<UserEventModel>;
  invitee?: Maybe<UserEventModelWithSource>;
  currentUserInvitee?: Maybe<UserEventModel>;
  /** only counts individuals invited directly */
  inviteesCount: Scalars['NonNegativeInt'];
  attendeesCount: Scalars['NonNegativeInt'];
  presentCount: Scalars['NonNegativeInt'];
  formattedTimeRange: Scalars['String'];
  currentUserInvitation?: Maybe<UserEventModel>;
  registerToAttend?: Maybe<UserEventModel>;
  /** used for changing student status in 3d party calendars events */
  changeStatusForAttenderIn3dPartyCalendars?: Maybe<Scalars['Boolean']>;
  cancelAttendance?: Maybe<UserEventModel>;
  author: UserModelPublicBase;
  organisation: OrganisationModel;
  invitedGroups: Array<GroupModelGqlBase>;
  invitedGroupsCount: Scalars['NonNegativeInt'];
  /** finds a single invitedGroup by the idColumn of the relation */
  invitedGroup?: Maybe<GroupModelGqlBase>;
  inviteeGroups: Array<EventGroupModel>;
  inviteeGroupsCount: Scalars['NonNegativeInt'];
  /** finds a single inviteeGroup by the idColumn of the relation */
  inviteeGroup?: Maybe<EventGroupModel>;
  invitedUsers: Array<UserModelPublicBase>;
  invitedUsersCount: Scalars['NonNegativeInt'];
  /** finds a single invitedUser by the idColumn of the relation */
  invitedUser?: Maybe<UserModelPublicBase>;
  tags: Array<TagModel>;
  tagsCount: Scalars['NonNegativeInt'];
  /** finds a single tag by the idColumn of the relation */
  tag?: Maybe<TagModel>;
  certificationItems: Array<CertificationItemModel>;
  certificationItemsCount: Scalars['NonNegativeInt'];
  /** finds a single certificationItem by the idColumn of the relation */
  certificationItem?: Maybe<CertificationItemModel>;
  facilitator?: Maybe<UserModelPublicBase>;
  recurringEvent?: Maybe<RecurringEventModelAsStudent>;
  patch?: Maybe<EventModelAsAdmin>;
  sendUpdatedEmailToAllInvitees?: Maybe<EventModelAsAdmin>;
  /** Publishes your event so it will be visible to invitees or everyone if it is an open event */
  publish?: Maybe<Scalars['DateTime']>;
  /** used for creating new event in 3d party calendars */
  sendNewEventTo3dPartyCalendars?: Maybe<Scalars['Boolean']>;
  /** when called for user who is not a direct invitee yet, it will create a new  direct invitee record in the DB. This happens when a user from a group is marked as attending for example */
  inviteeWithUpsert?: Maybe<UserEventModel>;
  /** used for sync all attendees status of event with 3d party calendars */
  syncAttendeesStatusWith3dPartyCalendars?: Maybe<Scalars['Boolean']>;
  duplicate?: Maybe<EventModelAsAdmin>;
  /** returns 1 if event was removed, 0 if it was not deleted */
  delete: Scalars['NonNegativeInt'];
  /** returns 1 if invitee was removed, 0 if it was not deleted */
  removeInvitee: Scalars['NonNegativeInt'];
  /** used for to push invitees of event to 3d party calendars */
  addAttendeesTo3dPartyCalendars?: Maybe<Scalars['Boolean']>;
  /** used to remove invitees from event in 3d party calendars */
  removeAttendeesFrom3dPartyCalendars?: Maybe<Scalars['Boolean']>;
  inviteUser?: Maybe<UserEventModel>;
  inviteGroup?: Maybe<EventGroupModel>;
  removeGroupInvite: Scalars['NonNegativeInt'];
  addTag: Scalars['NonNegativeInt'];
  removeTag: Scalars['NonNegativeInt'];
  removeAllTags: Scalars['NonNegativeInt'];
  exportInvitees: CsvExport;
  relatedCertifications: Array<CertificationModelAsAdmin>;
  relatedCampaigns: Array<CampaignModelAsAdminQueries>;
  /** individual invitees and people who are invited from certification and groups-these are generated by extrapolating current group members and current certification enrolments */
  eventInvitees: Array<EventInvitee>;
  eventInviteesTotalCount?: Maybe<Scalars['NonNegativeInt']>;
  /** individual invitees and people who are invited from certification and groups-these are generated by extrapolating current group members and current certification enrolments */
  inviteesIncludingIndirect?: Maybe<PaginatableInvitees>;
  unSyncedEvent?: Maybe<EventModel>;
  pushUnSyncedEventToCalendars?: Maybe<EventModelAsAdmin>;
  isFollowingComments: Scalars['Boolean'];
  comments: Array<CommentModel>;
  addComment: CommentModel;
};


export type EventModelAsAdminInviteeArgs = {
  userId: Scalars['PositiveInt'];
};


export type EventModelAsAdminChangeStatusForAttenderIn3dPartyCalendarsArgs = {
  attending: Scalars['Boolean'];
};


export type EventModelAsAdminInvitedGroupsArgs = {
  filters?: Maybe<Array<GroupModelGqlBaseFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type EventModelAsAdminInvitedGroupsCountArgs = {
  filters?: Maybe<Array<GroupModelGqlBaseFilterInput>>;
};


export type EventModelAsAdminInvitedGroupArgs = {
  id: Scalars['PositiveInt'];
};


export type EventModelAsAdminInviteeGroupsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type EventModelAsAdminInviteeGroupsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type EventModelAsAdminInviteeGroupArgs = {
  id: Scalars['PositiveInt'];
};


export type EventModelAsAdminInvitedUsersArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type EventModelAsAdminInvitedUsersCountArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
};


export type EventModelAsAdminInvitedUserArgs = {
  id: Scalars['PositiveInt'];
};


export type EventModelAsAdminTagsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type EventModelAsAdminTagsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type EventModelAsAdminTagArgs = {
  id: Scalars['PositiveInt'];
};


export type EventModelAsAdminCertificationItemsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type EventModelAsAdminCertificationItemsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type EventModelAsAdminCertificationItemArgs = {
  id: Scalars['PositiveInt'];
};


export type EventModelAsAdminPatchArgs = {
  data: EventModelInput;
  tags?: Maybe<Array<Scalars['PositiveInt']>>;
  emailIdentityId?: Maybe<Scalars['PositiveInt']>;
  notifyRSVPdInvitees?: Maybe<Scalars['Boolean']>;
  notifyAllInvitees?: Maybe<Scalars['Boolean']>;
};


export type EventModelAsAdminSendUpdatedEmailToAllInviteesArgs = {
  emailIdentityId?: Maybe<Scalars['PositiveInt']>;
  notifyRSVPdInvitees?: Maybe<Scalars['Boolean']>;
};


export type EventModelAsAdminInviteeWithUpsertArgs = {
  userId: Scalars['PositiveInt'];
  groupId?: Maybe<Scalars['PositiveInt']>;
};


export type EventModelAsAdminDeleteArgs = {
  sendCancellationEmail: Scalars['Boolean'];
  emailIdentityId?: Maybe<Scalars['PositiveInt']>;
};


export type EventModelAsAdminRemoveInviteeArgs = {
  userId: Scalars['PositiveInt'];
  sendCancellationEmail: Scalars['Boolean'];
};


export type EventModelAsAdminAddAttendeesTo3dPartyCalendarsArgs = {
  emails?: Maybe<Array<Scalars['String']>>;
  groupIds?: Maybe<Array<Scalars['PositiveInt']>>;
};


export type EventModelAsAdminRemoveAttendeesFrom3dPartyCalendarsArgs = {
  emails: Array<Scalars['String']>;
};


export type EventModelAsAdminInviteUserArgs = {
  userId: Scalars['PositiveInt'];
  sendInviteEmail: Scalars['Boolean'];
  certification_id?: Maybe<Scalars['PositiveInt']>;
  emailIdentityId?: Maybe<Scalars['PositiveInt']>;
};


export type EventModelAsAdminInviteGroupArgs = {
  groupId: Scalars['PositiveInt'];
  sendInviteEmail: Scalars['Boolean'];
  emailIdentityId?: Maybe<Scalars['PositiveInt']>;
};


export type EventModelAsAdminRemoveGroupInviteArgs = {
  groupId: Scalars['PositiveInt'];
};


export type EventModelAsAdminAddTagArgs = {
  id: Scalars['PositiveInt'];
};


export type EventModelAsAdminRemoveTagArgs = {
  id: Scalars['PositiveInt'];
};


export type EventModelAsAdminEventInviteesArgs = {
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['PositiveInt']>;
  filters?: Maybe<Array<EventInviteeFilterInput>>;
  orderBy?: Maybe<InviteesIndirectOrderColumnEnum>;
  orderDirection: SqlOrderDirectionEnum;
};


export type EventModelAsAdminEventInviteesTotalCountArgs = {
  filters?: Maybe<Array<EventInviteeFilterInput>>;
};


export type EventModelAsAdminAddCommentArgs = {
  content: Scalars['String'];
  replyTo?: Maybe<Scalars['PositiveInt']>;
};

export enum EventModelAsAdminFilterEnum {
  search = 'search',
  title = 'title',
  searchEventTitle = 'searchEventTitle',
  published = 'published',
  draft = 'draft',
  open = 'open',
  inProgress = 'inProgress',
  completed = 'completed',
  afterEventId = 'afterEventId',
  before = 'before',
  after = 'after',
  endingFrom = 'endingFrom',
  status = 'status',
  tagId = 'tagId',
  includeDeleted = 'includeDeleted',
  period = 'period'
}

export type EventModelAsAdminFilterInput = {
  name: EventModelAsAdminFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type EventModelAsStudent = {
  __typename?: 'EventModelAsStudent';
  deleted_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  author_id: Scalars['PositiveInt'];
  recurring_event_id?: Maybe<Scalars['PositiveInt']>;
  start_time?: Maybe<Scalars['DateTime']>;
  end_time?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  update_email_sent_at?: Maybe<Scalars['DateTime']>;
  published_date?: Maybe<Scalars['DateTime']>;
  participants_limit?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['String']>;
  title: Scalars['LengthValidatedString_512'];
  location?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['SizeValidatedString_200KB']>;
  allow_comments: Scalars['Boolean'];
  is_open: Scalars['Boolean'];
  facilitator_id?: Maybe<Scalars['PositiveInt']>;
  google_meet_uuid?: Maybe<Scalars['String']>;
  google_meet_id?: Maybe<Scalars['String']>;
  ms_teams_url?: Maybe<Scalars['String']>;
  ms_teams_enabled: Scalars['Boolean'];
  /** only individuals invited directly */
  attendedInvitees: Array<UserEventModel>;
  /** only individuals invited directly */
  invitees: Array<UserEventModel>;
  invitee?: Maybe<UserEventModel>;
  currentUserInvitee?: Maybe<UserEventModel>;
  /** only counts individuals invited directly */
  inviteesCount: Scalars['NonNegativeInt'];
  attendeesCount: Scalars['NonNegativeInt'];
  presentCount: Scalars['NonNegativeInt'];
  formattedTimeRange: Scalars['String'];
  currentUserInvitation?: Maybe<UserEventModel>;
  registerToAttend?: Maybe<UserEventModel>;
  /** used for changing student status in 3d party calendars events */
  changeStatusForAttenderIn3dPartyCalendars?: Maybe<Scalars['Boolean']>;
  cancelAttendance?: Maybe<UserEventModel>;
  author: UserModelPublicBase;
  organisation: OrganisationModel;
  invitedGroups: Array<GroupModelGqlBase>;
  invitedGroupsCount: Scalars['NonNegativeInt'];
  /** finds a single invitedGroup by the idColumn of the relation */
  invitedGroup?: Maybe<GroupModelGqlBase>;
  inviteeGroups: Array<EventGroupModel>;
  inviteeGroupsCount: Scalars['NonNegativeInt'];
  /** finds a single inviteeGroup by the idColumn of the relation */
  inviteeGroup?: Maybe<EventGroupModel>;
  invitedUsers: Array<UserModelPublicBase>;
  invitedUsersCount: Scalars['NonNegativeInt'];
  /** finds a single invitedUser by the idColumn of the relation */
  invitedUser?: Maybe<UserModelPublicBase>;
  tags: Array<TagModel>;
  tagsCount: Scalars['NonNegativeInt'];
  /** finds a single tag by the idColumn of the relation */
  tag?: Maybe<TagModel>;
  certificationItems: Array<CertificationItemModel>;
  certificationItemsCount: Scalars['NonNegativeInt'];
  /** finds a single certificationItem by the idColumn of the relation */
  certificationItem?: Maybe<CertificationItemModel>;
  facilitator?: Maybe<UserModelPublicBase>;
  recurringEvent?: Maybe<RecurringEventModelAsStudent>;
  isFollowingComments: Scalars['Boolean'];
  comments: Array<CommentModel>;
  addComment: CommentModel;
};


export type EventModelAsStudentInviteeArgs = {
  userId: Scalars['PositiveInt'];
};


export type EventModelAsStudentChangeStatusForAttenderIn3dPartyCalendarsArgs = {
  attending: Scalars['Boolean'];
};


export type EventModelAsStudentInvitedGroupsArgs = {
  filters?: Maybe<Array<GroupModelGqlBaseFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type EventModelAsStudentInvitedGroupsCountArgs = {
  filters?: Maybe<Array<GroupModelGqlBaseFilterInput>>;
};


export type EventModelAsStudentInvitedGroupArgs = {
  id: Scalars['PositiveInt'];
};


export type EventModelAsStudentInviteeGroupsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type EventModelAsStudentInviteeGroupsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type EventModelAsStudentInviteeGroupArgs = {
  id: Scalars['PositiveInt'];
};


export type EventModelAsStudentInvitedUsersArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type EventModelAsStudentInvitedUsersCountArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
};


export type EventModelAsStudentInvitedUserArgs = {
  id: Scalars['PositiveInt'];
};


export type EventModelAsStudentTagsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type EventModelAsStudentTagsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type EventModelAsStudentTagArgs = {
  id: Scalars['PositiveInt'];
};


export type EventModelAsStudentCertificationItemsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type EventModelAsStudentCertificationItemsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type EventModelAsStudentCertificationItemArgs = {
  id: Scalars['PositiveInt'];
};


export type EventModelAsStudentAddCommentArgs = {
  content: Scalars['String'];
  replyTo?: Maybe<Scalars['PositiveInt']>;
};

export enum EventModelFilterEnum {
  search = 'search',
  title = 'title',
  searchEventTitle = 'searchEventTitle',
  published = 'published',
  draft = 'draft',
  open = 'open',
  inProgress = 'inProgress',
  completed = 'completed',
  afterEventId = 'afterEventId',
  before = 'before',
  after = 'after',
  endingFrom = 'endingFrom',
  status = 'status',
  tagId = 'tagId',
  includeDeleted = 'includeDeleted',
  period = 'period'
}

export type EventModelFilterInput = {
  name: EventModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type EventModelInput = {
  start_time?: Maybe<Scalars['DateTime']>;
  end_time?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  participants_limit?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['LengthValidatedString_512']>;
  location?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['SizeValidatedString_200KB']>;
  allow_comments?: Maybe<Scalars['Boolean']>;
  is_open?: Maybe<Scalars['Boolean']>;
  facilitator_id?: Maybe<Scalars['PositiveInt']>;
  google_meet_uuid?: Maybe<Scalars['String']>;
  ms_teams_enabled?: Maybe<Scalars['Boolean']>;
};

export enum EventRecurrenceDayEnum {
  SU = 'SU',
  MO = 'MO',
  TU = 'TU',
  WE = 'WE',
  TH = 'TH',
  FR = 'FR',
  SA = 'SA'
}

export enum EventRecurrenceFreqEnum {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}

export enum EventRecurrenceMonthEnum {
  jan = 'jan',
  feb = 'feb',
  mar = 'mar',
  apr = 'apr',
  may = 'may',
  jun = 'jun',
  jul = 'jul',
  aug = 'aug',
  sep = 'sep',
  oct = 'oct',
  nov = 'nov',
  dec = 'dec'
}

export type EventRecurrencePattern = {
  __typename?: 'EventRecurrencePattern';
  count: Scalars['PositiveInt'];
  freq?: Maybe<EventRecurrenceFreqEnum>;
  interval?: Maybe<Scalars['PositiveInt']>;
  byDay?: Maybe<Array<EventRecurrenceDayEnum>>;
  byMonth?: Maybe<Array<EventRecurrenceMonthEnum>>;
  byYear?: Maybe<Scalars['PositiveInt']>;
};

export type FeatureConfigModel = {
  __typename?: 'FeatureConfigModel';
  id: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  name: Scalars['String'];
  enabled: Scalars['Boolean'];
  config?: Maybe<Scalars['JSON']>;
};

export type FieldsConfigRecord = {
  __typename?: 'FieldsConfigRecord';
  verificationFields?: Maybe<Array<Scalars['String']>>;
};

export type FieldsConfigRecordInput = {
  verificationFields: Array<Scalars['String']>;
};

export type FileDetailsInput = {
  fileUrl: Scalars['String'];
  mimeType: Scalars['String'];
  fileSize: Scalars['Int'];
};

export type FilterDescriptor = {
  name: Scalars['String'];
  value?: Maybe<Scalars['JSON']>;
};

export enum FollowResourceType {
  topic = 'topic',
  event = 'event',
  pathway = 'pathway'
}

export type GoogleCalendarConfigPublic = {
  __typename?: 'GoogleCalendarConfigPublic';
  calendarId?: Maybe<Scalars['String']>;
};

export type GoogleDriveFileInput = {
  description?: Maybe<Scalars['String']>;
  embedUrl?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastEditedUtc?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type GroupInput = {
  name?: Maybe<Scalars['String']>;
  is_cpd?: Maybe<Scalars['Boolean']>;
};

export type GroupModel = {
  __typename?: 'GroupModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  name: Scalars['String'];
  created_by: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  is_cpd: Scalars['Boolean'];
  usersCountInGroup?: Maybe<Scalars['NonNegativeInt']>;
  users: Array<UserModelPublicBase>;
  usersCount: Scalars['NonNegativeInt'];
  /** finds a single user by the idColumn of the relation */
  user?: Maybe<UserModelPublicBase>;
};


export type GroupModelUsersArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type GroupModelUsersCountArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
};


export type GroupModelUserArgs = {
  id: Scalars['PositiveInt'];
};

export type GroupModelAsAdmin = {
  __typename?: 'GroupModelAsAdmin';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  name: Scalars['String'];
  created_by: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  is_cpd: Scalars['Boolean'];
  usersCountInGroup?: Maybe<Scalars['NonNegativeInt']>;
  users: Array<UserModelAsAdminQueries>;
  usersCount: Scalars['NonNegativeInt'];
  /** finds a single user by the idColumn of the relation */
  user?: Maybe<UserModelAsAdminQueries>;
  patch?: Maybe<GroupModelAsAdmin>;
  delete?: Maybe<Scalars['NonNegativeInt']>;
  relatedCampaigns: Array<CampaignModelAsAdminMutations>;
  relatedDashboards: Array<DashboardModelAsAdminMutations>;
  createSecretSignupLink?: Maybe<SecretSignupLinkModel>;
  /** Returns ids of added users. Users who already were in that group are not returned. */
  batchAddUsers?: Maybe<Array<Scalars['PositiveInt']>>;
  workspaces: Array<WorkspaceModelAsCoordinator>;
  workspacesCount: Scalars['NonNegativeInt'];
  /** finds a single workspace by the idColumn of the relation */
  workspace?: Maybe<WorkspaceModelAsCoordinator>;
  groupWorkspaces: Array<GroupWorkspaceModel>;
  groupWorkspacesCount: Scalars['NonNegativeInt'];
  /** finds a single groupWorkspace by the idColumn of the relation */
  groupWorkspace?: Maybe<GroupWorkspaceModel>;
  organisation: OrganisationModel;
  scimResource?: Maybe<ScimResourceModel>;
  secretSignupLinks: Array<SecretSignupLinkModel>;
  secretSignupLinksCount: Scalars['NonNegativeInt'];
  /** finds a single secretSignupLink by the idColumn of the relation */
  secretSignupLink?: Maybe<SecretSignupLinkModel>;
};


export type GroupModelAsAdminUsersArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type GroupModelAsAdminUsersCountArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
};


export type GroupModelAsAdminUserArgs = {
  id: Scalars['PositiveInt'];
};


export type GroupModelAsAdminPatchArgs = {
  input: GroupInput;
};


export type GroupModelAsAdminBatchAddUsersArgs = {
  userIds: Array<Scalars['PositiveInt']>;
};


export type GroupModelAsAdminWorkspacesArgs = {
  filters?: Maybe<Array<WorkspaceModelAsCoordinatorFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type GroupModelAsAdminWorkspacesCountArgs = {
  filters?: Maybe<Array<WorkspaceModelAsCoordinatorFilterInput>>;
};


export type GroupModelAsAdminWorkspaceArgs = {
  id: Scalars['PositiveInt'];
};


export type GroupModelAsAdminGroupWorkspacesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type GroupModelAsAdminGroupWorkspacesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type GroupModelAsAdminGroupWorkspaceArgs = {
  id: Scalars['PositiveInt'];
};


export type GroupModelAsAdminSecretSignupLinksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type GroupModelAsAdminSecretSignupLinksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type GroupModelAsAdminSecretSignupLinkArgs = {
  id: Scalars['PositiveInt'];
};

export enum GroupModelAsAdminFilterEnum {
  search = 'search'
}

export type GroupModelAsAdminFilterInput = {
  name: GroupModelAsAdminFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export enum GroupModelFilterEnum {
  search = 'search'
}

export type GroupModelFilterInput = {
  name: GroupModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type GroupModelGqlBase = {
  __typename?: 'GroupModelGQLBase';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  name: Scalars['String'];
  created_by: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  is_cpd: Scalars['Boolean'];
  usersCountInGroup?: Maybe<Scalars['NonNegativeInt']>;
  users: Array<UserModelPublicBase>;
  usersCount: Scalars['NonNegativeInt'];
  /** finds a single user by the idColumn of the relation */
  user?: Maybe<UserModelPublicBase>;
};


export type GroupModelGqlBaseUsersArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type GroupModelGqlBaseUsersCountArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
};


export type GroupModelGqlBaseUserArgs = {
  id: Scalars['PositiveInt'];
};

export enum GroupModelGqlBaseFilterEnum {
  search = 'search'
}

export type GroupModelGqlBaseFilterInput = {
  name: GroupModelGqlBaseFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type GroupModelWithWorkspaceRole = {
  __typename?: 'GroupModelWithWorkspaceRole';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  name: Scalars['String'];
  created_by: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  is_cpd: Scalars['Boolean'];
  usersCountInGroup?: Maybe<Scalars['NonNegativeInt']>;
  users: Array<UserModelPublicBase>;
  usersCount: Scalars['NonNegativeInt'];
  /** finds a single user by the idColumn of the relation */
  user?: Maybe<UserModelPublicBase>;
  workspaceRole?: Maybe<WorkspaceRoleEnum>;
};


export type GroupModelWithWorkspaceRoleUsersArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type GroupModelWithWorkspaceRoleUsersCountArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
};


export type GroupModelWithWorkspaceRoleUserArgs = {
  id: Scalars['PositiveInt'];
};

export type GroupModelWithWorkspaceRoleOverview = {
  __typename?: 'GroupModelWithWorkspaceRoleOverview';
  items: Array<GroupModelWithWorkspaceRole>;
  count?: Maybe<Scalars['Float']>;
};

export type GroupWorkspaceModel = {
  __typename?: 'GroupWorkspaceModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  group_id: Scalars['PositiveInt'];
  workspace_id: Scalars['PositiveInt'];
  role?: Maybe<WorkspaceRoleEnum>;
};

export type HotjarSetup = {
  __typename?: 'HotjarSetup';
  enabled?: Maybe<Scalars['Boolean']>;
  site_id?: Maybe<Scalars['PositiveInt']>;
};

/** any item which can be found using full text search */
export type ISearchable = {
  id: Scalars['PositiveInt'];
};

export type IThemeModel = {
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  workspace_id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  title?: Maybe<Scalars['String']>;
  topics: Array<ITopicModel>;
  topicsCount: Scalars['NonNegativeInt'];
  /** finds a single topic by the idColumn of the relation */
  topic?: Maybe<ITopicModel>;
};


export type IThemeModelTopicsArgs = {
  filters?: Maybe<Array<ITopicModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type IThemeModelTopicsCountArgs = {
  filters?: Maybe<Array<ITopicModelFilterInput>>;
};


export type IThemeModelTopicArgs = {
  id: Scalars['PositiveInt'];
};

/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModel = {
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  workspace_id: Scalars['PositiveInt'];
  production_topic_version_id?: Maybe<Scalars['PositiveInt']>;
  allow_comments?: Maybe<Scalars['Boolean']>;
  /** Sum of all rating values by students on this topic */
  total_rating: Scalars['NonNegativeInt'];
  /** Sum of students who rated this topic */
  number_rated: Scalars['NonNegativeInt'];
  theme_id?: Maybe<Scalars['PositiveInt']>;
  /** if published, returns title of currentTopicVersion, if not returns title of draftVersion */
  currentTitle: Scalars['String'];
  lastPublishedDate?: Maybe<Scalars['DateTime']>;
  firstPublishedDate?: Maybe<Scalars['DateTime']>;
  draftUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** returns date of last access to topic */
  lastViewedAt?: Maybe<Scalars['DateTime']>;
  /** creates a new enrolment if retry is allowed on the current topic version */
  reEnrol?: Maybe<TopicEnrolmentModelAsStudent>;
  /** returns current user's last enrolment for this topic or null */
  lastEnrolment?: Maybe<TopicEnrolmentModelAsStudent>;
  certificationRelatedEnrolment?: Maybe<TopicEnrolmentModel>;
  lastCompletedEnrolment?: Maybe<TopicEnrolmentModelAsStudent>;
  latestPublishedTopicVersion?: Maybe<Scalars['String']>;
  /** returns already existing enrolment or it creates a new one if various conditions are met */
  enrolmentOrSelfEnrol: TopicEnrolmentModelAsStudent;
  openedFromCampaignShareEmail?: Maybe<Scalars['NonNegativeInt']>;
  author: UserModelPublicBase;
  currentTopicVersion?: Maybe<TopicVersionModel>;
  coverImage?: Maybe<DocumentModel>;
  coverImageVariants: Array<ImageVariantModel>;
  coverImageVariantsCount: Scalars['NonNegativeInt'];
  /** finds a single coverImageVariant by the idColumn of the relation */
  coverImageVariant?: Maybe<ImageVariantModel>;
  pathways: Array<PathwayModel>;
  pathwaysCount: Scalars['NonNegativeInt'];
  /** finds a single pathway by the idColumn of the relation */
  pathway?: Maybe<PathwayModel>;
  topicEditors: Array<TopicEditorModel>;
  topicEditorsCount: Scalars['NonNegativeInt'];
  /** finds a single topicEditor by the idColumn of the relation */
  topicEditor?: Maybe<TopicEditorModel>;
  theme: ThemeModel;
  certificationItems: Array<CertificationItemModel>;
  certificationItemsCount: Scalars['NonNegativeInt'];
  /** finds a single certificationItem by the idColumn of the relation */
  certificationItem?: Maybe<CertificationItemModel>;
  isFollowingComments: Scalars['Boolean'];
  comments: Array<CommentModel>;
  addComment: CommentModel;
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelCertificationRelatedEnrolmentArgs = {
  certEnrolmentId: Scalars['PositiveInt'];
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelEnrolmentOrSelfEnrolArgs = {
  restartEnrolment?: Maybe<Scalars['Boolean']>;
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelOpenedFromCampaignShareEmailArgs = {
  scheduledCampaignActionId: Scalars['PositiveInt'];
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelCoverImageVariantsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelCoverImageVariantsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelCoverImageVariantArgs = {
  id: Scalars['PositiveInt'];
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelPathwaysArgs = {
  filters?: Maybe<Array<PathwayModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelPathwaysCountArgs = {
  filters?: Maybe<Array<PathwayModelFilterInput>>;
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelPathwayArgs = {
  id: Scalars['PositiveInt'];
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelTopicEditorsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelTopicEditorsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelTopicEditorArgs = {
  id: Scalars['PositiveInt'];
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelCertificationItemsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelCertificationItemsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelCertificationItemArgs = {
  id: Scalars['PositiveInt'];
};


/** base topic model accessible to anyone who has access to parent workspace */
export type ITopicModelAddCommentArgs = {
  content: Scalars['String'];
  replyTo?: Maybe<Scalars['PositiveInt']>;
};

export enum ITopicModelFilterEnum {
  title = 'title',
  withCurrentVersion = 'withCurrentVersion',
  notArchived = 'notArchived',
  searchByIds = 'searchByIds',
  noTheme = 'noTheme'
}

export type ITopicModelFilterInput = {
  name: ITopicModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type IWorkspaceBookmarkModel = {
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  title: Scalars['String'];
  url: Scalars['String'];
  order?: Maybe<Scalars['NonNegativeInt']>;
  type?: Maybe<WorkspaceBookmarkTypeEnum>;
  image?: Maybe<PrivateImageWithVariants>;
  workspace: WorkspaceModel;
};

export type IWorkspaceModel = {
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  is_open: Scalars['Boolean'];
  /**
   * role of the current user in this workspace,
   *       DEPRECATED prefer checking the typename of the workspace,
   *       can be null when STUDENT user is accessing this workspace from analytics
   */
  role?: Maybe<WorkspaceRoleEnum>;
  publishedTopicsCount: Scalars['NonNegativeInt'];
  currentTopicVersion?: Maybe<TopicVersionModel>;
  topics: Array<ITopicModel>;
  bookmarkList: Array<IWorkspaceBookmarkModel>;
  topic?: Maybe<ITopicModel>;
  /** returns a count of incomplete assigned enrolments for the current user in this workspace */
  assignedEnrolmentsCount?: Maybe<Scalars['NonNegativeInt']>;
  coverImage?: Maybe<DocumentModel>;
  tags: Array<TagModel>;
  tagsCount: Scalars['NonNegativeInt'];
  /** finds a single tag by the idColumn of the relation */
  tag?: Maybe<TagModel>;
  owner: UserModelPublicBase;
  themes: Array<IThemeModel>;
  themesCount: Scalars['NonNegativeInt'];
  /** finds a single theme by the idColumn of the relation */
  theme?: Maybe<IThemeModel>;
  bookmarks: Array<IWorkspaceBookmarkModel>;
  bookmarksCount: Scalars['NonNegativeInt'];
  /** finds a single bookmark by the idColumn of the relation */
  bookmark?: Maybe<IWorkspaceBookmarkModel>;
};


export type IWorkspaceModelCurrentTopicVersionArgs = {
  id: Scalars['PositiveInt'];
};


export type IWorkspaceModelTopicsArgs = {
  filters?: Maybe<Array<ITopicModelFilterInput>>;
};


export type IWorkspaceModelTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type IWorkspaceModelTagsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type IWorkspaceModelTagsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type IWorkspaceModelTagArgs = {
  id: Scalars['PositiveInt'];
};


export type IWorkspaceModelThemesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type IWorkspaceModelThemesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type IWorkspaceModelThemeArgs = {
  id: Scalars['PositiveInt'];
};


export type IWorkspaceModelBookmarksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type IWorkspaceModelBookmarksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type IWorkspaceModelBookmarkArgs = {
  id: Scalars['PositiveInt'];
};

export type ImageVariantModel = {
  __typename?: 'ImageVariantModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  cdnUrl?: Maybe<Scalars['String']>;
  file_url?: Maybe<Scalars['String']>;
  document_id: Scalars['PositiveInt'];
  size_key?: Maybe<Scalars['String']>;
};

export enum ImageVariantSizes {
  small = 'small',
  medium = 'medium',
  large = 'large',
  extraLarge = 'extraLarge'
}

export type ImageWithVariants = {
  __typename?: 'ImageWithVariants';
  original?: Maybe<Scalars['String']>;
  variants?: Maybe<Scalars['JSON']>;
  variantCdnUrl?: Maybe<Scalars['String']>;
  originalCdnUrl?: Maybe<Scalars['String']>;
};


export type ImageWithVariantsVariantCdnUrlArgs = {
  imageSize: ImageVariantSizes;
};

/** returned from campaign immediateUsers resolver */
export type ImmediateCampaignUser = {
  __typename?: 'ImmediateCampaignUser';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  image_url?: Maybe<Scalars['String']>;
  id: Scalars['PositiveInt'];
  email?: Maybe<Scalars['EmailAddressWithTLD']>;
  custom_1?: Maybe<Scalars['String']>;
  custom_2?: Maybe<Scalars['String']>;
  custom_3?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  manager_id?: Maybe<Scalars['PositiveInt']>;
  position?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  states?: Maybe<Scalars['JSON']>;
  step?: Maybe<Scalars['Float']>;
  employee_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  privacy_policy_accepted?: Maybe<Scalars['DateTime']>;
  preferences: UserPreferences;
  organisation_role: OrganisationRoleEnum;
  uploaded_img_url?: Maybe<Scalars['String']>;
  profile_img_url?: Maybe<Scalars['String']>;
  password_last_updated_at?: Maybe<Scalars['DateTime']>;
  display_name: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  verified: Scalars['Boolean'];
  phone_number?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['NonEmptyString']>;
  locale?: Maybe<SupportedLocalesEnum>;
  calendars: UserCalendars;
  userIdentity: Scalars['String'];
  memberInGroups?: Maybe<Scalars['String']>;
  /** When false, user can still have the default password that was used in the CSV user import. True indicates this user has set his own password-it was not set for him by someone else. */
  hasOwnPasswordSet?: Maybe<Scalars['Boolean']>;
  analytic_events_count: Scalars['NonNegativeInt'];
};

export type ImportScormCourseInput = {
  url: Scalars['String'];
  filename: Scalars['String'];
  filesize: Scalars['PositiveInt'];
};

export enum InviteesIndirectOrderColumnEnum {
  created_at = 'created_at',
  inviteSource = 'inviteSource',
  attending = 'attending',
  present = 'present',
  user_display_name = 'user_display_name',
  display_name = 'display_name'
}






export type LinkUnfurlingData = {
  __typename?: 'LinkUnfurlingData';
  enabled?: Maybe<Scalars['Boolean']>;
  switched_on?: Maybe<Scalars['Boolean']>;
};


export type LoginAndSetAdditionalDataInput = {
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailAddress']>;
  custom_1?: Maybe<Scalars['String']>;
  custom_2?: Maybe<Scalars['String']>;
  custom_3?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  employee_id?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
};

export type LoginAndSetPasswordWithAdditionalDataInput = {
  password: Scalars['String'];
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailAddress']>;
  custom_1?: Maybe<Scalars['String']>;
  custom_2?: Maybe<Scalars['String']>;
  custom_3?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  employee_id?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
};

export type MsGraphCalendarConfig = {
  __typename?: 'MSGraphCalendarConfig';
  accountName?: Maybe<Scalars['String']>;
};

export enum MediaImpressionsOverviewOrderColumn {
  displayName = 'displayName',
  engagementPercent = 'engagementPercent',
  playTimeSeconds = 'playTimeSeconds',
  updatedAt = 'updatedAt'
}

export enum MediaOverviewOrderColumn {
  fileName = 'fileName',
  resourceName = 'resourceName',
  avgEngagement = 'avgEngagement',
  playsCount = 'playsCount',
  uniquePlaysCount = 'uniquePlaysCount',
  impressionsCount = 'impressionsCount',
  uniqueImpressionsCount = 'uniqueImpressionsCount',
  playRate = 'playRate',
  lastActivity = 'lastActivity',
  createdAt = 'createdAt',
  totalPlayTime = 'totalPlayTime'
}

export type MessageSendEvent = {
  __typename?: 'MessageSendEvent';
  sent?: Maybe<Scalars['DateTime']>;
};

export type MicrosoftFileInput = {
  embedUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum MoveDirectionEnum {
  UP = 'UP',
  DOWN = 'DOWN'
}

export type Mutation = {
  __typename?: 'Mutation';
  organisation?: Maybe<OrganisationModelGqlBase>;
  /** With this mutation user is marked as verified-green checkbox appears next to the email on user's profile. */
  verifyUser?: Maybe<UserModelPublicBase>;
  isAvailableForLogin?: Maybe<AvailableForLoginResponse>;
  generateResetPasswordLink?: Maybe<Scalars['Boolean']>;
  generateUserResetPasswordLinkUsingSecurityQuestions?: Maybe<Scalars['String']>;
  resetPassword?: Maybe<UserModelBase>;
  sendVerificationEmail?: Maybe<SendEmailRequestResult>;
  selfSignUpToOrganisation?: Maybe<UserModelPublicBase>;
  /** Allows to sign up in organisation with provided additional info + secret questions answers */
  selfSignUpToOrganisationWithSecurityQuestions?: Maybe<UserSessionModelSelf>;
  /** Allows to login in organisation without password with provided verification data and additional info + secret questions answers */
  loginToExistingAccountWithVerificationFlow?: Maybe<UserSessionModelSelf>;
  login?: Maybe<UserSessionModelSelf>;
  logout?: Maybe<Scalars['Boolean']>;
  loginWithSSOAccessToken?: Maybe<UserSessionModel>;
  signup?: Maybe<SignupResult>;
  sendEmailWithAvailableSubdomains?: Maybe<SendEmailRequestResult>;
  updateVerifiedEmailIdentities?: Maybe<Scalars['NonNegativeInt']>;
  loginAndSaveSecurityQuestions?: Maybe<UserSessionModel>;
  loginAndSaveAdditionalData?: Maybe<UserSessionModel>;
  userByCredentials?: Maybe<UserModelBase>;
};


export type MutationOrganisationArgs = {
  subdomainName?: Maybe<Scalars['String']>;
};


export type MutationVerifyUserArgs = {
  token: Scalars['String'];
};


export type MutationIsAvailableForLoginArgs = {
  accountNameOrEmail: Scalars['NonEmptyString'];
};


export type MutationGenerateResetPasswordLinkArgs = {
  email: Scalars['EmailAddressWithTLD'];
  organisationId: Scalars['PositiveInt'];
};


export type MutationGenerateUserResetPasswordLinkUsingSecurityQuestionsArgs = {
  accountName: Scalars['NonEmptyString'];
  questionAnswers: Array<SecurityQuestionsDataInput>;
};


export type MutationResetPasswordArgs = {
  userId: Scalars['PositiveInt'];
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationSendVerificationEmailArgs = {
  email: Scalars['EmailAddressWithTLD'];
  organisationId: Scalars['PositiveInt'];
};


export type MutationSelfSignUpToOrganisationArgs = {
  email: Scalars['EmailAddressWithTLD'];
  password: Scalars['String'];
};


export type MutationSelfSignUpToOrganisationWithSecurityQuestionsArgs = {
  userData: SelfSignUpUserDataInput;
  securityQuestions?: Maybe<Array<SecurityQuestionsDataInput>>;
};


export type MutationLoginToExistingAccountWithVerificationFlowArgs = {
  accountName: Scalars['NonEmptyString'];
  verificationData: UserVerificationDataInput;
  additionalData: LoginAndSetPasswordWithAdditionalDataInput;
  questionAnswers?: Maybe<Array<SecurityQuestionsDataInput>>;
};


export type MutationLoginArgs = {
  password: Scalars['String'];
  accountNameOrEmail: Scalars['NonEmptyString'];
};


export type MutationLoginWithSsoAccessTokenArgs = {
  accessToken: Scalars['String'];
  provider: SsoProviderEnum;
};


export type MutationSignupArgs = {
  organisationInput: SignupOrganisationInput;
  userInput: SignupUserInput;
};


export type MutationSendEmailWithAvailableSubdomainsArgs = {
  email: Scalars['EmailAddressWithTLD'];
};


export type MutationLoginAndSaveSecurityQuestionsArgs = {
  password: Scalars['String'];
  accountNameOrEmail: Scalars['NonEmptyString'];
  additionalData: LoginAndSetAdditionalDataInput;
  questionAnswers: Array<SecurityQuestionsDataInput>;
};


export type MutationLoginAndSaveAdditionalDataArgs = {
  password: Scalars['String'];
  accountNameOrEmail: Scalars['NonEmptyString'];
  additionalData: LoginAndSetAdditionalDataInput;
};


export type MutationUserByCredentialsArgs = {
  password: Scalars['NonEmptyString'];
  accountNameOrEmail: Scalars['NonEmptyString'];
};




export enum NotificationModelStateEnum {
  PROCESSED = 'PROCESSED',
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
  DELIVERY = 'DELIVERY',
  BOUNCE = 'BOUNCE',
  COMPLAINT = 'COMPLAINT'
}

export enum NotificationModelTypeEnum {
  EMAIL_WELCOME = 'EMAIL_WELCOME',
  EMAIL_ACTIVATE_ACCOUNT = 'EMAIL_ACTIVATE_ACCOUNT',
  EMAIL_RESET_PASSWORD = 'EMAIL_RESET_PASSWORD',
  EMAIL_ASSIGN = 'EMAIL_ASSIGN',
  EMAIL_CAMPAIGN_TOPIC_ASSIGN = 'EMAIL_CAMPAIGN_TOPIC_ASSIGN',
  EMAIL_CAMPAIGN = 'EMAIL_CAMPAIGN',
  EMAIL_VERIFY = 'EMAIL_VERIFY',
  EMAIL_SUBDOMAIN_ACCESS = 'EMAIL_SUBDOMAIN_ACCESS',
  EMAIL_SUBDOMAIN_NO_ACCESS = 'EMAIL_SUBDOMAIN_NO_ACCESS',
  EMAIL_COMMENTS = 'EMAIL_COMMENTS',
  EMAIL_ENROLMENT_REMINDER = 'EMAIL_ENROLMENT_REMINDER',
  EMAIL_NEW_CONTENT = 'EMAIL_NEW_CONTENT',
  EMAIL_ORG_SUSPEND = 'EMAIL_ORG_SUSPEND',
  EMAIL_RECURRING_INVITE = 'EMAIL_RECURRING_INVITE',
  EMAIL_EVENT_INVITE = 'EMAIL_EVENT_INVITE',
  EMAIL_EVENT_REGISTERED = 'EMAIL_EVENT_REGISTERED',
  EMAIL_EVENT_CANCELLED = 'EMAIL_EVENT_CANCELLED',
  EMAIL_RECURRING_EVENT_ATTEND_MULTIPLE_CANCELLED = 'EMAIL_RECURRING_EVENT_ATTEND_MULTIPLE_CANCELLED',
  EMAIL_RECURRING_EVENT_ATTEND_MULTIPLE_CANCELLED_FOR_RSVPED = 'EMAIL_RECURRING_EVENT_ATTEND_MULTIPLE_CANCELLED_FOR_RSVPED',
  EMAIL_RECURRING_EVENT_ATTEND_ALL_CANCELLED = 'EMAIL_RECURRING_EVENT_ATTEND_ALL_CANCELLED',
  EMAIL_EVENT_UPDATED = 'EMAIL_EVENT_UPDATED',
  EMAIL_RECURRING_EVENT_INVITE = 'EMAIL_RECURRING_EVENT_INVITE',
  EMAIL_RECURRING_SPECIFIC_EVENT_INVITE = 'EMAIL_RECURRING_SPECIFIC_EVENT_INVITE',
  EMAIL_RECURRING_EVENT_REGISTERED = 'EMAIL_RECURRING_EVENT_REGISTERED',
  EMAIL_RECURRING_EVENT_ATTEND_ALL_UPDATED = 'EMAIL_RECURRING_EVENT_ATTEND_ALL_UPDATED',
  EMAIL_RECURRING_EVENT_ATTEND_MULTIPLE_UPDATED = 'EMAIL_RECURRING_EVENT_ATTEND_MULTIPLE_UPDATED',
  EMAIL_ACCESS_REQUEST = 'EMAIL_ACCESS_REQUEST',
  EMAIL_ACCESS_APPROVE = 'EMAIL_ACCESS_APPROVE',
  EMAIL_PATHWAY = 'EMAIL_PATHWAY',
  EMAIL_CAMPAIGN_PATHWAY_ASSIGN = 'EMAIL_CAMPAIGN_PATHWAY_ASSIGN',
  EMAIL_CAMPAIGN_SURVEY_ASSIGN = 'EMAIL_CAMPAIGN_SURVEY_ASSIGN',
  EMAIL_CERTIFICATION = 'EMAIL_CERTIFICATION',
  EMAIL_FEEDBACK = 'EMAIL_FEEDBACK',
  EMAIL_SURVEY_SEND = 'EMAIL_SURVEY_SEND',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION',
  SMS_CAMPAIGN_MESSAGE = 'SMS_CAMPAIGN_MESSAGE',
  SLACK_CAMPAIGN_MESSAGE = 'SLACK_CAMPAIGN_MESSAGE',
  FOURTH_CAMPAIGN_MESSAGE = 'FOURTH_CAMPAIGN_MESSAGE',
  MSTEAMS_CAMPAIGN_MESSAGE = 'MSTEAMS_CAMPAIGN_MESSAGE',
  EMAIL_VIDEO_ASSESSMENT_SUBMITTED = 'EMAIL_VIDEO_ASSESSMENT_SUBMITTED',
  EMAIL_VIDEO_ASSESSMENT_REVIEWED = 'EMAIL_VIDEO_ASSESSMENT_REVIEWED',
  EMAIL_VERIFY_CUSTOM_SMTP_SENDER = 'EMAIL_VERIFY_CUSTOM_SMTP_SENDER',
  EMAIL_GROUP_DELETION = 'EMAIL_GROUP_DELETION',
  EMAIL_SERIES_REGISTERED = 'EMAIL_SERIES_REGISTERED'
}

export enum NotificationProcessedStateEnum {
  BOUNCE = 'BOUNCE',
  COMPLAINT = 'COMPLAINT',
  DELIVERY = 'DELIVERY',
  FAILED = 'FAILED',
  PROCESSED = 'PROCESSED'
}

export type NotificationQueueModel = {
  __typename?: 'NotificationQueueModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  from_id?: Maybe<Scalars['PositiveInt']>;
  to_id: Scalars['PositiveInt'];
  scheduled?: Maybe<Scalars['DateTime']>;
  device_token?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  message_id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['JSON']>;
  type?: Maybe<NotificationModelTypeEnum>;
  access_status?: Maybe<Scalars['String']>;
  pid?: Maybe<Scalars['String']>;
  analytics_hash?: Maybe<Scalars['String']>;
  state?: Maybe<NotificationModelStateEnum>;
  process?: Maybe<Scalars['String']>;
};


export type NotificationQueueModelProcessArgs = {
  batchId?: Maybe<Scalars['String']>;
};

export type NotificationQueueProcessedModel = {
  __typename?: 'NotificationQueueProcessedModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  from_id?: Maybe<Scalars['PositiveInt']>;
  to_id: Scalars['PositiveInt'];
  scheduled?: Maybe<Scalars['DateTime']>;
  device_token?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  message_id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['JSON']>;
  type?: Maybe<NotificationModelTypeEnum>;
  access_status?: Maybe<Scalars['String']>;
  pid?: Maybe<Scalars['String']>;
  analytics_hash?: Maybe<Scalars['String']>;
  opened_at?: Maybe<Scalars['DateTime']>;
  state?: Maybe<NotificationProcessedStateEnum>;
  organisation?: Maybe<OrganisationModelLambda>;
  recipient: UserModel;
  sender?: Maybe<UserModel>;
  scheduledCampaignAction: ScheduledCampaignActionModel;
};

export type OauthConfigModel = {
  __typename?: 'OauthConfigModel';
  id: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  provider: SsoProviderEnum;
  enabled: Scalars['Boolean'];
  data?: Maybe<Scalars['JSON']>;
  strategy?: Maybe<Scalars['String']>;
  generateServiceProviderMetadata?: Maybe<Scalars['String']>;
};


export type OauthConfigModelGenerateServiceProviderMetadataArgs = {
  decryptionCert?: Maybe<Scalars['String']>;
  signingCert?: Maybe<Scalars['String']>;
};

export enum OauthConfigModelFilterEnum {
  enabled = 'enabled'
}

export type OauthConfigModelFilterInput = {
  name: OauthConfigModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type OauthModel = {
  __typename?: 'OauthModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  user_id?: Maybe<Scalars['PositiveInt']>;
  link_user?: Maybe<Scalars['PositiveInt']>;
  method: Scalars['String'];
  provider_id: Scalars['String'];
  email?: Maybe<Scalars['EmailAddressWithTLD']>;
};

export type OrderDescriptor = {
  name: Scalars['String'];
  /** defaults to "asc" order */
  sort?: Maybe<Scalars['String']>;
};

export type OrderDescriptorWorkspaceUsersWithRole = {
  name: WorkspacesUsersWithRoleSortableColumnsEnum;
  sort?: Maybe<SqlOrderDirectionEnum>;
};

export type OrderDescriptorWorkspacesGroupsWithRole = {
  name: WorkspacesGroupsWithRoleSortableColumnsEnum;
  sort?: Maybe<SqlOrderDirectionEnum>;
};

export type OrganisationAccountNameLoginConfigAsAdminModel = {
  __typename?: 'OrganisationAccountNameLoginConfigAsAdminModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['PositiveInt']>;
  organisation: OrganisationModel;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  isUsingVerificationFields?: Maybe<Scalars['Boolean']>;
  fields_config?: Maybe<FieldsConfigRecord>;
  needToVerifyUserData?: Maybe<Scalars['Boolean']>;
};

export type OrganisationAccountNameLoginConfigModel = {
  __typename?: 'OrganisationAccountNameLoginConfigModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['PositiveInt']>;
  organisation: OrganisationModel;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  isUsingVerificationFields?: Maybe<Scalars['Boolean']>;
  fields_config?: Maybe<FieldsConfigRecord>;
  needToVerifyUserData?: Maybe<Scalars['Boolean']>;
};

export type OrganisationBusinessHoursModel = {
  __typename?: 'OrganisationBusinessHoursModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  patch: OrganisationBusinessHoursModel;
  id?: Maybe<Scalars['PositiveInt']>;
  enabled: Scalars['Boolean'];
  organisation_id: Scalars['PositiveInt'];
  days?: Maybe<BusinessHoursByDays>;
  organisation: OrganisationModel;
};


export type OrganisationBusinessHoursModelPatchArgs = {
  input: OrganisationBusinessHoursModelInput;
};

export type OrganisationBusinessHoursModelInput = {
  enabled?: Maybe<Scalars['Boolean']>;
  days?: Maybe<BusinessHoursByDaysInput>;
};

export type OrganisationCalendars = {
  __typename?: 'OrganisationCalendars';
  google?: Maybe<GoogleCalendarConfigPublic>;
  msgraph?: Maybe<MsGraphCalendarConfig>;
};

export type OrganisationCalendarsInputType = {
  google?: Maybe<Scalars['JSON']>;
};

export type OrganisationColorsInputType = {
  navbarBackground?: Maybe<Scalars['String']>;
  navbarLink?: Maybe<Scalars['String']>;
  buttonPrimary?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
};

export type OrganisationEmailIdentityInputType = {
  id?: Maybe<Scalars['PositiveInt']>;
  name: Scalars['String'];
  email: Scalars['String'];
  order?: Maybe<Scalars['NonNegativeInt']>;
};

export type OrganisationFeatures = {
  __typename?: 'OrganisationFeatures';
  campaigns?: Maybe<Scalars['Boolean']>;
  campaigns_event_filters?: Maybe<Scalars['Boolean']>;
  campaign_templating?: Maybe<Scalars['Boolean']>;
  campaign_manager_notification?: Maybe<Scalars['Boolean']>;
  campaigns_archive_cert_enrolments_after_user_leave?: Maybe<Scalars['Boolean']>;
  custom_email_sender_address?: Maybe<Scalars['Boolean']>;
  custom_i18n?: Maybe<Scalars['Boolean']>;
  search_analytics?: Maybe<Scalars['Boolean']>;
  SCORM?: Maybe<Scalars['Boolean']>;
  custom_font?: Maybe<Scalars['Boolean']>;
  Slack?: Maybe<Scalars['Boolean']>;
  Fourth?: Maybe<Scalars['Boolean']>;
  sms?: Maybe<Scalars['Boolean']>;
  account_name_login?: Maybe<Scalars['Boolean']>;
  msteams?: Maybe<Scalars['Boolean']>;
  dashboards?: Maybe<Scalars['Boolean']>;
  certificates?: Maybe<Scalars['Boolean']>;
  hotjar?: Maybe<HotjarSetup>;
  link_unfurling?: Maybe<LinkUnfurlingData>;
  bongo?: Maybe<Scalars['Boolean']>;
  cpd?: Maybe<CpdData>;
  gsuite?: Maybe<Scalars['Boolean']>;
  microsoft_365?: Maybe<Scalars['Boolean']>;
  multiple_senders?: Maybe<Scalars['Boolean']>;
  custom_smtp?: Maybe<Scalars['Boolean']>;
  video_analytics?: Maybe<Scalars['Boolean']>;
  calendars_integration?: Maybe<Scalars['Boolean']>;
  secret_signup?: Maybe<Scalars['Boolean']>;
  instant_sso_login?: Maybe<Scalars['Boolean']>;
};

export type OrganisationGSuite = {
  __typename?: 'OrganisationGSuite';
  calendar?: Maybe<Scalars['Boolean']>;
  drive?: Maybe<Scalars['Boolean']>;
  driveServiceAccount?: Maybe<Scalars['Boolean']>;
  linkedResourcesDriveId?: Maybe<Scalars['String']>;
};

export type OrganisationGSuiteInputType = {
  calendar?: Maybe<Scalars['Boolean']>;
  drive?: Maybe<Scalars['Boolean']>;
  driveServiceAccount?: Maybe<Scalars['Boolean']>;
  linkedResourcesDriveId?: Maybe<Scalars['String']>;
};

export type OrganisationInputType = {
  email_comments?: Maybe<Scalars['Boolean']>;
  email_content?: Maybe<Scalars['Boolean']>;
  allow_signup?: Maybe<Scalars['Boolean']>;
  session_expiry?: Maybe<Scalars['PositiveInt']>;
  color?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['LengthValidatedString_255']>;
  subdomain?: Maybe<Scalars['String']>;
  default_user_locale?: Maybe<SupportedLocalesEnum>;
  timezone?: Maybe<Scalars['String']>;
  domain_lock?: Maybe<Array<Scalars['DomainName']>>;
  ip_whitelist?: Maybe<Array<OrganisationIpWhitelistRecordInputType>>;
  logo?: Maybe<Scalars['JSON']>;
  oauthConfigs?: Maybe<Array<SsoProviderEnum>>;
  can_students_update_profile?: Maybe<Scalars['Boolean']>;
  only_sso_login?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<Scalars['JSON']>;
  hotjar_site_id?: Maybe<Scalars['PositiveInt']>;
  link_unfurling_switched_on?: Maybe<Scalars['Boolean']>;
  cpd_switched_on?: Maybe<Scalars['Boolean']>;
  g_suite?: Maybe<OrganisationGSuiteInputType>;
  styles?: Maybe<OrganisationStylesInputType>;
  embed_domains?: Maybe<EmbedDomainsInput>;
  calendars?: Maybe<OrganisationCalendarsInputType>;
};

export type OrganisationIpWhitelistRecordInputType = {
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
};

export type OrganisationModel = {
  __typename?: 'OrganisationModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  /** duration of a user session in seconds */
  session_expiry: Scalars['PositiveInt'];
  name?: Maybe<Scalars['String']>;
  default_user_locale?: Maybe<SupportedLocalesEnum>;
};

export type OrganisationModelAsAdminMutations = {
  __typename?: 'OrganisationModelAsAdminMutations';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  session_expiry?: Maybe<Scalars['PositiveInt']>;
  name?: Maybe<Scalars['LengthValidatedString_255']>;
  default_user_locale?: Maybe<SupportedLocalesEnum>;
  user_id: Scalars['PositiveInt'];
  domain_lock?: Maybe<Scalars['JSON']>;
  color?: Maybe<Scalars['String']>;
  logo?: Maybe<ImageWithVariants>;
  allow_signup?: Maybe<Scalars['Boolean']>;
  email_comments?: Maybe<Scalars['Boolean']>;
  email_content?: Maybe<Scalars['Boolean']>;
  can_students_update_profile?: Maybe<Scalars['Boolean']>;
  only_sso_login: Scalars['Boolean'];
  timezone: Scalars['String'];
  banner_url?: Maybe<Scalars['String']>;
  ip_whitelist?: Maybe<Scalars['JSON']>;
  oauthConfigs: Array<OauthConfigModel>;
  custom_font_config?: Maybe<Scalars['JSON']>;
  billing_status?: Maybe<BillingStatusType>;
  notifications?: Maybe<Scalars['JSON']>;
  features: OrganisationFeatures;
  cpd?: Maybe<CpdData>;
  g_suite?: Maybe<OrganisationGSuite>;
  styles: OrganisationStyles;
  /** custom overrides unique for each organisation */
  customTranslationMessages: Array<CustomTranslationModel>;
  embed_domains?: Maybe<EmbedDomains>;
  custom_smtp?: Maybe<CustomSmtp>;
  emailIdentities: Array<EmailIdentityAsAdminModel>;
  secretSelfSignupLink?: Maybe<SecretSignupLinkModel>;
  userByVerificationData?: Maybe<UserModelBase>;
  additionalFieldsConfig?: Maybe<AdditionalFieldsConfigRecord>;
  oauthConfigsCount: Scalars['NonNegativeInt'];
  /** finds a single oauthConfig by the idColumn of the relation */
  oauthConfig?: Maybe<OauthConfigModel>;
  subdomain?: Maybe<SubdomainModel>;
  accountNameLoginConfig?: Maybe<OrganisationAccountNameLoginConfigAsAdminModel>;
  agreed_on?: Maybe<Scalars['DateTime']>;
  plan?: Maybe<Scalars['String']>;
  agreed_terms_conds?: Maybe<Scalars['Boolean']>;
  bt_customer_id?: Maybe<Scalars['String']>;
  promo_code?: Maybe<Scalars['String']>;
  bt_subscription_id?: Maybe<Scalars['String']>;
  suspension_reason?: Maybe<Scalars['String']>;
  suspension_ts?: Maybe<Scalars['String']>;
  cc_token?: Maybe<Scalars['String']>;
  bill_start_date?: Maybe<Scalars['DateTime']>;
  next_bill_date?: Maybe<Scalars['DateTime']>;
  times_billed?: Maybe<Scalars['Float']>;
  auto_scaling?: Maybe<Scalars['Boolean']>;
  is_free?: Maybe<Scalars['Boolean']>;
  billing_email?: Maybe<Scalars['String']>;
  scim_archive_on_deactivate?: Maybe<Scalars['Boolean']>;
  calendars: OrganisationCalendars;
  businessHours: OrganisationBusinessHoursModel;
  isSubdomainAvailable?: Maybe<Scalars['Boolean']>;
  createOrganisationToken?: Maybe<OrganisationTokenModel>;
  patch?: Maybe<OrganisationModelAsAdminQueries>;
  setupMSGraphCalendarIntegrationForOrganisation?: Maybe<OrganisationModelAsAdminQueries>;
  renewMSGraphCalendarIntegrationCredentialsForOrganisation?: Maybe<OrganisationModelAsAdminQueries>;
  setGoogleCalendarIdForOrganisation?: Maybe<Scalars['Boolean']>;
  pushUnSyncedEventsToCalendars: Array<EventModel>;
  setScimArchiveOnDeactivate?: Maybe<OrganisationModelAsAdminQueries>;
  setEmailIdentity?: Maybe<EmailIdentityAsAdminModel>;
  createCertificateTemplate?: Maybe<CertificateTemplateModel>;
  disableCampaignsByIds?: Maybe<Array<Scalars['PositiveInt']>>;
  slackIntegrationUrl?: Maybe<Scalars['String']>;
  importSamlXmlAndSetUpSSO: OauthConfigModel;
  setCustomSMTP?: Maybe<CustomSmtpResults>;
  /** only works when customSMTP is enabled. Without it a mutation updateVerifiedEmailIdentities on root should be used */
  verifyCustomSenderEmail?: Maybe<EmailIdentityModel>;
  createOrUpdateSelfSigninFieldsConfig?: Maybe<OrganisationAccountNameLoginConfigAsAdminModel>;
  createOrUpdateAdditionalFieldsConfig?: Maybe<AdditionalFieldsConfigRecord>;
  askUsersToAcceptPrivacyPolicyAgain?: Maybe<Scalars['Float']>;
  certificateTemplates: Array<CertificateTemplateModelAsAdmin>;
  certificateTemplatesCount: Scalars['NonNegativeInt'];
  /** finds a single certificateTemplate by the idColumn of the relation */
  certificateTemplate?: Maybe<CertificateTemplateModelAsAdmin>;
  emailIdentitiesCount: Scalars['NonNegativeInt'];
  /** finds a single emailIdentity by the idColumn of the relation */
  emailIdentity?: Maybe<EmailIdentityAsAdminModel>;
};


export type OrganisationModelAsAdminMutationsOauthConfigsArgs = {
  filters?: Maybe<Array<OauthConfigModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminMutationsCustomTranslationMessagesArgs = {
  locale: SupportedLocalesEnum;
  appSection?: Maybe<CustomTranslationsSectionEnum>;
};


export type OrganisationModelAsAdminMutationsEmailIdentitiesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminMutationsSecretSelfSignupLinkArgs = {
  token: Scalars['UUID'];
};


export type OrganisationModelAsAdminMutationsUserByVerificationDataArgs = {
  accountName: Scalars['NonEmptyString'];
  input: UserVerificationDataInput;
};


export type OrganisationModelAsAdminMutationsOauthConfigsCountArgs = {
  filters?: Maybe<Array<OauthConfigModelFilterInput>>;
};


export type OrganisationModelAsAdminMutationsOauthConfigArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminMutationsIsSubdomainAvailableArgs = {
  subdomainName: Scalars['String'];
};


export type OrganisationModelAsAdminMutationsCreateOrganisationTokenArgs = {
  privileges: Array<OrganisationTokenPrivilege>;
};


export type OrganisationModelAsAdminMutationsPatchArgs = {
  input: OrganisationInputType;
};


export type OrganisationModelAsAdminMutationsSetupMsGraphCalendarIntegrationForOrganisationArgs = {
  authCode: Scalars['String'];
};


export type OrganisationModelAsAdminMutationsRenewMsGraphCalendarIntegrationCredentialsForOrganisationArgs = {
  authCode: Scalars['String'];
};


export type OrganisationModelAsAdminMutationsSetGoogleCalendarIdForOrganisationArgs = {
  calendarId: Scalars['String'];
};


export type OrganisationModelAsAdminMutationsSetScimArchiveOnDeactivateArgs = {
  value: Scalars['Boolean'];
};


export type OrganisationModelAsAdminMutationsSetEmailIdentityArgs = {
  input: OrganisationEmailIdentityInputType;
};


export type OrganisationModelAsAdminMutationsCreateCertificateTemplateArgs = {
  input: CertificateTemplateInput;
};


export type OrganisationModelAsAdminMutationsDisableCampaignsByIdsArgs = {
  id: Array<Scalars['PositiveInt']>;
};


export type OrganisationModelAsAdminMutationsImportSamlXmlAndSetUpSsoArgs = {
  xml: Scalars['String'];
  provider: SsoProviderEnum;
};


export type OrganisationModelAsAdminMutationsSetCustomSmtpArgs = {
  input: CustomSmtpInput;
};


export type OrganisationModelAsAdminMutationsVerifyCustomSenderEmailArgs = {
  token: Scalars['String'];
};


export type OrganisationModelAsAdminMutationsCreateOrUpdateSelfSigninFieldsConfigArgs = {
  data: FieldsConfigRecordInput;
};


export type OrganisationModelAsAdminMutationsCreateOrUpdateAdditionalFieldsConfigArgs = {
  data: AdditionalFieldsConfigRecordInput;
};


export type OrganisationModelAsAdminMutationsCertificateTemplatesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminMutationsCertificateTemplatesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminMutationsCertificateTemplateArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminMutationsEmailIdentitiesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminMutationsEmailIdentityArgs = {
  id: Scalars['PositiveInt'];
};

export type OrganisationModelAsAdminQueries = {
  __typename?: 'OrganisationModelAsAdminQueries';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  session_expiry?: Maybe<Scalars['PositiveInt']>;
  name?: Maybe<Scalars['LengthValidatedString_255']>;
  default_user_locale?: Maybe<SupportedLocalesEnum>;
  user_id: Scalars['PositiveInt'];
  domain_lock?: Maybe<Scalars['JSON']>;
  color?: Maybe<Scalars['String']>;
  logo?: Maybe<ImageWithVariants>;
  allow_signup?: Maybe<Scalars['Boolean']>;
  email_comments?: Maybe<Scalars['Boolean']>;
  email_content?: Maybe<Scalars['Boolean']>;
  can_students_update_profile?: Maybe<Scalars['Boolean']>;
  only_sso_login: Scalars['Boolean'];
  timezone: Scalars['String'];
  banner_url?: Maybe<Scalars['String']>;
  ip_whitelist?: Maybe<Scalars['JSON']>;
  oauthConfigs: Array<OauthConfigModel>;
  custom_font_config?: Maybe<Scalars['JSON']>;
  billing_status?: Maybe<BillingStatusType>;
  notifications?: Maybe<Scalars['JSON']>;
  features: OrganisationFeatures;
  cpd?: Maybe<CpdData>;
  g_suite?: Maybe<OrganisationGSuite>;
  styles: OrganisationStyles;
  /** custom overrides unique for each organisation */
  customTranslationMessages: Array<CustomTranslationModel>;
  embed_domains?: Maybe<EmbedDomains>;
  custom_smtp?: Maybe<CustomSmtp>;
  emailIdentities: Array<EmailIdentityAsAdminModel>;
  secretSelfSignupLink?: Maybe<SecretSignupLinkModel>;
  userByVerificationData?: Maybe<UserModelBase>;
  additionalFieldsConfig?: Maybe<AdditionalFieldsConfigRecord>;
  oauthConfigsCount: Scalars['NonNegativeInt'];
  /** finds a single oauthConfig by the idColumn of the relation */
  oauthConfig?: Maybe<OauthConfigModel>;
  subdomain?: Maybe<SubdomainModel>;
  accountNameLoginConfig?: Maybe<OrganisationAccountNameLoginConfigAsAdminModel>;
  agreed_on?: Maybe<Scalars['DateTime']>;
  plan?: Maybe<Scalars['String']>;
  agreed_terms_conds?: Maybe<Scalars['Boolean']>;
  bt_customer_id?: Maybe<Scalars['String']>;
  promo_code?: Maybe<Scalars['String']>;
  bt_subscription_id?: Maybe<Scalars['String']>;
  suspension_reason?: Maybe<Scalars['String']>;
  suspension_ts?: Maybe<Scalars['String']>;
  cc_token?: Maybe<Scalars['String']>;
  bill_start_date?: Maybe<Scalars['DateTime']>;
  next_bill_date?: Maybe<Scalars['DateTime']>;
  times_billed?: Maybe<Scalars['Float']>;
  auto_scaling?: Maybe<Scalars['Boolean']>;
  is_free?: Maybe<Scalars['Boolean']>;
  billing_email?: Maybe<Scalars['String']>;
  scim_archive_on_deactivate?: Maybe<Scalars['Boolean']>;
  calendars: OrganisationCalendars;
  businessHours: OrganisationBusinessHoursModel;
  isSubdomainAvailable?: Maybe<Scalars['Boolean']>;
  createOrganisationToken?: Maybe<OrganisationTokenModel>;
  publicAwsS3UploadCredentials?: Maybe<UploadCredentials>;
  domainWhitelistBreaches?: Maybe<Scalars['JSON']>;
  getCampaignsByActionType: Array<CampaignModelAsAdminQueries>;
  exportEmailBlacklist: Array<EmailBlocklistExport>;
  /** Email identities that are allowed to be edited in the moment */
  editableEmailIdentities: Array<EmailIdentityAsAdminModel>;
  defaultOrganisationEmailIdentity?: Maybe<EmailIdentityModel>;
  hasSSOBoundToSubdomain: Scalars['Boolean'];
  elementsWithEmbeddedDomain?: Maybe<Scalars['JSON']>;
  authUrlForMSGraphCalendarIntegration?: Maybe<Scalars['String']>;
  userAttributeSuggestions: Array<Scalars['String']>;
  unSyncedEvents: Array<EventModel>;
  /** users including archived ones */
  users: Array<UserModelAsAdminQueries>;
  usersCount: Scalars['NonNegativeInt'];
  /** finds a single user by the idColumn of the relation */
  user?: Maybe<UserModelAsAdminQueries>;
  featureConfigs: Array<FeatureConfigModel>;
  featureConfigsCount: Scalars['NonNegativeInt'];
  /** finds a single featureConfig by the idColumn of the relation */
  featureConfig?: Maybe<FeatureConfigModel>;
  /** resolves last user who called an API within this organisation */
  lastActiveUser?: Maybe<UserModel>;
  groups: Array<GroupModelAsAdmin>;
  groupsCount: Scalars['NonNegativeInt'];
  /** finds a single group by the idColumn of the relation */
  group?: Maybe<GroupModelAsAdmin>;
  tags: Array<TagModel>;
  tagsCount: Scalars['NonNegativeInt'];
  /** finds a single tag by the idColumn of the relation */
  tag?: Maybe<TagModel>;
  events: Array<EventModelAsAdmin>;
  eventsCount: Scalars['NonNegativeInt'];
  /** finds a single event by the idColumn of the relation */
  event?: Maybe<EventModelAsAdmin>;
  recurringEvents: Array<RecurringEventModel>;
  recurringEventsCount: Scalars['NonNegativeInt'];
  /** finds a single recurringEvent by the idColumn of the relation */
  recurringEvent?: Maybe<RecurringEventModel>;
  comments: Array<CommentModel>;
  commentsCount: Scalars['NonNegativeInt'];
  /** finds a single comment by the idColumn of the relation */
  comment?: Maybe<CommentModel>;
  appEvents: Array<AppEventModel>;
  appEventsCount: Scalars['NonNegativeInt'];
  /** finds a single appEvent by the idColumn of the relation */
  appEvent?: Maybe<AppEventModel>;
  campaigns: Array<CampaignModel>;
  campaignsCount: Scalars['NonNegativeInt'];
  /** finds a single campaign by the idColumn of the relation */
  campaign?: Maybe<CampaignModel>;
  campaignBanners: Array<CampaignBannerModel>;
  campaignBannersCount: Scalars['NonNegativeInt'];
  /** finds a single campaignBanner by the idColumn of the relation */
  campaignBanner?: Maybe<CampaignBannerModel>;
  userSessions: Array<UserSessionModel>;
  userSessionsCount: Scalars['NonNegativeInt'];
  /** finds a single userSession by the idColumn of the relation */
  userSession?: Maybe<UserSessionModel>;
  topicAnalyticEvents: Array<TopicAnalyticEventModel>;
  topicAnalyticEventsCount: Scalars['NonNegativeInt'];
  /** finds a single topicAnalyticEvent by the idColumn of the relation */
  topicAnalyticEvent?: Maybe<TopicAnalyticEventModel>;
  emailIdentitiesCount: Scalars['NonNegativeInt'];
  /** finds a single emailIdentity by the idColumn of the relation */
  emailIdentity?: Maybe<EmailIdentityAsAdminModel>;
  owner: UserModel;
  workspaces: Array<WorkspaceModelAsCoordinator>;
  workspacesCount: Scalars['NonNegativeInt'];
  /** finds a single workspace by the idColumn of the relation */
  workspace?: Maybe<WorkspaceModelAsCoordinator>;
  processedNotifications: Array<NotificationQueueProcessedModel>;
  processedNotificationsCount: Scalars['NonNegativeInt'];
  /** finds a single processedNotification by the idColumn of the relation */
  processedNotification?: Maybe<NotificationQueueProcessedModel>;
  pathways: Array<PathwayModelAsAdmin>;
  pathwaysCount: Scalars['NonNegativeInt'];
  /** finds a single pathway by the idColumn of the relation */
  pathway?: Maybe<PathwayModelAsAdmin>;
  surveys: Array<SurveyModelAsAdmin>;
  surveysCount: Scalars['NonNegativeInt'];
  /** finds a single survey by the idColumn of the relation */
  survey?: Maybe<SurveyModelAsAdmin>;
  topics: Array<TopicModelAsEditor>;
  topicsCount: Scalars['NonNegativeInt'];
  /** finds a single topic by the idColumn of the relation */
  topic?: Maybe<TopicModelAsEditor>;
  tagTaggables: Array<TagTaggableModel>;
  tagTaggablesCount: Scalars['NonNegativeInt'];
  /** finds a single tagTaggable by the idColumn of the relation */
  tagTaggable?: Maybe<TagTaggableModel>;
  pathwayEnrolments: Array<PathwayEnrolmentModelAsAdmin>;
  pathwayEnrolmentsCount: Scalars['NonNegativeInt'];
  /** finds a single pathwayEnrolment by the idColumn of the relation */
  pathwayEnrolment?: Maybe<PathwayEnrolmentModelAsAdmin>;
  organisationTokens: Array<OrganisationTokenModel>;
  organisationTokensCount: Scalars['NonNegativeInt'];
  /** finds a single organisationToken by the idColumn of the relation */
  organisationToken?: Maybe<OrganisationTokenModel>;
  webhookSubscriptions: Array<WebhookSubscriptionModel>;
  webhookSubscriptionsCount: Scalars['NonNegativeInt'];
  /** finds a single webhookSubscription by the idColumn of the relation */
  webhookSubscription?: Maybe<WebhookSubscriptionModel>;
  dashboards: Array<DashboardModel>;
  dashboardsCount: Scalars['NonNegativeInt'];
  /** finds a single dashboard by the idColumn of the relation */
  dashboard?: Maybe<DashboardModel>;
  blacklistedEmails: Array<EmailBlacklistModelAsAdmin>;
  blacklistedEmailsCount: Scalars['NonNegativeInt'];
  /** finds a single blacklistedEmail by the idColumn of the relation */
  blacklistedEmail?: Maybe<EmailBlacklistModelAsAdmin>;
  certificateTemplates: Array<CertificateTemplateModelAsAdmin>;
  certificateTemplatesCount: Scalars['NonNegativeInt'];
  /** finds a single certificateTemplate by the idColumn of the relation */
  certificateTemplate?: Maybe<CertificateTemplateModelAsAdmin>;
  certifications: Array<CertificationModelAsAdmin>;
  certificationsCount: Scalars['NonNegativeInt'];
  /** finds a single certification by the idColumn of the relation */
  certification?: Maybe<CertificationModelAsAdmin>;
  customTranslations: Array<CustomTranslationModel>;
  customTranslationsCount: Scalars['NonNegativeInt'];
  /** finds a single customTranslation by the idColumn of the relation */
  customTranslation?: Maybe<CustomTranslationModel>;
  secretSignupLinks: Array<SecretSignupLinkModel>;
  secretSignupLinksCount: Scalars['NonNegativeInt'];
  /** finds a single secretSignupLink by the idColumn of the relation */
  secretSignupLink?: Maybe<SecretSignupLinkModel>;
  searchStatistics: Array<SearchStatisticModel>;
  searchStatisticsCount: Scalars['NonNegativeInt'];
  /** finds a single searchStatistic by the idColumn of the relation */
  searchStatistic?: Maybe<SearchStatisticModel>;
};


export type OrganisationModelAsAdminQueriesOauthConfigsArgs = {
  filters?: Maybe<Array<OauthConfigModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesCustomTranslationMessagesArgs = {
  locale: SupportedLocalesEnum;
  appSection?: Maybe<CustomTranslationsSectionEnum>;
};


export type OrganisationModelAsAdminQueriesEmailIdentitiesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesSecretSelfSignupLinkArgs = {
  token: Scalars['UUID'];
};


export type OrganisationModelAsAdminQueriesUserByVerificationDataArgs = {
  accountName: Scalars['NonEmptyString'];
  input: UserVerificationDataInput;
};


export type OrganisationModelAsAdminQueriesOauthConfigsCountArgs = {
  filters?: Maybe<Array<OauthConfigModelFilterInput>>;
};


export type OrganisationModelAsAdminQueriesOauthConfigArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesIsSubdomainAvailableArgs = {
  subdomainName: Scalars['String'];
};


export type OrganisationModelAsAdminQueriesCreateOrganisationTokenArgs = {
  privileges: Array<OrganisationTokenPrivilege>;
};


export type OrganisationModelAsAdminQueriesPublicAwsS3UploadCredentialsArgs = {
  fileName: Scalars['String'];
};


export type OrganisationModelAsAdminQueriesGetCampaignsByActionTypeArgs = {
  type: CampaignMessageTypeEnum;
};


export type OrganisationModelAsAdminQueriesElementsWithEmbeddedDomainArgs = {
  domain: Scalars['String'];
};


export type OrganisationModelAsAdminQueriesUserAttributeSuggestionsArgs = {
  userAttribute: CampaignSearchableUserAttribute;
  search: Scalars['LengthValidatedString_2_to_1000'];
};


export type OrganisationModelAsAdminQueriesUsersArgs = {
  filters?: Maybe<Array<UserModelAsAdminQueriesFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesUsersCountArgs = {
  filters?: Maybe<Array<UserModelAsAdminQueriesFilterInput>>;
};


export type OrganisationModelAsAdminQueriesUserArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesFeatureConfigsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesFeatureConfigsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesFeatureConfigArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesGroupsArgs = {
  filters?: Maybe<Array<GroupModelAsAdminFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesGroupsCountArgs = {
  filters?: Maybe<Array<GroupModelAsAdminFilterInput>>;
};


export type OrganisationModelAsAdminQueriesGroupArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesTagsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesTagsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesTagArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesEventsArgs = {
  filters?: Maybe<Array<EventModelAsAdminFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesEventsCountArgs = {
  filters?: Maybe<Array<EventModelAsAdminFilterInput>>;
};


export type OrganisationModelAsAdminQueriesEventArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesRecurringEventsArgs = {
  filters?: Maybe<Array<RecurringEventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesRecurringEventsCountArgs = {
  filters?: Maybe<Array<RecurringEventModelFilterInput>>;
};


export type OrganisationModelAsAdminQueriesRecurringEventArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesCommentsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesCommentsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesCommentArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesAppEventsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesAppEventsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesAppEventArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesCampaignsArgs = {
  filters?: Maybe<Array<CampaignModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesCampaignsCountArgs = {
  filters?: Maybe<Array<CampaignModelFilterInput>>;
};


export type OrganisationModelAsAdminQueriesCampaignArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesCampaignBannersArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesCampaignBannersCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesCampaignBannerArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesUserSessionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesUserSessionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesUserSessionArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesTopicAnalyticEventsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesTopicAnalyticEventsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesTopicAnalyticEventArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesEmailIdentitiesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesEmailIdentityArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesWorkspacesArgs = {
  filters?: Maybe<Array<WorkspaceModelAsCoordinatorFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesWorkspacesCountArgs = {
  filters?: Maybe<Array<WorkspaceModelAsCoordinatorFilterInput>>;
};


export type OrganisationModelAsAdminQueriesWorkspaceArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesProcessedNotificationsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesProcessedNotificationsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesProcessedNotificationArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesPathwaysArgs = {
  filters?: Maybe<Array<PathwayModelAsAdminFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesPathwaysCountArgs = {
  filters?: Maybe<Array<PathwayModelAsAdminFilterInput>>;
};


export type OrganisationModelAsAdminQueriesPathwayArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesSurveysArgs = {
  filters?: Maybe<Array<SurveyModelAsAdminFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesSurveysCountArgs = {
  filters?: Maybe<Array<SurveyModelAsAdminFilterInput>>;
};


export type OrganisationModelAsAdminQueriesSurveyArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesTopicsArgs = {
  filters?: Maybe<Array<TopicModelAsEditorFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesTopicsCountArgs = {
  filters?: Maybe<Array<TopicModelAsEditorFilterInput>>;
};


export type OrganisationModelAsAdminQueriesTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesTagTaggablesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesTagTaggablesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesTagTaggableArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesPathwayEnrolmentsArgs = {
  filters?: Maybe<Array<PathwayEnrolmentModelAsAdminFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesPathwayEnrolmentsCountArgs = {
  filters?: Maybe<Array<PathwayEnrolmentModelAsAdminFilterInput>>;
};


export type OrganisationModelAsAdminQueriesPathwayEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesOrganisationTokensArgs = {
  filters?: Maybe<Array<OrganisationTokenModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesOrganisationTokensCountArgs = {
  filters?: Maybe<Array<OrganisationTokenModelFilterInput>>;
};


export type OrganisationModelAsAdminQueriesOrganisationTokenArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesWebhookSubscriptionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesWebhookSubscriptionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesWebhookSubscriptionArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesDashboardsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesDashboardsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesDashboardArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesBlacklistedEmailsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesBlacklistedEmailsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesBlacklistedEmailArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesCertificateTemplatesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesCertificateTemplatesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesCertificateTemplateArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesCertificationsArgs = {
  filters?: Maybe<Array<CertificationModelAsAdminFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesCertificationsCountArgs = {
  filters?: Maybe<Array<CertificationModelAsAdminFilterInput>>;
};


export type OrganisationModelAsAdminQueriesCertificationArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesCustomTranslationsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesCustomTranslationsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesCustomTranslationArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesSecretSignupLinksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesSecretSignupLinksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationModelAsAdminQueriesSecretSignupLinkArgs = {
  id: Scalars['PositiveInt'];
};


export type OrganisationModelAsAdminQueriesSearchStatisticsArgs = {
  filters?: Maybe<Array<SearchStatisticModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelAsAdminQueriesSearchStatisticsCountArgs = {
  filters?: Maybe<Array<SearchStatisticModelFilterInput>>;
};


export type OrganisationModelAsAdminQueriesSearchStatisticArgs = {
  id: Scalars['PositiveInt'];
};

export type OrganisationModelGqlBase = {
  __typename?: 'OrganisationModelGQLBase';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  /** duration of a user session in seconds */
  session_expiry: Scalars['PositiveInt'];
  name?: Maybe<Scalars['LengthValidatedString_255']>;
  default_user_locale?: Maybe<SupportedLocalesEnum>;
  user_id: Scalars['PositiveInt'];
  domain_lock?: Maybe<Scalars['JSON']>;
  color?: Maybe<Scalars['String']>;
  logo?: Maybe<ImageWithVariants>;
  allow_signup?: Maybe<Scalars['Boolean']>;
  email_comments?: Maybe<Scalars['Boolean']>;
  email_content?: Maybe<Scalars['Boolean']>;
  can_students_update_profile?: Maybe<Scalars['Boolean']>;
  only_sso_login: Scalars['Boolean'];
  timezone: Scalars['String'];
  banner_url?: Maybe<Scalars['String']>;
  ip_whitelist?: Maybe<Scalars['JSON']>;
  oauthConfigs: Array<OauthConfigModel>;
  custom_font_config?: Maybe<Scalars['JSON']>;
  billing_status?: Maybe<BillingStatusType>;
  notifications?: Maybe<Scalars['JSON']>;
  features: OrganisationFeatures;
  cpd?: Maybe<CpdData>;
  g_suite?: Maybe<OrganisationGSuite>;
  styles: OrganisationStyles;
  /** custom overrides unique for each organisation */
  customTranslationMessages: Array<CustomTranslationModel>;
  embed_domains?: Maybe<EmbedDomains>;
  custom_smtp?: Maybe<CustomSmtp>;
  emailIdentities: Array<EmailIdentityModel>;
  secretSelfSignupLink?: Maybe<SecretSignupLinkModel>;
  userByVerificationData?: Maybe<UserModelBase>;
  additionalFieldsConfig?: Maybe<AdditionalFieldsConfigRecord>;
  oauthConfigsCount: Scalars['NonNegativeInt'];
  /** finds a single oauthConfig by the idColumn of the relation */
  oauthConfig?: Maybe<OauthConfigModel>;
  subdomain?: Maybe<SubdomainModel>;
  accountNameLoginConfig?: Maybe<OrganisationAccountNameLoginConfigModel>;
};


export type OrganisationModelGqlBaseOauthConfigsArgs = {
  filters?: Maybe<Array<OauthConfigModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationModelGqlBaseCustomTranslationMessagesArgs = {
  locale: SupportedLocalesEnum;
  appSection?: Maybe<CustomTranslationsSectionEnum>;
};


export type OrganisationModelGqlBaseSecretSelfSignupLinkArgs = {
  token: Scalars['UUID'];
};


export type OrganisationModelGqlBaseUserByVerificationDataArgs = {
  accountName: Scalars['NonEmptyString'];
  input: UserVerificationDataInput;
};


export type OrganisationModelGqlBaseOauthConfigsCountArgs = {
  filters?: Maybe<Array<OauthConfigModelFilterInput>>;
};


export type OrganisationModelGqlBaseOauthConfigArgs = {
  id: Scalars['PositiveInt'];
};

export type OrganisationModelLambda = {
  __typename?: 'OrganisationModelLambda';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export enum OrganisationRoleEnum {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  STUDENT = 'STUDENT'
}

export type OrganisationStyles = {
  __typename?: 'OrganisationStyles';
  logo?: Maybe<Scalars['JSON']>;
  fontConfig?: Maybe<Scalars['JSON']>;
  colors?: Maybe<Scalars['JSON']>;
};

export type OrganisationStylesInputType = {
  logo?: Maybe<Scalars['JSON']>;
  fontConfig?: Maybe<Scalars['JSON']>;
  colors?: Maybe<OrganisationColorsInputType>;
};

export type OrganisationTokenModel = {
  __typename?: 'OrganisationTokenModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  token?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  privileges: Array<Scalars['String']>;
  scimResources: Array<ScimResourceModel>;
  scimResourcesCount: Scalars['NonNegativeInt'];
  /** finds a single scimResource by the idColumn of the relation */
  scimResource?: Maybe<ScimResourceModel>;
};


export type OrganisationTokenModelScimResourcesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type OrganisationTokenModelScimResourcesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type OrganisationTokenModelScimResourceArgs = {
  id: Scalars['PositiveInt'];
};

export enum OrganisationTokenModelFilterEnum {
  privileges = 'privileges',
  first = 'first',
  sortById = 'sortById',
  includeDeleted = 'includeDeleted'
}

export type OrganisationTokenModelFilterInput = {
  name: OrganisationTokenModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export enum OrganisationTokenPrivilege {
  SCIM = 'SCIM',
  PUBLIC_API = 'PUBLIC_API'
}

export enum OrientationEnum {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
  SQUARE = 'SQUARE'
}

export type PaginatableInvitees = {
  __typename?: 'PaginatableInvitees';
  items: Array<UserEventModelWithSource>;
  totalCount?: Maybe<Scalars['NonNegativeInt']>;
};


export type PaginatableInviteesItemsArgs = {
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['PositiveInt']>;
  filters?: Maybe<Array<UserEventModelWithSourceFilterInput>>;
  orderBy?: Maybe<InviteesIndirectOrderColumnEnum>;
  orderDirection: SqlOrderDirectionEnum;
};

export type PasswordResetStrategy = {
  __typename?: 'PasswordResetStrategy';
  strategy?: Maybe<ResetPasswordStrategyEnum>;
};

export type PathwayAddGroupInput = {
  groupId: Scalars['PositiveInt'];
};

export type PathwayAddUserInput = {
  userId: Scalars['PositiveInt'];
};

export type PathwayCoverImageInput = {
  name: Scalars['String'];
  data: Scalars['String'];
};

export type PathwayEnrolmentImportedModel = {
  __typename?: 'PathwayEnrolmentImportedModel';
  id: Scalars['PositiveInt'];
  source_name?: Maybe<Scalars['String']>;
  imported_by?: Maybe<UserModel>;
  importedBy?: Maybe<UserModelBase>;
};

export type PathwayEnrolmentModel = {
  __typename?: 'PathwayEnrolmentModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  user_id?: Maybe<Scalars['PositiveInt']>;
  pathway_id?: Maybe<Scalars['PositiveInt']>;
  certification_id?: Maybe<Scalars['PositiveInt']>;
  pathway_version_id?: Maybe<Scalars['PositiveInt']>;
  progress?: Maybe<Scalars['Float']>;
  target_date?: Maybe<Scalars['DateTime']>;
  started_at?: Maybe<Scalars['DateTime']>;
  completed_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  campaign_pathway_share_action_id?: Maybe<Scalars['PositiveInt']>;
  shared_at?: Maybe<Scalars['DateTime']>;
  shared_by?: Maybe<Scalars['PositiveInt']>;
  completed_status?: Maybe<Scalars['String']>;
  pathwayVersion?: Maybe<PathwayVersionModel>;
  notificationMessage?: Maybe<PathwayNotificationMessageEnum>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  importedAt?: Maybe<Scalars['Date']>;
  status?: Maybe<PathwayEnrolmentStatusEnum>;
  pathway?: Maybe<PathwayModelAsStudent>;
  topics: Array<TopicModelAsMember>;
  topicsCount: Scalars['NonNegativeInt'];
  /** finds a single topic by the idColumn of the relation */
  topic?: Maybe<TopicModelAsMember>;
  user: UserModel;
  certification: CertificationModel;
  sharedBy?: Maybe<UserModelBase>;
  importRecord?: Maybe<PathwayEnrolmentImportedModel>;
  pathwayShareActions?: Maybe<CampaignPathwayShareActionModel>;
};


export type PathwayEnrolmentModelTopicsArgs = {
  filters?: Maybe<Array<TopicModelAsMemberFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayEnrolmentModelTopicsCountArgs = {
  filters?: Maybe<Array<TopicModelAsMemberFilterInput>>;
};


export type PathwayEnrolmentModelTopicArgs = {
  id: Scalars['PositiveInt'];
};

export type PathwayEnrolmentModelAsAdmin = {
  __typename?: 'PathwayEnrolmentModelAsAdmin';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  user_id?: Maybe<Scalars['PositiveInt']>;
  pathway_id?: Maybe<Scalars['PositiveInt']>;
  certification_id?: Maybe<Scalars['PositiveInt']>;
  pathway_version_id?: Maybe<Scalars['PositiveInt']>;
  progress?: Maybe<Scalars['Float']>;
  target_date?: Maybe<Scalars['DateTime']>;
  started_at?: Maybe<Scalars['DateTime']>;
  completed_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  campaign_pathway_share_action_id?: Maybe<Scalars['PositiveInt']>;
  shared_at?: Maybe<Scalars['DateTime']>;
  shared_by?: Maybe<Scalars['PositiveInt']>;
  completed_status?: Maybe<Scalars['String']>;
  pathwayVersion?: Maybe<PathwayVersionModel>;
  notificationMessage?: Maybe<PathwayNotificationMessageEnum>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  importedAt?: Maybe<Scalars['Date']>;
  status?: Maybe<PathwayEnrolmentStatusEnum>;
  pathway?: Maybe<PathwayModelAsStudent>;
  topics: Array<TopicModelAsEditor>;
  topicsCount: Scalars['NonNegativeInt'];
  /** finds a single topic by the idColumn of the relation */
  topic?: Maybe<TopicModelAsEditor>;
  user: UserModelAsAdminQueries;
  certification: CertificationModel;
  sharedBy?: Maybe<UserModelBase>;
  importRecord?: Maybe<PathwayEnrolmentImportedModel>;
  pathwayShareActions?: Maybe<CampaignPathwayShareActionModel>;
  topicEnrolments: Array<TopicEnrolmentModelAsStudent>;
  newTopicsInPathway: Array<Scalars['PositiveInt']>;
  recalculateProgressAsAdmin?: Maybe<PathwayEnrolmentModelAsAdmin>;
  markAsComplete?: Maybe<PathwayEnrolmentModelAsAdmin>;
  archive?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayEnrolmentModelAsAdminTopicsArgs = {
  filters?: Maybe<Array<TopicModelAsMemberFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayEnrolmentModelAsAdminTopicsCountArgs = {
  filters?: Maybe<Array<TopicModelAsMemberFilterInput>>;
};


export type PathwayEnrolmentModelAsAdminTopicArgs = {
  id: Scalars['PositiveInt'];
};

export enum PathwayEnrolmentModelAsAdminFilterEnum {
  startedInInterval = 'startedInInterval',
  noOverdue = 'noOverdue',
  forUsersInGroups = 'forUsersInGroups',
  progress = 'progress',
  inProgress = 'inProgress',
  failed = 'failed',
  successful = 'successful',
  overdue = 'overdue',
  search = 'search',
  includeAdminActivity = 'includeAdminActivity',
  pathwayId = 'pathwayId'
}

export type PathwayEnrolmentModelAsAdminFilterInput = {
  name: PathwayEnrolmentModelAsAdminFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type PathwayEnrolmentModelAsStudent = {
  __typename?: 'PathwayEnrolmentModelAsStudent';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  user_id?: Maybe<Scalars['PositiveInt']>;
  pathway_id?: Maybe<Scalars['PositiveInt']>;
  certification_id?: Maybe<Scalars['PositiveInt']>;
  pathway_version_id?: Maybe<Scalars['PositiveInt']>;
  progress?: Maybe<Scalars['Float']>;
  target_date?: Maybe<Scalars['DateTime']>;
  started_at?: Maybe<Scalars['DateTime']>;
  completed_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  campaign_pathway_share_action_id?: Maybe<Scalars['PositiveInt']>;
  shared_at?: Maybe<Scalars['DateTime']>;
  shared_by?: Maybe<Scalars['PositiveInt']>;
  completed_status?: Maybe<Scalars['String']>;
  pathwayVersion?: Maybe<PathwayVersionModel>;
  notificationMessage?: Maybe<PathwayNotificationMessageEnum>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  importedAt?: Maybe<Scalars['Date']>;
  status?: Maybe<PathwayEnrolmentStatusEnum>;
  pathway?: Maybe<PathwayModelAsStudent>;
  topics: Array<TopicModelAsMember>;
  topicsCount: Scalars['NonNegativeInt'];
  /** finds a single topic by the idColumn of the relation */
  topic?: Maybe<TopicModelAsMember>;
  user: UserModel;
  certification: CertificationModel;
  sharedBy?: Maybe<UserModelBase>;
  importRecord?: Maybe<PathwayEnrolmentImportedModel>;
  pathwayShareActions?: Maybe<CampaignPathwayShareActionModel>;
  topicEnrolments: Array<TopicEnrolmentModelAsStudent>;
  newTopicsInPathway: Array<Scalars['PositiveInt']>;
};


export type PathwayEnrolmentModelAsStudentTopicsArgs = {
  filters?: Maybe<Array<TopicModelAsMemberFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayEnrolmentModelAsStudentTopicsCountArgs = {
  filters?: Maybe<Array<TopicModelAsMemberFilterInput>>;
};


export type PathwayEnrolmentModelAsStudentTopicArgs = {
  id: Scalars['PositiveInt'];
};

export enum PathwayEnrolmentModelFilterEnum {
  startedInInterval = 'startedInInterval',
  noOverdue = 'noOverdue',
  forUsersInGroups = 'forUsersInGroups',
  progress = 'progress',
  inProgress = 'inProgress',
  failed = 'failed',
  successful = 'successful',
  overdue = 'overdue',
  search = 'search',
  includeAdminActivity = 'includeAdminActivity',
  pathwayId = 'pathwayId'
}

export type PathwayEnrolmentModelFilterInput = {
  name: PathwayEnrolmentModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export enum PathwayEnrolmentStatusEnum {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  OVERDUE = 'OVERDUE',
  FAILED = 'FAILED'
}

export type PathwayGroupModel = {
  __typename?: 'PathwayGroupModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  pathway_id: Scalars['PositiveInt'];
  group_id: Scalars['PositiveInt'];
  pathway: PathwayModel;
  group: GroupModel;
};

export type PathwayInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['LengthValidatedString_100000']>;
  is_public?: Maybe<Scalars['Boolean']>;
  published_date?: Maybe<Scalars['DateTime']>;
  progress?: Maybe<PathwayProgress>;
  allow_comments?: Maybe<Scalars['Boolean']>;
};

export type PathwayModel = {
  __typename?: 'PathwayModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  is_public?: Maybe<Scalars['Boolean']>;
  published_date?: Maybe<Scalars['DateTime']>;
  progress?: Maybe<PathwayProgress>;
  organisation_id: Scalars['PositiveInt'];
  order: Scalars['PositiveInt'];
  created_by: Scalars['PositiveInt'];
  production_pathway_version_id: Scalars['PositiveInt'];
  background_document_id?: Maybe<Scalars['PositiveInt']>;
  allow_comments: Scalars['Boolean'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  openedFromCampaignShareEmail?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelOpenedFromCampaignShareEmailArgs = {
  scheduledCampaignActionId: Scalars['PositiveInt'];
};

export type PathwayModelAsAdmin = ISearchable & {
  __typename?: 'PathwayModelAsAdmin';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  is_public?: Maybe<Scalars['Boolean']>;
  published_date?: Maybe<Scalars['DateTime']>;
  progress?: Maybe<PathwayProgress>;
  organisation_id: Scalars['PositiveInt'];
  order: Scalars['PositiveInt'];
  created_by: Scalars['PositiveInt'];
  production_pathway_version_id: Scalars['PositiveInt'];
  background_document_id?: Maybe<Scalars['PositiveInt']>;
  allow_comments: Scalars['Boolean'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  openedFromCampaignShareEmail?: Maybe<Scalars['NonNegativeInt']>;
  state?: Maybe<PathwayState>;
  currentTopicVersions: Array<TopicVersionModelAsEditor>;
  currentTopicVersionsCount?: Maybe<Scalars['NonNegativeInt']>;
  currentEnrolment?: Maybe<PathwayEnrolmentModelAsStudent>;
  numberOfTopics?: Maybe<Scalars['NonNegativeInt']>;
  /** returns current topics for the pathway */
  topics?: Maybe<Array<TopicModelAsMember>>;
  /** returns topic if it belongs to current version of the pathway */
  topic?: Maybe<TopicModelAsMember>;
  nextUnfinishedTopic?: Maybe<TopicModelAsMember>;
  /** returns a topic after the passed one. Topics are taken from the current topics on a pathway. Unpublished and archived topics are ignored in both cases. */
  nextTopicAfter?: Maybe<TopicModelAsMember>;
  /** creates a new self enrolment if none exists. If there is an existing enrolment we check if it has been started, If not, we mark it as started */
  enrolmentOrSelfEnrol?: Maybe<PathwayEnrolmentModel>;
  tags: Array<TagModel>;
  tagsCount: Scalars['NonNegativeInt'];
  /** finds a single tag by the idColumn of the relation */
  tag?: Maybe<TagModel>;
  coverImage?: Maybe<DocumentModel>;
  coverImageVariants: Array<ImageVariantModel>;
  coverImageVariantsCount: Scalars['NonNegativeInt'];
  /** finds a single coverImageVariant by the idColumn of the relation */
  coverImageVariant?: Maybe<ImageVariantModel>;
  currentVersionTopics: Array<PathwayVersionTopicModel>;
  currentVersionTopicsCount: Scalars['NonNegativeInt'];
  /** finds a single currentVersionTopic by the idColumn of the relation */
  currentVersionTopic?: Maybe<PathwayVersionTopicModel>;
  owner: UserModel;
  currentPathwayVersion: PathwayVersionModel;
  currentTopics: Array<TopicModel>;
  currentTopicsCount: Scalars['NonNegativeInt'];
  /** finds a single currentTopic by the idColumn of the relation */
  currentTopic?: Maybe<TopicModel>;
  versions: Array<PathwayVersionModelAsStudent>;
  versionsCount: Scalars['NonNegativeInt'];
  /** finds a single version by the idColumn of the relation */
  version?: Maybe<PathwayVersionModelAsStudent>;
  patch?: Maybe<PathwayModelAsAdmin>;
  currentEnrolmentForUser?: Maybe<PathwayEnrolmentModel>;
  certificationRelatedEnrolment?: Maybe<PathwayEnrolmentModel>;
  move: Scalars['NonNegativeInt'];
  archive?: Maybe<Scalars['NonNegativeInt']>;
  updateTopicsOrder?: Maybe<PathwayModelAsAdmin>;
  archiveEnrolmentsAndTopics?: Maybe<PathwayModelAsAdmin>;
  shareWithUsers?: Maybe<Array<PathwayEnrolmentModel>>;
  shareWithGroups?: Maybe<Array<PathwayGroupModel>>;
  addUser?: Maybe<PathwayUserModel>;
  addGroup?: Maybe<PathwayGroupModel>;
  removeUser?: Maybe<Scalars['NonNegativeInt']>;
  removeGroup?: Maybe<Scalars['NonNegativeInt']>;
  uploadCoverImage?: Maybe<PathwayModelAsAdmin>;
  removeCoverImage?: Maybe<PathwayModelAsAdmin>;
  setTopics?: Maybe<PathwayModelAsAdmin>;
  clone?: Maybe<PathwayModelAsAdmin>;
  addTag?: Maybe<Scalars['NonNegativeInt']>;
  removeTag?: Maybe<Scalars['NonNegativeInt']>;
  removeAllTags?: Maybe<Scalars['NonNegativeInt']>;
  userEnrolment?: Maybe<PathwayEnrolmentModel>;
  archiveUserEnrolment?: Maybe<Scalars['Boolean']>;
  relatedCampaignsByFilters: Array<CampaignModelAsAdminMutations>;
  relatedCampaignsByActions: Array<CampaignModelAsAdminMutations>;
  relatedCertifications: Array<CertificationModelAsAdmin>;
  organisation: OrganisationModel;
  pathwayVersions: Array<PathwayVersionModel>;
  pathwayVersionsCount: Scalars['NonNegativeInt'];
  /** finds a single pathwayVersion by the idColumn of the relation */
  pathwayVersion?: Maybe<PathwayVersionModel>;
  users: Array<UserModel>;
  usersCount: Scalars['NonNegativeInt'];
  /** finds a single user by the idColumn of the relation */
  user?: Maybe<UserModel>;
  pathwayUsers: Array<PathwayUserModel>;
  pathwayUsersCount: Scalars['NonNegativeInt'];
  /** finds a single pathwayUser by the idColumn of the relation */
  pathwayUser?: Maybe<PathwayUserModel>;
  groups: Array<GroupModel>;
  groupsCount: Scalars['NonNegativeInt'];
  /** finds a single group by the idColumn of the relation */
  group?: Maybe<GroupModel>;
  enrolments: Array<PathwayEnrolmentModel>;
  enrolmentsCount: Scalars['NonNegativeInt'];
  /** finds a single enrolment by the idColumn of the relation */
  enrolment?: Maybe<PathwayEnrolmentModel>;
  topicEnrolments: Array<TopicEnrolmentModel>;
  topicEnrolmentsCount: Scalars['NonNegativeInt'];
  /** finds a single topicEnrolment by the idColumn of the relation */
  topicEnrolment?: Maybe<TopicEnrolmentModel>;
  certificationItems: Array<CertificationItemModel>;
  certificationItemsCount: Scalars['NonNegativeInt'];
  /** finds a single certificationItem by the idColumn of the relation */
  certificationItem?: Maybe<CertificationItemModel>;
  isFollowingComments: Scalars['Boolean'];
  comments: Array<CommentModel>;
  addComment: CommentModel;
};


export type PathwayModelAsAdminOpenedFromCampaignShareEmailArgs = {
  scheduledCampaignActionId: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminCurrentTopicVersionsArgs = {
  filters?: Maybe<Array<FilterDescriptor>>;
  order?: Maybe<Array<OrderDescriptor>>;
};


export type PathwayModelAsAdminCurrentTopicVersionsCountArgs = {
  filters?: Maybe<Array<FilterDescriptor>>;
};


export type PathwayModelAsAdminTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminNextTopicAfterArgs = {
  topicId: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminTagsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsAdminTagsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type PathwayModelAsAdminTagArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminCoverImageVariantsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsAdminCoverImageVariantsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type PathwayModelAsAdminCoverImageVariantArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminCurrentVersionTopicsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsAdminCurrentVersionTopicsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type PathwayModelAsAdminCurrentVersionTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminCurrentTopicsArgs = {
  filters?: Maybe<Array<TopicModelAsMemberFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsAdminCurrentTopicsCountArgs = {
  filters?: Maybe<Array<TopicModelAsMemberFilterInput>>;
};


export type PathwayModelAsAdminCurrentTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminVersionsArgs = {
  filters?: Maybe<Array<PathwayVersionModelAsStudentFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsAdminVersionsCountArgs = {
  filters?: Maybe<Array<PathwayVersionModelAsStudentFilterInput>>;
};


export type PathwayModelAsAdminVersionArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminPatchArgs = {
  input: PathwayInput;
};


export type PathwayModelAsAdminCurrentEnrolmentForUserArgs = {
  userId?: Maybe<Scalars['PositiveInt']>;
};


export type PathwayModelAsAdminCertificationRelatedEnrolmentArgs = {
  certEnrolmentId: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminMoveArgs = {
  direction: MoveDirectionEnum;
};


export type PathwayModelAsAdminUpdateTopicsOrderArgs = {
  topicIds: Array<Scalars['PositiveInt']>;
};


export type PathwayModelAsAdminArchiveEnrolmentsAndTopicsArgs = {
  userIds: Array<Scalars['PositiveInt']>;
};


export type PathwayModelAsAdminShareWithUsersArgs = {
  variables: PathwayShareWithUsersInput;
};


export type PathwayModelAsAdminShareWithGroupsArgs = {
  variables: PathwayShareWithGroupsInput;
};


export type PathwayModelAsAdminAddUserArgs = {
  input: PathwayAddUserInput;
};


export type PathwayModelAsAdminAddGroupArgs = {
  input: PathwayAddGroupInput;
};


export type PathwayModelAsAdminRemoveUserArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminRemoveGroupArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminUploadCoverImageArgs = {
  file: PathwayCoverImageInput;
};


export type PathwayModelAsAdminSetTopicsArgs = {
  topicIds: Array<Scalars['PositiveInt']>;
};


export type PathwayModelAsAdminAddTagArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminRemoveTagArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminUserEnrolmentArgs = {
  userId: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminArchiveUserEnrolmentArgs = {
  pathwayEnrolmentId: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminPathwayVersionsArgs = {
  filters?: Maybe<Array<PathwayVersionModelAsStudentFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsAdminPathwayVersionsCountArgs = {
  filters?: Maybe<Array<PathwayVersionModelAsStudentFilterInput>>;
};


export type PathwayModelAsAdminPathwayVersionArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminUsersArgs = {
  filters?: Maybe<Array<UserModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsAdminUsersCountArgs = {
  filters?: Maybe<Array<UserModelFilterInput>>;
};


export type PathwayModelAsAdminUserArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminPathwayUsersArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsAdminPathwayUsersCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type PathwayModelAsAdminPathwayUserArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminGroupsArgs = {
  filters?: Maybe<Array<GroupModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsAdminGroupsCountArgs = {
  filters?: Maybe<Array<GroupModelFilterInput>>;
};


export type PathwayModelAsAdminGroupArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminEnrolmentsArgs = {
  filters?: Maybe<Array<PathwayEnrolmentModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsAdminEnrolmentsCountArgs = {
  filters?: Maybe<Array<PathwayEnrolmentModelFilterInput>>;
};


export type PathwayModelAsAdminEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminTopicEnrolmentsArgs = {
  filters?: Maybe<Array<TopicEnrolmentModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsAdminTopicEnrolmentsCountArgs = {
  filters?: Maybe<Array<TopicEnrolmentModelFilterInput>>;
};


export type PathwayModelAsAdminTopicEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminCertificationItemsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsAdminCertificationItemsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type PathwayModelAsAdminCertificationItemArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsAdminAddCommentArgs = {
  content: Scalars['String'];
  replyTo?: Maybe<Scalars['PositiveInt']>;
};

export enum PathwayModelAsAdminFilterEnum {
  title = 'title',
  published = 'published',
  searchByIds = 'searchByIds',
  includeDeleted = 'includeDeleted'
}

export type PathwayModelAsAdminFilterInput = {
  name: PathwayModelAsAdminFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type PathwayModelAsStudent = {
  __typename?: 'PathwayModelAsStudent';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  is_public?: Maybe<Scalars['Boolean']>;
  published_date?: Maybe<Scalars['DateTime']>;
  progress?: Maybe<PathwayProgress>;
  organisation_id: Scalars['PositiveInt'];
  order: Scalars['PositiveInt'];
  created_by: Scalars['PositiveInt'];
  production_pathway_version_id: Scalars['PositiveInt'];
  background_document_id?: Maybe<Scalars['PositiveInt']>;
  allow_comments: Scalars['Boolean'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  openedFromCampaignShareEmail?: Maybe<Scalars['NonNegativeInt']>;
  state?: Maybe<PathwayState>;
  currentTopicVersions: Array<TopicVersionModelAsEditor>;
  currentTopicVersionsCount?: Maybe<Scalars['NonNegativeInt']>;
  currentEnrolment?: Maybe<PathwayEnrolmentModelAsStudent>;
  numberOfTopics?: Maybe<Scalars['NonNegativeInt']>;
  /** returns current topics for the pathway */
  topics?: Maybe<Array<TopicModelAsMember>>;
  /** returns topic if it belongs to current version of the pathway */
  topic?: Maybe<TopicModelAsMember>;
  nextUnfinishedTopic?: Maybe<TopicModelAsMember>;
  /** returns a topic after the passed one. Topics are taken from the current topics on a pathway. Unpublished and archived topics are ignored in both cases. */
  nextTopicAfter?: Maybe<TopicModelAsMember>;
  /** creates a new self enrolment if none exists. If there is an existing enrolment we check if it has been started, If not, we mark it as started */
  enrolmentOrSelfEnrol?: Maybe<PathwayEnrolmentModel>;
  tags: Array<TagModel>;
  tagsCount: Scalars['NonNegativeInt'];
  /** finds a single tag by the idColumn of the relation */
  tag?: Maybe<TagModel>;
  coverImage?: Maybe<DocumentModel>;
  coverImageVariants: Array<ImageVariantModel>;
  coverImageVariantsCount: Scalars['NonNegativeInt'];
  /** finds a single coverImageVariant by the idColumn of the relation */
  coverImageVariant?: Maybe<ImageVariantModel>;
  currentVersionTopics: Array<PathwayVersionTopicModel>;
  currentVersionTopicsCount: Scalars['NonNegativeInt'];
  /** finds a single currentVersionTopic by the idColumn of the relation */
  currentVersionTopic?: Maybe<PathwayVersionTopicModel>;
  owner: UserModel;
  currentPathwayVersion: PathwayVersionModel;
  currentTopics: Array<TopicModelAsMember>;
  currentTopicsCount: Scalars['NonNegativeInt'];
  /** finds a single currentTopic by the idColumn of the relation */
  currentTopic?: Maybe<TopicModelAsMember>;
  versions: Array<PathwayVersionModelAsStudent>;
  versionsCount: Scalars['NonNegativeInt'];
  /** finds a single version by the idColumn of the relation */
  version?: Maybe<PathwayVersionModelAsStudent>;
  isFollowingComments: Scalars['Boolean'];
  comments: Array<CommentModel>;
  addComment: CommentModel;
};


export type PathwayModelAsStudentOpenedFromCampaignShareEmailArgs = {
  scheduledCampaignActionId: Scalars['PositiveInt'];
};


export type PathwayModelAsStudentCurrentTopicVersionsArgs = {
  filters?: Maybe<Array<FilterDescriptor>>;
  order?: Maybe<Array<OrderDescriptor>>;
};


export type PathwayModelAsStudentCurrentTopicVersionsCountArgs = {
  filters?: Maybe<Array<FilterDescriptor>>;
};


export type PathwayModelAsStudentTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsStudentNextTopicAfterArgs = {
  topicId: Scalars['PositiveInt'];
};


export type PathwayModelAsStudentTagsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsStudentTagsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type PathwayModelAsStudentTagArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsStudentCoverImageVariantsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsStudentCoverImageVariantsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type PathwayModelAsStudentCoverImageVariantArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsStudentCurrentVersionTopicsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsStudentCurrentVersionTopicsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type PathwayModelAsStudentCurrentVersionTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsStudentCurrentTopicsArgs = {
  filters?: Maybe<Array<TopicModelAsMemberFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsStudentCurrentTopicsCountArgs = {
  filters?: Maybe<Array<TopicModelAsMemberFilterInput>>;
};


export type PathwayModelAsStudentCurrentTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsStudentVersionsArgs = {
  filters?: Maybe<Array<PathwayVersionModelAsStudentFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayModelAsStudentVersionsCountArgs = {
  filters?: Maybe<Array<PathwayVersionModelAsStudentFilterInput>>;
};


export type PathwayModelAsStudentVersionArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayModelAsStudentAddCommentArgs = {
  content: Scalars['String'];
  replyTo?: Maybe<Scalars['PositiveInt']>;
};

export enum PathwayModelFilterEnum {
  title = 'title',
  published = 'published',
  searchByIds = 'searchByIds'
}

export type PathwayModelFilterInput = {
  name: PathwayModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export enum PathwayNotificationMessageEnum {
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  P4 = 'P4'
}

export enum PathwayProgress {
  linear = 'linear',
  open = 'open',
  locked = 'locked'
}

export enum PathwayProgressStatus {
  ALL = 'ALL',
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
  OVERDUE = 'OVERDUE'
}

export type PathwayShareWithGroupsInput = {
  groupIds: Array<Scalars['PositiveInt']>;
  targetDate?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  sendEmail?: Maybe<Scalars['Boolean']>;
  emailIdentityId?: Maybe<Scalars['PositiveInt']>;
  resetEnrolments?: Maybe<Scalars['Boolean']>;
};

export type PathwayShareWithUsersInput = {
  userIds: Array<Scalars['PositiveInt']>;
  targetDate?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  sendEmail?: Maybe<Scalars['Boolean']>;
  emailIdentityId?: Maybe<Scalars['PositiveInt']>;
  resetEnrolments?: Maybe<Scalars['Boolean']>;
  certificationId?: Maybe<Scalars['PositiveInt']>;
  campaignPathwayShareActionId?: Maybe<Scalars['PositiveInt']>;
};

export enum PathwayState {
  draft = 'draft',
  published = 'published'
}

export type PathwayUserModel = {
  __typename?: 'PathwayUserModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  pathway_id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  pathway: PathwayModel;
  user: UserModel;
};

export type PathwayVersionModel = {
  __typename?: 'PathwayVersionModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  pathway_id: Scalars['PositiveInt'];
  minor_version: Scalars['PositiveInt'];
  major_version: Scalars['PositiveInt'];
  version: Scalars['String'];
  pathway: PathwayModel;
  pathwayTopics: Array<PathwayVersionTopicModel>;
  pathwayTopicsCount: Scalars['NonNegativeInt'];
  /** finds a single pathwayTopic by the idColumn of the relation */
  pathwayTopic?: Maybe<PathwayVersionTopicModel>;
  author?: Maybe<UserModel>;
};


export type PathwayVersionModelPathwayTopicsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayVersionModelPathwayTopicsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type PathwayVersionModelPathwayTopicArgs = {
  id: Scalars['PositiveInt'];
};

export type PathwayVersionModelAsStudent = {
  __typename?: 'PathwayVersionModelAsStudent';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  pathway_id: Scalars['PositiveInt'];
  minor_version: Scalars['PositiveInt'];
  major_version: Scalars['PositiveInt'];
  version: Scalars['String'];
  pathway: PathwayModel;
  pathwayTopics: Array<PathwayVersionTopicModel>;
  pathwayTopicsCount: Scalars['NonNegativeInt'];
  /** finds a single pathwayTopic by the idColumn of the relation */
  pathwayTopic?: Maybe<PathwayVersionTopicModel>;
  author?: Maybe<UserModel>;
  topics: Array<TopicModelAsMember>;
  topicsCount: Scalars['NonNegativeInt'];
  /** finds a single topic by the idColumn of the relation */
  topic?: Maybe<TopicModelAsMember>;
};


export type PathwayVersionModelAsStudentPathwayTopicsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayVersionModelAsStudentPathwayTopicsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type PathwayVersionModelAsStudentPathwayTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type PathwayVersionModelAsStudentTopicsArgs = {
  filters?: Maybe<Array<TopicModelAsMemberFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type PathwayVersionModelAsStudentTopicsCountArgs = {
  filters?: Maybe<Array<TopicModelAsMemberFilterInput>>;
};


export type PathwayVersionModelAsStudentTopicArgs = {
  id: Scalars['PositiveInt'];
};

export enum PathwayVersionModelAsStudentFilterEnum {
  version = 'version'
}

export type PathwayVersionModelAsStudentFilterInput = {
  name: PathwayVersionModelAsStudentFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type PathwayVersionTopicModel = {
  __typename?: 'PathwayVersionTopicModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  topic_id: Scalars['PositiveInt'];
  pathway_version_id: Scalars['PositiveInt'];
  order: Scalars['Int'];
  topic: TopicModel;
  pathwayVersion: PathwayVersionModel;
};

export enum PathwaysOverviewOrderColumn {
  displayName = 'displayName',
  pathwayName = 'pathwayName',
  progress = 'progress',
  startedAt = 'startedAt',
  completedAt = 'completedAt',
  attempt = 'attempt'
}


export type PrivateImageWithVariants = {
  __typename?: 'PrivateImageWithVariants';
  original?: Maybe<Scalars['String']>;
  variants?: Maybe<Scalars['JSON']>;
  variantCdnUrl?: Maybe<Scalars['String']>;
  originalCdnUrl?: Maybe<Scalars['String']>;
};


export type PrivateImageWithVariantsVariantCdnUrlArgs = {
  imageSize: ImageVariantSizes;
};

export type Query = {
  __typename?: 'Query';
  organisation?: Maybe<OrganisationModelGqlBase>;
  user?: Maybe<UserModelPublicBase>;
  /** looop web frontend uses this endpoint to obtain a session token at the startup */
  session?: Maybe<UserSessionModelSelf>;
  releasedVersion: Scalars['String'];
  howUserCanResetPassword?: Maybe<PasswordResetStrategy>;
  getUserSecurityQuestions?: Maybe<Array<UserSecurityQuestionsEnum>>;
  yourIp?: Maybe<Scalars['String']>;
  /** latest from poeditor-common for every organisation */
  translationMessages: Scalars['JSON'];
};


export type QueryOrganisationArgs = {
  subdomainName?: Maybe<Scalars['String']>;
};


export type QueryUserArgs = {
  token: Scalars['String'];
};


export type QuerySessionArgs = {
  sid?: Maybe<Scalars['String']>;
};


export type QueryHowUserCanResetPasswordArgs = {
  accountNameOrEmail: Scalars['NonEmptyString'];
};


export type QueryGetUserSecurityQuestionsArgs = {
  accountName: Scalars['NonEmptyString'];
};


export type QueryTranslationMessagesArgs = {
  locale: SupportedLocalesEnum;
};

export type QuizElementResults = {
  __typename?: 'QuizElementResults';
  elementId?: Maybe<Scalars['PositiveInt']>;
  content?: Maybe<Scalars['String']>;
  is_auto_assessable?: Maybe<Scalars['Boolean']>;
  freeQuizResponse?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Scalars['JSON']>>;
  /** null is returned when user did not answer this quiz element yet */
  response_is_correct?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  /** null is returned when user did not answer that quiz yet */
  created_at?: Maybe<Scalars['DateTime']>;
  scormQuizResponse?: Maybe<Scalars['String']>;
};

export type QuizOptionClickRateAnalytic = {
  __typename?: 'QuizOptionClickRateAnalytic';
  clicks: Scalars['NonNegativeInt'];
  totalResponses: Scalars['NonNegativeInt'];
};

export type QuizOptionModel = {
  __typename?: 'QuizOptionModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  content?: Maybe<Scalars['String']>;
  is_correct: Scalars['Boolean'];
  feedback?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  other?: Maybe<Scalars['String']>;
  id: Scalars['PositiveInt'];
  topic_element_id: Scalars['PositiveInt'];
  /** indicates how often are students selecting this option vs all the other options */
  clickRate?: Maybe<QuizOptionClickRateAnalytic>;
};


export type QuizOptionModelClickRateArgs = {
  interval?: Maybe<TimeInterval>;
  groupIds?: Maybe<Array<Scalars['PositiveInt']>>;
};

export type QuizOptionModelAsEditor = {
  __typename?: 'QuizOptionModelAsEditor';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  content?: Maybe<Scalars['String']>;
  is_correct: Scalars['Boolean'];
  feedback?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  other?: Maybe<Scalars['String']>;
  id: Scalars['PositiveInt'];
  topic_element_id: Scalars['PositiveInt'];
  /** indicates how often are students selecting this option vs all the other options */
  clickRate?: Maybe<QuizOptionClickRateAnalytic>;
  patch: QuizOptionModel;
};


export type QuizOptionModelAsEditorClickRateArgs = {
  interval?: Maybe<TimeInterval>;
  groupIds?: Maybe<Array<Scalars['PositiveInt']>>;
};


export type QuizOptionModelAsEditorPatchArgs = {
  input: QuizOptionModelBaseInput;
};

export type QuizOptionModelBaseInput = {
  content?: Maybe<Scalars['String']>;
  is_correct?: Maybe<Scalars['Boolean']>;
  feedback?: Maybe<Scalars['String']>;
};

export type RangeTimeComparator = {
  __typename?: 'RangeTimeComparator';
  toDate?: Maybe<Scalars['DateTime']>;
  fromDate?: Maybe<Scalars['DateTime']>;
};

export type RangeTimeComparatorInput = {
  toDate?: Maybe<Scalars['DateTime']>;
  fromDate?: Maybe<Scalars['DateTime']>;
};

export enum RecurringEventAttendanceTypeEnum {
  multiple = 'multiple',
  all = 'all'
}

export type RecurringEventInviteeGroupModel = {
  __typename?: 'RecurringEventInviteeGroupModel';
  id: Scalars['PositiveInt'];
  group_id: Scalars['PositiveInt'];
  recurring_event_id: Scalars['PositiveInt'];
  created_at?: Maybe<Scalars['DateTime']>;
};

export type RecurringEventInviteeModel = {
  __typename?: 'RecurringEventInviteeModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  last_edit_by?: Maybe<Scalars['PositiveInt']>;
  /** Id of a user who invited this user */
  created_by?: Maybe<Scalars['PositiveInt']>;
  user_id: Scalars['PositiveInt'];
  recurring_event_id: Scalars['PositiveInt'];
  certification_id?: Maybe<Scalars['PositiveInt']>;
  from_invited_group_id?: Maybe<Scalars['PositiveInt']>;
  /** how a user responded to the invitation */
  attending?: Maybe<Scalars['Boolean']>;
  /** actually recorded attendance of the user by the organiser */
  present?: Maybe<Scalars['Boolean']>;
  resendInvitationEmail?: Maybe<Scalars['DateTime']>;
  patch?: Maybe<RecurringEventInviteeModel>;
  recurringEvent: RecurringEventModel;
  user: UserModel;
  userEvents: Array<UserEventModel>;
  userEventsCount: Scalars['NonNegativeInt'];
  /** finds a single userEvent by the idColumn of the relation */
  userEvent?: Maybe<UserEventModel>;
  lastEditedBy: UserModel;
  group?: Maybe<GroupModel>;
  certification?: Maybe<CertificationModel>;
};


export type RecurringEventInviteeModelPatchArgs = {
  present?: Maybe<Scalars['Boolean']>;
  attending?: Maybe<Scalars['Boolean']>;
};


export type RecurringEventInviteeModelUserEventsArgs = {
  filters?: Maybe<Array<UserEventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type RecurringEventInviteeModelUserEventsCountArgs = {
  filters?: Maybe<Array<UserEventModelFilterInput>>;
};


export type RecurringEventInviteeModelUserEventArgs = {
  id: Scalars['PositiveInt'];
};

export type RecurringEventModel = {
  __typename?: 'RecurringEventModel';
  deleted_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  author_id: Scalars['PositiveInt'];
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  update_email_sent_at?: Maybe<Scalars['DateTime']>;
  published_date?: Maybe<Scalars['DateTime']>;
  participants_limit?: Maybe<Scalars['Float']>;
  recurrence?: Maybe<EventRecurrencePattern>;
  start_time?: Maybe<Scalars['DateTime']>;
  end_time?: Maybe<Scalars['DateTime']>;
  attendance_type?: Maybe<RecurringEventAttendanceTypeEnum>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  facilitator_id?: Maybe<Scalars['PositiveInt']>;
  description?: Maybe<Scalars['SizeValidatedString_199KB']>;
  is_open: Scalars['Boolean'];
  allow_comments: Scalars['Boolean'];
  google_meet_uuid?: Maybe<Scalars['String']>;
  google_meet_id?: Maybe<Scalars['String']>;
  ms_teams_url?: Maybe<Scalars['String']>;
  ms_teams_enabled: Scalars['Boolean'];
  attendeesCount: Scalars['NonNegativeInt'];
  invitee?: Maybe<RecurringEventInviteeModel>;
  repeatPattern: Scalars['String'];
  /** only counts individuals invited directly */
  inviteesCount: Scalars['NonNegativeInt'];
};


export type RecurringEventModelInviteeArgs = {
  userId: Scalars['PositiveInt'];
};

export type RecurringEventModelAsStudent = {
  __typename?: 'RecurringEventModelAsStudent';
  deleted_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  author_id: Scalars['PositiveInt'];
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  update_email_sent_at?: Maybe<Scalars['DateTime']>;
  published_date?: Maybe<Scalars['DateTime']>;
  participants_limit?: Maybe<Scalars['Float']>;
  recurrence?: Maybe<EventRecurrencePattern>;
  start_time?: Maybe<Scalars['DateTime']>;
  end_time?: Maybe<Scalars['DateTime']>;
  attendance_type?: Maybe<RecurringEventAttendanceTypeEnum>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  facilitator_id?: Maybe<Scalars['PositiveInt']>;
  description?: Maybe<Scalars['SizeValidatedString_199KB']>;
  is_open: Scalars['Boolean'];
  allow_comments: Scalars['Boolean'];
  google_meet_uuid?: Maybe<Scalars['String']>;
  google_meet_id?: Maybe<Scalars['String']>;
  ms_teams_url?: Maybe<Scalars['String']>;
  ms_teams_enabled: Scalars['Boolean'];
  attendeesCount: Scalars['NonNegativeInt'];
  invitee?: Maybe<RecurringEventInviteeModel>;
  repeatPattern: Scalars['String'];
  /** only counts individuals invited directly */
  inviteesCount: Scalars['NonNegativeInt'];
  registerToAttendWholeSeries?: Maybe<RecurringEventInviteeModel>;
  events: Array<EventModel>;
  eventsCount: Scalars['NonNegativeInt'];
  /** finds a single event by the idColumn of the relation */
  event?: Maybe<EventModel>;
  author: UserModelPublicBase;
  organisation: OrganisationModel;
  tags: Array<TagModel>;
  tagsCount: Scalars['NonNegativeInt'];
  /** finds a single tag by the idColumn of the relation */
  tag?: Maybe<TagModel>;
  invitedGroups: Array<GroupModelGqlBase>;
  invitedGroupsCount: Scalars['NonNegativeInt'];
  /** finds a single invitedGroup by the idColumn of the relation */
  invitedGroup?: Maybe<GroupModelGqlBase>;
  inviteeGroups: Array<RecurringEventInviteeGroupModel>;
  inviteeGroupsCount: Scalars['NonNegativeInt'];
  /** finds a single inviteeGroup by the idColumn of the relation */
  inviteeGroup?: Maybe<RecurringEventInviteeGroupModel>;
  invitedUsers: Array<UserModelPublicBase>;
  invitedUsersCount: Scalars['NonNegativeInt'];
  /** finds a single invitedUser by the idColumn of the relation */
  invitedUser?: Maybe<UserModelPublicBase>;
  facilitator?: Maybe<UserModelPublicBase>;
};


export type RecurringEventModelAsStudentInviteeArgs = {
  userId: Scalars['PositiveInt'];
};


export type RecurringEventModelAsStudentRegisterToAttendWholeSeriesArgs = {
  emailIdentityId?: Maybe<Scalars['PositiveInt']>;
};


export type RecurringEventModelAsStudentEventsArgs = {
  filters?: Maybe<Array<EventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type RecurringEventModelAsStudentEventsCountArgs = {
  filters?: Maybe<Array<EventModelFilterInput>>;
};


export type RecurringEventModelAsStudentEventArgs = {
  id: Scalars['PositiveInt'];
};


export type RecurringEventModelAsStudentTagsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type RecurringEventModelAsStudentTagsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type RecurringEventModelAsStudentTagArgs = {
  id: Scalars['PositiveInt'];
};


export type RecurringEventModelAsStudentInvitedGroupsArgs = {
  filters?: Maybe<Array<GroupModelGqlBaseFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type RecurringEventModelAsStudentInvitedGroupsCountArgs = {
  filters?: Maybe<Array<GroupModelGqlBaseFilterInput>>;
};


export type RecurringEventModelAsStudentInvitedGroupArgs = {
  id: Scalars['PositiveInt'];
};


export type RecurringEventModelAsStudentInviteeGroupsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type RecurringEventModelAsStudentInviteeGroupsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type RecurringEventModelAsStudentInviteeGroupArgs = {
  id: Scalars['PositiveInt'];
};


export type RecurringEventModelAsStudentInvitedUsersArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type RecurringEventModelAsStudentInvitedUsersCountArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
};


export type RecurringEventModelAsStudentInvitedUserArgs = {
  id: Scalars['PositiveInt'];
};

export enum RecurringEventModelFilterEnum {
  search = 'search',
  title = 'title',
  searchEventTitle = 'searchEventTitle',
  published = 'published',
  draft = 'draft',
  open = 'open',
  after = 'after',
  status = 'status',
  tagId = 'tagId'
}

export type RecurringEventModelFilterInput = {
  name: RecurringEventModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type RelativeTimeComparator = {
  __typename?: 'RelativeTimeComparator';
  direction?: Maybe<TemporalDirection>;
  duration?: Maybe<UserFilterTimeDuration>;
};

export type RelativeTimeComparatorInput = {
  direction?: Maybe<TemporalDirection>;
  duration?: Maybe<UserFilterTimeDurationInput>;
};

export type ReorderItemsInput = {
  from: Scalars['NonNegativeInt'];
  to: Scalars['NonNegativeInt'];
};

export type RequestTranscodingInput = {
  filePath: Scalars['String'];
};

export enum ResetPasswordStrategyEnum {
  email = 'email',
  security_questions = 'security_questions'
}

export enum ResourceActivityOverviewOrderColumn {
  displayName = 'displayName',
  viewsCount = 'viewsCount',
  lastViewedAt = 'lastViewedAt'
}

export type ResourceFollowerModel = {
  __typename?: 'ResourceFollowerModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  item_id: Scalars['PositiveInt'];
  item_type?: Maybe<Scalars['String']>;
};

export enum ResourceVersionsOverviewOrderColumn {
  version = 'version',
  createdAt = 'createdAt',
  publishedBy = 'publishedBy',
  avgRating = 'avgRating',
  viewsCount = 'viewsCount',
  lastViewedAt = 'lastViewedAt'
}

export enum ResourcesOverviewOrderColumn {
  resourceName = 'resourceName',
  workspaceName = 'workspaceName',
  displayName = 'displayName',
  averageRating = 'averageRating',
  viewsCount = 'viewsCount',
  lastViewedAt = 'lastViewedAt',
  passRate = 'passRate'
}

export type ResponseModel = {
  __typename?: 'ResponseModel';
  id?: Maybe<Scalars['PositiveInt']>;
  is_correct?: Maybe<Scalars['Boolean']>;
  topic_element_id?: Maybe<Scalars['PositiveInt']>;
  topic_enrolment_id?: Maybe<Scalars['PositiveInt']>;
  created_at: Scalars['DateTime'];
  optionResponses?: Maybe<Array<SingleOptionResponse>>;
  freeQuizResponse?: Maybe<Scalars['String']>;
  enrolment: TopicEnrolmentModel;
  topicElement: TopicElementModel;
};

export type ResponseModelAsEditor = {
  __typename?: 'ResponseModelAsEditor';
  id?: Maybe<Scalars['PositiveInt']>;
  is_correct?: Maybe<Scalars['Boolean']>;
  topic_element_id?: Maybe<Scalars['PositiveInt']>;
  topic_enrolment_id?: Maybe<Scalars['PositiveInt']>;
  created_at: Scalars['DateTime'];
  optionResponses?: Maybe<Array<SingleOptionResponse>>;
  freeQuizResponse?: Maybe<Scalars['String']>;
  enrolment: TopicEnrolmentModelAsEditor;
  topicElement: TopicElementModel;
};

export type ResponsesBreakdownStats = {
  __typename?: 'ResponsesBreakdownStats';
  correct: Scalars['NonNegativeInt'];
  incorrect: Scalars['NonNegativeInt'];
};

export enum SqlOrderDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum SsoProviderEnum {
  azure = 'azure',
  facebook = 'facebook',
  forcedotcom = 'forcedotcom',
  twitter = 'twitter',
  google = 'google',
  googlesaml = 'googlesaml',
  azuresaml = 'azuresaml',
  adfs = 'adfs',
  windowslive = 'windowslive',
  okta = 'okta',
  oak = 'oak',
  centrify = 'centrify',
  rockrms = 'rockrms',
  fourth = 'fourth',
  onelogin = 'onelogin',
  jumpcloud = 'jumpcloud',
  idaptive = 'idaptive',
  keycloakveeam = 'keycloakveeam',
  pingidentity = 'pingidentity',
  azureb2c = 'azureb2c',
  auth0 = 'auth0'
}

export type SvgObject = {
  x: Scalars['Float'];
  y: Scalars['Float'];
  type: Scalars['String'];
  rotate?: Maybe<Scalars['Float']>;
  fontFamily?: Maybe<Scalars['String']>;
  fontWeight?: Maybe<Scalars['String']>;
  fontStyle?: Maybe<Scalars['String']>;
  fontSize?: Maybe<Scalars['String']>;
  blendMode?: Maybe<Scalars['String']>;
  fill?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  textDecoration?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  xlinkHref?: Maybe<Scalars['String']>;
};

export type ScheduledActionReport = {
  __typename?: 'ScheduledActionReport';
  id: Scalars['PositiveInt'];
  campaign_topic_share_action_id?: Maybe<Scalars['PositiveInt']>;
  campaign_pathway_share_action_id?: Maybe<Scalars['PositiveInt']>;
  campaign_survey_share_action_id?: Maybe<Scalars['PositiveInt']>;
  campaign_certification_share_action_id?: Maybe<Scalars['PositiveInt']>;
  campaign_email_action_id?: Maybe<Scalars['PositiveInt']>;
  campaign_message_action_id?: Maybe<Scalars['PositiveInt']>;
  campaign_banner_id?: Maybe<Scalars['PositiveInt']>;
  scheduled_time: Scalars['DateTime'];
  pathwayEnrolmentsEvent?: Maybe<EnrolmentEvent>;
  certificationEnrolmentsEvent?: Maybe<EnrolmentEvent>;
  surveysEvent?: Maybe<EnrolmentEvent>;
  topicEnrolmentsEvent?: Maybe<EnrolmentEvent>;
  emailEvent?: Maybe<EmailEvent>;
  bannerEvent?: Maybe<BannerEvent>;
  messageEvent?: Maybe<MessageSendEvent>;
  processedNotification?: Maybe<NotificationQueueProcessedModel>;
};

export type ScheduledCampaignActionModel = {
  __typename?: 'ScheduledCampaignActionModel';
  id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  campaign_id: Scalars['PositiveInt'];
  scheduled_time: Scalars['DateTime'];
  campaign_email_action_id?: Maybe<Scalars['PositiveInt']>;
  campaign_topic_share_action_id?: Maybe<Scalars['PositiveInt']>;
  campaign_pathway_share_action_id?: Maybe<Scalars['PositiveInt']>;
  campaign_certification_share_action_id?: Maybe<Scalars['PositiveInt']>;
  campaign_banner_id?: Maybe<Scalars['PositiveInt']>;
  campaign_survey_share_action_id?: Maybe<Scalars['PositiveInt']>;
  notification_id?: Maybe<Scalars['PositiveInt']>;
  notification_processed_id?: Maybe<Scalars['PositiveInt']>;
  created_at: Scalars['DateTime'];
  processed_at: Scalars['DateTime'];
  isBannerStarted?: Maybe<Scalars['Boolean']>;
  campaign_message_action_id?: Maybe<Scalars['PositiveInt']>;
  emailAction?: Maybe<CampaignEmailActionModel>;
  topicShareAction?: Maybe<CampaignTopicShareActionModel>;
  pathwayShareAction?: Maybe<CampaignPathwayShareActionModel>;
  certificationShareAction?: Maybe<CampaignCertificationShareActionModel>;
  surveyShareAction?: Maybe<CampaignSurveyShareActionModel>;
  sentEmails?: Maybe<NotificationQueueProcessedModel>;
  banner?: Maybe<CampaignBannerModel>;
  user: UserModel;
  campaign: CampaignModel;
  notification?: Maybe<NotificationQueueModel>;
  processedNotification?: Maybe<NotificationQueueProcessedModel>;
  messageAction?: Maybe<CampaignMessageActionModel>;
};

export enum ScheduledCampaignActionModelFilterEnum {
  untilNow = 'untilNow'
}

export type ScheduledCampaignActionModelFilterInput = {
  name: ScheduledCampaignActionModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type ScimResourceModel = {
  __typename?: 'ScimResourceModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  external_id?: Maybe<Scalars['String']>;
};

export type ScormCourseModel = {
  __typename?: 'ScormCourseModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  topic_version_id?: Maybe<Scalars['PositiveInt']>;
  job_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  job_details?: Maybe<Scalars['JSON']>;
  file_details?: Maybe<Scalars['JSON']>;
  importScormCourse?: Maybe<ScormCourseModel>;
  courseStatus?: Maybe<ScormCourseModel>;
  uploadCredentials?: Maybe<UploadCredentials>;
  /** returns null if the SCORM course is not already processed */
  preview?: Maybe<Scalars['String']>;
};


export type ScormCourseModelImportScormCourseArgs = {
  input: ImportScormCourseInput;
};


export type ScormCourseModelUploadCredentialsArgs = {
  filename: Scalars['String'];
};


export type ScormCourseModelPreviewArgs = {
  redirect: Scalars['String'];
};

export type ScormRegistrationModel = {
  __typename?: 'ScormRegistrationModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  user_topic_id?: Maybe<Scalars['PositiveInt']>;
  progress_report?: Maybe<Scalars['JSON']>;
  launchLink?: Maybe<Scalars['String']>;
  progressDetails?: Maybe<ScormRegistrationModel>;
  topicEnrolment?: Maybe<TopicEnrolmentModelAsStudent>;
};


export type ScormRegistrationModelLaunchLinkArgs = {
  redirect: Scalars['String'];
};

export enum SearchOverviewOrderColumn {
  search_term = 'search_term',
  count = 'count',
  last_searched = 'last_searched'
}

export enum SearchOverviewResultSelectEnum {
  NO_RESULT = 'NO_RESULT',
  RESULT = 'RESULT',
  ALL = 'ALL'
}

export type SearchStatisticModel = {
  __typename?: 'SearchStatisticModel';
  created_at: Scalars['DateTime'];
  user_id: Scalars['PositiveInt'];
  search_term: Scalars['String'];
  results_count: Scalars['NonNegativeInt'];
};

export enum SearchStatisticModelFilterEnum {
  inTimeInterval = 'inTimeInterval',
  noResults = 'noResults'
}

export type SearchStatisticModelFilterInput = {
  name: SearchStatisticModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type SecretLinkSignUpInput = {
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailAddress']>;
  custom_1?: Maybe<Scalars['String']>;
  custom_2?: Maybe<Scalars['String']>;
  custom_3?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  display_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  employee_id?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
};

export type SecretSignupLinkModel = {
  __typename?: 'SecretSignupLinkModel';
  token: Scalars['UUID'];
  group_id: Scalars['PositiveInt'];
  created_by: Scalars['PositiveInt'];
  created_at: Scalars['DateTime'];
  deleted_at: Scalars['DateTime'];
  organisation_id: Scalars['PositiveInt'];
  input_mapping: Scalars['JSON'];
  /** if the group was deleted, it will throw error */
  signUp?: Maybe<UserSessionModel>;
  /** returns null when user is already a member in the group */
  addCurrentUserToGroup?: Maybe<UserGroupModel>;
  organisation: OrganisationModel;
  group?: Maybe<GroupModel>;
  createdBy: UserModelPublicBase;
};


export type SecretSignupLinkModelSignUpArgs = {
  userInput: SecretLinkSignUpInput;
  securityQuestions?: Maybe<Array<SecurityQuestionsDataInput>>;
};

export type SecurityQuestionsDataInput = {
  question: UserSecurityQuestionsEnum;
  answer: Scalars['NonEmptyString'];
};

export type SelfSignUpUserDataInput = {
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  account_name: Scalars['String'];
  password: Scalars['String'];
  email?: Maybe<Scalars['EmailAddress']>;
  custom_1?: Maybe<Scalars['String']>;
  custom_2?: Maybe<Scalars['String']>;
  custom_3?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  employee_id?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
};

export type SendEmailRequestResult = {
  __typename?: 'SendEmailRequestResult';
  type?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type SignupOrganisationInput = {
  name: Scalars['String'];
  timezone: Scalars['String'];
};

export type SignupResult = {
  __typename?: 'SignupResult';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  sid?: Maybe<Scalars['String']>;
  user_id: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  expires: Scalars['DateTime'];
  session_attributes_data?: Maybe<Scalars['JSON']>;
  user: UserModelSelf;
  organisation: OrganisationModel;
  subdomain: SubdomainModel;
};

export type SignupUserInput = {
  name: Scalars['String'];
  password: Scalars['String'];
  email: Scalars['String'];
};

export type SingleOptionResponse = {
  __typename?: 'SingleOptionResponse';
  option_id?: Maybe<Scalars['PositiveInt']>;
  is_correct?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
  feedback?: Maybe<Scalars['String']>;
  optionContent?: Maybe<Scalars['String']>;
};

export type SingleOptionResponseInput = {
  option_id?: Maybe<Scalars['PositiveInt']>;
  value?: Maybe<Scalars['Boolean']>;
  feedback?: Maybe<Scalars['String']>;
  optionContent?: Maybe<Scalars['String']>;
};




export type StaticTimeComparator = {
  __typename?: 'StaticTimeComparator';
  direction?: Maybe<TemporalDirection>;
  date?: Maybe<Scalars['DateTime']>;
};

export type StaticTimeComparatorInput = {
  direction?: Maybe<TemporalDirection>;
  date?: Maybe<Scalars['DateTime']>;
};

export type SubdomainModel = {
  __typename?: 'SubdomainModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  created_by?: Maybe<Scalars['PositiveInt']>;
  fullUrl: Scalars['String'];
  organisation: OrganisationModel;
  createdBy: UserModel;
};

export enum SupportedLocalesEnum {
  enUs = 'enUs',
  enGb = 'enGb',
  esEs = 'esEs',
  frFr = 'frFr',
  itIt = 'itIt',
  deDe = 'deDe',
  ptBr = 'ptBr',
  ptPt = 'ptPt',
  zhHans = 'zhHans',
  zhHant = 'zhHant',
  viVn = 'viVn',
  pseudo = 'pseudo'
}

export type SurveyActionsCountByTimeUnit = {
  __typename?: 'SurveyActionsCountByTimeUnit';
  day: Scalars['DateTime'];
  count: Scalars['NonNegativeInt'];
};

export type SurveyAnswerModel = {
  __typename?: 'SurveyAnswerModel';
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  question_id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  value?: Maybe<Scalars['JSON']>;
  question: SurveyQuestionModel;
  user: UserModel;
};

export enum SurveyAnswerModelFilterEnum {
  from = 'from',
  to = 'to'
}

export type SurveyAnswerModelFilterInput = {
  name: SurveyAnswerModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export enum SurveyManageUsersOverviewOrderColumn {
  display_name = 'display_name',
  created_at = 'created_at',
  started_at = 'started_at',
  completed_at = 'completed_at'
}

export type SurveyModel = {
  __typename?: 'SurveyModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  title: Scalars['String'];
  organisation_id: Scalars['PositiveInt'];
  author_id: Scalars['PositiveInt'];
  published_at?: Maybe<Scalars['DateTime']>;
  completed_at?: Maybe<Scalars['DateTime']>;
  started_at?: Maybe<Scalars['DateTime']>;
  /** Special resolver for Survey CSV export that explicitly joins some relations to avoid performance issues */
  usersWithAnswers: Array<SurveyUserModel>;
};

export type SurveyModelAsAdmin = {
  __typename?: 'SurveyModelAsAdmin';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  title: Scalars['String'];
  organisation_id: Scalars['PositiveInt'];
  author_id: Scalars['PositiveInt'];
  published_at?: Maybe<Scalars['DateTime']>;
  completed_at?: Maybe<Scalars['DateTime']>;
  started_at?: Maybe<Scalars['DateTime']>;
  /** Special resolver for Survey CSV export that explicitly joins some relations to avoid performance issues */
  usersWithAnswers: Array<SurveyUserModel>;
  patch?: Maybe<SurveyModelAsAdmin>;
  archive?: Maybe<Scalars['NonNegativeInt']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  createQuestion?: Maybe<SurveyQuestionModel>;
  reorderQuestions?: Maybe<Array<SurveyQuestionModel>>;
  responses?: Maybe<SurveyResponses>;
  surveyOpenedByTimeUnit: Array<SurveyActionsCountByTimeUnit>;
  surveyCompletedByTimeUnit: Array<SurveyActionsCountByTimeUnit>;
  surveySendByTimeUnit: Array<SurveyActionsCountByTimeUnit>;
  resend?: Maybe<Scalars['DateTime']>;
  publish?: Maybe<Scalars['DateTime']>;
  send?: Maybe<Scalars['NonNegativeInt']>;
  participants: Array<SurveyUserModel>;
  participantsCount: Scalars['NonNegativeInt'];
  addTag: Scalars['NonNegativeInt'];
  removeTag?: Maybe<Scalars['NonNegativeInt']>;
  removeAllTags: Scalars['NonNegativeInt'];
  /** Returns questions for this survey */
  questionsWithoutInfoType: Array<SurveyQuestionModel>;
  organisation: OrganisationModel;
  questions: Array<SurveyQuestionModelAsEditor>;
  questionsCount: Scalars['NonNegativeInt'];
  /** finds a single question by the idColumn of the relation */
  question?: Maybe<SurveyQuestionModelAsEditor>;
  users: Array<SurveyUserModel>;
  usersCount: Scalars['NonNegativeInt'];
  /** finds a single user by the idColumn of the relation */
  user?: Maybe<SurveyUserModel>;
  tags: Array<TagModel>;
  tagsCount: Scalars['NonNegativeInt'];
  /** finds a single tag by the idColumn of the relation */
  tag?: Maybe<TagModel>;
  author?: Maybe<UserModel>;
};


export type SurveyModelAsAdminPatchArgs = {
  input: SurveyPatchInput;
};


export type SurveyModelAsAdminCreateQuestionArgs = {
  input: SurveyQuestionCreateInput;
};


export type SurveyModelAsAdminReorderQuestionsArgs = {
  input: ReorderItemsInput;
};


export type SurveyModelAsAdminSurveyOpenedByTimeUnitArgs = {
  unit: TimeUnitEnum;
};


export type SurveyModelAsAdminSurveyCompletedByTimeUnitArgs = {
  unit: TimeUnitEnum;
};


export type SurveyModelAsAdminSurveySendByTimeUnitArgs = {
  unit: TimeUnitEnum;
};


export type SurveyModelAsAdminResendArgs = {
  userId: Scalars['PositiveInt'];
};


export type SurveyModelAsAdminSendArgs = {
  input: SurveySendInput;
};


export type SurveyModelAsAdminParticipantsArgs = {
  search?: Maybe<Scalars['String']>;
  order?: Maybe<SurveyManageUsersOverviewOrderColumn>;
  orderDirection?: Maybe<SqlOrderDirectionEnum>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['PositiveInt']>;
};


export type SurveyModelAsAdminAddTagArgs = {
  id: Scalars['PositiveInt'];
};


export type SurveyModelAsAdminRemoveTagArgs = {
  id: Scalars['PositiveInt'];
};


export type SurveyModelAsAdminQuestionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type SurveyModelAsAdminQuestionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type SurveyModelAsAdminQuestionArgs = {
  id: Scalars['PositiveInt'];
};


export type SurveyModelAsAdminUsersArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type SurveyModelAsAdminUsersCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type SurveyModelAsAdminUserArgs = {
  id: Scalars['PositiveInt'];
};


export type SurveyModelAsAdminTagsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type SurveyModelAsAdminTagsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type SurveyModelAsAdminTagArgs = {
  id: Scalars['PositiveInt'];
};

export enum SurveyModelAsAdminFilterEnum {
  title = 'title'
}

export type SurveyModelAsAdminFilterInput = {
  name: SurveyModelAsAdminFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export enum SurveyModelFilterEnum {
  title = 'title'
}

export type SurveyModelFilterInput = {
  name: SurveyModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type SurveyPatchInput = {
  title?: Maybe<Scalars['String']>;
  completed_at?: Maybe<Scalars['DateTime']>;
};

export type SurveyQuestionAggregatedAnswer = {
  __typename?: 'SurveyQuestionAggregatedAnswer';
  id?: Maybe<Scalars['PositiveInt']>;
  value?: Maybe<Scalars['JSON']>;
  count?: Maybe<Scalars['NonNegativeInt']>;
  user?: Maybe<UserModel>;
};

export type SurveyQuestionContent = {
  __typename?: 'SurveyQuestionContent';
  options?: Maybe<Array<SurveyQuestionOption>>;
};

export type SurveyQuestionCreateInput = {
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type: SurveyQuestionTypes;
  content?: Maybe<Scalars['JSON']>;
  order?: Maybe<Scalars['PositiveInt']>;
};

export type SurveyQuestionModel = {
  __typename?: 'SurveyQuestionModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  survey_id: Scalars['PositiveInt'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<SurveyQuestionTypes>;
  order: Scalars['PositiveInt'];
  title: Scalars['String'];
  content?: Maybe<SurveyQuestionContent>;
  userAnswer?: Maybe<Scalars['JSON']>;
  answersCount: Scalars['NonNegativeInt'];
  /** Returns aggregated answers for this question with value and count */
  aggregatedAnswers: Array<SurveyQuestionAggregatedAnswer>;
};


export type SurveyQuestionModelAggregatedAnswersArgs = {
  filters: TimeInterval;
};

export type SurveyQuestionModelAsEditor = {
  __typename?: 'SurveyQuestionModelAsEditor';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  survey_id: Scalars['PositiveInt'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<SurveyQuestionTypes>;
  order: Scalars['PositiveInt'];
  title: Scalars['String'];
  content?: Maybe<SurveyQuestionContent>;
  userAnswer?: Maybe<Scalars['JSON']>;
  answersCount: Scalars['NonNegativeInt'];
  /** Returns aggregated answers for this question with value and count */
  aggregatedAnswers: Array<SurveyQuestionAggregatedAnswer>;
  patch?: Maybe<SurveyQuestionModel>;
  delete?: Maybe<Scalars['NonNegativeInt']>;
  duplicate?: Maybe<SurveyQuestionModel>;
  survey: SurveyModel;
  answers: Array<SurveyAnswerModel>;
  /** finds a single answer by the idColumn of the relation */
  answer?: Maybe<SurveyAnswerModel>;
};


export type SurveyQuestionModelAsEditorAnswersCountArgs = {
  filters?: Maybe<Array<SurveyAnswerModelFilterInput>>;
};


export type SurveyQuestionModelAsEditorAggregatedAnswersArgs = {
  filters: TimeInterval;
};


export type SurveyQuestionModelAsEditorPatchArgs = {
  input: SurveyQuestionPatchInput;
};


export type SurveyQuestionModelAsEditorAnswersArgs = {
  filters?: Maybe<Array<SurveyAnswerModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type SurveyQuestionModelAsEditorAnswerArgs = {
  id: Scalars['PositiveInt'];
};

export type SurveyQuestionOption = {
  __typename?: 'SurveyQuestionOption';
  label: Scalars['String'];
  id: Scalars['ID'];
  chosenByUsers: Array<UserModel>;
};

export type SurveyQuestionPatchInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  content: Scalars['JSON'];
};

export enum SurveyQuestionTypes {
  CHOOSE_ONE = 'CHOOSE_ONE',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  TEXT = 'TEXT',
  RATING = 'RATING',
  BOOL = 'BOOL',
  INFO = 'INFO'
}

export type SurveyResponses = {
  __typename?: 'SurveyResponses';
  totalCount: Scalars['NonNegativeInt'];
  startedCount: Scalars['NonNegativeInt'];
  completedCount: Scalars['NonNegativeInt'];
};

export type SurveySendInput = {
  users: Array<Scalars['PositiveInt']>;
  groups: Array<Scalars['PositiveInt']>;
  sendEmail: Scalars['Boolean'];
  noteText?: Maybe<Scalars['String']>;
  emailIdentityId?: Maybe<Scalars['PositiveInt']>;
};

export type SurveyUserModel = {
  __typename?: 'SurveyUserModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  survey_id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  invited_group_id?: Maybe<Scalars['PositiveInt']>;
  sent_by: Scalars['PositiveInt'];
  started_at?: Maybe<Scalars['DateTime']>;
  completed_at?: Maybe<Scalars['DateTime']>;
  note_text?: Maybe<Scalars['String']>;
  survey: SurveyModel;
  user: UserModel;
};

export enum SurveyUsersOverviewOrderColumn {
  surveyName = 'surveyName',
  startedAt = 'startedAt',
  completedAt = 'completedAt',
  createdAt = 'createdAt',
  status = 'status'
}

export type TagModel = {
  __typename?: 'TagModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
  name: Scalars['String'];
  organisation_id: Scalars['PositiveInt'];
  created_by: Scalars['PositiveInt'];
  organisation: OrganisationModel;
  events: Array<EventModel>;
  eventsCount: Scalars['NonNegativeInt'];
  /** finds a single event by the idColumn of the relation */
  event?: Maybe<EventModel>;
  recurring_events: Array<RecurringEventModel>;
  recurring_eventsCount: Scalars['NonNegativeInt'];
  /** finds a single recurring_event by the idColumn of the relation */
  recurring_event?: Maybe<RecurringEventModel>;
  pathways: Array<PathwayModel>;
  pathwaysCount: Scalars['NonNegativeInt'];
  /** finds a single pathway by the idColumn of the relation */
  pathway?: Maybe<PathwayModel>;
  surveys: Array<SurveyModel>;
  surveysCount: Scalars['NonNegativeInt'];
  /** finds a single survey by the idColumn of the relation */
  survey?: Maybe<SurveyModel>;
};


export type TagModelEventsArgs = {
  filters?: Maybe<Array<EventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TagModelEventsCountArgs = {
  filters?: Maybe<Array<EventModelFilterInput>>;
};


export type TagModelEventArgs = {
  id: Scalars['PositiveInt'];
};


export type TagModelRecurring_EventsArgs = {
  filters?: Maybe<Array<RecurringEventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TagModelRecurring_EventsCountArgs = {
  filters?: Maybe<Array<RecurringEventModelFilterInput>>;
};


export type TagModelRecurring_EventArgs = {
  id: Scalars['PositiveInt'];
};


export type TagModelPathwaysArgs = {
  filters?: Maybe<Array<PathwayModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TagModelPathwaysCountArgs = {
  filters?: Maybe<Array<PathwayModelFilterInput>>;
};


export type TagModelPathwayArgs = {
  id: Scalars['PositiveInt'];
};


export type TagModelSurveysArgs = {
  filters?: Maybe<Array<SurveyModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TagModelSurveysCountArgs = {
  filters?: Maybe<Array<SurveyModelFilterInput>>;
};


export type TagModelSurveyArgs = {
  id: Scalars['PositiveInt'];
};

export type TagTaggableModel = {
  __typename?: 'TagTaggableModel';
  event_id?: Maybe<Scalars['PositiveInt']>;
  pathway_id?: Maybe<Scalars['PositiveInt']>;
  survey_id?: Maybe<Scalars['PositiveInt']>;
  recurring_event_id?: Maybe<Scalars['PositiveInt']>;
  tag_id: Scalars['PositiveInt'];
};

export enum TargetEnrolmentStatusEnum {
  any_status = 'any_status',
  completed = 'completed',
  not_completed = 'not_completed',
  in_progress = 'in_progress',
  not_started = 'not_started',
  overdue = 'overdue',
  failed = 'failed',
  passed = 'passed',
  expires = 'expires',
  expired_or_expires = 'expired_or_expires',
  last_viewed_at = 'last_viewed_at',
  no_enrolment = 'no_enrolment',
  not_completed_or_no_enrolment = 'not_completed_or_no_enrolment'
}

export enum TemporalDirection {
  BEFORE = 'BEFORE',
  AFTER = 'AFTER'
}

export type ThemeModel = {
  __typename?: 'ThemeModel';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  workspace_id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  title?: Maybe<Scalars['String']>;
};

export type ThemeModelAsEditor = IThemeModel & {
  __typename?: 'ThemeModelAsEditor';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  workspace_id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  title?: Maybe<Scalars['String']>;
  topics: Array<ITopicModel>;
  topicsCount: Scalars['NonNegativeInt'];
  /** finds a single topic by the idColumn of the relation */
  topic?: Maybe<ITopicModel>;
  delete: Scalars['NonNegativeInt'];
  setTitle?: Maybe<ThemeModelAsEditor>;
  reorderTopics?: Maybe<Scalars['NonNegativeInt']>;
  order: Scalars['NonNegativeInt'];
  move: Scalars['NonNegativeInt'];
};


export type ThemeModelAsEditorTopicsArgs = {
  filters?: Maybe<Array<ITopicModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type ThemeModelAsEditorTopicsCountArgs = {
  filters?: Maybe<Array<ITopicModelFilterInput>>;
};


export type ThemeModelAsEditorTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type ThemeModelAsEditorSetTitleArgs = {
  title: Scalars['String'];
};


export type ThemeModelAsEditorReorderTopicsArgs = {
  topicIds: Array<Scalars['PositiveInt']>;
};


export type ThemeModelAsEditorMoveArgs = {
  direction: MoveDirectionEnum;
};

export type ThemeModelAsMember = IThemeModel & {
  __typename?: 'ThemeModelAsMember';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  workspace_id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  title?: Maybe<Scalars['String']>;
  topics: Array<ITopicModel>;
  topicsCount: Scalars['NonNegativeInt'];
  /** finds a single topic by the idColumn of the relation */
  topic?: Maybe<ITopicModel>;
};


export type ThemeModelAsMemberTopicsArgs = {
  filters?: Maybe<Array<ITopicModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type ThemeModelAsMemberTopicsCountArgs = {
  filters?: Maybe<Array<ITopicModelFilterInput>>;
};


export type ThemeModelAsMemberTopicArgs = {
  id: Scalars['PositiveInt'];
};

export type TimeComparatorForEnrolment = {
  __typename?: 'TimeComparatorForEnrolment';
  relative?: Maybe<RelativeTimeComparator>;
  static?: Maybe<StaticTimeComparator>;
  range?: Maybe<RangeTimeComparator>;
  field?: Maybe<Scalars['String']>;
};

export type TimeComparatorForEnrolmentInput = {
  relative?: Maybe<RelativeTimeComparatorInput>;
  static?: Maybe<StaticTimeComparatorInput>;
  range?: Maybe<RangeTimeComparatorInput>;
  field?: Maybe<Scalars['String']>;
};

export enum TimeDurationUnitsEnum {
  YEAR = 'YEAR',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  DAY = 'DAY',
  HOUR = 'HOUR'
}

export type TimeInterval = {
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};

export enum TimeUnitEnum {
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  DAY = 'DAY'
}

export type TopicAnalyticEventModel = {
  __typename?: 'TopicAnalyticEventModel';
  workspace_id?: Maybe<Scalars['PositiveInt']>;
  user_id?: Maybe<Scalars['PositiveInt']>;
  topic_version_id?: Maybe<Scalars['PositiveInt']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  topic_id?: Maybe<Scalars['PositiveInt']>;
  pathway_id?: Maybe<Scalars['PositiveInt']>;
  device_type?: Maybe<Scalars['String']>;
  user_agent?: Maybe<Scalars['String']>;
  accessed_at?: Maybe<Scalars['DateTime']>;
  left_at?: Maybe<Scalars['DateTime']>;
};

export type TopicCoverImageInput = {
  name: Scalars['String'];
  data: Scalars['String'];
};

export type TopicEditorModel = {
  __typename?: 'TopicEditorModel';
  user_id: Scalars['PositiveInt'];
  topic_id: Scalars['PositiveInt'];
  starts: Scalars['DateTime'];
  ends: Scalars['DateTime'];
};

export type TopicElementModel = {
  __typename?: 'TopicElementModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  topic_version_id: Scalars['PositiveInt'];
  data?: Maybe<Scalars['JSON']>;
  duration?: Maybe<Scalars['NonNegativeInt']>;
  order: Scalars['Int'];
  tsv?: Maybe<Scalars['String']>;
  type: TopicElementType;
  deleted_at?: Maybe<Scalars['DateTime']>;
  mediaFileName?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  documents: Array<VideoDocument>;
  topicVersion: TopicVersionModel;
  quizOptions: Array<QuizOptionModel>;
  quizOptionsCount: Scalars['NonNegativeInt'];
  /** finds a single quizOption by the idColumn of the relation */
  quizOption?: Maybe<QuizOptionModel>;
  responses: Array<ResponseModel>;
  responsesCount: Scalars['NonNegativeInt'];
  /** finds a single response by the idColumn of the relation */
  response?: Maybe<ResponseModel>;
};


export type TopicElementModelQuizOptionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TopicElementModelQuizOptionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type TopicElementModelQuizOptionArgs = {
  id: Scalars['PositiveInt'];
};


export type TopicElementModelResponsesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TopicElementModelResponsesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type TopicElementModelResponseArgs = {
  id: Scalars['PositiveInt'];
};

export type TopicElementModelAsEditor = {
  __typename?: 'TopicElementModelAsEditor';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  topic_version_id: Scalars['PositiveInt'];
  data?: Maybe<Scalars['JSON']>;
  duration?: Maybe<Scalars['NonNegativeInt']>;
  order: Scalars['Int'];
  tsv?: Maybe<Scalars['String']>;
  type: TopicElementType;
  deleted_at?: Maybe<Scalars['DateTime']>;
  mediaFileName?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  documents: Array<VideoDocument>;
  topicVersion: TopicVersionModel;
  quizOptions: Array<QuizOptionModelAsEditor>;
  quizOptionsCount: Scalars['NonNegativeInt'];
  /** finds a single quizOption by the idColumn of the relation */
  quizOption?: Maybe<QuizOptionModelAsEditor>;
  responses: Array<ResponseModel>;
  responsesCount: Scalars['NonNegativeInt'];
  /** finds a single response by the idColumn of the relation */
  response?: Maybe<ResponseModel>;
  responsesBreakdown?: Maybe<ResponsesBreakdownStats>;
  freeTextResponses: Array<ResponseModelAsEditor>;
  addOption?: Maybe<TopicElementModel>;
  deleteOption?: Maybe<TopicElementModel>;
  remove?: Maybe<TopicElementModel>;
  changeQuizType?: Maybe<TopicElementModelAsEditor>;
  setLength?: Maybe<TopicElementModel>;
  setLinkUrl?: Maybe<TopicElementModel>;
  patchContent: TopicElementModel;
  setDuration?: Maybe<TopicElementModel>;
  setMp3ContentUrl?: Maybe<TopicElementModel>;
  scanForViruses?: Maybe<Scalars['String']>;
  patchFileDetails?: Maybe<TopicElementModel>;
  uploadCredentials?: Maybe<UploadCredentials>;
  requestTranscoding?: Maybe<TopicElementModel>;
  /** Used for drag n drop */
  dragUp: Array<TopicElementModel>;
  /** Used for drag n drop */
  dragDown: Array<TopicElementModel>;
  /** This method swaps positions ("order" field) of elements. */
  swap?: Maybe<TopicElementModel>;
  patchGoogleDriveFileElement?: Maybe<TopicElementModel>;
  patchMicrosoftFileElement?: Maybe<TopicElementModel>;
  patchEmbedLinkElement?: Maybe<TopicElementModel>;
};


export type TopicElementModelAsEditorQuizOptionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TopicElementModelAsEditorQuizOptionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type TopicElementModelAsEditorQuizOptionArgs = {
  id: Scalars['PositiveInt'];
};


export type TopicElementModelAsEditorResponsesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TopicElementModelAsEditorResponsesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type TopicElementModelAsEditorResponseArgs = {
  id: Scalars['PositiveInt'];
};


export type TopicElementModelAsEditorResponsesBreakdownArgs = {
  interval?: Maybe<TimeInterval>;
  groupIds?: Maybe<Array<Scalars['PositiveInt']>>;
};


export type TopicElementModelAsEditorFreeTextResponsesArgs = {
  interval?: Maybe<TimeInterval>;
  groupIds?: Maybe<Array<Scalars['PositiveInt']>>;
};


export type TopicElementModelAsEditorDeleteOptionArgs = {
  optionId: Scalars['PositiveInt'];
};


export type TopicElementModelAsEditorChangeQuizTypeArgs = {
  type: TopicElementType;
};


export type TopicElementModelAsEditorSetLengthArgs = {
  minLength: Scalars['NonNegativeInt'];
  maxLength: Scalars['PositiveInt'];
};


export type TopicElementModelAsEditorSetLinkUrlArgs = {
  url: Scalars['String'];
  duration?: Maybe<Scalars['PositiveInt']>;
  getEmbedly?: Maybe<Scalars['Boolean']>;
};


export type TopicElementModelAsEditorPatchContentArgs = {
  content: Scalars['String'];
};


export type TopicElementModelAsEditorSetDurationArgs = {
  duration: Scalars['NonNegativeInt'];
};


export type TopicElementModelAsEditorSetMp3ContentUrlArgs = {
  bucketPath: Scalars['String'];
};


export type TopicElementModelAsEditorScanForVirusesArgs = {
  fileUrl: Scalars['String'];
};


export type TopicElementModelAsEditorPatchFileDetailsArgs = {
  input: FileDetailsInput;
};


export type TopicElementModelAsEditorUploadCredentialsArgs = {
  input: UploadCredentialsInput;
};


export type TopicElementModelAsEditorRequestTranscodingArgs = {
  input: RequestTranscodingInput;
};


export type TopicElementModelAsEditorDragUpArgs = {
  input: ReorderItemsInput;
};


export type TopicElementModelAsEditorDragDownArgs = {
  input: ReorderItemsInput;
};


export type TopicElementModelAsEditorSwapArgs = {
  order: Scalars['NonNegativeInt'];
};


export type TopicElementModelAsEditorPatchGoogleDriveFileElementArgs = {
  googleDriveFile: GoogleDriveFileInput;
};


export type TopicElementModelAsEditorPatchMicrosoftFileElementArgs = {
  microsoftFile: MicrosoftFileInput;
};


export type TopicElementModelAsEditorPatchEmbedLinkElementArgs = {
  embedLink: Scalars['String'];
};

export enum TopicElementModelFilterEnum {
  quizzes = 'quizzes'
}

export type TopicElementModelFilterInput = {
  name: TopicElementModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export enum TopicElementType {
  DOCUMENT = 'DOCUMENT',
  TEXT = 'TEXT',
  LINK = 'LINK',
  MEDIA = 'MEDIA',
  QUIZ_SINGLE = 'QUIZ_SINGLE',
  QUIZ_MULTI = 'QUIZ_MULTI',
  QUIZ_OPEN = 'QUIZ_OPEN',
  QUIZ_FREE = 'QUIZ_FREE',
  GOOGLE_DRIVE_FILE = 'GOOGLE_DRIVE_FILE',
  MICROSOFT_FILE = 'MICROSOFT_FILE',
  SCORM = 'SCORM',
  EMBED_LINK = 'EMBED_LINK'
}

export type TopicEnrolmentImportedModel = {
  __typename?: 'TopicEnrolmentImportedModel';
  id: Scalars['PositiveInt'];
  source_name?: Maybe<Scalars['String']>;
  imported_by?: Maybe<UserModel>;
  importedBy?: Maybe<UserModelBase>;
};

export type TopicEnrolmentModel = {
  __typename?: 'TopicEnrolmentModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  topic_id: Scalars['PositiveInt'];
  certification_id?: Maybe<Scalars['PositiveInt']>;
  topic_version_id?: Maybe<Scalars['PositiveInt']>;
  auto_correct: Scalars['NonNegativeInt'];
  auto_incorrect: Scalars['NonNegativeInt'];
  available_points?: Maybe<Scalars['NonNegativeInt']>;
  duration?: Maybe<Scalars['NonNegativeInt']>;
  feedback?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['PositiveInt']>;
  max_visited_element?: Maybe<Scalars['NonNegativeInt']>;
  num_responses?: Maybe<Scalars['NonNegativeInt']>;
  pass_mark?: Maybe<Scalars['NonNegativeInt']>;
  progress?: Maybe<Scalars['NonNegativeInt']>;
  /** when this is a date it means it was shared by an editor, so this enrolment is not a self-share */
  share_batch_ts?: Maybe<Scalars['DateTime']>;
  shared_by?: Maybe<Scalars['PositiveInt']>;
  start_date?: Maybe<Scalars['DateTime']>;
  completion_date?: Maybe<Scalars['DateTime']>;
  target_completion_date?: Maybe<Scalars['DateTime']>;
  campaign_topic_share_action_id?: Maybe<Scalars['PositiveInt']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  attempt?: Maybe<Scalars['PositiveInt']>;
  progress_time?: Maybe<Scalars['NonNegativeInt']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isMaxAttemptsExceeded?: Maybe<Scalars['Boolean']>;
  isNewAttemptAllowed?: Maybe<Scalars['Boolean']>;
  trackAccess?: Maybe<Scalars['DateTime']>;
  getOrCreateScormRegistration?: Maybe<ScormRegistrationModel>;
  storeRating?: Maybe<TopicEnrolmentModel>;
  status?: Maybe<WorkbookStatusEnum>;
  notificationMessage?: Maybe<TopicNotificationModel>;
};


export type TopicEnrolmentModelStoreRatingArgs = {
  ratingValue: Scalars['NonNegativeInt'];
  feedbackValue?: Maybe<Scalars['String']>;
};

export type TopicEnrolmentModelAsEditor = {
  __typename?: 'TopicEnrolmentModelAsEditor';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  topic_id: Scalars['PositiveInt'];
  certification_id?: Maybe<Scalars['PositiveInt']>;
  topic_version_id?: Maybe<Scalars['PositiveInt']>;
  auto_correct: Scalars['NonNegativeInt'];
  auto_incorrect: Scalars['NonNegativeInt'];
  available_points?: Maybe<Scalars['NonNegativeInt']>;
  duration?: Maybe<Scalars['NonNegativeInt']>;
  feedback?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['PositiveInt']>;
  max_visited_element?: Maybe<Scalars['NonNegativeInt']>;
  num_responses?: Maybe<Scalars['NonNegativeInt']>;
  pass_mark?: Maybe<Scalars['NonNegativeInt']>;
  progress?: Maybe<Scalars['NonNegativeInt']>;
  /** when this is a date it means it was shared by an editor, so this enrolment is not a self-share */
  share_batch_ts?: Maybe<Scalars['DateTime']>;
  shared_by?: Maybe<Scalars['PositiveInt']>;
  start_date?: Maybe<Scalars['DateTime']>;
  completion_date?: Maybe<Scalars['DateTime']>;
  target_completion_date?: Maybe<Scalars['DateTime']>;
  campaign_topic_share_action_id?: Maybe<Scalars['PositiveInt']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  attempt?: Maybe<Scalars['PositiveInt']>;
  progress_time?: Maybe<Scalars['NonNegativeInt']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isMaxAttemptsExceeded?: Maybe<Scalars['Boolean']>;
  isNewAttemptAllowed?: Maybe<Scalars['Boolean']>;
  trackAccess?: Maybe<Scalars['DateTime']>;
  getOrCreateScormRegistration?: Maybe<ScormRegistrationModel>;
  storeRating?: Maybe<TopicEnrolmentModel>;
  status?: Maybe<WorkbookStatusEnum>;
  notificationMessage?: Maybe<TopicNotificationModel>;
  assigned_at?: Maybe<Scalars['DateTime']>;
  student?: Maybe<UserModel>;
  archive?: Maybe<Scalars['Boolean']>;
  quizResponses: Array<ResponseModel>;
  markAsComplete?: Maybe<TopicEnrolmentModelAsEditor>;
  quizzesResults: Array<QuizElementResults>;
  user: UserModel;
  sharedBy?: Maybe<UserModelBase>;
  workspace?: Maybe<WorkspaceModelAsMember>;
  topic: TopicModel;
  topicVersion?: Maybe<TopicVersionModel>;
  quizResponsesCount: Scalars['NonNegativeInt'];
  /** finds a single quizResponse by the idColumn of the relation */
  quizResponse?: Maybe<ResponseModel>;
  scormRegistration?: Maybe<ScormRegistrationModel>;
  importRecord?: Maybe<TopicEnrolmentImportedModel>;
  videoImpressions: Array<VideoImpressionModel>;
  videoImpressionsCount: Scalars['NonNegativeInt'];
  /** finds a single videoImpression by the idColumn of the relation */
  videoImpression?: Maybe<VideoImpressionModel>;
  cpdUserEntry?: Maybe<CpdUserEntryModel>;
};


export type TopicEnrolmentModelAsEditorStoreRatingArgs = {
  ratingValue: Scalars['NonNegativeInt'];
  feedbackValue?: Maybe<Scalars['String']>;
};


export type TopicEnrolmentModelAsEditorQuizResponsesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TopicEnrolmentModelAsEditorQuizResponsesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type TopicEnrolmentModelAsEditorQuizResponseArgs = {
  id: Scalars['PositiveInt'];
};


export type TopicEnrolmentModelAsEditorVideoImpressionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TopicEnrolmentModelAsEditorVideoImpressionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type TopicEnrolmentModelAsEditorVideoImpressionArgs = {
  id: Scalars['PositiveInt'];
};

export enum TopicEnrolmentModelAsEditorFilterEnum {
  completedInTimeInterval = 'completedInTimeInterval',
  startedInInterval = 'startedInInterval',
  inTimeInterval = 'inTimeInterval',
  successful = 'successful',
  failed = 'failed',
  inProgress = 'inProgress',
  notStarted = 'notStarted',
  expired = 'expired',
  overdue = 'overdue',
  noOverdue = 'noOverdue',
  assigned = 'assigned',
  selfEnrolled = 'selfEnrolled',
  notArchived = 'notArchived',
  includeDeleted = 'includeDeleted',
  completed = 'completed',
  onlyCpdUserEntries = 'onlyCpdUserEntries',
  withFeedback = 'withFeedback',
  withRating = 'withRating',
  topicVersionId = 'topicVersionId',
  majorVersion = 'majorVersion'
}

export type TopicEnrolmentModelAsEditorFilterInput = {
  name: TopicEnrolmentModelAsEditorFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type TopicEnrolmentModelAsStudent = {
  __typename?: 'TopicEnrolmentModelAsStudent';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  user_id: Scalars['PositiveInt'];
  topic_id: Scalars['PositiveInt'];
  certification_id?: Maybe<Scalars['PositiveInt']>;
  topic_version_id?: Maybe<Scalars['PositiveInt']>;
  auto_correct: Scalars['NonNegativeInt'];
  auto_incorrect: Scalars['NonNegativeInt'];
  available_points?: Maybe<Scalars['NonNegativeInt']>;
  duration?: Maybe<Scalars['NonNegativeInt']>;
  feedback?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['PositiveInt']>;
  max_visited_element?: Maybe<Scalars['NonNegativeInt']>;
  num_responses?: Maybe<Scalars['NonNegativeInt']>;
  pass_mark?: Maybe<Scalars['NonNegativeInt']>;
  progress?: Maybe<Scalars['NonNegativeInt']>;
  /** when this is a date it means it was shared by an editor, so this enrolment is not a self-share */
  share_batch_ts?: Maybe<Scalars['DateTime']>;
  shared_by?: Maybe<Scalars['PositiveInt']>;
  start_date?: Maybe<Scalars['DateTime']>;
  completion_date?: Maybe<Scalars['DateTime']>;
  target_completion_date?: Maybe<Scalars['DateTime']>;
  campaign_topic_share_action_id?: Maybe<Scalars['PositiveInt']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  attempt?: Maybe<Scalars['PositiveInt']>;
  progress_time?: Maybe<Scalars['NonNegativeInt']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isMaxAttemptsExceeded?: Maybe<Scalars['Boolean']>;
  isNewAttemptAllowed?: Maybe<Scalars['Boolean']>;
  trackAccess?: Maybe<Scalars['DateTime']>;
  getOrCreateScormRegistration?: Maybe<ScormRegistrationModel>;
  storeRating?: Maybe<TopicEnrolmentModelAsStudent>;
  status?: Maybe<WorkbookStatusEnum>;
  notificationMessage?: Maybe<TopicNotificationModel>;
  lastViewedAt?: Maybe<Scalars['DateTime']>;
  addFreeQuizResponse?: Maybe<ResponseModel>;
  addQuizResponse?: Maybe<ResponseModel>;
  /** returns either the topic version that the user is enrolled to or the current topic version for the topic */
  topicVersion?: Maybe<TopicVersionModel>;
  updateProgress: TopicEnrolmentModelAsStudent;
  /** indicates whether enrolment of the current user can be restarted through the reEnrol or not. This is true only for enrolments with answered quizzes */
  canBeRestarted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  bongoParams?: Maybe<Scalars['JSON']>;
  createMediaImpression?: Maybe<VideoImpressionModel>;
  originSection?: Maybe<EnrolmentOriginSection>;
  readDurationSeconds?: Maybe<Scalars['NonNegativeInt']>;
  isCpdEntry?: Maybe<Scalars['Boolean']>;
  topic: TopicModelAsMember;
  certification?: Maybe<CertificationModelAsStudent>;
  pathwayEnrolment?: Maybe<PathwayEnrolmentModelAsStudent>;
  user: UserModel;
  quizResponses: Array<ResponseModel>;
  quizResponsesCount: Scalars['NonNegativeInt'];
  /** finds a single quizResponse by the idColumn of the relation */
  quizResponse?: Maybe<ResponseModel>;
  sharedBy?: Maybe<UserModelBase>;
  scormRegistration?: Maybe<ScormRegistrationModel>;
  workspace?: Maybe<WorkspaceModelAsMember>;
  videoImpressions: Array<VideoImpressionModel>;
  videoImpressionsCount: Scalars['NonNegativeInt'];
  /** finds a single videoImpression by the idColumn of the relation */
  videoImpression?: Maybe<VideoImpressionModel>;
  cpdUserEntry?: Maybe<CpdUserEntryModel>;
};


export type TopicEnrolmentModelAsStudentStoreRatingArgs = {
  ratingValue: Scalars['NonNegativeInt'];
  feedbackValue?: Maybe<Scalars['String']>;
};


export type TopicEnrolmentModelAsStudentAddFreeQuizResponseArgs = {
  elementId: Scalars['PositiveInt'];
  response: Scalars['String'];
};


export type TopicEnrolmentModelAsStudentAddQuizResponseArgs = {
  elementId: Scalars['PositiveInt'];
  optionResponses: Array<SingleOptionResponseInput>;
};


export type TopicEnrolmentModelAsStudentUpdateProgressArgs = {
  elementId: Scalars['PositiveInt'];
};


export type TopicEnrolmentModelAsStudentCreateMediaImpressionArgs = {
  elementId: Scalars['PositiveInt'];
};


export type TopicEnrolmentModelAsStudentQuizResponsesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TopicEnrolmentModelAsStudentQuizResponsesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type TopicEnrolmentModelAsStudentQuizResponseArgs = {
  id: Scalars['PositiveInt'];
};


export type TopicEnrolmentModelAsStudentVideoImpressionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TopicEnrolmentModelAsStudentVideoImpressionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type TopicEnrolmentModelAsStudentVideoImpressionArgs = {
  id: Scalars['PositiveInt'];
};

export enum TopicEnrolmentModelAsStudentFilterEnum {
  completedInTimeInterval = 'completedInTimeInterval',
  startedInInterval = 'startedInInterval',
  inTimeInterval = 'inTimeInterval',
  successful = 'successful',
  failed = 'failed',
  inProgress = 'inProgress',
  notStarted = 'notStarted',
  expired = 'expired',
  overdue = 'overdue',
  noOverdue = 'noOverdue',
  assigned = 'assigned',
  selfEnrolled = 'selfEnrolled',
  notArchived = 'notArchived',
  includeDeleted = 'includeDeleted',
  completed = 'completed',
  onlyCpdUserEntries = 'onlyCpdUserEntries'
}

export type TopicEnrolmentModelAsStudentFilterInput = {
  name: TopicEnrolmentModelAsStudentFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export enum TopicEnrolmentModelFilterEnum {
  completedInTimeInterval = 'completedInTimeInterval',
  startedInInterval = 'startedInInterval',
  inTimeInterval = 'inTimeInterval',
  successful = 'successful',
  failed = 'failed',
  inProgress = 'inProgress',
  notStarted = 'notStarted',
  expired = 'expired',
  overdue = 'overdue',
  noOverdue = 'noOverdue',
  assigned = 'assigned',
  selfEnrolled = 'selfEnrolled',
  notArchived = 'notArchived',
  includeDeleted = 'includeDeleted',
  completed = 'completed',
  onlyCpdUserEntries = 'onlyCpdUserEntries'
}

export type TopicEnrolmentModelFilterInput = {
  name: TopicEnrolmentModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type TopicModel = {
  __typename?: 'TopicModel';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  workspace_id: Scalars['PositiveInt'];
  production_topic_version_id?: Maybe<Scalars['PositiveInt']>;
  allow_comments?: Maybe<Scalars['Boolean']>;
  /** Sum of all rating values by students on this topic */
  total_rating: Scalars['NonNegativeInt'];
  /** Sum of students who rated this topic */
  number_rated: Scalars['NonNegativeInt'];
  theme_id?: Maybe<Scalars['PositiveInt']>;
  /** if published, returns title of currentTopicVersion, if not returns title of draftVersion */
  currentTitle: Scalars['String'];
  lastPublishedDate?: Maybe<Scalars['DateTime']>;
  firstPublishedDate?: Maybe<Scalars['DateTime']>;
  draftUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** returns date of last access to topic */
  lastViewedAt?: Maybe<Scalars['DateTime']>;
};

/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditor = ITopicModel & ISearchable & {
  __typename?: 'TopicModelAsEditor';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  workspace_id: Scalars['PositiveInt'];
  production_topic_version_id?: Maybe<Scalars['PositiveInt']>;
  allow_comments?: Maybe<Scalars['Boolean']>;
  /** Sum of all rating values by students on this topic */
  total_rating: Scalars['NonNegativeInt'];
  /** Sum of students who rated this topic */
  number_rated: Scalars['NonNegativeInt'];
  theme_id?: Maybe<Scalars['PositiveInt']>;
  /** if published, returns title of currentTopicVersion, if not returns title of draftVersion */
  currentTitle: Scalars['String'];
  lastPublishedDate?: Maybe<Scalars['DateTime']>;
  firstPublishedDate?: Maybe<Scalars['DateTime']>;
  draftUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** returns date of last access to topic */
  lastViewedAt?: Maybe<Scalars['DateTime']>;
  /** creates a new enrolment if retry is allowed on the current topic version */
  reEnrol?: Maybe<TopicEnrolmentModelAsStudent>;
  /** returns current user's last enrolment for this topic or null */
  lastEnrolment?: Maybe<TopicEnrolmentModelAsStudent>;
  certificationRelatedEnrolment?: Maybe<TopicEnrolmentModel>;
  lastCompletedEnrolment?: Maybe<TopicEnrolmentModelAsStudent>;
  latestPublishedTopicVersion?: Maybe<Scalars['String']>;
  /** returns already existing enrolment or it creates a new one if various conditions are met */
  enrolmentOrSelfEnrol: TopicEnrolmentModelAsStudent;
  openedFromCampaignShareEmail?: Maybe<Scalars['NonNegativeInt']>;
  author: UserModelPublicBase;
  currentTopicVersion?: Maybe<TopicVersionModel>;
  coverImage?: Maybe<DocumentModel>;
  coverImageVariants: Array<ImageVariantModel>;
  coverImageVariantsCount: Scalars['NonNegativeInt'];
  /** finds a single coverImageVariant by the idColumn of the relation */
  coverImageVariant?: Maybe<ImageVariantModel>;
  pathways: Array<PathwayModel>;
  pathwaysCount: Scalars['NonNegativeInt'];
  /** finds a single pathway by the idColumn of the relation */
  pathway?: Maybe<PathwayModel>;
  topicEditors: Array<TopicEditorModel>;
  topicEditorsCount: Scalars['NonNegativeInt'];
  /** finds a single topicEditor by the idColumn of the relation */
  topicEditor?: Maybe<TopicEditorModel>;
  theme: ThemeModel;
  certificationItems: Array<CertificationItemModel>;
  certificationItemsCount: Scalars['NonNegativeInt'];
  /** finds a single certificationItem by the idColumn of the relation */
  certificationItem?: Maybe<CertificationItemModel>;
  ratingDetails?: Maybe<Array<Scalars['NonNegativeInt']>>;
  averageRating?: Maybe<Scalars['NonNegativeFloat']>;
  /** The topic version with highest id - it should always be the last published one, no matter if the topic is published or not */
  lastTopicVersion?: Maybe<TopicVersionModelAsEditor>;
  /** Checks whether workspace is accessible for a user. User might not have access to the workspace because topic is accessible only from pathway or certification. */
  isWorkspaceAccessible?: Maybe<Scalars['Boolean']>;
  workspace?: Maybe<WorkspaceModelAsCollaborator>;
  archive: TopicModelAsEditor;
  order: Scalars['NonNegativeInt'];
  /** used for analytics */
  lastEnrolmentForUser?: Maybe<TopicEnrolmentModel>;
  currentTopicEditorUser?: Maybe<UserModel>;
  draftVersion?: Maybe<TopicVersionModelAsEditor>;
  /** used for analytics */
  lastCompletedEnrolmentForUser?: Maybe<TopicEnrolmentModel>;
  endEditing?: Maybe<Scalars['DateTime']>;
  unpublishTopic?: Maybe<TopicModel>;
  isTopicValid?: Maybe<Scalars['Boolean']>;
  publishTopic?: Maybe<TopicVersionModel>;
  patchDraftVersion?: Maybe<TopicVersionModel>;
  removeTopicTitleImage?: Maybe<Scalars['NonNegativeInt']>;
  uploadTopicTitleImage?: Maybe<Scalars['String']>;
  patch?: Maybe<TopicModelAsEditor>;
  moveTo: Scalars['NonNegativeInt'];
  /** used for analytics */
  lastAnalyticEvent?: Maybe<TopicAnalyticEventModel>;
  analytics?: Maybe<AnalyticsModel>;
  duplicate?: Maybe<TopicModelAsEditor>;
  relatedCampaignsByFilters: Array<CampaignModelAsAdminQueries>;
  relatedCampaignsByActions: Array<CampaignModelAsAdminQueries>;
  relatedCertifications: Array<CertificationModelAsAdmin>;
  relatedPathways: Array<PathwayModelAsAdmin>;
  bongoParams?: Maybe<Scalars['JSON']>;
  topicVersions: Array<TopicVersionModel>;
  topicVersionsCount: Scalars['NonNegativeInt'];
  /** finds a single topicVersion by the idColumn of the relation */
  topicVersion?: Maybe<TopicVersionModel>;
  pathwayVersions: Array<PathwayVersionTopicModel>;
  pathwayVersionsCount: Scalars['NonNegativeInt'];
  /** finds a single pathwayVersion by the idColumn of the relation */
  pathwayVersion?: Maybe<PathwayVersionTopicModel>;
  enrolments: Array<TopicEnrolmentModelAsEditor>;
  enrolmentsCount: Scalars['NonNegativeInt'];
  /** finds a single enrolment by the idColumn of the relation */
  enrolment?: Maybe<TopicEnrolmentModelAsEditor>;
  analyticEvents: Array<TopicAnalyticEventModel>;
  analyticEventsCount: Scalars['NonNegativeInt'];
  /** finds a single analyticEvent by the idColumn of the relation */
  analyticEvent?: Maybe<TopicAnalyticEventModel>;
  currentTopicVersionAsEditor?: Maybe<TopicVersionModelAsEditor>;
  pathwayVersionTopics: Array<PathwayVersionTopicModel>;
  pathwayVersionTopicsCount: Scalars['NonNegativeInt'];
  /** finds a single pathwayVersionTopic by the idColumn of the relation */
  pathwayVersionTopic?: Maybe<PathwayVersionTopicModel>;
  isFollowingComments: Scalars['Boolean'];
  comments: Array<CommentModel>;
  addComment: CommentModel;
  move: Scalars['NonNegativeInt'];
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorCertificationRelatedEnrolmentArgs = {
  certEnrolmentId: Scalars['PositiveInt'];
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorEnrolmentOrSelfEnrolArgs = {
  restartEnrolment?: Maybe<Scalars['Boolean']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorOpenedFromCampaignShareEmailArgs = {
  scheduledCampaignActionId: Scalars['PositiveInt'];
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorCoverImageVariantsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorCoverImageVariantsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorCoverImageVariantArgs = {
  id: Scalars['PositiveInt'];
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorPathwaysArgs = {
  filters?: Maybe<Array<PathwayModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorPathwaysCountArgs = {
  filters?: Maybe<Array<PathwayModelFilterInput>>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorPathwayArgs = {
  id: Scalars['PositiveInt'];
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorTopicEditorsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorTopicEditorsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorTopicEditorArgs = {
  id: Scalars['PositiveInt'];
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorCertificationItemsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorCertificationItemsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorCertificationItemArgs = {
  id: Scalars['PositiveInt'];
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorLastEnrolmentForUserArgs = {
  userId?: Maybe<Scalars['PositiveInt']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorDraftVersionArgs = {
  lockForEditing?: Maybe<Scalars['Boolean']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorLastCompletedEnrolmentForUserArgs = {
  userId?: Maybe<Scalars['PositiveInt']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorPublishTopicArgs = {
  major?: Maybe<Scalars['Boolean']>;
  resetEnrolments?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorPatchDraftVersionArgs = {
  input: TopicVersionInput;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorUploadTopicTitleImageArgs = {
  file: TopicCoverImageInput;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorPatchArgs = {
  input: TopicPatchInput;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorMoveToArgs = {
  workspaceId?: Maybe<Scalars['PositiveInt']>;
  themeId?: Maybe<Scalars['PositiveInt']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorAnalyticsArgs = {
  filter: AnalyticsFilter;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorBongoParamsArgs = {
  customLaunchView?: Maybe<Scalars['String']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorTopicVersionsArgs = {
  filters?: Maybe<Array<TopicVersionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorTopicVersionsCountArgs = {
  filters?: Maybe<Array<TopicVersionModelFilterInput>>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorTopicVersionArgs = {
  id: Scalars['PositiveInt'];
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorPathwayVersionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorPathwayVersionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorPathwayVersionArgs = {
  id: Scalars['PositiveInt'];
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorEnrolmentsArgs = {
  filters?: Maybe<Array<TopicEnrolmentModelAsEditorFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorEnrolmentsCountArgs = {
  filters?: Maybe<Array<TopicEnrolmentModelAsEditorFilterInput>>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorAnalyticEventsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorAnalyticEventsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorAnalyticEventArgs = {
  id: Scalars['PositiveInt'];
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorPathwayVersionTopicsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorPathwayVersionTopicsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorPathwayVersionTopicArgs = {
  id: Scalars['PositiveInt'];
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorAddCommentArgs = {
  content: Scalars['String'];
  replyTo?: Maybe<Scalars['PositiveInt']>;
};


/** topic model for workspace COLLABORATOR or COORDINATOR */
export type TopicModelAsEditorMoveArgs = {
  direction: MoveDirectionEnum;
};

export enum TopicModelAsEditorFilterEnum {
  title = 'title',
  withCurrentVersion = 'withCurrentVersion',
  notArchived = 'notArchived',
  searchByIds = 'searchByIds',
  noTheme = 'noTheme'
}

export type TopicModelAsEditorFilterInput = {
  name: TopicModelAsEditorFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

/** topic model for workspace MEMBER */
export type TopicModelAsMember = ITopicModel & {
  __typename?: 'TopicModelAsMember';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  workspace_id: Scalars['PositiveInt'];
  production_topic_version_id?: Maybe<Scalars['PositiveInt']>;
  allow_comments?: Maybe<Scalars['Boolean']>;
  /** Sum of all rating values by students on this topic */
  total_rating: Scalars['NonNegativeInt'];
  /** Sum of students who rated this topic */
  number_rated: Scalars['NonNegativeInt'];
  theme_id?: Maybe<Scalars['PositiveInt']>;
  /** if published, returns title of currentTopicVersion, if not returns title of draftVersion */
  currentTitle: Scalars['String'];
  lastPublishedDate?: Maybe<Scalars['DateTime']>;
  firstPublishedDate?: Maybe<Scalars['DateTime']>;
  draftUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** returns date of last access to topic */
  lastViewedAt?: Maybe<Scalars['DateTime']>;
  /** creates a new enrolment if retry is allowed on the current topic version */
  reEnrol?: Maybe<TopicEnrolmentModelAsStudent>;
  /** returns current user's last enrolment for this topic or null */
  lastEnrolment?: Maybe<TopicEnrolmentModelAsStudent>;
  certificationRelatedEnrolment?: Maybe<TopicEnrolmentModel>;
  lastCompletedEnrolment?: Maybe<TopicEnrolmentModelAsStudent>;
  latestPublishedTopicVersion?: Maybe<Scalars['String']>;
  /** returns already existing enrolment or it creates a new one if various conditions are met */
  enrolmentOrSelfEnrol: TopicEnrolmentModelAsStudent;
  openedFromCampaignShareEmail?: Maybe<Scalars['NonNegativeInt']>;
  author: UserModelPublicBase;
  currentTopicVersion?: Maybe<TopicVersionModel>;
  coverImage?: Maybe<DocumentModel>;
  coverImageVariants: Array<ImageVariantModel>;
  coverImageVariantsCount: Scalars['NonNegativeInt'];
  /** finds a single coverImageVariant by the idColumn of the relation */
  coverImageVariant?: Maybe<ImageVariantModel>;
  pathways: Array<PathwayModel>;
  pathwaysCount: Scalars['NonNegativeInt'];
  /** finds a single pathway by the idColumn of the relation */
  pathway?: Maybe<PathwayModel>;
  topicEditors: Array<TopicEditorModel>;
  topicEditorsCount: Scalars['NonNegativeInt'];
  /** finds a single topicEditor by the idColumn of the relation */
  topicEditor?: Maybe<TopicEditorModel>;
  theme: ThemeModel;
  certificationItems: Array<CertificationItemModel>;
  certificationItemsCount: Scalars['NonNegativeInt'];
  /** finds a single certificationItem by the idColumn of the relation */
  certificationItem?: Maybe<CertificationItemModel>;
  ratingDetails?: Maybe<Array<Scalars['NonNegativeInt']>>;
  averageRating?: Maybe<Scalars['NonNegativeFloat']>;
  /** The topic version with highest id - it should always be the last published one, no matter if the topic is published or not */
  lastTopicVersion?: Maybe<TopicVersionModelAsEditor>;
  /** Checks whether workspace is accessible for a user. User might not have access to the workspace because topic is accessible only from pathway or certification. */
  isWorkspaceAccessible?: Maybe<Scalars['Boolean']>;
  workspace: WorkspaceModelAsMember;
  isFollowingComments: Scalars['Boolean'];
  comments: Array<CommentModel>;
  addComment: CommentModel;
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberCertificationRelatedEnrolmentArgs = {
  certEnrolmentId: Scalars['PositiveInt'];
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberEnrolmentOrSelfEnrolArgs = {
  restartEnrolment?: Maybe<Scalars['Boolean']>;
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberOpenedFromCampaignShareEmailArgs = {
  scheduledCampaignActionId: Scalars['PositiveInt'];
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberCoverImageVariantsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberCoverImageVariantsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberCoverImageVariantArgs = {
  id: Scalars['PositiveInt'];
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberPathwaysArgs = {
  filters?: Maybe<Array<PathwayModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberPathwaysCountArgs = {
  filters?: Maybe<Array<PathwayModelFilterInput>>;
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberPathwayArgs = {
  id: Scalars['PositiveInt'];
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberTopicEditorsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberTopicEditorsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberTopicEditorArgs = {
  id: Scalars['PositiveInt'];
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberCertificationItemsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberCertificationItemsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberCertificationItemArgs = {
  id: Scalars['PositiveInt'];
};


/** topic model for workspace MEMBER */
export type TopicModelAsMemberAddCommentArgs = {
  content: Scalars['String'];
  replyTo?: Maybe<Scalars['PositiveInt']>;
};

export enum TopicModelAsMemberFilterEnum {
  title = 'title',
  withCurrentVersion = 'withCurrentVersion',
  notArchived = 'notArchived',
  searchByIds = 'searchByIds',
  noTheme = 'noTheme'
}

export type TopicModelAsMemberFilterInput = {
  name: TopicModelAsMemberFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export enum TopicModelFilterEnum {
  title = 'title',
  withCurrentVersion = 'withCurrentVersion',
  notArchived = 'notArchived',
  searchByIds = 'searchByIds',
  noTheme = 'noTheme'
}

export type TopicModelFilterInput = {
  name: TopicModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type TopicNotificationModel = {
  __typename?: 'TopicNotificationModel';
  message_code: Scalars['PositiveInt'];
};

export type TopicPatchInput = {
  user_id?: Maybe<Scalars['PositiveInt']>;
  allow_comments?: Maybe<Scalars['Boolean']>;
};

export type TopicVersionInput = {
  title?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  topic_type?: Maybe<Scalars['String']>;
  pass_mark?: Maybe<Scalars['NonNegativeInt']>;
  allow_retry?: Maybe<Scalars['Boolean']>;
  manual_duration?: Maybe<Scalars['PositiveInt']>;
  max_attempts?: Maybe<Scalars['NonNegativeInt']>;
};

export type TopicVersionModel = {
  __typename?: 'TopicVersionModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  topic_id: Scalars['PositiveInt'];
  number_quizzes: Scalars['Float'];
  pass_mark: Scalars['NonNegativeInt'];
  title?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  minor_version: Scalars['NonNegativeInt'];
  major_version: Scalars['NonNegativeInt'];
  total_rating?: Maybe<Scalars['NonNegativeInt']>;
  number_rated?: Maybe<Scalars['NonNegativeInt']>;
  background_img_id?: Maybe<Scalars['PositiveInt']>;
  color?: Maybe<Scalars['String']>;
  publishing_message?: Maybe<Scalars['String']>;
  topic_type: TopicVersionType;
  allow_retry: Scalars['Boolean'];
  max_attempts: Scalars['NonNegativeInt'];
  publishedElements?: Maybe<Array<TopicElementModel>>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  version: Scalars['String'];
  readDurationMins?: Maybe<Scalars['NonNegativeInt']>;
  readDurationSeconds?: Maybe<Scalars['NonNegativeInt']>;
  averageRating?: Maybe<Scalars['NonNegativeFloat']>;
  ratingDetails?: Maybe<Array<Scalars['NonNegativeInt']>>;
  topic: TopicModel;
  backgroundImage?: Maybe<DocumentModel>;
  elements: Array<TopicElementModel>;
  elementsCount: Scalars['NonNegativeInt'];
  /** finds a single element by the idColumn of the relation */
  element?: Maybe<TopicElementModel>;
  scormCourse?: Maybe<ScormCourseModel>;
  enrolments: Array<TopicEnrolmentModel>;
  enrolmentsCount: Scalars['NonNegativeInt'];
  /** finds a single enrolment by the idColumn of the relation */
  enrolment?: Maybe<TopicEnrolmentModel>;
  author?: Maybe<UserModel>;
};


export type TopicVersionModelPublishedElementsArgs = {
  useUnsignedCdnUrl?: Maybe<Scalars['Boolean']>;
};


export type TopicVersionModelElementsArgs = {
  filters?: Maybe<Array<TopicElementModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TopicVersionModelElementsCountArgs = {
  filters?: Maybe<Array<TopicElementModelFilterInput>>;
};


export type TopicVersionModelElementArgs = {
  id: Scalars['PositiveInt'];
};


export type TopicVersionModelEnrolmentsArgs = {
  filters?: Maybe<Array<TopicEnrolmentModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TopicVersionModelEnrolmentsCountArgs = {
  filters?: Maybe<Array<TopicEnrolmentModelFilterInput>>;
};


export type TopicVersionModelEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};

export type TopicVersionModelAsEditor = {
  __typename?: 'TopicVersionModelAsEditor';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  topic_id: Scalars['PositiveInt'];
  number_quizzes: Scalars['Float'];
  pass_mark: Scalars['NonNegativeInt'];
  title?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  minor_version: Scalars['NonNegativeInt'];
  major_version: Scalars['NonNegativeInt'];
  total_rating?: Maybe<Scalars['NonNegativeInt']>;
  number_rated?: Maybe<Scalars['NonNegativeInt']>;
  background_img_id?: Maybe<Scalars['PositiveInt']>;
  color?: Maybe<Scalars['String']>;
  publishing_message?: Maybe<Scalars['String']>;
  topic_type: TopicVersionType;
  allow_retry: Scalars['Boolean'];
  max_attempts: Scalars['NonNegativeInt'];
  publishedElements?: Maybe<Array<TopicElementModel>>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  version: Scalars['String'];
  readDurationMins?: Maybe<Scalars['NonNegativeInt']>;
  readDurationSeconds?: Maybe<Scalars['NonNegativeInt']>;
  averageRating?: Maybe<Scalars['NonNegativeFloat']>;
  ratingDetails?: Maybe<Array<Scalars['NonNegativeInt']>>;
  topic: TopicModelAsEditor;
  backgroundImage?: Maybe<DocumentModel>;
  elements: Array<TopicElementModelAsEditor>;
  elementsCount: Scalars['NonNegativeInt'];
  /** finds a single element by the idColumn of the relation */
  element?: Maybe<TopicElementModelAsEditor>;
  scormCourse?: Maybe<ScormCourseModel>;
  enrolments: Array<TopicEnrolmentModel>;
  enrolmentsCount: Scalars['NonNegativeInt'];
  /** finds a single enrolment by the idColumn of the relation */
  enrolment?: Maybe<TopicEnrolmentModel>;
  author?: Maybe<UserModel>;
  manual_duration?: Maybe<Scalars['NonNegativeInt']>;
  createTextElements?: Maybe<Scalars['PositiveInt']>;
  createElement?: Maybe<TopicElementModel>;
  publishedQuizzes?: Maybe<Array<TopicElementModelAsEditor>>;
  publishedElement?: Maybe<TopicElementModelAsEditor>;
  replaceElement?: Maybe<TopicElementModelAsEditor>;
};


export type TopicVersionModelAsEditorPublishedElementsArgs = {
  useUnsignedCdnUrl?: Maybe<Scalars['Boolean']>;
};


export type TopicVersionModelAsEditorElementsArgs = {
  filters?: Maybe<Array<TopicElementModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TopicVersionModelAsEditorElementsCountArgs = {
  filters?: Maybe<Array<TopicElementModelFilterInput>>;
};


export type TopicVersionModelAsEditorElementArgs = {
  id: Scalars['PositiveInt'];
};


export type TopicVersionModelAsEditorEnrolmentsArgs = {
  filters?: Maybe<Array<TopicEnrolmentModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type TopicVersionModelAsEditorEnrolmentsCountArgs = {
  filters?: Maybe<Array<TopicEnrolmentModelFilterInput>>;
};


export type TopicVersionModelAsEditorEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};


export type TopicVersionModelAsEditorCreateTextElementsArgs = {
  contentArray?: Maybe<Array<Scalars['String']>>;
};


export type TopicVersionModelAsEditorCreateElementArgs = {
  type: Scalars['String'];
};


export type TopicVersionModelAsEditorPublishedElementArgs = {
  id: Scalars['PositiveInt'];
};


export type TopicVersionModelAsEditorReplaceElementArgs = {
  id: Scalars['PositiveInt'];
};

export enum TopicVersionModelFilterEnum {
  status = 'status',
  version = 'version'
}

export type TopicVersionModelFilterInput = {
  name: TopicVersionModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export enum TopicVersionType {
  s = 's',
  m = 'm',
  scorm = 'scorm',
  VIDEO_ASSESSMENT_INDIVIDUAL = 'VIDEO_ASSESSMENT_INDIVIDUAL',
  VIDEO_ASSESSMENT_GROUP = 'VIDEO_ASSESSMENT_GROUP',
  VIDEO_ASSESSMENT_Q_AND_A = 'VIDEO_ASSESSMENT_Q_AND_A',
  VIDEO_ASSESSMENT_INTERACTIVE = 'VIDEO_ASSESSMENT_INTERACTIVE'
}

export type TrackedLinkAsStudent = {
  __typename?: 'TrackedLinkAsStudent';
  id?: Maybe<Scalars['Float']>;
  created_at?: Maybe<Scalars['DateTime']>;
  removed_from_source_at?: Maybe<Scalars['DateTime']>;
  link?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  campaign_email_action_id?: Maybe<Scalars['PositiveInt']>;
  campaign_message_action_id?: Maybe<Scalars['PositiveInt']>;
  campaign_pathway_share_action_id?: Maybe<Scalars['PositiveInt']>;
  campaign_topic_share_action_id?: Maybe<Scalars['PositiveInt']>;
  campaign_survey_share_action_id?: Maybe<Scalars['PositiveInt']>;
};


export type UploadCredentials = {
  __typename?: 'UploadCredentials';
  uploadUrl: Scalars['String'];
  filename: Scalars['String'];
  params: Scalars['JSON'];
  publicCdnDomain: Scalars['String'];
  cdnDomain: Scalars['String'];
  cdnUrl: Scalars['String'];
};

export type UploadCredentialsInput = {
  fileName: Scalars['String'];
};

export type UserActivityHistory = {
  __typename?: 'UserActivityHistory';
  items: Array<UserActivityHistoryItem>;
  count: Scalars['Float'];
};

export type UserActivityHistoryInput = {
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  orderDirection: SqlOrderDirectionEnum;
  limit: Scalars['PositiveInt'];
  page: Scalars['PositiveInt'];
  search: Scalars['LengthValidatedString_255'];
  orderColumn: ActivityHistoryOrderColumn;
  cpdOnly: Scalars['Boolean'];
};

export type UserActivityHistoryItem = TopicEnrolmentModelAsStudent | UserEventModel | CpdManualEntryModel;

export enum UserActivityOverviewOrderColumn {
  resourceName = 'resourceName',
  viewsCount = 'viewsCount',
  lastViewedAt = 'lastViewedAt'
}

export type UserCalendars = {
  __typename?: 'UserCalendars';
  google?: Maybe<Scalars['JSON']>;
  msgraph?: Maybe<Scalars['JSON']>;
};

export type UserCertificationModel = {
  __typename?: 'UserCertificationModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  user_id?: Maybe<Scalars['PositiveInt']>;
  certification_id?: Maybe<Scalars['PositiveInt']>;
};

export enum UserCreationMethodEnum {
  MANUAL = 'MANUAL',
  SELF_SIGNUP = 'SELF_SIGNUP',
  SSO_JIT = 'SSO_JIT',
  SCIM = 'SCIM',
  FOURTH_SCIM = 'FOURTH_SCIM',
  BAMBOOHR_SCIM = 'BAMBOOHR_SCIM',
  SECRET_SIGNUP_LINK = 'SECRET_SIGNUP_LINK',
  CSV_IMPORT = 'CSV_IMPORT'
}

export enum UserEventInvitationSourceEnum {
  GROUP = 'GROUP',
  CERTIFICATE = 'CERTIFICATE',
  INDIVIDUAL = 'INDIVIDUAL'
}

export type UserEventModel = {
  __typename?: 'UserEventModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  last_edit_by?: Maybe<Scalars['PositiveInt']>;
  /** Id of a user who invited this user */
  created_by?: Maybe<Scalars['PositiveInt']>;
  user_id: Scalars['PositiveInt'];
  event_id: Scalars['PositiveInt'];
  recurring_event_invitee_id?: Maybe<Scalars['PositiveInt']>;
  certification_id?: Maybe<Scalars['PositiveInt']>;
  from_invited_group_id?: Maybe<Scalars['PositiveInt']>;
  /** how a user responded to the invitation */
  attending?: Maybe<Scalars['Boolean']>;
  /** actually recorded attendance of the user by the organiser */
  present?: Maybe<Scalars['Boolean']>;
  rsvp?: Maybe<UserEventModel>;
  patch?: Maybe<UserEventModel>;
  resendInvitationEmail?: Maybe<Scalars['DateTime']>;
  isCpdEntry?: Maybe<Scalars['Boolean']>;
  event: EventModel;
  recurringEventInvitee: RecurringEventInviteeModel;
  user: UserModel;
  lastEditedBy: UserModel;
  certification?: Maybe<CertificationModel>;
  group?: Maybe<GroupModel>;
  cpdUserEntry?: Maybe<CpdUserEntryModel>;
};


export type UserEventModelRsvpArgs = {
  attending: Scalars['Boolean'];
};


export type UserEventModelPatchArgs = {
  attending?: Maybe<Scalars['Boolean']>;
  present?: Maybe<Scalars['Boolean']>;
};

export enum UserEventModelFilterEnum {
  invitationResponse = 'invitationResponse',
  attendanceRecord = 'attendanceRecord',
  eventAlreadyEnded = 'eventAlreadyEnded',
  eventIsInProgress = 'eventIsInProgress',
  eventIsNotDeleted = 'eventIsNotDeleted',
  eventStartedBetween = 'eventStartedBetween',
  search = 'search',
  onlyCpdUserEntries = 'onlyCpdUserEntries'
}

export type UserEventModelFilterInput = {
  name: UserEventModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type UserEventModelWithSource = {
  __typename?: 'UserEventModelWithSource';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  last_edit_by?: Maybe<Scalars['PositiveInt']>;
  /** Id of a user who invited this user */
  created_by?: Maybe<Scalars['PositiveInt']>;
  user_id: Scalars['PositiveInt'];
  event_id: Scalars['PositiveInt'];
  recurring_event_invitee_id?: Maybe<Scalars['PositiveInt']>;
  certification_id?: Maybe<Scalars['PositiveInt']>;
  from_invited_group_id?: Maybe<Scalars['PositiveInt']>;
  /** how a user responded to the invitation */
  attending?: Maybe<Scalars['Boolean']>;
  /** actually recorded attendance of the user by the organiser */
  present?: Maybe<Scalars['Boolean']>;
  rsvp?: Maybe<UserEventModel>;
  patch?: Maybe<UserEventModel>;
  resendInvitationEmail?: Maybe<Scalars['DateTime']>;
  isCpdEntry?: Maybe<Scalars['Boolean']>;
  event: EventModel;
  recurringEventInvitee: RecurringEventInviteeModel;
  user: UserModel;
  lastEditedBy: UserModel;
  certification?: Maybe<CertificationModel>;
  group?: Maybe<GroupModel>;
  cpdUserEntry?: Maybe<CpdUserEntryModel>;
  inviteSource: UserEventInvitationSourceEnum;
};


export type UserEventModelWithSourceRsvpArgs = {
  attending: Scalars['Boolean'];
};


export type UserEventModelWithSourcePatchArgs = {
  attending?: Maybe<Scalars['Boolean']>;
  present?: Maybe<Scalars['Boolean']>;
};

/** acceptable fieldNames are fields on UserEventModelWithSource, when omitted it defaults to searching invited users by their display_name and email */
export type UserEventModelWithSourceFilterInput = {
  fieldName?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export enum UserEventsOverviewOrderColumn {
  eventName = 'eventName',
  startTime = 'startTime',
  endTime = 'endTime',
  attending = 'attending',
  present = 'present'
}

export type UserFilterComparator = {
  __typename?: 'UserFilterComparator';
  operator?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
  field?: Maybe<Scalars['String']>;
};

export type UserFilterComparatorInput = {
  operator?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
  field?: Maybe<Scalars['String']>;
};

export type UserFilterTimeDuration = {
  __typename?: 'UserFilterTimeDuration';
  multiplier?: Maybe<Scalars['PositiveInt']>;
  unit?: Maybe<TimeDurationUnitsEnum>;
};

export type UserFilterTimeDurationInput = {
  multiplier?: Maybe<Scalars['PositiveInt']>;
  unit?: Maybe<TimeDurationUnitsEnum>;
};

export type UserGroupModel = {
  __typename?: 'UserGroupModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  user_id: Scalars['PositiveInt'];
  group_id: Scalars['PositiveInt'];
  added_by?: Maybe<Scalars['PositiveInt']>;
  role: UserGroupRoleEnum;
};

export enum UserGroupRoleEnum {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER'
}

/** represents an outcome of a dashboard user sights calculation */
export type UserInsightResult = {
  __typename?: 'UserInsightResult';
  surveyId: Scalars['PositiveInt'];
  surveyTitle: Scalars['String'];
  userId: Scalars['PositiveInt'];
};

export type UserLinkClick = {
  __typename?: 'UserLinkClick';
  tracked_link_id: Scalars['PositiveInt'];
  first_click_at: Scalars['DateTime'];
  last_click_at: Scalars['DateTime'];
  total_clicks_count?: Maybe<Scalars['Float']>;
};

export type UserModel = {
  __typename?: 'UserModel';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  image_url?: Maybe<Scalars['String']>;
  id: Scalars['PositiveInt'];
  email?: Maybe<Scalars['EmailAddressWithTLD']>;
  custom_1?: Maybe<Scalars['String']>;
  custom_2?: Maybe<Scalars['String']>;
  custom_3?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  manager_id?: Maybe<Scalars['PositiveInt']>;
  position?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  states?: Maybe<Scalars['JSON']>;
  step?: Maybe<Scalars['Float']>;
  employee_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  privacy_policy_accepted?: Maybe<Scalars['DateTime']>;
  preferences: UserPreferences;
  organisation_role: OrganisationRoleEnum;
  uploaded_img_url?: Maybe<Scalars['String']>;
  profile_img_url?: Maybe<Scalars['String']>;
  password_last_updated_at?: Maybe<Scalars['DateTime']>;
  display_name: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  verified: Scalars['Boolean'];
  phone_number?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['NonEmptyString']>;
  locale?: Maybe<SupportedLocalesEnum>;
  calendars: UserCalendars;
  userIdentity: Scalars['String'];
  memberInGroups?: Maybe<Scalars['String']>;
  /** When false, user can still have the default password that was used in the CSV user import. True indicates this user has set his own password-it was not set for him by someone else. */
  hasOwnPasswordSet?: Maybe<Scalars['Boolean']>;
  is_archived: Scalars['Boolean'];
  is_active: Scalars['Boolean'];
  creation_method?: Maybe<UserCreationMethodEnum>;
  last_activity_at?: Maybe<Scalars['DateTime']>;
  followResource?: Maybe<ResourceFollowerModel>;
  unfollowResource?: Maybe<Scalars['Int']>;
  isOrganisationOwner: Scalars['Boolean'];
  start_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['PositiveInt']>;
  isCurrentUser?: Maybe<Scalars['Boolean']>;
  currentPathwayEnrolment?: Maybe<PathwayEnrolmentModel>;
  createCPDEntry?: Maybe<CpdManualEntryModel>;
  cpdManualEntry?: Maybe<CpdManualEntryModel>;
  /** sets expire of the current session to a later date by adding session_expiry of the user's org to the current date */
  refreshSession?: Maybe<UserSessionModel>;
  manager?: Maybe<UserModel>;
  createdBy?: Maybe<UserModel>;
};


export type UserModelFollowResourceArgs = {
  itemId: Scalars['PositiveInt'];
  itemType: FollowResourceType;
};


export type UserModelUnfollowResourceArgs = {
  itemId: Scalars['PositiveInt'];
  itemType: FollowResourceType;
};


export type UserModelCurrentPathwayEnrolmentArgs = {
  pathwayId: Scalars['PositiveInt'];
};


export type UserModelCreateCpdEntryArgs = {
  input: CpdManualEntryModelInput;
};


export type UserModelCpdManualEntryArgs = {
  id: Scalars['PositiveInt'];
};

export type UserModelAsAdminQueries = {
  __typename?: 'UserModelAsAdminQueries';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  image_url?: Maybe<Scalars['String']>;
  id: Scalars['PositiveInt'];
  email?: Maybe<Scalars['EmailAddressWithTLD']>;
  custom_1?: Maybe<Scalars['String']>;
  custom_2?: Maybe<Scalars['String']>;
  custom_3?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  manager_id?: Maybe<Scalars['PositiveInt']>;
  position?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  states?: Maybe<Scalars['JSON']>;
  step?: Maybe<Scalars['Float']>;
  employee_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  privacy_policy_accepted?: Maybe<Scalars['DateTime']>;
  preferences: UserPreferences;
  organisation_role: OrganisationRoleEnum;
  uploaded_img_url?: Maybe<Scalars['String']>;
  profile_img_url?: Maybe<Scalars['String']>;
  password_last_updated_at?: Maybe<Scalars['DateTime']>;
  display_name: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  verified: Scalars['Boolean'];
  phone_number?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['NonEmptyString']>;
  locale?: Maybe<SupportedLocalesEnum>;
  calendars: UserCalendars;
  userIdentity: Scalars['String'];
  memberInGroups?: Maybe<Scalars['String']>;
  /** When false, user can still have the default password that was used in the CSV user import. True indicates this user has set his own password-it was not set for him by someone else. */
  hasOwnPasswordSet?: Maybe<Scalars['Boolean']>;
  is_archived: Scalars['Boolean'];
  is_active: Scalars['Boolean'];
  creation_method?: Maybe<UserCreationMethodEnum>;
  last_activity_at?: Maybe<Scalars['DateTime']>;
  followResource?: Maybe<ResourceFollowerModel>;
  unfollowResource?: Maybe<Scalars['Int']>;
  isOrganisationOwner: Scalars['Boolean'];
  start_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['PositiveInt']>;
  isCurrentUser?: Maybe<Scalars['Boolean']>;
  currentPathwayEnrolment?: Maybe<PathwayEnrolmentModel>;
  createCPDEntry?: Maybe<CpdManualEntryModel>;
  /** finds a single cpdManualEntry by the idColumn of the relation */
  cpdManualEntry?: Maybe<CpdManualEntryModel>;
  /** sets expire of the current session to a later date by adding session_expiry of the user's org to the current date */
  refreshSession?: Maybe<UserSessionModel>;
  manager?: Maybe<UserModelPublicBase>;
  createdBy?: Maybe<UserModel>;
  certificationEnrolment?: Maybe<CertificationEnrolmentModelAsStudent>;
  canViewAnalytics: Scalars['Boolean'];
  isMemberOfCPDGroup: Scalars['Boolean'];
  totalManualCpdHours: Scalars['NonNegativeFloat'];
  totalHoursSpentInEvents: Scalars['NonNegativeFloat'];
  totalHoursSpentInResources: Scalars['NonNegativeFloat'];
  canUpdateProfile: Scalars['Boolean'];
  isAdminOfSomeGroup: Scalars['Boolean'];
  certificationEnrolments: Array<CertificationEnrolmentModelAsStudent>;
  /**
   * Returns past enrolments of this user ordered by last update time. Optionally it
   *     can filter out inaccessible workspaces. Enrolments in inaccessible workspaces or archived ones
   *     are not returned.
   */
  recentlyUpdatedTopicEnrolments: Array<TopicEnrolmentModelAsStudent>;
  assignedPathways: Array<PathwayModelAsStudent>;
  activeBanners: Array<CampaignBannerModel>;
  /** finds a single topicEnrolment by the idColumn of the relation */
  topicEnrolment?: Maybe<TopicEnrolmentModelAsStudent>;
  /** return current status of user's Google Calendar API authentication */
  isGoogleCalendarAPIAuthenticated?: Maybe<Scalars['Boolean']>;
  activityHistory: UserActivityHistory;
  scimResource?: Maybe<ScimResourceModel>;
  topicEnrolments: Array<TopicEnrolmentModelAsStudent>;
  topicEnrolmentsCount: Scalars['NonNegativeInt'];
  eventInvitations: Array<UserEventModel>;
  eventInvitationsCount: Scalars['NonNegativeInt'];
  /** finds a single eventInvitation by the idColumn of the relation */
  eventInvitation?: Maybe<UserEventModel>;
  cpdManualEntries: Array<CpdManualEntryModel>;
  cpdManualEntriesCount: Scalars['NonNegativeInt'];
  /** workspaces that this user can access */
  accessibleWorkspaces?: Maybe<Array<WorkspaceModel>>;
  /**  returned day time value is in user's timezone */
  dayTimeWhenMostActive?: Maybe<Scalars['String']>;
  workspaces: Array<WorkspaceModel>;
  workspacesCount: Scalars['NonNegativeInt'];
  /** finds a single workspace by the idColumn of the relation */
  workspace?: Maybe<WorkspaceModel>;
  groups: Array<GroupModel>;
  groupsCount: Scalars['NonNegativeInt'];
  /** finds a single group by the idColumn of the relation */
  group?: Maybe<GroupModel>;
  events: Array<EventModel>;
  eventsCount: Scalars['NonNegativeInt'];
  /** finds a single event by the idColumn of the relation */
  event?: Maybe<EventModel>;
  pathways: Array<PathwayModel>;
  pathwaysCount: Scalars['NonNegativeInt'];
  /** finds a single pathway by the idColumn of the relation */
  pathway?: Maybe<PathwayModel>;
  organisation: OrganisationModel;
  enrolledTopics: Array<TopicModel>;
  enrolledTopicsCount: Scalars['NonNegativeInt'];
  /** finds a single enrolledTopic by the idColumn of the relation */
  enrolledTopic?: Maybe<TopicModel>;
  sessions: Array<UserSessionModel>;
  sessionsCount: Scalars['NonNegativeInt'];
  /** finds a single session by the idColumn of the relation */
  session?: Maybe<UserSessionModel>;
  oauths: Array<OauthModel>;
  oauthsCount: Scalars['NonNegativeInt'];
  /** finds a single oauth by the idColumn of the relation */
  oauth?: Maybe<OauthModel>;
  campaignAnalyticEvents: Array<CampaignAnalyticEventModel>;
  campaignAnalyticEventsCount: Scalars['NonNegativeInt'];
  /** finds a single campaignAnalyticEvent by the idColumn of the relation */
  campaignAnalyticEvent?: Maybe<CampaignAnalyticEventModel>;
  campaignUserEvents: Array<CampaignUserEventModel>;
  campaignUserEventsCount: Scalars['NonNegativeInt'];
  /** finds a single campaignUserEvent by the idColumn of the relation */
  campaignUserEvent?: Maybe<CampaignUserEventModel>;
  pathwayEnrolments: Array<PathwayEnrolmentModel>;
  pathwayEnrolmentsCount: Scalars['NonNegativeInt'];
  /** finds a single pathwayEnrolment by the idColumn of the relation */
  pathwayEnrolment?: Maybe<PathwayEnrolmentModel>;
  topics: Array<TopicModel>;
  topicsCount: Scalars['NonNegativeInt'];
  /** finds a single topic by the idColumn of the relation */
  topic?: Maybe<TopicModel>;
  userGroups: Array<UserGroupModel>;
  userGroupsCount: Scalars['NonNegativeInt'];
  /** finds a single userGroup by the idColumn of the relation */
  userGroup?: Maybe<UserGroupModel>;
  userWorkspaces: Array<UserWorkspaceModel>;
  userWorkspacesCount: Scalars['NonNegativeInt'];
  /** finds a single userWorkspace by the idColumn of the relation */
  userWorkspace?: Maybe<UserWorkspaceModel>;
  scheduledCampaignActions: Array<ScheduledCampaignActionModel>;
  scheduledCampaignActionsCount: Scalars['NonNegativeInt'];
  /** finds a single scheduledCampaignAction by the idColumn of the relation */
  scheduledCampaignAction?: Maybe<ScheduledCampaignActionModel>;
  userCertifications: Array<UserCertificationModel>;
  userCertificationsCount: Scalars['NonNegativeInt'];
  /** finds a single userCertification by the idColumn of the relation */
  userCertification?: Maybe<UserCertificationModel>;
  securityQuestions: Array<UserSecurityQuestionsModel>;
  securityQuestionsCount: Scalars['NonNegativeInt'];
  /** finds a single securityQuestion by the idColumn of the relation */
  securityQuestion?: Maybe<UserSecurityQuestionsModel>;
  processedNotifications: Array<NotificationQueueProcessedModel>;
  processedNotificationsCount: Scalars['NonNegativeInt'];
  /** finds a single processedNotification by the idColumn of the relation */
  processedNotification?: Maybe<NotificationQueueProcessedModel>;
};


export type UserModelAsAdminQueriesFollowResourceArgs = {
  itemId: Scalars['PositiveInt'];
  itemType: FollowResourceType;
};


export type UserModelAsAdminQueriesUnfollowResourceArgs = {
  itemId: Scalars['PositiveInt'];
  itemType: FollowResourceType;
};


export type UserModelAsAdminQueriesCurrentPathwayEnrolmentArgs = {
  pathwayId: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesCreateCpdEntryArgs = {
  input: CpdManualEntryModelInput;
};


export type UserModelAsAdminQueriesCpdManualEntryArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesCertificationEnrolmentArgs = {
  certificationId: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesTotalManualCpdHoursArgs = {
  from?: Maybe<Scalars['DateTime']>;
  to?: Maybe<Scalars['DateTime']>;
};


export type UserModelAsAdminQueriesTotalHoursSpentInEventsArgs = {
  from?: Maybe<Scalars['DateTime']>;
  to?: Maybe<Scalars['DateTime']>;
  cpdOnly?: Maybe<Scalars['Boolean']>;
};


export type UserModelAsAdminQueriesTotalHoursSpentInResourcesArgs = {
  from?: Maybe<Scalars['DateTime']>;
  to?: Maybe<Scalars['DateTime']>;
  cpdOnly?: Maybe<Scalars['Boolean']>;
};


export type UserModelAsAdminQueriesRecentlyUpdatedTopicEnrolmentsArgs = {
  limit: Scalars['NonNegativeInt'];
};


export type UserModelAsAdminQueriesTopicEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesActivityHistoryArgs = {
  filters?: Maybe<UserActivityHistoryInput>;
};


export type UserModelAsAdminQueriesTopicEnrolmentsArgs = {
  filters?: Maybe<Array<TopicEnrolmentModelAsStudentFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesTopicEnrolmentsCountArgs = {
  filters?: Maybe<Array<TopicEnrolmentModelAsStudentFilterInput>>;
};


export type UserModelAsAdminQueriesEventInvitationsArgs = {
  filters?: Maybe<Array<UserEventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesEventInvitationsCountArgs = {
  filters?: Maybe<Array<UserEventModelFilterInput>>;
};


export type UserModelAsAdminQueriesEventInvitationArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesCpdManualEntriesArgs = {
  filters?: Maybe<Array<CpdManualEntryModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesCpdManualEntriesCountArgs = {
  filters?: Maybe<Array<CpdManualEntryModelFilterInput>>;
};


export type UserModelAsAdminQueriesWorkspacesArgs = {
  filters?: Maybe<Array<WorkspaceModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesWorkspacesCountArgs = {
  filters?: Maybe<Array<WorkspaceModelFilterInput>>;
};


export type UserModelAsAdminQueriesWorkspaceArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesGroupsArgs = {
  filters?: Maybe<Array<GroupModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesGroupsCountArgs = {
  filters?: Maybe<Array<GroupModelFilterInput>>;
};


export type UserModelAsAdminQueriesGroupArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesEventsArgs = {
  filters?: Maybe<Array<EventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesEventsCountArgs = {
  filters?: Maybe<Array<EventModelFilterInput>>;
};


export type UserModelAsAdminQueriesEventArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesPathwaysArgs = {
  filters?: Maybe<Array<PathwayModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesPathwaysCountArgs = {
  filters?: Maybe<Array<PathwayModelFilterInput>>;
};


export type UserModelAsAdminQueriesPathwayArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesEnrolledTopicsArgs = {
  filters?: Maybe<Array<TopicModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesEnrolledTopicsCountArgs = {
  filters?: Maybe<Array<TopicModelFilterInput>>;
};


export type UserModelAsAdminQueriesEnrolledTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesSessionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesSessionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type UserModelAsAdminQueriesSessionArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesOauthsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesOauthsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type UserModelAsAdminQueriesOauthArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesCampaignAnalyticEventsArgs = {
  filters?: Maybe<Array<CampaignAnalyticEventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesCampaignAnalyticEventsCountArgs = {
  filters?: Maybe<Array<CampaignAnalyticEventModelFilterInput>>;
};


export type UserModelAsAdminQueriesCampaignAnalyticEventArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesCampaignUserEventsArgs = {
  filters?: Maybe<Array<CampaignUserEventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesCampaignUserEventsCountArgs = {
  filters?: Maybe<Array<CampaignUserEventModelFilterInput>>;
};


export type UserModelAsAdminQueriesCampaignUserEventArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesPathwayEnrolmentsArgs = {
  filters?: Maybe<Array<PathwayEnrolmentModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesPathwayEnrolmentsCountArgs = {
  filters?: Maybe<Array<PathwayEnrolmentModelFilterInput>>;
};


export type UserModelAsAdminQueriesPathwayEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesTopicsArgs = {
  filters?: Maybe<Array<TopicModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesTopicsCountArgs = {
  filters?: Maybe<Array<TopicModelFilterInput>>;
};


export type UserModelAsAdminQueriesTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesUserGroupsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesUserGroupsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type UserModelAsAdminQueriesUserGroupArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesUserWorkspacesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesUserWorkspacesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type UserModelAsAdminQueriesUserWorkspaceArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesScheduledCampaignActionsArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesScheduledCampaignActionsCountArgs = {
  filters?: Maybe<Array<ScheduledCampaignActionModelFilterInput>>;
};


export type UserModelAsAdminQueriesScheduledCampaignActionArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesUserCertificationsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesUserCertificationsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type UserModelAsAdminQueriesUserCertificationArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesSecurityQuestionsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesSecurityQuestionsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type UserModelAsAdminQueriesSecurityQuestionArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelAsAdminQueriesProcessedNotificationsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelAsAdminQueriesProcessedNotificationsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type UserModelAsAdminQueriesProcessedNotificationArgs = {
  id: Scalars['PositiveInt'];
};

export enum UserModelAsAdminQueriesFilterEnum {
  billable = 'billable',
  notArchived = 'notArchived',
  is_archived = 'is_archived',
  id = 'id',
  id_exact = 'id_exact',
  email = 'email',
  noEmail = 'noEmail',
  display_name = 'display_name',
  last_activity_at = 'last_activity_at',
  organisation_role = 'organisation_role',
  not_admin_role = 'not_admin_role',
  group_id = 'group_id',
  search = 'search',
  displayNameOrIdentity = 'displayNameOrIdentity',
  workspace_id = 'workspace_id',
  groupsAllConcatenated = 'groupsAllConcatenated'
}

export type UserModelAsAdminQueriesFilterInput = {
  name: UserModelAsAdminQueriesFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type UserModelBase = {
  __typename?: 'UserModelBase';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  image_url?: Maybe<Scalars['String']>;
  id: Scalars['PositiveInt'];
  email?: Maybe<Scalars['EmailAddressWithTLD']>;
  custom_1?: Maybe<Scalars['String']>;
  custom_2?: Maybe<Scalars['String']>;
  custom_3?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  manager_id?: Maybe<Scalars['PositiveInt']>;
  position?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  states?: Maybe<Scalars['JSON']>;
  step?: Maybe<Scalars['Float']>;
  employee_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  privacy_policy_accepted?: Maybe<Scalars['DateTime']>;
  preferences: UserPreferences;
  organisation_role: OrganisationRoleEnum;
  uploaded_img_url?: Maybe<Scalars['String']>;
  profile_img_url?: Maybe<Scalars['String']>;
  password_last_updated_at?: Maybe<Scalars['DateTime']>;
  display_name: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  verified: Scalars['Boolean'];
  phone_number?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['NonEmptyString']>;
  locale?: Maybe<SupportedLocalesEnum>;
  calendars: UserCalendars;
  userIdentity: Scalars['String'];
  memberInGroups?: Maybe<Scalars['String']>;
  /** When false, user can still have the default password that was used in the CSV user import. True indicates this user has set his own password-it was not set for him by someone else. */
  hasOwnPasswordSet?: Maybe<Scalars['Boolean']>;
  is_archived: Scalars['Boolean'];
  is_active: Scalars['Boolean'];
  creation_method?: Maybe<UserCreationMethodEnum>;
  last_activity_at?: Maybe<Scalars['DateTime']>;
  followResource?: Maybe<ResourceFollowerModel>;
  unfollowResource?: Maybe<Scalars['Int']>;
  isOrganisationOwner: Scalars['Boolean'];
};


export type UserModelBaseFollowResourceArgs = {
  itemId: Scalars['PositiveInt'];
  itemType: FollowResourceType;
};


export type UserModelBaseUnfollowResourceArgs = {
  itemId: Scalars['PositiveInt'];
  itemType: FollowResourceType;
};

export enum UserModelFilterEnum {
  billable = 'billable',
  notArchived = 'notArchived',
  is_archived = 'is_archived',
  id = 'id',
  id_exact = 'id_exact',
  email = 'email',
  noEmail = 'noEmail',
  display_name = 'display_name',
  last_activity_at = 'last_activity_at',
  organisation_role = 'organisation_role',
  not_admin_role = 'not_admin_role',
  group_id = 'group_id',
  search = 'search',
  displayNameOrIdentity = 'displayNameOrIdentity',
  workspace_id = 'workspace_id',
  groupsAllConcatenated = 'groupsAllConcatenated'
}

export type UserModelFilterInput = {
  name: UserModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

/** a user with all the public fields any user can edit on himself */
export type UserModelPublicBase = {
  __typename?: 'UserModelPublicBase';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  image_url?: Maybe<Scalars['String']>;
  id: Scalars['PositiveInt'];
  email?: Maybe<Scalars['EmailAddressWithTLD']>;
  custom_1?: Maybe<Scalars['String']>;
  custom_2?: Maybe<Scalars['String']>;
  custom_3?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  manager_id?: Maybe<Scalars['PositiveInt']>;
  position?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  states?: Maybe<Scalars['JSON']>;
  step?: Maybe<Scalars['Float']>;
  employee_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  privacy_policy_accepted?: Maybe<Scalars['DateTime']>;
  preferences: UserPreferences;
  organisation_role: OrganisationRoleEnum;
  uploaded_img_url?: Maybe<Scalars['String']>;
  profile_img_url?: Maybe<Scalars['String']>;
  password_last_updated_at?: Maybe<Scalars['DateTime']>;
  display_name: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  verified: Scalars['Boolean'];
  phone_number?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['NonEmptyString']>;
  locale?: Maybe<SupportedLocalesEnum>;
  calendars: UserCalendars;
  userIdentity: Scalars['String'];
  memberInGroups?: Maybe<Scalars['String']>;
  /** When false, user can still have the default password that was used in the CSV user import. True indicates this user has set his own password-it was not set for him by someone else. */
  hasOwnPasswordSet?: Maybe<Scalars['Boolean']>;
};

export enum UserModelPublicBaseFilterEnum {
  billable = 'billable',
  notArchived = 'notArchived',
  is_archived = 'is_archived',
  id = 'id',
  id_exact = 'id_exact',
  email = 'email',
  noEmail = 'noEmail',
  display_name = 'display_name',
  last_activity_at = 'last_activity_at',
  organisation_role = 'organisation_role',
  not_admin_role = 'not_admin_role',
  group_id = 'group_id',
  search = 'search',
  displayNameOrIdentity = 'displayNameOrIdentity',
  workspace_id = 'workspace_id',
  groupsAllConcatenated = 'groupsAllConcatenated'
}

export type UserModelPublicBaseFilterInput = {
  name: UserModelPublicBaseFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type UserModelSelf = {
  __typename?: 'UserModelSelf';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  image_url?: Maybe<Scalars['String']>;
  id: Scalars['PositiveInt'];
  email?: Maybe<Scalars['EmailAddressWithTLD']>;
  custom_1?: Maybe<Scalars['String']>;
  custom_2?: Maybe<Scalars['String']>;
  custom_3?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  manager_id?: Maybe<Scalars['PositiveInt']>;
  position?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  states?: Maybe<Scalars['JSON']>;
  step?: Maybe<Scalars['Float']>;
  employee_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  privacy_policy_accepted?: Maybe<Scalars['DateTime']>;
  preferences: UserPreferences;
  organisation_role: OrganisationRoleEnum;
  uploaded_img_url?: Maybe<Scalars['String']>;
  profile_img_url?: Maybe<Scalars['String']>;
  password_last_updated_at?: Maybe<Scalars['DateTime']>;
  display_name: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  verified: Scalars['Boolean'];
  phone_number?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['NonEmptyString']>;
  locale?: Maybe<SupportedLocalesEnum>;
  calendars: UserCalendars;
  userIdentity: Scalars['String'];
  memberInGroups?: Maybe<Scalars['String']>;
  /** When false, user can still have the default password that was used in the CSV user import. True indicates this user has set his own password-it was not set for him by someone else. */
  hasOwnPasswordSet?: Maybe<Scalars['Boolean']>;
  is_archived: Scalars['Boolean'];
  is_active: Scalars['Boolean'];
  creation_method?: Maybe<UserCreationMethodEnum>;
  last_activity_at?: Maybe<Scalars['DateTime']>;
  followResource?: Maybe<ResourceFollowerModel>;
  unfollowResource?: Maybe<Scalars['Int']>;
  isOrganisationOwner: Scalars['Boolean'];
  start_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['PositiveInt']>;
  isCurrentUser?: Maybe<Scalars['Boolean']>;
  currentPathwayEnrolment?: Maybe<PathwayEnrolmentModel>;
  createCPDEntry?: Maybe<CpdManualEntryModel>;
  /** finds a single cpdManualEntry by the idColumn of the relation */
  cpdManualEntry?: Maybe<CpdManualEntryModel>;
  /** sets expire of the current session to a later date by adding session_expiry of the user's org to the current date */
  refreshSession?: Maybe<UserSessionModel>;
  manager?: Maybe<UserModelPublicBase>;
  createdBy?: Maybe<UserModel>;
  certificationEnrolment?: Maybe<CertificationEnrolmentModelAsStudent>;
  canViewAnalytics: Scalars['Boolean'];
  isMemberOfCPDGroup: Scalars['Boolean'];
  totalManualCpdHours: Scalars['NonNegativeFloat'];
  totalHoursSpentInEvents: Scalars['NonNegativeFloat'];
  totalHoursSpentInResources: Scalars['NonNegativeFloat'];
  canUpdateProfile: Scalars['Boolean'];
  isAdminOfSomeGroup: Scalars['Boolean'];
  certificationEnrolments: Array<CertificationEnrolmentModelAsStudent>;
  /**
   * Returns past enrolments of this user ordered by last update time. Optionally it
   *     can filter out inaccessible workspaces. Enrolments in inaccessible workspaces or archived ones
   *     are not returned.
   */
  recentlyUpdatedTopicEnrolments: Array<TopicEnrolmentModelAsStudent>;
  assignedPathways: Array<PathwayModelAsStudent>;
  activeBanners: Array<CampaignBannerModel>;
  /** finds a single topicEnrolment by the idColumn of the relation */
  topicEnrolment?: Maybe<TopicEnrolmentModelAsStudent>;
  /** return current status of user's Google Calendar API authentication */
  isGoogleCalendarAPIAuthenticated?: Maybe<Scalars['Boolean']>;
  activityHistory: UserActivityHistory;
  scimResource?: Maybe<ScimResourceModel>;
  topicEnrolments: Array<TopicEnrolmentModelAsStudent>;
  topicEnrolmentsCount: Scalars['NonNegativeInt'];
  eventInvitations: Array<UserEventModel>;
  eventInvitationsCount: Scalars['NonNegativeInt'];
  /** finds a single eventInvitation by the idColumn of the relation */
  eventInvitation?: Maybe<UserEventModel>;
  cpdManualEntries: Array<CpdManualEntryModel>;
  cpdManualEntriesCount: Scalars['NonNegativeInt'];
};


export type UserModelSelfFollowResourceArgs = {
  itemId: Scalars['PositiveInt'];
  itemType: FollowResourceType;
};


export type UserModelSelfUnfollowResourceArgs = {
  itemId: Scalars['PositiveInt'];
  itemType: FollowResourceType;
};


export type UserModelSelfCurrentPathwayEnrolmentArgs = {
  pathwayId: Scalars['PositiveInt'];
};


export type UserModelSelfCreateCpdEntryArgs = {
  input: CpdManualEntryModelInput;
};


export type UserModelSelfCpdManualEntryArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelSelfCertificationEnrolmentArgs = {
  certificationId: Scalars['PositiveInt'];
};


export type UserModelSelfTotalManualCpdHoursArgs = {
  from?: Maybe<Scalars['DateTime']>;
  to?: Maybe<Scalars['DateTime']>;
};


export type UserModelSelfTotalHoursSpentInEventsArgs = {
  from?: Maybe<Scalars['DateTime']>;
  to?: Maybe<Scalars['DateTime']>;
  cpdOnly?: Maybe<Scalars['Boolean']>;
};


export type UserModelSelfTotalHoursSpentInResourcesArgs = {
  from?: Maybe<Scalars['DateTime']>;
  to?: Maybe<Scalars['DateTime']>;
  cpdOnly?: Maybe<Scalars['Boolean']>;
};


export type UserModelSelfRecentlyUpdatedTopicEnrolmentsArgs = {
  limit: Scalars['NonNegativeInt'];
};


export type UserModelSelfTopicEnrolmentArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelSelfActivityHistoryArgs = {
  filters?: Maybe<UserActivityHistoryInput>;
};


export type UserModelSelfTopicEnrolmentsArgs = {
  filters?: Maybe<Array<TopicEnrolmentModelAsStudentFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelSelfTopicEnrolmentsCountArgs = {
  filters?: Maybe<Array<TopicEnrolmentModelAsStudentFilterInput>>;
};


export type UserModelSelfEventInvitationsArgs = {
  filters?: Maybe<Array<UserEventModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelSelfEventInvitationsCountArgs = {
  filters?: Maybe<Array<UserEventModelFilterInput>>;
};


export type UserModelSelfEventInvitationArgs = {
  id: Scalars['PositiveInt'];
};


export type UserModelSelfCpdManualEntriesArgs = {
  filters?: Maybe<Array<CpdManualEntryModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type UserModelSelfCpdManualEntriesCountArgs = {
  filters?: Maybe<Array<CpdManualEntryModelFilterInput>>;
};

export type UserModelWithWorkspaceRole = {
  __typename?: 'UserModelWithWorkspaceRole';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  image_url?: Maybe<Scalars['String']>;
  id: Scalars['PositiveInt'];
  email?: Maybe<Scalars['EmailAddressWithTLD']>;
  custom_1?: Maybe<Scalars['String']>;
  custom_2?: Maybe<Scalars['String']>;
  custom_3?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  manager_id?: Maybe<Scalars['PositiveInt']>;
  position?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  states?: Maybe<Scalars['JSON']>;
  step?: Maybe<Scalars['Float']>;
  employee_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  privacy_policy_accepted?: Maybe<Scalars['DateTime']>;
  preferences: UserPreferences;
  organisation_role: OrganisationRoleEnum;
  uploaded_img_url?: Maybe<Scalars['String']>;
  profile_img_url?: Maybe<Scalars['String']>;
  password_last_updated_at?: Maybe<Scalars['DateTime']>;
  display_name: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  verified: Scalars['Boolean'];
  phone_number?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['NonEmptyString']>;
  locale?: Maybe<SupportedLocalesEnum>;
  calendars: UserCalendars;
  userIdentity: Scalars['String'];
  memberInGroups?: Maybe<Scalars['String']>;
  /** When false, user can still have the default password that was used in the CSV user import. True indicates this user has set his own password-it was not set for him by someone else. */
  hasOwnPasswordSet?: Maybe<Scalars['Boolean']>;
  workspaceRole?: Maybe<WorkspaceRoleEnum>;
};

export type UserModelWithWorkspaceRoleOverview = {
  __typename?: 'UserModelWithWorkspaceRoleOverview';
  items: Array<UserModelWithWorkspaceRole>;
  count?: Maybe<Scalars['Float']>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  sendCommentSummaryEmails?: Maybe<Scalars['Boolean']>;
  highContrast?: Maybe<Scalars['Boolean']>;
};

export enum UserSecurityQuestionsEnum {
  MOTHER_MAIDEN_NAME = 'MOTHER_MAIDEN_NAME',
  CHILDHOOD_NICKNAME = 'CHILDHOOD_NICKNAME',
  OLDEST_SIBLING_MIDDLE_NAME = 'OLDEST_SIBLING_MIDDLE_NAME',
  FIRST_JOB_TOWN = 'FIRST_JOB_TOWN',
  CHILD_DREAM_JOB = 'CHILD_DREAM_JOB',
  GRANDMOTHERS_FIRST_NAME = 'GRANDMOTHERS_FIRST_NAME',
  FAVOURITE_MOVIE = 'FAVOURITE_MOVIE',
  FAVOURITE_PET_NAME = 'FAVOURITE_PET_NAME',
  FIRST_PHONE_MODEL = 'FIRST_PHONE_MODEL',
  FAVOURITE_PIZZA_TOPPING = 'FAVOURITE_PIZZA_TOPPING'
}

export type UserSecurityQuestionsModel = {
  __typename?: 'UserSecurityQuestionsModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type UserSessionModel = {
  __typename?: 'UserSessionModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  sid?: Maybe<Scalars['String']>;
  user_id: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  expires: Scalars['DateTime'];
  session_attributes_data?: Maybe<Scalars['JSON']>;
};

export type UserSessionModelSelf = {
  __typename?: 'UserSessionModelSelf';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  sid?: Maybe<Scalars['String']>;
  user_id: Scalars['PositiveInt'];
  organisation_id: Scalars['PositiveInt'];
  expires: Scalars['DateTime'];
  session_attributes_data?: Maybe<Scalars['JSON']>;
  user: UserModelSelf;
};

export enum UserStateResponseEnum {
  VERIFIED = 'VERIFIED',
  NOT_VERIFIED = 'NOT_VERIFIED',
  NOT_VERIFIED_NO_PASSWORD = 'NOT_VERIFIED_NO_PASSWORD',
  NOT_VERIFIED_REQUEST_VERIFICATION = 'NOT_VERIFIED_REQUEST_VERIFICATION',
  NOT_FOUND = 'NOT_FOUND',
  NOT_ACTIVE = 'NOT_ACTIVE',
  FORBIDDEN = 'FORBIDDEN'
}

export type UserVerificationDataInput = {
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailAddressWithTLD']>;
  phone_number?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  employee_id?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  custom_1?: Maybe<Scalars['String']>;
  custom_2?: Maybe<Scalars['String']>;
  custom_3?: Maybe<Scalars['String']>;
};

/** returned from campaign audienceEvents resolver */
export type UserWithCampaignUserEvent = {
  __typename?: 'UserWithCampaignUserEvent';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  image_url?: Maybe<Scalars['String']>;
  id: Scalars['PositiveInt'];
  email?: Maybe<Scalars['EmailAddressWithTLD']>;
  custom_1?: Maybe<Scalars['String']>;
  custom_2?: Maybe<Scalars['String']>;
  custom_3?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  manager_id?: Maybe<Scalars['PositiveInt']>;
  position?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  states?: Maybe<Scalars['JSON']>;
  step?: Maybe<Scalars['Float']>;
  employee_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['PositiveInt']>;
  privacy_policy_accepted?: Maybe<Scalars['DateTime']>;
  preferences: UserPreferences;
  organisation_role: OrganisationRoleEnum;
  uploaded_img_url?: Maybe<Scalars['String']>;
  profile_img_url?: Maybe<Scalars['String']>;
  password_last_updated_at?: Maybe<Scalars['DateTime']>;
  display_name: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  verified: Scalars['Boolean'];
  phone_number?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['NonEmptyString']>;
  locale?: Maybe<SupportedLocalesEnum>;
  calendars: UserCalendars;
  userIdentity: Scalars['String'];
  memberInGroups?: Maybe<Scalars['String']>;
  /** When false, user can still have the default password that was used in the CSV user import. True indicates this user has set his own password-it was not set for him by someone else. */
  hasOwnPasswordSet?: Maybe<Scalars['Boolean']>;
  campaign_id: Scalars['PositiveInt'];
  lastJoinTimestamp?: Maybe<Scalars['DateTime']>;
  completedTimestamp?: Maybe<Scalars['DateTime']>;
  analyticEventsCount: Scalars['NonNegativeInt'];
  analyticEvents: Array<CampaignAnalyticEventModel>;
  /** includes all kinds of actions */
  scheduledActions?: Maybe<Array<ScheduledCampaignActionModel>>;
  /** omits banner actions as these are not actions we perform on the backend */
  scheduledActionsCountUntilNow?: Maybe<Scalars['NonNegativeInt']>;
};


/** returned from campaign audienceEvents resolver */
export type UserWithCampaignUserEventScheduledActionsArgs = {
  from?: Maybe<Scalars['DateTime']>;
  limit?: Maybe<Scalars['PositiveInt']>;
};

export type UserWorkspaceModel = {
  __typename?: 'UserWorkspaceModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  user_id?: Maybe<Scalars['PositiveInt']>;
  workspace_id?: Maybe<Scalars['PositiveInt']>;
  role?: Maybe<WorkspaceRoleEnum>;
};

export enum UsersActivityFilterEnum {
  ALL = 'ALL',
  INACTIVE_ONLY = 'INACTIVE_ONLY',
  ACTIVE_ONLY = 'ACTIVE_ONLY'
}

export enum UsersOverviewOrderColumn {
  id = 'id',
  display_name = 'display_name',
  pathwayEnrolmentsCount = 'pathwayEnrolmentsCount',
  resourceViewsCount = 'resourceViewsCount',
  attendedEventsCount = 'attendedEventsCount',
  certificationEnrolmentsCount = 'certificationEnrolmentsCount',
  workbooksCount = 'workbooksCount',
  surveysCount = 'surveysCount',
  lastActivityAt = 'lastActivityAt'
}

export type VideoDocument = {
  __typename?: 'VideoDocument';
  id?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentTranscodingStatusEnum>;
  cdnUrl?: Maybe<Scalars['String']>;
};

export type VideoEngagement = {
  __typename?: 'VideoEngagement';
  from_time_ms: Scalars['Float'];
  to_time_ms: Scalars['Float'];
  origin?: Maybe<VideoEngagementOrigin>;
};

export type VideoEngagementInput = {
  from_time_ms: Scalars['NonNegativeInt'];
  to_time_ms: Scalars['PositiveInt'];
  origin: VideoEngagementOrigin;
};

export enum VideoEngagementOrigin {
  PAUSE = 'PAUSE',
  SEEK = 'SEEK',
  AUTO_FLUSH = 'AUTO_FLUSH',
  VIDEO_FINISHED = 'VIDEO_FINISHED',
  VIDEO_PLAYER_DESTROYED = 'VIDEO_PLAYER_DESTROYED'
}

export type VideoImpressionModel = {
  __typename?: 'VideoImpressionModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  finished_at?: Maybe<Scalars['DateTime']>;
  total_play_time_ms: Scalars['NonNegativeInt'];
  total_unique_play_time_ms: Scalars['NonNegativeInt'];
  video_duration_ms: Scalars['NonNegativeInt'];
  engagements: Array<VideoEngagement>;
  storeMediaEngagement?: Maybe<Scalars['Boolean']>;
  topicEnrolment: TopicEnrolmentModel;
  topicElement: TopicElementModel;
};


export type VideoImpressionModelStoreMediaEngagementArgs = {
  engagement: VideoEngagementInput;
};

export type VideoImpressionModelAsAdmin = {
  __typename?: 'VideoImpressionModelAsAdmin';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  finished_at?: Maybe<Scalars['DateTime']>;
  total_play_time_ms: Scalars['NonNegativeInt'];
  total_unique_play_time_ms: Scalars['NonNegativeInt'];
  video_duration_ms: Scalars['NonNegativeInt'];
  engagements: Array<VideoEngagement>;
  storeMediaEngagement?: Maybe<Scalars['Boolean']>;
  topicEnrolment: TopicEnrolmentModelAsEditor;
  topicElement: TopicElementModel;
  /** Virtual field filled by Media Analytics */
  engagementPercent?: Maybe<Scalars['NonNegativeInt']>;
  /** Virtual field filled by Media Analytics */
  userId?: Maybe<Scalars['NonNegativeInt']>;
  lastActiveAt?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};


export type VideoImpressionModelAsAdminStoreMediaEngagementArgs = {
  engagement: VideoEngagementInput;
};


export enum WebhookSubscriptionEventTypes {
  RESOURCE_ENROLMENT_CREATION = 'RESOURCE_ENROLMENT_CREATION',
  RESOURCE_ENROLMENT_COMPLETION = 'RESOURCE_ENROLMENT_COMPLETION',
  RESOURCE_ENROLMENT_ARCHIVATION = 'RESOURCE_ENROLMENT_ARCHIVATION',
  PATHWAY_ENROLMENT_CREATION = 'PATHWAY_ENROLMENT_CREATION',
  PATHWAY_ENROLMENT_COMPLETION = 'PATHWAY_ENROLMENT_COMPLETION',
  PATHWAY_ENROLMENT_ARCHIVATION = 'PATHWAY_ENROLMENT_ARCHIVATION',
  CERTIFICATION_ENROLMENT_CREATION = 'CERTIFICATION_ENROLMENT_CREATION',
  CERTIFICATION_ENROLMENT_COMPLETION = 'CERTIFICATION_ENROLMENT_COMPLETION',
  CERTIFICATION_ENROLMENT_ARCHIVATION = 'CERTIFICATION_ENROLMENT_ARCHIVATION'
}

export type WebhookSubscriptionModel = {
  __typename?: 'WebhookSubscriptionModel';
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  event: WebhookSubscriptionEventTypes;
  url: Scalars['String'];
  is_active: Scalars['Boolean'];
  secret_key?: Maybe<Scalars['String']>;
};

export enum WorkbookAssignedFilterEnum {
  ASSIGNED = 'ASSIGNED',
  SELF_ENROLLED = 'SELF_ENROLLED',
  ALL = 'ALL'
}

export enum WorkbookCompletedFilterEnum {
  COMPLETED = 'COMPLETED',
  NOT_COMPLETED = 'NOT_COMPLETED',
  ALL = 'ALL'
}

export enum WorkbookStatusEnum {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  OVERDUE = 'OVERDUE',
  FAILED = 'FAILED'
}

export enum WorkbooksOverviewOrderColumn {
  displayName = 'displayName',
  resourceName = 'resourceName',
  startDate = 'startDate',
  completionDate = 'completionDate',
  passMark = 'passMark',
  score = 'score',
  progress = 'progress',
  attempt = 'attempt',
  progress_time = 'progress_time'
}

/** Workspace bookmark model for workspace COORDINATOR */
export type WorkspaceBookmarkModelAsCoordinator = IWorkspaceBookmarkModel & {
  __typename?: 'WorkspaceBookmarkModelAsCoordinator';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  title: Scalars['String'];
  url: Scalars['String'];
  order?: Maybe<Scalars['NonNegativeInt']>;
  type?: Maybe<WorkspaceBookmarkTypeEnum>;
  image?: Maybe<PrivateImageWithVariants>;
  workspace: WorkspaceModel;
  remove?: Maybe<WorkspaceBookmarkModelAsCoordinator>;
  patch?: Maybe<WorkspaceBookmarkModelAsCoordinator>;
};


/** Workspace bookmark model for workspace COORDINATOR */
export type WorkspaceBookmarkModelAsCoordinatorPatchArgs = {
  input: WorkspaceBookmarkModelInput;
};

/** Workspace bookmark model for workspace MEMBER */
export type WorkspaceBookmarkModelAsMember = IWorkspaceBookmarkModel & {
  __typename?: 'WorkspaceBookmarkModelAsMember';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  title: Scalars['String'];
  url: Scalars['String'];
  order?: Maybe<Scalars['NonNegativeInt']>;
  type?: Maybe<WorkspaceBookmarkTypeEnum>;
  image?: Maybe<PrivateImageWithVariants>;
  workspace: WorkspaceModel;
};

export type WorkspaceBookmarkModelInput = {
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
};

export enum WorkspaceBookmarkTypeEnum {
  NORMAL = 'NORMAL',
  BIG = 'BIG'
}

export type WorkspaceModel = {
  __typename?: 'WorkspaceModel';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  is_open: Scalars['Boolean'];
  /**
   * role of the current user in this workspace,
   *       DEPRECATED prefer checking the typename of the workspace,
   *       can be null when STUDENT user is accessing this workspace from analytics
   */
  role?: Maybe<WorkspaceRoleEnum>;
  publishedTopicsCount: Scalars['NonNegativeInt'];
  currentTopicVersion?: Maybe<TopicVersionModel>;
};


export type WorkspaceModelCurrentTopicVersionArgs = {
  id: Scalars['PositiveInt'];
};

export type WorkspaceModelAsCollaborator = IWorkspaceModel & {
  __typename?: 'WorkspaceModelAsCollaborator';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  is_open: Scalars['Boolean'];
  /**
   * role of the current user in this workspace,
   *       DEPRECATED prefer checking the typename of the workspace,
   *       can be null when STUDENT user is accessing this workspace from analytics
   */
  role?: Maybe<WorkspaceRoleEnum>;
  publishedTopicsCount: Scalars['NonNegativeInt'];
  currentTopicVersion?: Maybe<TopicVersionModel>;
  topics: Array<ITopicModel>;
  bookmarkList: Array<IWorkspaceBookmarkModel>;
  topic?: Maybe<ITopicModel>;
  /** returns a count of incomplete assigned enrolments for the current user in this workspace */
  assignedEnrolmentsCount?: Maybe<Scalars['NonNegativeInt']>;
  coverImage?: Maybe<DocumentModel>;
  tags: Array<TagModel>;
  tagsCount: Scalars['NonNegativeInt'];
  /** finds a single tag by the idColumn of the relation */
  tag?: Maybe<TagModel>;
  owner: UserModelPublicBase;
  themes: Array<IThemeModel>;
  themesCount: Scalars['NonNegativeInt'];
  /** finds a single theme by the idColumn of the relation */
  theme?: Maybe<IThemeModel>;
  bookmarks: Array<IWorkspaceBookmarkModel>;
  bookmarksCount: Scalars['NonNegativeInt'];
  /** finds a single bookmark by the idColumn of the relation */
  bookmark?: Maybe<IWorkspaceBookmarkModel>;
  user_id?: Maybe<Scalars['PositiveInt']>;
  createTopic?: Maybe<TopicModelAsEditor>;
  topicModelAsEditor?: Maybe<TopicModelAsEditor>;
  /** list of possible author candidates — any user who has edit access into this workspace */
  authorCandidates: Array<UserModelPublicBase>;
  createTheme?: Maybe<ThemeModelAsEditor>;
  reorderTopics?: Maybe<Scalars['NonNegativeInt']>;
  reorderThemes?: Maybe<Scalars['NonNegativeInt']>;
  organisation: OrganisationModel;
};


export type WorkspaceModelAsCollaboratorCurrentTopicVersionArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCollaboratorTopicsArgs = {
  filters?: Maybe<Array<ITopicModelFilterInput>>;
};


export type WorkspaceModelAsCollaboratorTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCollaboratorTagsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type WorkspaceModelAsCollaboratorTagsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type WorkspaceModelAsCollaboratorTagArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCollaboratorThemesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type WorkspaceModelAsCollaboratorThemesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type WorkspaceModelAsCollaboratorThemeArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCollaboratorBookmarksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type WorkspaceModelAsCollaboratorBookmarksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type WorkspaceModelAsCollaboratorBookmarkArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCollaboratorCreateTopicArgs = {
  input: CreateTopicInput;
};


export type WorkspaceModelAsCollaboratorTopicModelAsEditorArgs = {
  topicId: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCollaboratorAuthorCandidatesArgs = {
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['PositiveInt']>;
};


export type WorkspaceModelAsCollaboratorCreateThemeArgs = {
  title: Scalars['String'];
};


export type WorkspaceModelAsCollaboratorReorderTopicsArgs = {
  topicIds: Array<Scalars['PositiveInt']>;
};


export type WorkspaceModelAsCollaboratorReorderThemesArgs = {
  themesIds: Array<Scalars['PositiveInt']>;
};

export type WorkspaceModelAsCoordinator = IWorkspaceModel & {
  __typename?: 'WorkspaceModelAsCoordinator';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  is_open: Scalars['Boolean'];
  /**
   * role of the current user in this workspace,
   *       DEPRECATED prefer checking the typename of the workspace,
   *       can be null when STUDENT user is accessing this workspace from analytics
   */
  role?: Maybe<WorkspaceRoleEnum>;
  publishedTopicsCount: Scalars['NonNegativeInt'];
  currentTopicVersion?: Maybe<TopicVersionModel>;
  topics: Array<ITopicModel>;
  bookmarkList: Array<IWorkspaceBookmarkModel>;
  topic?: Maybe<ITopicModel>;
  /** returns a count of incomplete assigned enrolments for the current user in this workspace */
  assignedEnrolmentsCount?: Maybe<Scalars['NonNegativeInt']>;
  coverImage?: Maybe<DocumentModel>;
  tags: Array<TagModel>;
  tagsCount: Scalars['NonNegativeInt'];
  /** finds a single tag by the idColumn of the relation */
  tag?: Maybe<TagModel>;
  owner: UserModelPublicBase;
  themes: Array<IThemeModel>;
  themesCount: Scalars['NonNegativeInt'];
  /** finds a single theme by the idColumn of the relation */
  theme?: Maybe<IThemeModel>;
  bookmarks: Array<IWorkspaceBookmarkModel>;
  bookmarksCount: Scalars['NonNegativeInt'];
  /** finds a single bookmark by the idColumn of the relation */
  bookmark?: Maybe<IWorkspaceBookmarkModel>;
  user_id?: Maybe<Scalars['PositiveInt']>;
  createTopic?: Maybe<TopicModelAsEditor>;
  topicModelAsEditor?: Maybe<TopicModelAsEditor>;
  /** list of possible author candidates — any user who has edit access into this workspace */
  authorCandidates: Array<UserModelPublicBase>;
  createTheme?: Maybe<ThemeModelAsEditor>;
  reorderTopics?: Maybe<Scalars['NonNegativeInt']>;
  reorderThemes?: Maybe<Scalars['NonNegativeInt']>;
  organisation: OrganisationModel;
  /** only organisation admins can do this */
  relatedCampaigns: Array<CampaignModelAsAdminMutations>;
  /** only organisation admins can do this */
  archive?: Maybe<ArchiveWorkspaceResult>;
  patch?: Maybe<WorkspaceModelAsCoordinator>;
  assignTopics?: Maybe<Scalars['JSON']>;
  /** gets all users in organisation and returns them with a flag signifying whether the user is a member of this workspace or not */
  usersWithRole: UserModelWithWorkspaceRoleOverview;
  /** gets all groups in organisation and returns them with a flag signifying what role they have in the workspace */
  groupsWithRole: GroupModelWithWorkspaceRoleOverview;
  /** returns null if user is not found */
  addUser?: Maybe<UserWorkspaceModel>;
  setUserRole?: Maybe<UserWorkspaceModel>;
  /** returns null if user is not found as member/collaborator/coordinator in the workspace */
  removeUser?: Maybe<UserModelPublicBase>;
  /** returns null if group is not found */
  addGroup?: Maybe<GroupWorkspaceModel>;
  setGroupRole?: Maybe<GroupWorkspaceModel>;
  /** returns null if group is not found in the workspace related groups */
  removeGroup?: Maybe<GroupModelGqlBase>;
  /** change status of workspace */
  setIsOpen?: Maybe<WorkspaceModelAsCoordinator>;
  createBookmark?: Maybe<WorkspaceBookmarkModelAsCoordinator>;
  setBookmarksType?: Maybe<WorkspaceBookmarkTypeEnum>;
  setBookmarksOrder?: Maybe<Scalars['PositiveInt']>;
  addTag: Scalars['NonNegativeInt'];
  removeTag: Scalars['NonNegativeInt'];
  removeAllTags: Scalars['NonNegativeInt'];
  members: Array<UserModelPublicBase>;
  membersCount: Scalars['NonNegativeInt'];
  /** finds a single member by the idColumn of the relation */
  member?: Maybe<UserModelPublicBase>;
  groups: Array<GroupModel>;
  groupsCount: Scalars['NonNegativeInt'];
  /** finds a single group by the idColumn of the relation */
  group?: Maybe<GroupModel>;
  topicsCount: Scalars['NonNegativeInt'];
};


export type WorkspaceModelAsCoordinatorCurrentTopicVersionArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCoordinatorTopicsArgs = {
  filters?: Maybe<Array<ITopicModelFilterInput>>;
};


export type WorkspaceModelAsCoordinatorTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCoordinatorTagsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type WorkspaceModelAsCoordinatorTagsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type WorkspaceModelAsCoordinatorTagArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCoordinatorThemesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type WorkspaceModelAsCoordinatorThemesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type WorkspaceModelAsCoordinatorThemeArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCoordinatorBookmarksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type WorkspaceModelAsCoordinatorBookmarksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type WorkspaceModelAsCoordinatorBookmarkArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCoordinatorCreateTopicArgs = {
  input: CreateTopicInput;
};


export type WorkspaceModelAsCoordinatorTopicModelAsEditorArgs = {
  topicId: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCoordinatorAuthorCandidatesArgs = {
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['PositiveInt']>;
};


export type WorkspaceModelAsCoordinatorCreateThemeArgs = {
  title: Scalars['String'];
};


export type WorkspaceModelAsCoordinatorReorderTopicsArgs = {
  topicIds: Array<Scalars['PositiveInt']>;
};


export type WorkspaceModelAsCoordinatorReorderThemesArgs = {
  themesIds: Array<Scalars['PositiveInt']>;
};


export type WorkspaceModelAsCoordinatorPatchArgs = {
  input: WorkspaceModelAsCoordinatorInput;
};


export type WorkspaceModelAsCoordinatorAssignTopicsArgs = {
  input: AssignTopicsInput;
};


export type WorkspaceModelAsCoordinatorUsersWithRoleArgs = {
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<WorkspaceRoleEnum>>;
  order?: Maybe<Array<OrderDescriptorWorkspaceUsersWithRole>>;
};


export type WorkspaceModelAsCoordinatorGroupsWithRoleArgs = {
  limit?: Maybe<Scalars['PositiveInt']>;
  page?: Maybe<Scalars['PositiveInt']>;
  search?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<WorkspaceRoleEnum>>;
  order?: Maybe<Array<OrderDescriptorWorkspacesGroupsWithRole>>;
};


export type WorkspaceModelAsCoordinatorAddUserArgs = {
  userId: Scalars['PositiveInt'];
  role?: Maybe<WorkspaceRoleEnum>;
};


export type WorkspaceModelAsCoordinatorSetUserRoleArgs = {
  userId: Scalars['PositiveInt'];
  role: WorkspaceRoleEnum;
};


export type WorkspaceModelAsCoordinatorRemoveUserArgs = {
  userId: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCoordinatorAddGroupArgs = {
  groupId: Scalars['PositiveInt'];
  role?: Maybe<WorkspaceRoleEnum>;
};


export type WorkspaceModelAsCoordinatorSetGroupRoleArgs = {
  groupId: Scalars['PositiveInt'];
  role: WorkspaceRoleEnum;
};


export type WorkspaceModelAsCoordinatorRemoveGroupArgs = {
  groupId: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCoordinatorSetIsOpenArgs = {
  isOpen: Scalars['Boolean'];
};


export type WorkspaceModelAsCoordinatorCreateBookmarkArgs = {
  input: WorkspaceBookmarkModelInput;
};


export type WorkspaceModelAsCoordinatorSetBookmarksTypeArgs = {
  targetType: WorkspaceBookmarkTypeEnum;
};


export type WorkspaceModelAsCoordinatorSetBookmarksOrderArgs = {
  orderOfIds: Array<Scalars['PositiveInt']>;
};


export type WorkspaceModelAsCoordinatorAddTagArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCoordinatorRemoveTagArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCoordinatorMembersArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type WorkspaceModelAsCoordinatorMembersCountArgs = {
  filters?: Maybe<Array<UserModelPublicBaseFilterInput>>;
};


export type WorkspaceModelAsCoordinatorMemberArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCoordinatorGroupsArgs = {
  filters?: Maybe<Array<GroupModelFilterInput>>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type WorkspaceModelAsCoordinatorGroupsCountArgs = {
  filters?: Maybe<Array<GroupModelFilterInput>>;
};


export type WorkspaceModelAsCoordinatorGroupArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsCoordinatorTopicsCountArgs = {
  filters?: Maybe<Array<TopicModelFilterInput>>;
};

export enum WorkspaceModelAsCoordinatorFilterEnum {
  name = 'name'
}

export type WorkspaceModelAsCoordinatorFilterInput = {
  name: WorkspaceModelAsCoordinatorFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export type WorkspaceModelAsCoordinatorInput = {
  description?: Maybe<Scalars['String']>;
};

export type WorkspaceModelAsMember = IWorkspaceModel & ISearchable & {
  __typename?: 'WorkspaceModelAsMember';
  deleted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['PositiveInt'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  is_open: Scalars['Boolean'];
  /**
   * role of the current user in this workspace,
   *       DEPRECATED prefer checking the typename of the workspace,
   *       can be null when STUDENT user is accessing this workspace from analytics
   */
  role?: Maybe<WorkspaceRoleEnum>;
  publishedTopicsCount: Scalars['NonNegativeInt'];
  currentTopicVersion?: Maybe<TopicVersionModel>;
  topics: Array<ITopicModel>;
  bookmarkList: Array<IWorkspaceBookmarkModel>;
  topic?: Maybe<ITopicModel>;
  /** returns a count of incomplete assigned enrolments for the current user in this workspace */
  assignedEnrolmentsCount?: Maybe<Scalars['NonNegativeInt']>;
  coverImage?: Maybe<DocumentModel>;
  tags: Array<TagModel>;
  tagsCount: Scalars['NonNegativeInt'];
  /** finds a single tag by the idColumn of the relation */
  tag?: Maybe<TagModel>;
  owner: UserModelPublicBase;
  themes: Array<IThemeModel>;
  themesCount: Scalars['NonNegativeInt'];
  /** finds a single theme by the idColumn of the relation */
  theme?: Maybe<IThemeModel>;
  bookmarks: Array<IWorkspaceBookmarkModel>;
  bookmarksCount: Scalars['NonNegativeInt'];
  /** finds a single bookmark by the idColumn of the relation */
  bookmark?: Maybe<IWorkspaceBookmarkModel>;
};


export type WorkspaceModelAsMemberCurrentTopicVersionArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsMemberTopicsArgs = {
  filters?: Maybe<Array<ITopicModelFilterInput>>;
};


export type WorkspaceModelAsMemberTopicArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsMemberTagsArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type WorkspaceModelAsMemberTagsCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type WorkspaceModelAsMemberTagArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsMemberThemesArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type WorkspaceModelAsMemberThemesCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type WorkspaceModelAsMemberThemeArgs = {
  id: Scalars['PositiveInt'];
};


export type WorkspaceModelAsMemberBookmarksArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
  order?: Maybe<Array<OrderDescriptor>>;
  offset?: Maybe<Scalars['NonNegativeInt']>;
  limit?: Maybe<Scalars['NonNegativeInt']>;
};


export type WorkspaceModelAsMemberBookmarksCountArgs = {
  filters?: Maybe<Scalars['VoidArgument']>;
};


export type WorkspaceModelAsMemberBookmarkArgs = {
  id: Scalars['PositiveInt'];
};

export enum WorkspaceModelFilterEnum {
  name = 'name'
}

export type WorkspaceModelFilterInput = {
  name: WorkspaceModelFilterEnum;
  value?: Maybe<Scalars['JSON']>;
};

export enum WorkspaceRoleEnum {
  MEMBER = 'MEMBER',
  COLLABORATOR = 'COLLABORATOR',
  COORDINATOR = 'COORDINATOR'
}

export enum WorkspacesGroupsWithRoleSortableColumnsEnum {
  id = 'id',
  name = 'name'
}

export enum WorkspacesUsersWithRoleSortableColumnsEnum {
  id = 'id',
  display_name = 'display_name',
  workspaceRole = 'workspaceRole',
  userIdentity = 'userIdentity'
}
